  const palette = ['#141414','#87C5E0','#B89968','#8C2030','#5C3D2E','#000000','#D4452D','#A8BCC8','#2D6A4F','#6B4226','#E8A0B8','#3A6B5E'];

  function bagSvg(color1, color2, accent='#141414') {
    return `<svg viewBox="0 0 200 240" xmlns="http://www.w3.org/2000/svg">
      <rect x="35" y="80" width="130" height="140" rx="8" fill="${color1}"/>
      <rect x="35" y="80" width="130" height="36" rx="8" fill="${color2}"/>
      <circle cx="100" cy="148" r="9" fill="${accent}"/>
      <g fill="none" stroke="${accent}" stroke-width="3" stroke-linecap="round">
        <rect x="35" y="80" width="130" height="140" rx="8"/>
        <path d="M 58 80 C 58 35, 142 35, 142 80"/>
        <circle cx="100" cy="156" r="13"/>
      </g>
    </svg>`;
  }
  function flapSvg(color1) {
    return `<svg viewBox="0 0 200 240" xmlns="http://www.w3.org/2000/svg">
      <rect x="25" y="90" width="150" height="120" rx="6" fill="${color1}"/>
      <path d="M25 90 L100 60 L175 90 Z" fill="${color1}" opacity="0.85"/>
      <rect x="92" y="135" width="16" height="22" rx="2" fill="#D4B872"/>
      <g fill="none" stroke="#141414" stroke-width="2">
        <rect x="25" y="90" width="150" height="120" rx="6"/>
        <path d="M25 90 L100 60 L175 90"/>
      </g>
    </svg>`;
  }
  function pochetteSvg(color1) {
    return `<svg viewBox="0 0 200 240" xmlns="http://www.w3.org/2000/svg">
      <rect x="20" y="100" width="160" height="80" rx="6" fill="${color1}"/>
      <path d="M20 100 L100 70 L180 100 Z" fill="${color1}" opacity="0.85"/>
      <text x="100" y="148" text-anchor="middle" font-family="serif" font-size="22" fill="#141414" font-weight="600">H</text>
      <g fill="none" stroke="#141414" stroke-width="2">
        <rect x="20" y="100" width="160" height="80" rx="6"/>
        <path d="M20 100 L100 70 L180 100"/>
      </g>
    </svg>`;
  }
  function pickArt(i) {
    const c1 = palette[i % palette.length];
    const c2 = palette[(i+3) % palette.length];
    if (i % 3 === 0) return bagSvg(c1, c2);
    if (i % 3 === 1) return flapSvg(c1);
    return pochetteSvg(c1);
  }

  const brandCode = { 'Hermès':`HRM`, 'Chanel':`CHN`, 'Louis Vuitton':'LV', 'Dior':`DIO`, 'Prada':`PRA`, 'Gucci':`GUC` };
  function buildSku(brand, year, seq) {
    const b = brandCode[brand] || brand.slice(0,3).toUpperCase();
    return `CASA-${b}-${year}-${String(seq).padStart(4,'0')}`;
  }
  // Real inventory lives in exactly ONE place: the FINAL INVENTORY module
  // (~line 6820) — its `items` array + CASA_GALLERIES dict. It rebuilds
  // `arrivals` from scratch on load (arrivals.length = 0, then repopulates).
  // This used to hold 12 fake seed products (Birkin/NéoNoé/etc, none real —
  // dummy prices+SKUs for early layout work) that were always wiped before
  // first paint. Removed 27 Aug 2026 so there's no second place that looks
  // like real data. Add new stock to FINAL INVENTORY's `items` array, never here.
  const arrivals = [];

  // The piece's indexable page, /bag/<slug>. MUST match slugFor() in api/bag.js
  // exactly, or every link costs Google a 301 hop. `color` arrives as '—' when the
  // record has none (toArrival), which the server treats as no colour.
  function casaBagPath(p) {
    const slugify = s => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '')
      .toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    const color = p.color && p.color !== '—' ? p.color : '';
    return (window.casaShopifyUrl && window.casaShopifyUrl(p.sku)) || '/bag/' + slugify([p.brand, p.name, color].filter(Boolean).join(' ')) + '-' + slugify(p.sku);
  }
  window.casaBagPath = casaBagPath;

  function productCard(p, i) {
    const imgHTML = p.img
      ? `<img src="${p.img}" alt="${p.brand} ${p.name}" style="width:100%; height:100%; object-fit:cover;">`
      : pickArt(i);
    // 16 Sep 2026: the image link gained an href. Search Console showed 43 of 44
    // /bag/ pages "Discovered - currently not indexed" with "Referring page: None
    // detected" — the storefront never linked to them, so Google had only the
    // sitemap and left them unvisited. A left click still opens Quick View
    // (preventDefault), so nothing a shopper sees or does changes; Googlebot, which
    // renders this grid, now finds a real link to every piece.
    return `<div class="product-card">
      ${p.badge ? `<span class="product-badge ${p.gold?'gold':''}">${p.badge}</span>` : ''}
      <a class="product-img" href="${p.sku ? casaBagPath(p) : '#'}" onclick="event.preventDefault(); openQuickView(${i})" title="View product details">
        ${imgHTML}
        <div class="quick-add">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg>
          View Product
        </div>
      </a>
      <div class="product-info" onclick="openQuickView(${i})" style="cursor: pointer;">
        <div class="product-brand">${p.brand}</div>
        <div class="product-name">${p.name}</div>
        <div class="product-price">
          <span class="price">${p.price}</span>
          <span class="condition">${p.cond}</span>
        </div>
        <div class="product-sku">SKU · ${p.sku}</div>
      </div>
    </div>`;
  }
  const homeArrivalsEl = document.getElementById('home-arrivals');
  if (homeArrivalsEl) homeArrivalsEl.innerHTML = arrivals.slice(0,4).map(productCard).join('');
  document.getElementById('shop-grid').innerHTML = arrivals.map(productCard).join('');

  const socialImgs = [
    'Casa%20Social/CHANEL%20SUMMER.png',
    'Casa%20Social/LV%20SUMMER.png',
    'Casa%20Social/CHANEL%20SUMMER%202.png',
    'Casa%20Social/ICE%20CREAM.png',
    'Casa%20Social/LV%20SUMMER%203.png',
    'Casa%20Social/CHANEL%20SUMMER%204.png'
  ];
  const igGridEl = document.getElementById('ig-grid');
  if (igGridEl) igGridEl.innerHTML = socialImgs.map((src) => `
    <div class="social-tile">
      <img src="${src}" alt="Casa Consignment on Instagram" loading="lazy" style="width:100%;height:100%;object-fit:cover;">
      <div class="ig-icon">
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/></svg>
      </div>
    </div>`).join('');

  // 24 Sep 2026: the address never changes on a section switch, so Vercel Analytics saw
  // every visitor as a one-page bounce. Each section is now reported as its own page:
  // home is "/", the rest "/<view>" (analytics labels only, not real URLs).
  var casaAnalyticsView = 'home';
  function switchView(view) {
    // 24 Sep 2026: a view that does not exist used to blank the page and throw (Firefox
    // report, 23 Sep). Show the home page instead; home always exists.
    if (!document.getElementById('view-' + view)) { if (view !== 'home') switchView('home'); return; }
    if (view !== casaAnalyticsView) {
      casaAnalyticsView = view;
      const page = view === 'home' ? '/' : '/' + view;
      try { window.va && window.va('pageview', { route: page, path: page }); } catch (e) {}
    }
    document.querySelectorAll('.view').forEach(v => v.classList.remove('active'));
    document.getElementById('view-' + view).classList.add('active');
    // Landing portal: when on home, hide all chrome (header/announcement/footer)
    document.body.classList.toggle('portal-mode', view === 'home');
    document.querySelectorAll('.nav-link').forEach(n => n.classList.remove('active'));
    document.querySelectorAll(`[data-view="${view}"]`).forEach(n => {
      if (n.classList.contains('nav-link')) n.classList.add('active');
    });
    window.scrollTo({top: 0, behavior: 'smooth'});
    setTimeout(() => {
      document.querySelectorAll('#view-' + view + ' .reveal').forEach(el => el.classList.add('in'));
    }, 100);
  }
  document.querySelectorAll('[data-view]').forEach(el => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      switchView(el.dataset.view);
    });
  });

  function openCart() {
    document.getElementById('cart-drawer').classList.add('open');
    document.getElementById('cart-backdrop').classList.add('open');
  }
  function closeCart() {
    document.getElementById('cart-drawer').classList.remove('open');
    document.getElementById('cart-backdrop').classList.remove('open');
  }
  function openModal(name) { document.getElementById('modal-' + name).classList.add('open'); }
  function closeModal(name) { document.getElementById('modal-' + name).classList.remove('open'); }
  function switchTab(btn, name) {
    btn.parentElement.querySelectorAll('button').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    document.querySelectorAll('.tab-panel').forEach(p => p.style.display = 'none');
    document.getElementById('tab-' + name).style.display = 'block';
    const titles = {
      signin: ['Welcome back', 'Sign in to your account'],
      register: ['Join the boutique', 'Save favorites and check out faster'],
      consignor: ['Become a Consignor', 'Submit pieces and earn up to 80%']
    };
    if (titles[name]) {
      document.getElementById('account-title').textContent = titles[name][0];
      document.getElementById('account-sub').textContent = titles[name][1];
    }
  }
  function switchTabByName(name) {
    const btn = document.querySelector(`.tab-row button[data-tab="${name}"]`);
    if (btn) switchTab(btn, name);
  }
  function openSellerSignup() {
    openModal('account');
    setTimeout(() => switchTabByName('consignor'), 50);
  }
  function openQuickView(i) {
    const p = arrivals[i];
    window.casaTrack('Quick View', { sku: p.sku, brand: p.brand });
    const img = p.img
      ? `<img src="${p.img}" alt="${p.brand} ${p.name}" style="width:100%; height:100%; object-fit:cover;">`
      : pickArt(i);
    document.getElementById('qv-img').innerHTML = img;
    document.getElementById('qv-brand').textContent = p.brand;
    document.getElementById('qv-sku').textContent = p.sku;
    document.getElementById('qv-name').textContent = p.name;
    document.getElementById('qv-price').textContent = p.price;
    document.getElementById('qv-size-link').style.display = p.brand === 'Hermès' ? 'inline-flex' : 'none';
    openModal('quickview');
  }

  const showcaseItems = [
    { type:'image', src:'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0021-front.webp?v=1785902934',
      brand:'Casa Consignment', name:'New Arrivals · The Collection',
      size:'Curated weekly', color:'Authenticated', swatch:'#6b6b6b' },
    { type:'image', src:'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0026-front.jpg?v=1785902986',
      brand:'Casa Consignment', name:'Designer Handbag · 05',
      size:'—', color:'Pristine', swatch:'#a8a8a8' },
    { type:'image', src:'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0004-front.jpg?v=1785902728',
      brand:'Casa Consignment', name:'Just In · Hand-Selected',
      size:'Limited', color:'Insured', swatch:'#6b6b6b' }
  ];
  function loadShowcase(idx) {
    const item = showcaseItems[idx];
    const wrap = document.querySelector('.showcase-video-wrap');
    const existing = wrap.querySelector('video, img.showcase-still');
    if (existing) existing.remove();
    let el;
    if (item.type === 'video') {
      el = document.createElement('video');
      el.autoplay = true; el.muted = true; el.loop = true; el.playsInline = true;
      el.src = item.src; if (item.poster) el.poster = item.poster;
      el.id = 'showcase-video';
    } else {
      el = document.createElement('img');
      el.src = item.src; el.alt = item.name;
      el.className = 'showcase-still';
      el.style.cssText = 'width:100%;height:100%;object-fit:cover;';
    }
    wrap.insertBefore(el, wrap.querySelector('.video-caption'));
    document.getElementById('sc-brand').textContent = item.brand;
    document.getElementById('sc-name').textContent = item.name;
    document.getElementById('sc-size').innerHTML = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M3 8h18M3 16h18M8 3v18M16 3v18"/></svg> ${item.size}`;
    document.getElementById('sc-color').innerHTML = `<span class="swatch-mini" style="background:${item.swatch}"></span> ${item.color}`;
    document.querySelectorAll('.showcase-thumb').forEach((t, ti) => t.classList.toggle('active', ti === idx));
  }

  function switchSizeTab(btn, name) {
    btn.parentElement.querySelectorAll('button').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    document.querySelectorAll('.sg-panel').forEach(p => p.style.display = 'none');
    document.getElementById('sg-' + name).style.display = 'block';
  }

  function setStep(n) {
    document.querySelectorAll('.form-step').forEach(s => s.classList.remove('active'));
    document.querySelector(`.form-step[data-step="${n}"]`).classList.add('active');
    document.querySelectorAll('.stepper-dot').forEach(d => {
      d.classList.toggle('active', parseInt(d.dataset.step) <= n);
    });
    document.querySelector('.sell-form-wrap').scrollIntoView({behavior:'smooth', block:'start'});
  }

  // ---- Consignor photos: compress client-side, upload to Vercel Blob,
  // carry the resulting URLs (never the bytes) through the intake payload.
  // See Documents/Casa Consignment - Content Moderation Options and
  // Recommendation, Section 12.3 for why: raw attachments/base64 in the
  // existing JSON payload both blow past provider/serverless size ceilings.
  window.casaConsignPhotos = { front: null, rear: null, side: null, bottom: null, inside: null, extra: [] };
  const CASA_REQUIRED_PHOTO_SLOTS = ['front', 'rear', 'side', 'bottom', 'inside'];
  let casaConsignPhotoRef = null;
  function casaConsignPhotoSubmissionRef() {
    if (!casaConsignPhotoRef) casaConsignPhotoRef = 'c' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
    return casaConsignPhotoRef;
  }

  // Resize to a review-quality max dimension and re-encode as JPEG. This is
  // what keeps a 10MB phone photo comfortably under both Vercel's 4.5MB
  // serverless request-body ceiling and this endpoint's own MAX_BYTES check —
  // not an attempt to preserve a publish-quality master.
  function casaCompressPhoto(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (ev) => {
        const img = new Image();
        img.onload = () => {
          const maxDim = 2000;
          let { width, height } = img;
          if (width > maxDim || height > maxDim) {
            const scale = maxDim / Math.max(width, height);
            width = Math.round(width * scale);
            height = Math.round(height * scale);
          }
          const canvas = document.createElement('canvas');
          canvas.width = width; canvas.height = height;
          canvas.getContext('2d').drawImage(img, 0, 0, width, height);
          canvas.toBlob((blob) => { if (blob) resolve(blob); else reject(new Error('compression failed')); }, 'image/jpeg', 0.82);
        };
        img.onerror = () => reject(new Error('could not read image'));
        img.src = ev.target.result;
      };
      reader.onerror = () => reject(new Error('could not read file'));
      reader.readAsDataURL(file);
    });
  }

  function casaUploadConsignPhoto(slot, blob) {
    const ref = casaConsignPhotoSubmissionRef();
    return fetch(`/api/consignment-photo?ref=${encodeURIComponent(ref)}&slot=${encodeURIComponent(slot)}`, {
      method: 'POST',
      headers: { 'Content-Type': blob.type || 'image/jpeg' },
      body: blob
    }).then(r => r.json().catch(() => ({}))).then(j => (j && j.ok && j.url) ? j.url : null).catch(() => null);
  }

  function casaUpdateStep2Continue() {
    const btn = document.getElementById('step2-continue');
    if (btn) btn.disabled = !CASA_REQUIRED_PHOTO_SLOTS.every(s => !!window.casaConsignPhotos[s]);
  }

  // The five required slots — each is its own input, so each angle is an
  // actual required target rather than a decorative label next to a shared
  // multi-file input.
  document.querySelectorAll('.photo-slot-input').forEach((input) => {
    input.addEventListener('change', (e) => {
      const file = e.target.files && e.target.files[0];
      if (!file) return;
      const slot = input.dataset.slot;
      const tile = input.closest('.photo-slot');
      const img = tile ? tile.querySelector('.photo-slot-preview') : null;
      const labelSpan = tile ? tile.querySelector('.photo-slot-label') : null;

      const previewReader = new FileReader();
      previewReader.onload = (ev) => {
        if (img) { img.src = ev.target.result; img.style.display = 'block'; }
        if (labelSpan) labelSpan.style.display = 'none';
      };
      previewReader.readAsDataURL(file);

      if (tile) { tile.classList.remove('uploaded', 'upload-failed'); tile.classList.add('uploading'); }
      window.casaConsignPhotos[slot] = null;
      casaUpdateStep2Continue();

      casaCompressPhoto(file).then(blob => casaUploadConsignPhoto(slot, blob)).then((url) => {
        if (tile) tile.classList.remove('uploading');
        if (url) {
          window.casaConsignPhotos[slot] = url;
          if (tile) tile.classList.add('uploaded');
        } else if (tile) {
          tile.classList.add('upload-failed');
          try { window.casaSignal && window.casaSignal('photo_upload_failed', 'consign ' + slot); } catch (e) {}
          if (img) img.style.display = 'none';
          if (labelSpan) { labelSpan.style.display = 'flex'; labelSpan.textContent = labelSpan.textContent.replace(/\s*\(retry\)$/, '') + ' (retry)'; }
        }
        casaUpdateStep2Continue();
      });
    });
  });

  const dz = document.getElementById('dropzone');
  if (dz) {
    // Optional overflow photos beyond the 5 required angles — still
    // compressed and uploaded, just non-blocking for Step 2 → Step 3.
    // Shared by both the click-to-pick <input> and the drop zone so a
    // dropped file gets the same real upload the picked one does.
    function handleExtraPhotoFiles(fileList) {
      const thumbs = document.getElementById('upload-thumbs');
      Array.from(fileList).slice(0, 7).forEach(file => {
        if (!file.type || !file.type.startsWith('image/')) return;
        const thumb = document.createElement('div');
        thumb.className = 'upload-thumb';
        thumbs.appendChild(thumb);
        const r = new FileReader();
        r.onload = (ev) => { thumb.innerHTML = `<img src="${ev.target.result}">`; };
        r.readAsDataURL(file);

        casaCompressPhoto(file).then(blob => casaUploadConsignPhoto('extra', blob)).then((url) => {
          if (url) window.casaConsignPhotos.extra.push(url);
        });
      });
    }
    ['dragenter','dragover'].forEach(ev => dz.addEventListener(ev, (e) => { e.preventDefault(); dz.classList.add('dragover'); }));
    ['dragleave'].forEach(ev => dz.addEventListener(ev, (e) => { e.preventDefault(); dz.classList.remove('dragover'); }));
    dz.addEventListener('drop', (e) => {
      e.preventDefault();
      dz.classList.remove('dragover');
      const files = e.dataTransfer && e.dataTransfer.files;
      if (files && files.length) handleExtraPhotoFiles(files);
    });
    document.getElementById('file-input').addEventListener('change', (e) => {
      handleExtraPhotoFiles(e.target.files);
    });
  }

  window.addEventListener('load', () => {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in'); });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(el => io.observe(el));
  });

  // =============================================================
  // BRAND CATALOG — show counts; "Coming Soon" for unstocked brands
  // =============================================================
  const BRANDS = [
    { key:'hermes', name:'Hermès', svg:'<rect x="18" y="36" width="64" height="50" rx="4" fill="#dcdcdc" stroke="none"/><rect x="18" y="36" width="64" height="50" rx="4"/><path d="M28 36 C28 18 72 18 72 36"/>' },
    { key:'chanel', name:'Chanel', svg:'<rect x="20" y="32" width="60" height="54" rx="2" fill="#dcdcdc" stroke="none"/><rect x="20" y="32" width="60" height="54" rx="2"/><path d="M30 32 V22 a8 8 0 0 1 16 0 V32"/><path d="M54 32 V22 a8 8 0 0 1 16 0 V32"/><path d="M20 50 L80 50"/>' },
    { key:'lv', name:'Louis Vuitton', svg:'<path d="M20 40 C20 38 22 36 24 36 H76 C78 36 80 38 80 40 L78 84 C78 86 76 88 74 88 H26 C24 88 22 86 22 84 Z" fill="#dcdcdc" stroke="none"/><path d="M20 40 C20 38 22 36 24 36 H76 C78 36 80 38 80 40 L78 84 C78 86 76 88 74 88 H26 C24 88 22 86 22 84 Z"/><path d="M32 36 C32 20 68 20 68 36"/>' },
    { key:'dior', name:'Dior', svg:'<circle cx="50" cy="60" r="28" fill="#dcdcdc" stroke="none"/><circle cx="50" cy="60" r="28"/><path d="M30 50 a20 20 0 0 1 40 0"/>' },
    { key:'prada', name:'Prada', svg:'<rect x="22" y="34" width="56" height="54" rx="3" fill="#dcdcdc" stroke="none"/><rect x="22" y="34" width="56" height="54" rx="3"/><path d="M30 34 C30 18 70 18 70 34"/><path d="M40 50 H60"/>' },
    { key:'gucci', name:'Gucci', svg:'<rect x="22" y="40" width="56" height="46" rx="6" fill="#dcdcdc" stroke="none"/><rect x="22" y="40" width="56" height="46" rx="6"/><path d="M32 40 C32 22 68 22 68 40"/><circle cx="40" cy="58" r="5"/><circle cx="60" cy="58" r="5"/>' },
    { key:'bottega', name:'Bottega Veneta', svg:'<rect x="20" y="38" width="60" height="48" rx="6" fill="#dcdcdc" stroke="none"/><rect x="20" y="38" width="60" height="48" rx="6"/><path d="M30 38 C30 22 70 22 70 38"/><path d="M28 50 L72 70 M72 50 L28 70" stroke-dasharray="2,2"/>' },
    { key:'ysl', name:'Saint Laurent', svg:'<rect x="22" y="38" width="56" height="52" rx="2" fill="#dcdcdc" stroke="none"/><rect x="22" y="38" width="56" height="52" rx="2"/><path d="M30 38 C30 22 70 22 70 38"/><text x="50" y="68" text-anchor="middle" font-family="serif" font-size="22" font-weight="700">Y</text>' },
  ];

  function countByBrand(brandName) {
    return arrivals.filter(a => a.brand === brandName).length;
  }

  function renderDesignerCards() {
    const grid = document.getElementById('designer-grid');
    if (!grid) return;
    grid.innerHTML = BRANDS.map(b => {
      const count = countByBrand(b.name);
      const isComingSoon = count === 0;
      const dataView = isComingSoon ? '' : `data-view="shop" data-brand="${b.name}"`;
      const piecesLabel = count === 1 ? 'piece' : 'pieces';
      const cardClass = `designer-card reveal ${isComingSoon ? 'coming-soon' : ''}`;
      const tail = isComingSoon
        ? `<div class="coming-pill" data-i18n="brand.comingSoon">Coming Soon</div>`
        : `<div class="count"><span data-i18n-count="${count}">${count}</span> <span data-i18n="brand.${count===1?'pieceWord':'piecesWord'}">${piecesLabel}</span></div>`;
      return `<div class="${cardClass}" ${dataView}>
        <svg class="silhouette" viewBox="0 0 100 100" fill="none" stroke="#141414" stroke-width="2">${b.svg}</svg>
        <h3>${b.name}</h3>
        ${tail}
      </div>`;
    }).join('');
    // Reattach data-view click handlers for new cards. A card with a
    // data-brand pre-filters Shop to that designer instead of landing on
    // the general Shop All grid (was a missed-opportunity gap per the
    // 17 Aug 2026 audit).
    grid.querySelectorAll('[data-view]').forEach(el => el.addEventListener('click', (e) => {
      e.preventDefault();
      const brand = el.dataset.brand;
      if (brand && typeof shopState !== 'undefined') {
        // Clear any category/condition filter left over from an earlier visit.
        // Same root cause as the "Shop All" stale-filter bug (see
        // navigateShopAll): shopState is module-level and survives view changes.
        // Without this, a designer card clicked after browsing Accessories gave
        // "that designer AND Accessories" — frequently an empty grid — instead of
        // the designer's pieces, which is what the card promises.
        shopState.categories.clear();
        shopState.conditions.clear();
        shopState.colors.clear();
        document.querySelectorAll('#view-shop .filter-group input[type="checkbox"]').forEach(cb => { cb.checked = false; });
        shopState.brands = new Set([brand]);
        document.querySelectorAll('#brand-filter-options input[type="checkbox"]').forEach(cb => {
          const label = cb.closest('.filter-option');
          const name = label ? label.textContent.replace(/\s*\d+\s*$/, '').trim() : '';
          cb.checked = name === brand;
        });
      }
      switchView(el.dataset.view);
      if (typeof renderShopGrid === 'function') renderShopGrid();
    }));
    grid.querySelectorAll('.reveal').forEach(el => el.classList.add('in'));
  }

  function renderBrandFilters() {
    const wrap = document.getElementById('brand-filter-options');
    if (!wrap) return;
    wrap.innerHTML = BRANDS.map(b => {
      const count = countByBrand(b.name);
      if (count === 0) {
        return `<label class="filter-option" style="opacity:0.5; cursor:not-allowed;">
          <input type="checkbox" disabled> ${b.name}
          <span class="count" style="color: var(--gold); font-style: italic;" data-i18n="brand.comingSoonShort">Coming Soon</span>
        </label>`;
      }
      return `<label class="filter-option">
        <input type="checkbox"> ${b.name} <span class="count">${count}</span>
      </label>`;
    }).join('');
  }
  renderDesignerCards();
  renderBrandFilters();

  // Toast
  function showToast(msg) {
    let t = document.getElementById('stc-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'stc-toast';
      t.style.cssText = 'position:fixed; bottom:32px; left:50%; transform:translateX(-50%) translateY(100px); background:var(--navy); color:#fff; padding:14px 24px; border-radius:4px; box-shadow:0 12px 32px rgba(0,0,0,0.25); z-index:9999; font-size:13px; letter-spacing:0.04em; transition:transform 0.35s var(--ease); max-width:90vw; text-align:center;';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    requestAnimationFrame(() => { t.style.transform = 'translateX(-50%) translateY(0)'; });
    clearTimeout(t._hideTimer);
    t._hideTimer = setTimeout(() => { t.style.transform = 'translateX(-50%) translateY(100px)'; }, 3500);
  }

  // =============================================================
  // i18n — English, Spanish, French, German, Japanese, Chinese
  // =============================================================
  const I18N = {
    en: {
      'nav.shop':`Shop`,'nav.sell':`Sell`,'nav.about':`About`,'nav.sizeGuide':`Size Guide`,'nav.dashboard':`Dashboard`,'nav.browse':`Browse`,'nav.review':`Review Desk`,
      'announce.auth':`Complimentary Authentication`,'announce.ship':`Insured U.S. Shipping`,'announce.consign':`Now Accepting Consignment`,
      'hero.eyebrow':`Curated Pre-Owned Luxury`,'hero.script':`timeless`,'hero.headline.middle':`pieces,`,'hero.headline.em':`responsibly`,'hero.headline.end':`resold.`,'hero.lead':`A boutique consignment house for the world’s most coveted handbags, jewelry, and apparel. Every piece authenticated, photographed, and stewarded by hand.`,'hero.cta.shop':`Shop the Collection`,'hero.cta.sell':`Sell With Us`,
      'tag.authenticated':`Authenticated`,'tag.consignor':`Consignor Approved`,'tag.insured':`Insured Shipping`,
      'trust.auth':`Authenticated`,'trust.auth.sub':`Every piece, hand-inspected`,'trust.secure':`Secure Checkout`,'trust.secure.sub':`SSL & PCI compliant`,'trust.insured':`Insured Delivery`,'trust.insured.sub':`Fully covered, door to door`,'trust.final':`All Sales Final`,'trust.final.sub':`Confidence in every piece`,
      'designer.eyebrow':`Shop by Maison`,'designer.title':`The Houses We Love`,'designer.lead':`Treasured names, sourced from private collections and curated for their craftsmanship, heritage, and enduring desirability.`,
      'brand.comingSoon':`Coming Soon`,'brand.comingSoonShort':`Coming Soon`,'brand.piecesWord':`pieces`,'brand.pieceWord':`piece`,
      'showcase.eyebrow':`In Motion`,'showcase.title.start':`See it from`,'showcase.title.em':`every angle.`,'showcase.lead':`Every new arrival gets the full treatment — 360° video, hardware close-ups, interior reveal, and stamping verification. Because online shopping for luxury should feel like the boutique.`,'showcase.stat1':`Walk-around`,'showcase.stat2':`Close-ups`,'showcase.stat3':`From listing`,'showcase.featured':`Featured pieces · this week`,'showcase.cta':`Shop New Arrivals`,'showcase.guide':`Hermès Size Guide`,
      'arrivals.eyebrow':`Just In`,'arrivals.title':`New Arrivals`,'arrivals.viewAll':`View All`,
      'editorial.eyebrow':`Our Standard`,'editorial.title.start':`Authenticated by people,`,'editorial.title.em':`not algorithms.`,'editorial.body':`Our authentication team has decades of combined experience handling rare Hermès, Chanel, and Louis Vuitton pieces. We examine stitching, hardware, leather grain, date codes, and provenance — and we stand behind every piece we ship.`,'editorial.stat1':`Pieces Authenticated`,'editorial.stat2':`Guarantee`,'editorial.stat3':`Avg. Review`,'editorial.cta':`Learn More`,
      'social.eyebrow':`Follow Along`,'social.title':`@CasaConsignment`,'social.lead':`New arrivals, behind-the-scenes, and styling stories — share yours with #CasaStyled.`,
      'shop.crumbHome':`Home`,'shop.crumbAll':`Shop All`,'shop.title':`Shop the Collection`,'shop.lead.start':`curated pieces — from heritage handbags to fine jewelry.`,'shop.showing':`Showing`,'shop.of':`of`,'shop.sort':`Sort`,'shop.sort.newest':`Newest`,'shop.sort.priceLow':`Price: Low to High`,'shop.sort.priceHigh':`Price: High to Low`,'shop.sort.coveted':`Most Coveted`,'shop.sort.alpha':`Designer A–Z`,
      'filter.designer':`Designer`,'filter.category':`Category`,'filter.condition':`Condition`,'filter.color':`Color`,'filter.price':`Price`,'filter.clear':`Clear Filters`,'sizeGuide.label':`Size Guide`,'sizeGuide.sub':`Hermès Birkin & Kelly · & more`,
      'sell.eyebrow':`Consign With Casa`,'sell.title.start':`Turn closet treasures`,'sell.title.em':`into your next chapter.`,'sell.lead':`Send us photos, accept our offer, ship insured — all on us. Expect a thoughtful response within 48 hours from a real specialist.`,'sell.step1.title':`Submit`,'sell.step1.sub':`Photos, condition, your ask`,'sell.step2.title':`Review`,'sell.step2.sub':`We authenticate & quote`,'sell.step3.title':`Ship`,'sell.step3.sub':`Prepaid, insured label`,'sell.step4.title':`Get Paid`,'sell.step4.sub':`Direct deposit on sale`,
      'tiers.eyebrow':`Transparent Payouts`,'tiers.title':`Commission Tiers`,'tiers.lead':`Your payout grows with the final selling price. We share the math up front — no surprises, no hidden deductions.`,'tiers.payoutLabel':`Consignor Payout`,'tiers.topTier':`Top Tier`,'tiers.commission':`Casa commission`,
      'consignorCta.eyebrow':`Consign with Casa`,'consignorCta.title':`Create your Seller account.`,'consignorCta.lead':`Submit a piece online with photos and a Casa specialist will review it and reply by email. Your account keeps your orders, wishlist and membership in one place.`,'consignorCta.cta':`Become a Consignor`,'consignorCta.alt':`Already registered? Sign in`,
      'demo.hintTitle':`Demo Accounts`,
      'modal.welcome':`Welcome`,'modal.welcomeSub':`Sign in or create your account`,'modal.tab.signin':`Sign In`,'modal.tab.shop':`Shop With Us`,'modal.tab.consignor':`Become a Consignor`,'modal.email':`Email`,'modal.password':`Password`,'modal.forgot':`Forgot your password?`,'modal.signin':`Sign In`,'modal.firstName':`First name`,'modal.lastName':`Last name`,'modal.createPw':`Choose a password`,'modal.createAccount':`Create Account`,'modal.orContinue':`or continue with`,'modal.google':`Continue with Google`,'modal.apple':`Continue with Apple`,
      'footer.shop':`Shop`,'footer.sell':`Sell`,'footer.support':`Support`,'footer.stayInKnow':`Stay In The Know`,'footer.subscribe':`Subscribe`,'footer.rights':`All rights reserved.`,
      'dash.viewingAs':`Viewing as`,'dash.demo':`Demo mode`,
      'dash.section.orders':`My Orders`,'dash.section.saved':`Saved Items`,'dash.section.sales':`Sales Dashboard`,'dash.section.listings':`My Listings`,'dash.section.payouts':`Payouts`,'dash.section.tickets':`Tickets`,'dash.section.kpis':`Overview`,'dash.section.revenue':`Revenue & Trends`,'dash.section.customers':`Customers`,'dash.section.skulog':`SKU Activity Log`,'dash.section.trends':`Growth Trends`,'dash.section.profile':`Profile & Address`,'dash.section.cohorts':`Cohort Analysis`,'dash.section.settings':`Settings`,'dash.section.signout':`Sign Out`,
      'dash.kpi.items':`Items Sold`,'dash.kpi.revenue':`Gross Revenue`,'dash.kpi.payout':`Your Payout`,'dash.kpi.commission':`Casa Commission`,'dash.kpi.openTickets':`Open`,'dash.kpi.inReview':`In Review`,'dash.kpi.escalated':`Escalated`,'dash.kpi.resolved':`Resolved · 7d`,'dash.kpi.totalCustomers':`Total Customers`,'dash.kpi.active':`Active`,'dash.kpi.inactive':`Inactive · 14d+`,'dash.kpi.avgSpend':`Avg. Lifetime Spend`,'dash.kpi.totalOrders':`Total Orders`,'dash.kpi.inTransit':`In Transit`,'dash.kpi.lifetimeSpend':`Lifetime Spend`,'dash.kpi.savedItems':`Saved Items`,'dash.kpi.activeListings':`Active Listings`,'dash.kpi.avgDays':`Avg. Days to Sell`,'dash.kpi.wishlist':`Wishlist Adds`,'dash.kpi.consignors':`Consignors`,
      'dash.range':`Range`,'dash.range.all':`All Time`,'dash.range.7d':`Last 7 Days`,'dash.range.30d':`Last 30 Days`,'dash.range.90d':`Last Quarter`,'dash.range.ytd':`Year-to-Date`,
      'dash.table.date':`Date`,'dash.table.sku':`SKU`,'dash.table.item':`Item`,'dash.table.sold':`Sold`,'dash.table.tier':`Tier`,'dash.table.yourPct':`Your %`,'dash.table.payout':`Payout`,'dash.table.status':`Status`,'dash.table.priority':`Priority`,'dash.table.subject':`Subject`,'dash.table.from':`From`,'dash.table.user':`User`,'dash.table.age':`Age`,'dash.table.ticket':`Ticket`,'dash.table.name':`Name`,'dash.table.email':`Email`,'dash.table.signedUp':`Signed Up`,'dash.table.lastSeen':`Last Seen`,'dash.table.orders':`Orders`,'dash.table.spend':`Spend`,'dash.table.event':`Event`,'dash.table.detail':`Detail`,'dash.table.month':`Month`,'dash.table.delta':`MoM Δ`,'dash.table.asking':`Asking`,'dash.table.condition':`Condition`,'dash.table.listed':`Listed`,'dash.table.amount':`Amount`,'dash.table.order':`Order`,
      'lang.label':`Language`
    },
    es: {
      'nav.shop':`Tienda`,'nav.sell':`Vender`,'nav.about':`Nosotros`,'nav.sizeGuide':`Guía de Tallas`,'nav.dashboard':`Panel`,'nav.browse':`Explorar`,'nav.review':`Mesa de Revisión`,
      'announce.auth':`Autenticación Gratuita`,'announce.ship':`Envío Asegurado en EE. UU.`,'announce.consign':`Aceptando Consignaciones`,
      'hero.eyebrow':`Lujo Pre-Amado Curado`,'hero.script':`piezas`,'hero.headline.middle':`atemporales,`,'hero.headline.em':`revendidas`,'hero.headline.end':`con responsabilidad.`,'hero.lead':`Una casa de consignación boutique para los bolsos, joyas y prendas más codiciadas del mundo. Cada pieza autenticada, fotografiada y cuidada a mano.`,'hero.cta.shop':`Comprar la Colección`,'hero.cta.sell':`Vender Con Nosotros`,
      'tag.authenticated':`Autenticado`,'tag.consignor':`Aprobado por Consignador`,'tag.insured':`Envío Asegurado`,
      'trust.auth':`Autenticado`,'trust.auth.sub':`Cada pieza, inspeccionada a mano`,'trust.secure':`Pago Seguro`,'trust.secure.sub':`SSL & PCI conforme`,'trust.insured':`Entrega Asegurada`,'trust.insured.sub':`Totalmente cubierta, puerta a puerta`,'trust.final':`Todas las Ventas Finales`,'trust.final.sub':`Confianza en cada pieza`,
      'designer.eyebrow':`Compra por Maison`,'designer.title':`Las Casas que Amamos`,'designer.lead':`Nombres atesorados, obtenidos de colecciones privadas y curados por su artesanía, herencia y deseabilidad perdurable.`,
      'brand.comingSoon':`Próximamente`,'brand.comingSoonShort':`Próximamente`,'brand.piecesWord':`piezas`,'brand.pieceWord':`pieza`,
      'showcase.eyebrow':`En Movimiento`,'showcase.title.start':`Mírala desde`,'showcase.title.em':`todos los ángulos.`,'showcase.lead':`Cada nueva llegada recibe el tratamiento completo — video 360°, primeros planos del herraje, revelación del interior y verificación de sellos. Porque comprar lujo en línea debe sentirse como en la boutique.`,'showcase.stat1':`Vista 360°`,'showcase.stat2':`Primeros Planos`,'showcase.stat3':`Desde el listado`,'showcase.featured':`Piezas destacadas · esta semana`,'showcase.cta':`Comprar Novedades`,'showcase.guide':`Guía de Tallas Hermès`,
      'arrivals.eyebrow':`Recién Llegado`,'arrivals.title':`Nuevas Llegadas`,'arrivals.viewAll':`Ver Todo`,
      'editorial.eyebrow':`Nuestro Estándar`,'editorial.title.start':`Autenticado por personas,`,'editorial.title.em':`no algoritmos.`,'editorial.body':`Nuestro equipo de autenticación tiene décadas de experiencia combinada manejando piezas raras de Hermès, Chanel y Louis Vuitton. Examinamos las costuras, herrajes, grano del cuero, códigos de fecha y procedencia — y respaldamos cada pieza que enviamos.`,'editorial.stat1':`Piezas Autenticadas`,'editorial.stat2':`Garantía`,'editorial.stat3':`Revisión Promedio`,'editorial.cta':`Saber Más`,
      'social.eyebrow':`Síguenos`,'social.title':`@CasaConsignment`,'social.lead':`Nuevas llegadas, detrás de escena e historias de estilo — comparte la tuya con #CasaStyled.`,
      'shop.crumbHome':`Inicio`,'shop.crumbAll':`Toda la Tienda`,'shop.title':`Comprar la Colección`,'shop.lead.start':`piezas curadas — desde bolsos de patrimonio hasta joyería fina.`,'shop.showing':`Mostrando`,'shop.of':`de`,'shop.sort':`Ordenar`,'shop.sort.newest':`Más Recientes`,'shop.sort.priceLow':`Precio: Menor a Mayor`,'shop.sort.priceHigh':`Precio: Mayor a Menor`,'shop.sort.coveted':`Más Codiciados`,'shop.sort.alpha':`Diseñador A–Z`,
      'filter.designer':`Diseñador`,'filter.category':`Categoría`,'filter.condition':`Condición`,'filter.color':`Color`,'filter.price':`Precio`,'filter.clear':`Limpiar Filtros`,'sizeGuide.label':`Guía de Tallas`,'sizeGuide.sub':`Hermès Birkin & Kelly · y más`,
      'sell.eyebrow':`Consigna con Casa`,'sell.title.start':`Convierte tesoros del armario`,'sell.title.em':`en tu próximo capítulo.`,'sell.lead':`Envíanos fotos, acepta nuestra oferta, envía asegurado — todo por nuestra cuenta. Espera una respuesta cuidadosa en 48 horas de un especialista real.`,'sell.step1.title':`Enviar`,'sell.step1.sub':`Fotos, condición, tu precio`,'sell.step2.title':`Revisar`,'sell.step2.sub':`Autenticamos y cotizamos`,'sell.step3.title':`Enviar`,'sell.step3.sub':`Etiqueta prepagada, asegurada`,'sell.step4.title':`Cobrar`,'sell.step4.sub':`Depósito directo al vender`,
      'tiers.eyebrow':`Pagos Transparentes`,'tiers.title':`Niveles de Comisión`,'tiers.lead':`Tu pago crece con el precio de venta final. Compartimos las cuentas por adelantado — sin sorpresas, sin deducciones ocultas.`,'tiers.payoutLabel':`Pago al Consignador`,'tiers.topTier':`Nivel Superior`,'tiers.commission':`comisión Casa`,
      'consignorCta.eyebrow':`Consigna con Casa`,'consignorCta.title':`Crea tu cuenta de Vendedor.`,'consignorCta.lead':`Envía tu pieza en línea con fotos y un especialista de Casa la revisará y te responderá por correo electrónico. Tu cuenta reúne tus pedidos, tu lista de deseos y tu membresía en un solo lugar.`,'consignorCta.cta':`Convertirse en Consignador`,'consignorCta.alt':`¿Ya registrado? Iniciar sesión`,
      'demo.hintTitle':`Cuentas Demo`,
      'modal.welcome':`Bienvenido`,'modal.welcomeSub':`Inicia sesión o crea tu cuenta`,'modal.tab.signin':`Iniciar Sesión`,'modal.tab.shop':`Compra Con Nosotros`,'modal.tab.consignor':`Convertirse en Consignador`,'modal.email':`Correo electrónico`,'modal.password':`Contraseña`,'modal.forgot':`¿Olvidaste tu contraseña?`,'modal.signin':`Iniciar Sesión`,'modal.firstName':`Nombre`,'modal.lastName':`Apellido`,'modal.createPw':`Elige una contraseña`,'modal.createAccount':`Crear Cuenta`,'modal.orContinue':`o continuar con`,'modal.google':`Continuar con Google`,'modal.apple':`Continuar con Apple`,
      'footer.shop':`Tienda`,'footer.sell':`Vender`,'footer.support':`Soporte`,'footer.stayInKnow':`Mantente Informado`,'footer.subscribe':`Suscribirse`,'footer.rights':`Todos los derechos reservados.`,
      'dash.viewingAs':`Viendo como`,'dash.demo':`Modo demo`,
      'dash.section.orders':`Mis Pedidos`,'dash.section.saved':`Guardados`,'dash.section.sales':`Panel de Ventas`,'dash.section.listings':`Mis Anuncios`,'dash.section.payouts':`Pagos`,'dash.section.tickets':`Tickets`,'dash.section.kpis':`Vista General`,'dash.section.revenue':`Ingresos y Tendencias`,'dash.section.customers':`Clientes`,'dash.section.skulog':`Registro de SKU`,'dash.section.trends':`Tendencias`,'dash.section.profile':`Perfil y Dirección`,'dash.section.cohorts':`Análisis de Cohortes`,'dash.section.settings':`Ajustes`,'dash.section.signout':`Cerrar Sesión`,
      'dash.kpi.items':`Artículos Vendidos`,'dash.kpi.revenue':`Ingresos Brutos`,'dash.kpi.payout':`Tu Pago`,'dash.kpi.commission':`Comisión Casa`,'dash.kpi.openTickets':`Abiertos`,'dash.kpi.inReview':`En Revisión`,'dash.kpi.escalated':`Escalados`,'dash.kpi.resolved':`Resueltos · 7d`,'dash.kpi.totalCustomers':`Clientes Totales`,'dash.kpi.active':`Activos`,'dash.kpi.inactive':`Inactivos · 14d+`,'dash.kpi.avgSpend':`Gasto Promedio`,'dash.kpi.totalOrders':`Pedidos Totales`,'dash.kpi.inTransit':`En Tránsito`,'dash.kpi.lifetimeSpend':`Gasto de Vida`,'dash.kpi.savedItems':`Guardados`,'dash.kpi.activeListings':`Anuncios Activos`,'dash.kpi.avgDays':`Días Promedio`,'dash.kpi.wishlist':`Favoritos`,'dash.kpi.consignors':`Consignadores`,
      'dash.range':`Rango`,'dash.range.all':`Todo`,'dash.range.7d':`7 Días`,'dash.range.30d':`30 Días`,'dash.range.90d':`Último Trimestre`,'dash.range.ytd':`Año Actual`,
      'dash.table.date':`Fecha`,'dash.table.sku':`SKU`,'dash.table.item':`Artículo`,'dash.table.sold':`Vendido`,'dash.table.tier':`Nivel`,'dash.table.yourPct':`Tu %`,'dash.table.payout':`Pago`,'dash.table.status':`Estado`,'dash.table.priority':`Prioridad`,'dash.table.subject':`Asunto`,'dash.table.from':`De`,'dash.table.user':`Usuario`,'dash.table.age':`Edad`,'dash.table.ticket':`Ticket`,'dash.table.name':`Nombre`,'dash.table.email':`Correo`,'dash.table.signedUp':`Registrado`,'dash.table.lastSeen':`Última Visita`,'dash.table.orders':`Pedidos`,'dash.table.spend':`Gasto`,'dash.table.event':`Evento`,'dash.table.detail':`Detalle`,'dash.table.month':`Mes`,'dash.table.delta':`Δ MoM`,'dash.table.asking':`Precio`,'dash.table.condition':`Condición`,'dash.table.listed':`Listado`,'dash.table.amount':`Monto`,'dash.table.order':`Pedido`,
      'lang.label':`Idioma`
    },
    fr: {
      'nav.shop':`Boutique`,'nav.sell':`Vendre`,'nav.about':`À Propos`,'nav.sizeGuide':`Guide des Tailles`,'nav.dashboard':`Tableau de Bord`,'nav.browse':`Parcourir`,'nav.review':`Bureau de Révision`,
      'announce.auth':`Authentification Offerte`,'announce.ship':`Livraison Assurée aux États-Unis`,'announce.consign':`Consignations Acceptées`,
      'hero.eyebrow':`Luxe Pré-Aimé Sélectionné`,'hero.script':`intemporelles`,'hero.headline.middle':`pièces`,'hero.headline.em':`revendues`,'hero.headline.end':`avec conscience.`,'hero.lead':`Une maison de consignation boutique pour les sacs à main, bijoux et vêtements les plus convoités au monde. Chaque pièce authentifiée, photographiée et gardée à la main.`,'hero.cta.shop':`Découvrir la Collection`,'hero.cta.sell':`Vendre Avec Nous`,
      'tag.authenticated':`Authentifié`,'tag.consignor':`Approuvé par le Consignateur`,'tag.insured':`Livraison Assurée`,
      'trust.auth':`Authentifié`,'trust.auth.sub':`Chaque pièce, inspectée à la main`,'trust.secure':`Paiement Sécurisé`,'trust.secure.sub':`Conforme SSL & PCI`,'trust.insured':`Livraison Assurée`,'trust.insured.sub':`Entièrement couverte, porte à porte`,'trust.final':`Toutes les Ventes Finales`,'trust.final.sub':`Confiance dans chaque pièce`,
      'designer.eyebrow':`Acheter par Maison`,'designer.title':`Les Maisons que Nous Aimons`,'designer.lead':`Noms précieux, sourcés de collections privées et sélectionnés pour leur savoir-faire, leur héritage et leur désirabilité durable.`,
      'brand.comingSoon':`Prochainement`,'brand.comingSoonShort':`Bientôt`,'brand.piecesWord':`pièces`,'brand.pieceWord':`pièce`,
      'showcase.eyebrow':`En Mouvement`,'showcase.title.start':`Voyez-la sous`,'showcase.title.em':`tous les angles.`,'showcase.lead':`Chaque nouveauté reçoit un traitement complet — vidéo 360°, gros plans des fermoirs, révélation intérieure et vérification des étampes. Parce que le shopping de luxe en ligne doit ressembler à la boutique.`,'showcase.stat1':`Tour Complet`,'showcase.stat2':`Gros Plans`,'showcase.stat3':`Depuis le listing`,'showcase.featured':`Pièces vedettes · cette semaine`,'showcase.cta':`Voir les Nouveautés`,'showcase.guide':`Guide Tailles Hermès`,
      'arrivals.eyebrow':`Tout Juste Arrivé`,'arrivals.title':`Nouveautés`,'arrivals.viewAll':`Voir Tout`,
      'editorial.eyebrow':`Notre Standard`,'editorial.title.start':`Authentifié par des humains,`,'editorial.title.em':`pas des algorithmes.`,'editorial.body':`Notre équipe d’authentification cumule des décennies d’expérience avec des pièces rares Hermès, Chanel et Louis Vuitton. Nous examinons les coutures, les fermoirs, le grain du cuir, les codes de date et la provenance — et nous garantissons chaque pièce envoyée.`,'editorial.stat1':`Pièces Authentifiées`,'editorial.stat2':`Garantie`,'editorial.stat3':`Examen Moyen`,'editorial.cta':`En Savoir Plus`,
      'social.eyebrow':`Suivez-nous`,'social.title':`@CasaConsignment`,'social.lead':`Nouveautés, coulisses et histoires de style — partagez la vôtre avec #CasaStyled.`,
      'shop.crumbHome':`Accueil`,'shop.crumbAll':`Toute la Boutique`,'shop.title':`Découvrir la Collection`,'shop.lead.start':`pièces sélectionnées — du sac patrimonial à la joaillerie fine.`,'shop.showing':`Affichage de`,'shop.of':`sur`,'shop.sort':`Trier`,'shop.sort.newest':`Plus Récents`,'shop.sort.priceLow':`Prix : Croissant`,'shop.sort.priceHigh':`Prix : Décroissant`,'shop.sort.coveted':`Plus Convoités`,'shop.sort.alpha':`Créateur A–Z`,
      'filter.designer':`Créateur`,'filter.category':`Catégorie`,'filter.condition':`État`,'filter.color':`Couleur`,'filter.price':`Prix`,'filter.clear':`Effacer`,'sizeGuide.label':`Guide des Tailles`,'sizeGuide.sub':`Hermès Birkin & Kelly · et plus`,
      'sell.eyebrow':`Consigner avec Casa`,'sell.title.start':`Transformez vos trésors`,'sell.title.em':`en votre prochain chapitre.`,'sell.lead':`Envoyez-nous des photos, acceptez notre offre, expédiez assuré — tout à nos frais. Attendez une réponse réfléchie sous 48 heures d’un vrai spécialiste.`,'sell.step1.title':`Soumettre`,'sell.step1.sub':`Photos, état, votre prix`,'sell.step2.title':`Examen`,'sell.step2.sub':`Nous authentifions et cotons`,'sell.step3.title':`Expédier`,'sell.step3.sub':`Étiquette prépayée, assurée`,'sell.step4.title':`Être Payé`,'sell.step4.sub':`Virement à la vente`,
      'tiers.eyebrow':`Paiements Transparents`,'tiers.title':`Niveaux de Commission`,'tiers.lead':`Votre paiement augmente avec le prix de vente final. Nous partageons les calculs en amont — pas de surprises, pas de déductions cachées.`,'tiers.payoutLabel':`Paiement Consignateur`,'tiers.topTier':`Niveau Supérieur`,'tiers.commission':`commission Casa`,
      'consignorCta.eyebrow':`Confiez à Casa`,'consignorCta.title':`Créez votre compte Vendeur.`,'consignorCta.lead':`Soumettez votre pièce en ligne avec des photos : un spécialiste Casa l'examinera et vous répondra par e-mail. Votre compte regroupe vos commandes, votre liste d'envies et votre adhésion.`,'consignorCta.cta':`Devenir Consignateur`,'consignorCta.alt':`Déjà inscrit ? Connectez-vous`,
      'demo.hintTitle':`Comptes Démo`,
      'modal.welcome':`Bienvenue`,'modal.welcomeSub':`Connectez-vous ou créez votre compte`,'modal.tab.signin':`Connexion`,'modal.tab.shop':`Achetez Avec Nous`,'modal.tab.consignor':`Devenir Consignateur`,'modal.email':`E-mail`,'modal.password':`Mot de passe`,'modal.forgot':`Mot de passe oublié ?`,'modal.signin':`Se Connecter`,'modal.firstName':`Prénom`,'modal.lastName':`Nom`,'modal.createPw':`Choisir un mot de passe`,'modal.createAccount':`Créer un Compte`,'modal.orContinue':`ou continuer avec`,'modal.google':`Continuer avec Google`,'modal.apple':`Continuer avec Apple`,
      'footer.shop':`Boutique`,'footer.sell':`Vendre`,'footer.support':`Support`,'footer.stayInKnow':`Restez Informé`,'footer.subscribe':`S’Abonner`,'footer.rights':`Tous droits réservés.`,
      'dash.viewingAs':`En tant que`,'dash.demo':`Mode démo`,
      'dash.section.orders':`Mes Commandes`,'dash.section.saved':`Favoris`,'dash.section.sales':`Tableau des Ventes`,'dash.section.listings':`Mes Annonces`,'dash.section.payouts':`Paiements`,'dash.section.tickets':`Tickets`,'dash.section.kpis':`Aperçu`,'dash.section.revenue':`Revenus & Tendances`,'dash.section.customers':`Clients`,'dash.section.skulog':`Journal SKU`,'dash.section.trends':`Tendances`,'dash.section.profile':`Profil & Adresse`,'dash.section.cohorts':`Analyse de Cohorte`,'dash.section.settings':`Paramètres`,'dash.section.signout':`Déconnexion`,
      'dash.kpi.items':`Articles Vendus`,'dash.kpi.revenue':`Revenus Bruts`,'dash.kpi.payout':`Votre Paiement`,'dash.kpi.commission':`Commission Casa`,'dash.kpi.openTickets':`Ouverts`,'dash.kpi.inReview':`En Examen`,'dash.kpi.escalated':`Escaladés`,'dash.kpi.resolved':`Résolus · 7j`,'dash.kpi.totalCustomers':`Clients Totaux`,'dash.kpi.active':`Actifs`,'dash.kpi.inactive':`Inactifs · 14j+`,'dash.kpi.avgSpend':`Dépense Moyenne`,'dash.kpi.totalOrders':`Commandes Totales`,'dash.kpi.inTransit':`En Transit`,'dash.kpi.lifetimeSpend':`Dépense Totale`,'dash.kpi.savedItems':`Favoris`,'dash.kpi.activeListings':`Annonces Actives`,'dash.kpi.avgDays':`Jours Moyens`,'dash.kpi.wishlist':`Souhaits`,'dash.kpi.consignors':`Consignateurs`,
      'dash.range':`Plage`,'dash.range.all':`Tout`,'dash.range.7d':`7 Jours`,'dash.range.30d':`30 Jours`,'dash.range.90d':`Dernier Trimestre`,'dash.range.ytd':`Année à Jour`,
      'dash.table.date':`Date`,'dash.table.sku':`SKU`,'dash.table.item':`Article`,'dash.table.sold':`Vendu`,'dash.table.tier':`Niveau`,'dash.table.yourPct':`Votre %`,'dash.table.payout':`Paiement`,'dash.table.status':`Statut`,'dash.table.priority':`Priorité`,'dash.table.subject':`Sujet`,'dash.table.from':`De`,'dash.table.user':`Utilisateur`,'dash.table.age':`Âge`,'dash.table.ticket':`Ticket`,'dash.table.name':`Nom`,'dash.table.email':`E-mail`,'dash.table.signedUp':`Inscrit`,'dash.table.lastSeen':`Dernière Visite`,'dash.table.orders':`Commandes`,'dash.table.spend':`Dépense`,'dash.table.event':`Événement`,'dash.table.detail':`Détail`,'dash.table.month':`Mois`,'dash.table.delta':`Δ MoM`,'dash.table.asking':`Prix`,'dash.table.condition':`État`,'dash.table.listed':`Listé`,'dash.table.amount':`Montant`,'dash.table.order':`Commande`,
      'lang.label':`Langue`
    },
    de: {
      'nav.shop':`Shop`,'nav.sell':`Verkaufen`,'nav.about':`Über Uns`,'nav.sizeGuide':`Größenführer`,'nav.dashboard':`Dashboard`,'nav.browse':`Stöbern`,'nav.review':`Prüfstelle`,
      'announce.auth':`Kostenlose Authentifizierung`,'announce.ship':`Versicherter Versand in den USA`,'announce.consign':`Kommission Wird Angenommen`,
      'hero.eyebrow':`Kuratierter Pre-Owned Luxus`,'hero.script':`zeitlose`,'hero.headline.middle':`Stücke,`,'hero.headline.em':`verantwortungsvoll`,'hero.headline.end':`weiterverkauft.`,'hero.lead':`Ein Boutique-Kommissionshaus für die begehrtesten Handtaschen, Schmuckstücke und Kleidung der Welt. Jedes Stück handgeprüft, fotografiert und betreut.`,'hero.cta.shop':`Kollektion Ansehen`,'hero.cta.sell':`Mit Uns Verkaufen`,
      'tag.authenticated':`Authentifiziert`,'tag.consignor':`Kommissionär Geprüft`,'tag.insured':`Versicherter Versand`,
      'trust.auth':`Authentifiziert`,'trust.auth.sub':`Jedes Stück, handgeprüft`,'trust.secure':`Sicherer Checkout`,'trust.secure.sub':`SSL & PCI-konform`,'trust.insured':`Versicherte Lieferung`,'trust.insured.sub':`Voll versichert, von Tür zu Tür`,'trust.final':`Alle Verkäufe Endgültig`,'trust.final.sub':`Vertrauen in jedes Stück`,
      'designer.eyebrow':`Nach Haus Einkaufen`,'designer.title':`Die Häuser, Die Wir Lieben`,'designer.lead':`Geschätzte Namen, bezogen aus privaten Sammlungen und kuratiert für ihre Handwerkskunst, Geschichte und beständige Begehrtheit.`,
      'brand.comingSoon':`Demnächst`,'brand.comingSoonShort':`Demnächst`,'brand.piecesWord':`Stücke`,'brand.pieceWord':`Stück`,
      'showcase.eyebrow':`In Bewegung`,'showcase.title.start':`Sehen Sie es aus`,'showcase.title.em':`jedem Blickwinkel.`,'showcase.lead':`Jede Neuheit erhält die volle Behandlung — 360°-Video, Hardware-Nahaufnahmen, Innenenthüllung und Stempelüberprüfung. Weil Online-Luxus-Shopping sich wie die Boutique anfühlen sollte.`,'showcase.stat1':`Rundum-Ansicht`,'showcase.stat2':`Nahaufnahmen`,'showcase.stat3':`Ab Listing`,'showcase.featured':`Empfohlene Stücke · diese Woche`,'showcase.cta':`Neuheiten Kaufen`,'showcase.guide':`Hermès Größenführer`,
      'arrivals.eyebrow':`Gerade Eingetroffen`,'arrivals.title':`Neuheiten`,'arrivals.viewAll':`Alle Ansehen`,
      'editorial.eyebrow':`Unser Standard`,'editorial.title.start':`Authentifiziert durch Menschen,`,'editorial.title.em':`nicht Algorithmen.`,'editorial.body':`Unser Authentifizierungsteam verfügt über Jahrzehnte gemeinsamer Erfahrung mit seltenen Hermès-, Chanel- und Louis Vuitton-Stücken. Wir untersuchen Nähte, Hardware, Lederkörnung, Datumscodes und Herkunft — und stehen hinter jedem versendeten Stück.`,'editorial.stat1':`Authentifizierte Stücke`,'editorial.stat2':`Garantie`,'editorial.stat3':`Durchschn. Prüfung`,'editorial.cta':`Mehr Erfahren`,
      'social.eyebrow':`Folgen Sie Uns`,'social.title':`@CasaConsignment`,'social.lead':`Neuheiten, Hinter-den-Kulissen und Styling-Geschichten — teilen Sie Ihre mit #CasaStyled.`,
      'shop.crumbHome':`Startseite`,'shop.crumbAll':`Alle Shop`,'shop.title':`Kollektion Kaufen`,'shop.lead.start':`kuratierte Stücke — von Erbe-Handtaschen bis Feinschmuck.`,'shop.showing':`Anzeige`,'shop.of':`von`,'shop.sort':`Sortieren`,'shop.sort.newest':`Neueste`,'shop.sort.priceLow':`Preis: Aufsteigend`,'shop.sort.priceHigh':`Preis: Absteigend`,'shop.sort.coveted':`Begehrteste`,'shop.sort.alpha':`Designer A–Z`,
      'filter.designer':`Designer`,'filter.category':`Kategorie`,'filter.condition':`Zustand`,'filter.color':`Farbe`,'filter.price':`Preis`,'filter.clear':`Filter Löschen`,'sizeGuide.label':`Größenführer`,'sizeGuide.sub':`Hermès Birkin & Kelly · und mehr`,
      'sell.eyebrow':`Kommission Mit Casa`,'sell.title.start':`Verwandeln Sie Schrankschätze`,'sell.title.em':`in Ihr nächstes Kapitel.`,'sell.lead':`Senden Sie uns Fotos, akzeptieren Sie unser Angebot, versenden Sie versichert — alles auf unsere Kosten. Erwarten Sie eine durchdachte Antwort innerhalb von 48 Stunden von einem echten Spezialisten.`,'sell.step1.title':`Einreichen`,'sell.step1.sub':`Fotos, Zustand, Ihr Preis`,'sell.step2.title':`Prüfen`,'sell.step2.sub':`Wir authentifizieren & bieten`,'sell.step3.title':`Versenden`,'sell.step3.sub':`Vorausbezahlt, versichert`,'sell.step4.title':`Auszahlung`,'sell.step4.sub':`Banküberweisung bei Verkauf`,
      'tiers.eyebrow':`Transparente Auszahlungen`,'tiers.title':`Provisionsstufen`,'tiers.lead':`Ihre Auszahlung wächst mit dem endgültigen Verkaufspreis. Wir teilen die Berechnung im Voraus — keine Überraschungen, keine versteckten Abzüge.`,'tiers.payoutLabel':`Kommissionär-Auszahlung`,'tiers.topTier':`Top Stufe`,'tiers.commission':`Casa Provision`,
      'consignorCta.eyebrow':`Mit Casa verkaufen`,'consignorCta.title':`Erstellen Sie Ihr Verkäuferkonto.`,'consignorCta.lead':`Reichen Sie Ihr Stück online mit Fotos ein. Ein Casa-Spezialist prüft es und antwortet per E-Mail. Ihr Konto bündelt Bestellungen, Wunschliste und Mitgliedschaft an einem Ort.`,'consignorCta.cta':`Kommissionär Werden`,'consignorCta.alt':`Bereits registriert? Anmelden`,
      'demo.hintTitle':`Demo-Konten`,
      'modal.welcome':`Willkommen`,'modal.welcomeSub':`Anmelden oder Konto erstellen`,'modal.tab.signin':`Anmelden`,'modal.tab.shop':`Mit Uns Einkaufen`,'modal.tab.consignor':`Kommissionär Werden`,'modal.email':`E-Mail`,'modal.password':`Passwort`,'modal.forgot':`Passwort vergessen?`,'modal.signin':`Anmelden`,'modal.firstName':`Vorname`,'modal.lastName':`Nachname`,'modal.createPw':`Passwort wählen`,'modal.createAccount':`Konto Erstellen`,'modal.orContinue':`oder fortfahren mit`,'modal.google':`Mit Google fortfahren`,'modal.apple':`Mit Apple fortfahren`,
      'footer.shop':`Shop`,'footer.sell':`Verkaufen`,'footer.support':`Support`,'footer.stayInKnow':`Bleiben Sie Informiert`,'footer.subscribe':`Abonnieren`,'footer.rights':`Alle Rechte vorbehalten.`,
      'dash.viewingAs':`Ansicht als`,'dash.demo':`Demo-Modus`,
      'dash.section.orders':`Meine Bestellungen`,'dash.section.saved':`Gespeichert`,'dash.section.sales':`Verkaufsdashboard`,'dash.section.listings':`Meine Angebote`,'dash.section.payouts':`Auszahlungen`,'dash.section.tickets':`Tickets`,'dash.section.kpis':`Übersicht`,'dash.section.revenue':`Umsatz & Trends`,'dash.section.customers':`Kunden`,'dash.section.skulog':`SKU-Protokoll`,'dash.section.trends':`Wachstum`,'dash.section.profile':`Profil & Adresse`,'dash.section.cohorts':`Kohortenanalyse`,'dash.section.settings':`Einstellungen`,'dash.section.signout':`Abmelden`,
      'dash.kpi.items':`Verkaufte Artikel`,'dash.kpi.revenue':`Bruttoumsatz`,'dash.kpi.payout':`Ihre Auszahlung`,'dash.kpi.commission':`Casa Provision`,'dash.kpi.openTickets':`Offen`,'dash.kpi.inReview':`In Prüfung`,'dash.kpi.escalated':`Eskaliert`,'dash.kpi.resolved':`Gelöst · 7T`,'dash.kpi.totalCustomers':`Gesamtkunden`,'dash.kpi.active':`Aktiv`,'dash.kpi.inactive':`Inaktiv · 14T+`,'dash.kpi.avgSpend':`Durchschn. Ausgaben`,'dash.kpi.totalOrders':`Gesamtbestellungen`,'dash.kpi.inTransit':`Unterwegs`,'dash.kpi.lifetimeSpend':`Lebenslange Ausgaben`,'dash.kpi.savedItems':`Gespeichert`,'dash.kpi.activeListings':`Aktive Angebote`,'dash.kpi.avgDays':`Durchschn. Tage`,'dash.kpi.wishlist':`Wunschliste`,'dash.kpi.consignors':`Kommissionäre`,
      'dash.range':`Bereich`,'dash.range.all':`Gesamt`,'dash.range.7d':`7 Tage`,'dash.range.30d':`30 Tage`,'dash.range.90d':`Letztes Quartal`,'dash.range.ytd':`Jahr bis Datum`,
      'dash.table.date':`Datum`,'dash.table.sku':`SKU`,'dash.table.item':`Artikel`,'dash.table.sold':`Verkauft`,'dash.table.tier':`Stufe`,'dash.table.yourPct':`Ihr %`,'dash.table.payout':`Auszahlung`,'dash.table.status':`Status`,'dash.table.priority':`Priorität`,'dash.table.subject':`Betreff`,'dash.table.from':`Von`,'dash.table.user':`Benutzer`,'dash.table.age':`Alter`,'dash.table.ticket':`Ticket`,'dash.table.name':`Name`,'dash.table.email':`E-Mail`,'dash.table.signedUp':`Registriert`,'dash.table.lastSeen':`Zuletzt Gesehen`,'dash.table.orders':`Bestellungen`,'dash.table.spend':`Ausgaben`,'dash.table.event':`Ereignis`,'dash.table.detail':`Details`,'dash.table.month':`Monat`,'dash.table.delta':`Δ MoM`,'dash.table.asking':`Preis`,'dash.table.condition':`Zustand`,'dash.table.listed':`Gelistet`,'dash.table.amount':`Betrag`,'dash.table.order':`Bestellung`,
      'lang.label':`Sprache`
    },
    ja: {
      'nav.shop':`ショップ`,'nav.sell':`販売`,'nav.about':`私たちについて`,'nav.sizeGuide':`サイズガイド`,'nav.dashboard':`ダッシュボード`,'nav.browse':`閲覧`,'nav.review':`レビューデスク`,
      'announce.auth':`無料認証`,'announce.ship':`米国内 保険付き配送`,'announce.consign':`委託販売受付中`,
      'hero.eyebrow':`厳選された中古ラグジュアリー`,'hero.script':`時代を超えた`,'hero.headline.middle':`品々を、`,'hero.headline.em':`責任を持って`,'hero.headline.end':`再販。`,'hero.lead':`世界で最も憧れのハンドバッグ、ジュエリー、アパレルのためのブティック委託販売店。すべての品が手作業で認証、撮影、管理されています。`,'hero.cta.shop':`コレクションを見る`,'hero.cta.sell':`販売する`,
      'tag.authenticated':`認証済み`,'tag.consignor':`委託者承認`,'tag.insured':`保険付き配送`,
      'trust.auth':`認証済み`,'trust.auth.sub':`すべての品、手作業で検査`,'trust.secure':`安全な決済`,'trust.secure.sub':`SSL & PCI 準拠`,'trust.insured':`保険付き配送`,'trust.insured.sub':`完全補償、ドア・ツー・ドア`,'trust.final':`すべての販売最終`,'trust.final.sub':`一つひとつに自信`,
      'designer.eyebrow':`メゾンで選ぶ`,'designer.title':`私たちが愛するメゾン`,'designer.lead':`プライベートコレクションから厳選された貴重な名前。職人技、伝統、そして永続的な魅力で選ばれました。`,
      'brand.comingSoon':`近日入荷`,'brand.comingSoonShort':`近日入荷`,'brand.piecesWord':`点`,'brand.pieceWord':`点`,
      'showcase.eyebrow':`動きの中で`,'showcase.title.start':`あらゆる`,'showcase.title.em':`角度から見る。`,'showcase.lead':`すべての新着品に360°ビデオ、金具のクローズアップ、内装の公開、刻印確認の完全な処理。オンラインでのラグジュアリーショッピングがブティックのように感じられるべきだから。`,'showcase.stat1':`360°ビュー`,'showcase.stat2':`クローズアップ`,'showcase.stat3':`出品から`,'showcase.featured':`今週の注目品`,'showcase.cta':`新着品を見る`,'showcase.guide':`エルメスサイズガイド`,
      'arrivals.eyebrow':`入荷したばかり`,'arrivals.title':`新着品`,'arrivals.viewAll':`すべて見る`,
      'editorial.eyebrow':`私たちの基準`,'editorial.title.start':`人間による認証、`,'editorial.title.em':`アルゴリズムではなく。`,'editorial.body':`当社の認証チームは、稀少なエルメス、シャネル、ルイヴィトンの作品を扱う数十年の経験を持ちます。縫製、金具、革の質感、日付コード、由来を検査し、出荷するすべての品を保証します。`,'editorial.stat1':`認証品数`,'editorial.stat2':`保証`,'editorial.stat3':`平均レビュー時間`,'editorial.cta':`詳細を見る`,
      'social.eyebrow':`フォローする`,'social.title':`@CasaConsignment`,'social.lead':`新着、舞台裏、スタイリングストーリー — あなたのものを #CasaStyled で共有してください。`,
      'shop.crumbHome':`ホーム`,'shop.crumbAll':`すべてのショップ`,'shop.title':`コレクションを購入`,'shop.lead.start':`厳選された品々 — 伝統的なハンドバッグからファインジュエリーまで。`,'shop.showing':`表示`,'shop.of':`/`,'shop.sort':`並び替え`,'shop.sort.newest':`新着順`,'shop.sort.priceLow':`価格：低い順`,'shop.sort.priceHigh':`価格：高い順`,'shop.sort.coveted':`人気順`,'shop.sort.alpha':`デザイナーA–Z`,
      'filter.designer':`デザイナー`,'filter.category':`カテゴリー`,'filter.condition':`状態`,'filter.color':`色`,'filter.price':`価格`,'filter.clear':`フィルタークリア`,'sizeGuide.label':`サイズガイド`,'sizeGuide.sub':`エルメス・バーキン & ケリー · その他`,
      'sell.eyebrow':`Casa に委託`,'sell.title.start':`クローゼットの宝物を`,'sell.title.em':`次の章へ。`,'sell.lead':`写真を送って、当社のオファーを承諾、保険付きで配送 — すべて当社負担。本物の専門家から48時間以内に丁寧な返答を期待してください。`,'sell.step1.title':`提出`,'sell.step1.sub':`写真、状態、希望価格`,'sell.step2.title':`レビュー`,'sell.step2.sub':`認証と見積もり`,'sell.step3.title':`発送`,'sell.step3.sub':`前払い・保険付き`,'sell.step4.title':`入金`,'sell.step4.sub':`販売時に直接振込`,
      'tiers.eyebrow':`透明な支払い`,'tiers.title':`手数料階層`,'tiers.lead':`最終販売価格とともに支払いが増えます。前もって計算を共有 — 驚きなし、隠れた控除なし。`,'tiers.payoutLabel':`委託者の取り分`,'tiers.topTier':`最上階層`,'tiers.commission':`Casa 手数料`,
      'consignorCta.eyebrow':`Casaに委託する`,'consignorCta.title':`販売者アカウントを作成。`,'consignorCta.lead':`写真を添えてオンラインでお品物をお送りください。Casaのスペシャリストが確認し、メールでご連絡します。アカウントでは注文、ウィッシュリスト、メンバーシップをまとめて管理できます。`,'consignorCta.cta':`委託者になる`,'consignorCta.alt':`既に登録済み？サインイン`,
      'demo.hintTitle':`デモアカウント`,
      'modal.welcome':`ようこそ`,'modal.welcomeSub':`サインインまたはアカウント作成`,'modal.tab.signin':`サインイン`,'modal.tab.shop':`お買い物`,'modal.tab.consignor':`委託者になる`,'modal.email':`メール`,'modal.password':`パスワード`,'modal.forgot':`パスワードをお忘れですか？`,'modal.signin':`サインイン`,'modal.firstName':`名`,'modal.lastName':`姓`,'modal.createPw':`パスワードを選択`,'modal.createAccount':`アカウント作成`,'modal.orContinue':`または以下で続行`,'modal.google':`Google で続行`,'modal.apple':`Apple で続行`,
      'footer.shop':`ショップ`,'footer.sell':`販売`,'footer.support':`サポート`,'footer.stayInKnow':`最新情報を受け取る`,'footer.subscribe':`購読`,'footer.rights':`無断複写・転載を禁じます。`,
      'dash.viewingAs':`表示モード`,'dash.demo':`デモモード`,
      'dash.section.orders':`注文履歴`,'dash.section.saved':`保存済み`,'dash.section.sales':`販売ダッシュボード`,'dash.section.listings':`出品`,'dash.section.payouts':`支払い`,'dash.section.tickets':`チケット`,'dash.section.kpis':`概要`,'dash.section.revenue':`収益と傾向`,'dash.section.customers':`顧客`,'dash.section.skulog':`SKUログ`,'dash.section.trends':`成長`,'dash.section.profile':`プロフィール`,'dash.section.cohorts':`コホート分析`,'dash.section.settings':`設定`,'dash.section.signout':`サインアウト`,
      'dash.kpi.items':`販売数`,'dash.kpi.revenue':`総収益`,'dash.kpi.payout':`あなたの取り分`,'dash.kpi.commission':`Casa手数料`,'dash.kpi.openTickets':`未対応`,'dash.kpi.inReview':`レビュー中`,'dash.kpi.escalated':`エスカレーション`,'dash.kpi.resolved':`解決済み · 7日`,'dash.kpi.totalCustomers':`総顧客数`,'dash.kpi.active':`アクティブ`,'dash.kpi.inactive':`非アクティブ · 14日+`,'dash.kpi.avgSpend':`平均支出`,'dash.kpi.totalOrders':`総注文数`,'dash.kpi.inTransit':`輸送中`,'dash.kpi.lifetimeSpend':`生涯支出`,'dash.kpi.savedItems':`保存数`,'dash.kpi.activeListings':`有効な出品`,'dash.kpi.avgDays':`平均日数`,'dash.kpi.wishlist':`ウィッシュリスト`,'dash.kpi.consignors':`委託者`,
      'dash.range':`期間`,'dash.range.all':`すべて`,'dash.range.7d':`7日間`,'dash.range.30d':`30日間`,'dash.range.90d':`前四半期`,'dash.range.ytd':`年初来`,
      'dash.table.date':`日付`,'dash.table.sku':`SKU`,'dash.table.item':`商品`,'dash.table.sold':`販売額`,'dash.table.tier':`階層`,'dash.table.yourPct':`あなたの%`,'dash.table.payout':`支払い`,'dash.table.status':`状態`,'dash.table.priority':`優先度`,'dash.table.subject':`件名`,'dash.table.from':`発信元`,'dash.table.user':`ユーザー`,'dash.table.age':`経過時間`,'dash.table.ticket':`チケット`,'dash.table.name':`名前`,'dash.table.email':`メール`,'dash.table.signedUp':`登録日`,'dash.table.lastSeen':`最終訪問`,'dash.table.orders':`注文数`,'dash.table.spend':`支出`,'dash.table.event':`イベント`,'dash.table.detail':`詳細`,'dash.table.month':`月`,'dash.table.delta':`前月比`,'dash.table.asking':`希望価格`,'dash.table.condition':`状態`,'dash.table.listed':`出品日`,'dash.table.amount':`金額`,'dash.table.order':`注文`,
      'lang.label':`言語`
    },
    zh: {
      'nav.shop':`购物`,'nav.sell':`出售`,'nav.about':`关于`,'nav.sizeGuide':`尺码指南`,'nav.dashboard':`仪表板`,'nav.browse':`浏览`,'nav.review':`审核台`,
      'announce.auth':`免费鉴定`,'announce.ship':`美国境内保险配送`,'announce.consign':`接受寄售中`,
      'hero.eyebrow':`精选二手奢侈品`,'hero.script':`永恒`,'hero.headline.middle':`之作，`,'hero.headline.em':`负责任地`,'hero.headline.end':`转售。`,'hero.lead':`专注于世界最受追捧的手袋、珠宝和服装的精品寄售屋。每件作品都经过手工鉴定、拍摄和精心管理。`,'hero.cta.shop':`选购系列`,'hero.cta.sell':`与我们一起出售`,
      'tag.authenticated':`已鉴定`,'tag.consignor':`寄售者批准`,'tag.insured':`保险配送`,
      'trust.auth':`已鉴定`,'trust.auth.sub':`每件作品手工检查`,'trust.secure':`安全结账`,'trust.secure.sub':`SSL 与 PCI 合规`,'trust.insured':`保险配送`,'trust.insured.sub':`全额承保，门到门`,'trust.final':`所有销售最终`,'trust.final.sub':`每件作品都自信`,
      'designer.eyebrow':`按品牌选购`,'designer.title':`我们钟爱的品牌`,'designer.lead':`珍贵的名字，来自私人收藏，因其工艺、传承和持久的吸引力而精选。`,
      'brand.comingSoon':`即将推出`,'brand.comingSoonShort':`即将推出`,'brand.piecesWord':`件`,'brand.pieceWord':`件`,
      'showcase.eyebrow':`动态展示`,'showcase.title.start':`从`,'showcase.title.em':`每个角度欣赏。`,'showcase.lead':`每件新品都获得完整待遇 — 360°视频、五金特写、内饰展示和印记验证。因为在线奢侈品购物应该有精品店的感觉。`,'showcase.stat1':`360°视图`,'showcase.stat2':`特写`,'showcase.stat3':`上架起`,'showcase.featured':`本周精选`,'showcase.cta':`选购新品`,'showcase.guide':`爱马仕尺码指南`,
      'arrivals.eyebrow':`刚到货`,'arrivals.title':`新品`,'arrivals.viewAll':`查看全部`,
      'editorial.eyebrow':`我们的标准`,'editorial.title.start':`由人鉴定，`,'editorial.title.em':`非算法。`,'editorial.body':`我们的鉴定团队在处理稀有爱马仕、香奈儿和路易威登作品方面有数十年的综合经验。我们检查缝线、五金、皮革纹理、日期代码和来源 — 并对发出的每一件作品负责。`,'editorial.stat1':`已鉴定作品`,'editorial.stat2':`保证`,'editorial.stat3':`平均审核`,'editorial.cta':`了解更多`,
      'social.eyebrow':`关注我们`,'social.title':`@CasaConsignment`,'social.lead':`新品、幕后花絮和搭配故事 — 用 #CasaStyled 分享您的故事。`,
      'shop.crumbHome':`首页`,'shop.crumbAll':`全部商品`,'shop.title':`选购系列`,'shop.lead.start':`精选作品 — 从传统手袋到精品珠宝。`,'shop.showing':`显示`,'shop.of':`共`,'shop.sort':`排序`,'shop.sort.newest':`最新`,'shop.sort.priceLow':`价格：从低到高`,'shop.sort.priceHigh':`价格：从高到低`,'shop.sort.coveted':`最受欢迎`,'shop.sort.alpha':`设计师 A–Z`,
      'filter.designer':`设计师`,'filter.category':`类别`,'filter.condition':`状况`,'filter.color':`颜色`,'filter.price':`价格`,'filter.clear':`清除筛选`,'sizeGuide.label':`尺码指南`,'sizeGuide.sub':`爱马仕铂金 & 凯莉 · 等`,
      'sell.eyebrow':`与 Casa 寄售`,'sell.title.start':`将衣柜中的珍藏`,'sell.title.em':`变成下一篇章。`,'sell.lead':`发送照片、接受报价、保险发货 — 全部由我们承担。期待真正的专家在48小时内做出周到回复。`,'sell.step1.title':`提交`,'sell.step1.sub':`照片、状况、您的价格`,'sell.step2.title':`审核`,'sell.step2.sub':`我们鉴定并报价`,'sell.step3.title':`发货`,'sell.step3.sub':`预付，保险`,'sell.step4.title':`付款`,'sell.step4.sub':`售出时直接存款`,
      'tiers.eyebrow':`透明支付`,'tiers.title':`佣金等级`,'tiers.lead':`您的收益随最终售价增长。我们提前分享计算 — 无意外，无隐藏扣除。`,'tiers.payoutLabel':`寄售者收益`,'tiers.topTier':`顶级`,'tiers.commission':`Casa 佣金`,
      'consignorCta.eyebrow':`委托 Casa 寄售`,'consignorCta.title':`创建您的卖家账户。`,'consignorCta.lead':`在线提交您的物品及照片，Casa 专家将审核并通过电子邮件回复您。您的账户集中管理订单、心愿单和会员资格。`,'consignorCta.cta':`成为寄售者`,'consignorCta.alt':`已注册？登录`,
      'demo.hintTitle':`演示账户`,
      'modal.welcome':`欢迎`,'modal.welcomeSub':`登录或创建账户`,'modal.tab.signin':`登录`,'modal.tab.shop':`与我们购物`,'modal.tab.consignor':`成为寄售者`,'modal.email':`邮箱`,'modal.password':`密码`,'modal.forgot':`忘记密码？`,'modal.signin':`登录`,'modal.firstName':`名`,'modal.lastName':`姓`,'modal.createPw':`选择密码`,'modal.createAccount':`创建账户`,'modal.orContinue':`或继续`,'modal.google':`使用 Google 继续`,'modal.apple':`使用 Apple 继续`,
      'footer.shop':`购物`,'footer.sell':`出售`,'footer.support':`支持`,'footer.stayInKnow':`保持联系`,'footer.subscribe':`订阅`,'footer.rights':`保留所有权利。`,
      'dash.viewingAs':`查看为`,'dash.demo':`演示模式`,
      'dash.section.orders':`我的订单`,'dash.section.saved':`收藏`,'dash.section.sales':`销售仪表板`,'dash.section.listings':`我的商品`,'dash.section.payouts':`付款`,'dash.section.tickets':`工单`,'dash.section.kpis':`概览`,'dash.section.revenue':`收入与趋势`,'dash.section.customers':`客户`,'dash.section.skulog':`SKU 日志`,'dash.section.trends':`增长趋势`,'dash.section.profile':`个人资料`,'dash.section.cohorts':`群组分析`,'dash.section.settings':`设置`,'dash.section.signout':`退出`,
      'dash.kpi.items':`已售商品`,'dash.kpi.revenue':`总收入`,'dash.kpi.payout':`您的收益`,'dash.kpi.commission':`Casa 佣金`,'dash.kpi.openTickets':`打开`,'dash.kpi.inReview':`审核中`,'dash.kpi.escalated':`已升级`,'dash.kpi.resolved':`已解决 · 7天`,'dash.kpi.totalCustomers':`客户总数`,'dash.kpi.active':`活跃`,'dash.kpi.inactive':`非活跃 · 14天+`,'dash.kpi.avgSpend':`平均消费`,'dash.kpi.totalOrders':`订单总数`,'dash.kpi.inTransit':`运输中`,'dash.kpi.lifetimeSpend':`终身消费`,'dash.kpi.savedItems':`收藏`,'dash.kpi.activeListings':`有效商品`,'dash.kpi.avgDays':`平均天数`,'dash.kpi.wishlist':`愿望清单`,'dash.kpi.consignors':`寄售者`,
      'dash.range':`范围`,'dash.range.all':`全部`,'dash.range.7d':`7天`,'dash.range.30d':`30天`,'dash.range.90d':`上季度`,'dash.range.ytd':`年初至今`,
      'dash.table.date':`日期`,'dash.table.sku':`SKU`,'dash.table.item':`商品`,'dash.table.sold':`已售`,'dash.table.tier':`等级`,'dash.table.yourPct':`您的%`,'dash.table.payout':`收益`,'dash.table.status':`状态`,'dash.table.priority':`优先级`,'dash.table.subject':`主题`,'dash.table.from':`来自`,'dash.table.user':`用户`,'dash.table.age':`时长`,'dash.table.ticket':`工单`,'dash.table.name':`姓名`,'dash.table.email':`邮箱`,'dash.table.signedUp':`注册日`,'dash.table.lastSeen':`最后访问`,'dash.table.orders':`订单`,'dash.table.spend':`消费`,'dash.table.event':`事件`,'dash.table.detail':`详情`,'dash.table.month':`月份`,'dash.table.delta':`环比`,'dash.table.asking':`要价`,'dash.table.condition':`状况`,'dash.table.listed':`上架`,'dash.table.amount':`金额`,'dash.table.order':`订单`,
      'lang.label':`语言`
    }
  };

  let currentLang = 'en';
  function t(key) { return (I18N[currentLang] && I18N[currentLang][key]) || I18N.en[key] || key; }

  function applyI18n() {
    document.querySelectorAll('[data-i18n]').forEach(el => {
      const key = el.getAttribute('data-i18n');
      const tr = t(key);
      if (tr) {
        // Preserve children spans with their own translations
        if (el.children.length === 0) el.textContent = tr;
        else {
          // Replace only top-level text nodes
          let replaced = false;
          el.childNodes.forEach(n => {
            if (n.nodeType === 3 && !replaced && n.textContent.trim()) { n.textContent = tr; replaced = true; }
          });
          if (!replaced) el.textContent = tr;
        }
      }
    });
    // Update placeholders
    document.querySelectorAll('[data-i18n-placeholder]').forEach(el => {
      el.placeholder = t(el.getAttribute('data-i18n-placeholder'));
    });
  }

  // Mark elements by selector → i18n key (after DOM exists)
  function tagI18n() {
    const tagMap = [
      // Nav
      ['.nav-left .nav-link:nth-child(1)', 'nav.shop'],
      ['.nav-left .nav-link:nth-child(2)', 'nav.sell'],
      ['.nav-left .nav-link:nth-child(3)', 'nav.about'],
      ['.nav-left .nav-link:nth-child(4)', 'nav.dashboard'],
      // Footer
      ['.footer-col:nth-child(2) h4', 'footer.shop'],
      ['.footer-col:nth-child(3) h4', 'footer.sell'],
      ['.footer-col:nth-child(4) h4', 'footer.support'],
      ['.footer-col:nth-child(5) h4', 'footer.stayInKnow'],
      // Scoped to exclude .newsletter-cta ("Inside Casa" section, ~line 2196):
      // it reuses .footer-newsletter for its /api/subscribe wiring, but has its
      // own copy ("Join Inside Casa") that this generic footer tag was silently
      // overwriting with "Subscribe" on every load — found 27 Aug 2026 while
      // confirming the Newsletter redesign actually renders as written.
      ['.footer-newsletter:not(.newsletter-cta .footer-newsletter) button', 'footer.subscribe'],
    ];
    tagMap.forEach(([sel, key]) => {
      document.querySelectorAll(sel).forEach(el => el.setAttribute('data-i18n', key));
    });
    // Tag by exact English text (more elements)
    const byText = {
      'Shop': `nav.shop`, 'Sell': `nav.sell`, 'About': `nav.about`, 'Size Guide': 'nav.sizeGuide',
      'Browse': `nav.browse`, 'Review Desk': 'nav.review', 'Dashboard': `nav.dashboard`,
      'Shop the Collection': 'showcase.cta',
      'Sell With Us': 'hero.cta.sell',
      'View All →': 'arrivals.viewAll', 'Learn More': 'editorial.cta',
      'Subscribe': `footer.subscribe`,
      'Become a Consignor': 'consignorCta.cta',
      'Already registered? Sign in': 'consignorCta.alt',
      'Clear Filters': 'filter.clear',
      'Sign In': 'modal.signin', 'Create Account': 'modal.createAccount',
      'or continue with': 'modal.orContinue',
      'Continue with Google': 'modal.google', 'Continue with Apple': 'modal.apple'
    };
    document.querySelectorAll('button, a, h3, h4, span, label, div').forEach(el => {
      const txt = el.textContent.trim();
      if (byText[txt] && el.children.length === 0 && !el.hasAttribute('data-i18n')) {
        el.setAttribute('data-i18n', byText[txt]);
      }
    });
  }

  function setLanguage(lang) {
    currentLang = lang;
    applyI18n();
    // Re-render brand cards (count words may change)
    renderDesignerCards();
    renderBrandFilters();
    document.documentElement.lang = lang;
    showToast(`Language: ${LANG_LABELS[lang]}`);
  }

  const LANG_LABELS = { en:'English', es:'Español', fr:'Français', de:'Deutsch', ja:'日本語', zh:'中文' };

  // Inject language switcher into header
  function injectLangSwitcher() {
    const navRight = document.querySelector('.nav-right');
    if (!navRight) return;
    const wrap = document.createElement('div');
    wrap.style.cssText = 'position:relative; margin-right:8px;';
    wrap.innerHTML = `
      <button class="icon-btn lang-btn" title="Language" id="lang-btn" style="font-size:11px; letter-spacing:0.16em; text-transform:uppercase; width:auto; padding:0 12px; gap:6px;">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18"/></svg>
        <span id="lang-current">EN</span>
      </button>
      <div id="lang-menu" style="position:absolute; top:48px; right:0; background:#fff; border:1px solid var(--line); border-radius:2px; min-width:170px; box-shadow:var(--shadow-md); display:none; z-index:200; padding:6px 0;">
        ${Object.entries(LANG_LABELS).map(([code, label]) => `
          <div class="lang-option" data-lang="${code}" style="padding:10px 16px; cursor:pointer; font-size:13px; color:var(--navy); transition:background 0.15s; display:flex; justify-content:space-between; align-items:center;">
            <span>${label}</span>
            <span style="font-family:'Courier New', monospace; font-size:10px; color:var(--muted); letter-spacing:0.18em;">${code.toUpperCase()}</span>
          </div>
        `).join('')}
      </div>
    `;
    navRight.insertBefore(wrap, navRight.firstChild);
    const btn = wrap.querySelector('#lang-btn');
    const menu = wrap.querySelector('#lang-menu');
    btn.addEventListener('click', (e) => { e.stopPropagation(); menu.style.display = menu.style.display === 'none' ? 'block' : 'none'; });
    document.addEventListener('click', () => { menu.style.display = 'none'; });
    wrap.querySelectorAll('.lang-option').forEach(opt => {
      opt.addEventListener('mouseenter', () => opt.style.background = 'var(--bg)');
      opt.addEventListener('mouseleave', () => opt.style.background = '');
      opt.addEventListener('click', (e) => {
        e.stopPropagation();
        const code = opt.dataset.lang;
        document.getElementById('lang-current').textContent = code.toUpperCase();
        menu.style.display = 'none';
        setLanguage(code);
      });
    });
  }
  injectLangSwitcher();
  tagI18n();
  applyI18n();




  // =============================================================
  // LOGO SIZE BUMP + COMPLETE i18n COVERAGE
  // =============================================================
  (function() {
    const style = document.createElement('style');
    style.textContent = `
      /* Logo at rest is 3x the original 84 / 68 / 56 — the 2x pass, then +50%.
         This mark is ONLY ever shown on subpages: switchView() puts
         body.portal-mode on the home view, and that rule hides
         header.site-header entirely, so the landing keeps its own portal mark
         at its own size. (No backticks in this comment — it lives inside a
         template literal and a stray one silently kills the whole style block.)

         The header is position:sticky, so holding 252px for the whole session
         would permanently cost ~28% of a 900px viewport. So it sits at full
         size at the top of every subpage, then compacts once the reader starts
         scrolling. Compact is still well above the original resting size
         (138 vs 84, 114 vs 68, 93 vs 56), so the mark is bigger than it has
         ever been at every scroll position. */
      /* ⚠️ The header and drawer use logo-header.png, NOT logo.png.
         logo.png is a 1280x1280 SQUARE canvas whose artwork is only 880x596 —
         68.8% of the width and 46.6% of the height, with 414 blank pixels
         above the mark and 270 below. Sizing that by height means over half
         the box is empty air, which is why the mark read as small and thin no
         matter how large the number got. logo-header.png is the same artwork
         cropped to 900x616 (ratio 1.461) with a 10px margin and nothing
         clipped. The landing keeps logo.png: the intro loader, the portal mark
         and the showcase corner are all built around the square canvas.

         Every height below was rescaled by 0.4813 (596/1280 over 596/616) so
         the VISIBLE mark stays exactly the size it was before the crop on
         desktop and tablet. The headers get shorter because the empty pixels
         are gone, not because the logo shrank. Phones are deliberately larger,
         see the 640px block.

         object-fit + aspect-ratio + flex-shrink:0 are the anti-squish guards.
         The bug this replaces: .logo-mark is display:flex, so an img with a
         fixed height and width:auto is a flex item whose auto width SHRINKS
         when the row runs out of room while its fixed height cannot — the mark
         was rendering ~55px wide in a 112px box on a phone, a 2:1 horizontal
         crush that smeared the wordmark into a blur. With object-fit:contain
         the artwork letterboxes instead of stretching even if a future rule
         forces a wrong box. */
      .logo-mark img.header-logo-img {
        height: 121px !important; width: auto !important;
        aspect-ratio: 900 / 616;
        object-fit: contain;
        flex: 0 0 auto;
        transition: height 280ms cubic-bezier(0.22, 1, 0.36, 1),
                    width  280ms cubic-bezier(0.22, 1, 0.36, 1);
      }
      .logo-mark:hover img.header-logo-img { transform: scale(1.03); }
      .nav-row {
        padding-top: 12px; padding-bottom: 12px;
        transition: padding 280ms cubic-bezier(0.22, 1, 0.36, 1);
      }
      .site-header.is-compact .logo-mark img.header-logo-img { height: 66px !important; }
      .site-header.is-compact .nav-row { padding-top: 8px; padding-bottom: 8px; }

      @media (max-width: 1024px) {
        .logo-mark img.header-logo-img { height: 98px !important; }
        .site-header.is-compact .logo-mark img.header-logo-img { height: 55px !important; }
      }
      @media (max-width: 640px) {
        /* ⚠️ logo.png is 1280x1280 — SQUARE. Height and width are the same
           number, so on a phone the mark competes for HORIZONTAL room, and it
           loses. Measured at 390px: the row is 336px of usable width, and the
           controls take [menu 38] + [language 66 + 3 icons 114 + gaps] = 250 of
           it. The centre track is left with 66px. A single-row header cannot
           show a 168px mark; it cannot honestly show the 112px one that is
           there today either, which is why the phone header is already
           overstuffed.

           So on phones the logo gets its OWN row, centred under the controls —
           the same centred-logo/flanking-controls arrangement as desktop, just
           stacked. That hands it the full 336px instead of 66. Width-driven,
           not height-driven: width is the axis that can overflow here, and
           capping the axis that overflows is what makes it impossible to
           break the row.

           300 is the phone-only figure and it is measured in CROPPED pixels,
           so nearly all of it is artwork: the visible mark goes from ~105
           device px wide in production to ~293. min() lets it fall back to the
           row width on a 320px device rather than overflow. */
           SUPERSEDED 6 Aug 2026 (phones only, per Erich): the mark goes back
           INLINE on a single row, immediately to the right of the menu button,
           so the brand anchors the top-left corner instead of banner-ing across
           a second row. Everything above still describes the constraint
           correctly — a phone row genuinely cannot spare 300px — so the way
           this is paid for is the chrome around it, not the mark:
             grid gap    24 -> 8    (saves 32)
             row padding 18 -> 10 a side (saves 16)
             icon btns   38 -> 32   (x4 incl. language, saves 24)
             control gap  8 -> 4    (saves ~18 across both clusters)
             lang padding 12 -> 6 a side (saves 12)
           Budget on the WORST case, a 360px device: 340 usable - [menu 32] -
           [lang ~50 + 3 icons 96 + gaps 12] - [grid gaps 16] = ~134px of track
           for a 112px mark. Every wider phone has more. The 100% term in the
           min() is the safety net, not the operating point — if a future
           control lands in this row the mark shrinks instead of the row
           overflowing, and min-width:0 on .logo-mark is what allows that (the
           1fr track will not shrink below content without it).

           112px wide is 76px tall at the 900x616 ratio — SMALLER than the 98px
           the mark already renders at on tablet, and the single row makes the
           sticky band roughly half its two-row height. Nothing outside this
           block moved: desktop keeps 121/66 and tablet keeps 98/55. */
        .nav-row {
          grid-template-columns: auto 1fr auto;
          align-items: center;
          gap: 8px;
          padding: 8px 10px;
        }
        /* The controls have to give the room back, or the 1fr track collapses
           and the mark renders ~30px wide on a 360px device — verified, it is
           what the first attempt at this did. 38px taps become 32px (still
           above the 24px WCAG 2.2 AA target-size floor and inside a 40px row,
           so nothing gets harder to hit) and the language button's INLINE
           padding is overridden, which needs !important because it is set as a
           style attribute in the injector near index.html:4676. */
        .nav-left, .nav-right { gap: 4px; }
        .nav-row .icon-btn { width: 32px; height: 32px; }
        .nav-right .lang-btn { padding: 0 6px !important; gap: 4px !important; }
        .logo-mark { justify-content: flex-start; min-width: 0; }
        .logo-mark img.header-logo-img {
          height: auto !important;
          width: min(112px, 100%) !important;
        }
        .site-header.is-compact .nav-row { padding: 6px 10px; }
        .site-header.is-compact .logo-mark img.header-logo-img {
          height: auto !important;
          width: min(88px, 100%) !important;
        }
      }
      /* The compaction is a size change, not decoration: it must still happen
         without motion, just instantly. */
      @media (prefers-reduced-motion: reduce) {
        .logo-mark img.header-logo-img,
        .nav-row { transition: none !important; }
      }
    `;
    document.head.appendChild(style);

    // Drives the resting/compact states above. Threshold is 48px with a 24px
    // release, so the header can't flutter when a reader hovers the boundary.
    // rAF-throttled: scroll fires far more often than paint, and this changes
    // layout.
    //
    // ⚠️ This page scrolls on <body> (body has overflow-y:auto), NOT on the
    // window, so window.scrollY is permanently 0 here and a window-only
    // listener never fires. Read all three offsets and listen on both targets —
    // scroll does not bubble, so binding one is not enough.
    (function headerCompaction() {
      const header = document.querySelector('header.site-header');
      if (!header) return;
      let compact = false, ticking = false;
      const offset = () => window.scrollY
        || document.documentElement.scrollTop
        || document.body.scrollTop
        || 0;
      const apply = () => {
        const y = offset();
        if (!compact && y > 48) { compact = true; header.classList.add('is-compact'); }
        else if (compact && y < 24) { compact = false; header.classList.remove('is-compact'); }
        ticking = false;
      };
      const onScroll = () => {
        if (!ticking) { ticking = true; window.requestAnimationFrame(apply); }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      document.body.addEventListener('scroll', onScroll, { passive: true });
      // Deep links and reloads can restore a scrolled position before this runs,
      // which would otherwise show a full-height header over mid-page content.
      apply();
    })();
  })();

  // =============================================================
  // Expand dictionaries with ALL missing strings
  // =============================================================
  const EXTRA_I18N = {
    en: {
      // HTML-aware (innerHTML) translations for complex headings
      'hero.headlineHTML': `<span class="script">timeless</span>pieces, <em>responsibly</em><br>resold.`,
      'sell.titleHTML': `Turn closet treasures<br>into <em>your next chapter.</em>`,
      'editorial.titleHTML': `Authenticated by people, <em>not algorithms.</em>`,
      'showcase.titleHTML': `See it from <em>every angle.</em>`,
      'about.titleHTML': `Welcome to <em>Casa Consignment.</em>`,
      'arrivals.viewAllArrow': `View All →`,
      // Common phrases
      'common.signinLink': `Sign In`,
      'common.continueShopping': `Continue Shopping`,
      'common.checkout': `Checkout →`,
      'common.addToBag': `Add to Bag`,
      'common.saveWishlist': `♡ Save to Wishlist`,
      'common.viewCertificate': `View Certificate`,
      'common.viewProduct': `View Product`,
      // Section eyebrows + headings
      'arrivals.eyebrow': `Just In`,
      'arrivals.title': `New Arrivals`,
      'showcase.eyebrow': `In Motion`,
      'editorial.eyebrow': `Our Standard`,
      'social.eyebrow': `Follow Along`,
      'designer.eyebrow': `Shop by Maison`,
      'designer.title': `The Houses We Love`,
      'tiers.eyebrow': `Transparent Payouts`,
      'tiers.title': `Commission Tiers`,
      'consignorCta.eyebrow': `Consign with Casa`,
      // Shop
      'shop.titleFull': `Shop the Collection`,
      'shop.leadFull': `Curated pieces, from heritage handbags to fine jewelry.`,
      'shop.crumbAll': `Shop All`,
      'shop.crumbHome': `Home`,
      // Filter categories
      'cat.handbags': `Handbags`, 'cat.jewelry': `Jewelry`, 'cat.accessories': `Accessories`, 'cat.apparel': `Apparel`,
      'cond.pristine': `Pristine`, 'cond.excellent': `Excellent`, 'cond.veryGood': `Very Good`, 'cond.good': `Good`,
      'cond.new': `New`, 'cond.fair': `Fair`,
      // Sell form
      'sell.formTitle': `Start a Consignment Request`,
      'sell.formSub': `Tell us about your piece. The more detail, the faster we can respond.`,
      'sell.step.item': `Item`, 'sell.step.photos': `Photos`, 'sell.step.price': `Price & You`, 'sell.step.done': `Done`,
      'sell.field.brand': `Designer / Brand`, 'sell.field.category': `Category`, 'sell.field.model': `Model / Style`, 'sell.field.year': `Year Purchased`, 'sell.field.condition': `Condition`, 'sell.field.color': `Original Color`, 'sell.field.notes': `Notes & Provenance`,
      'sell.photo.instructions': `Upload one clear photo of each angle — the same five views Casa photographs for every live listing.`, 'sell.photo.front': `Front`, 'sell.photo.rear': `Rear`, 'sell.photo.side': `Side`, 'sell.photo.bottom': `Bottom`, 'sell.photo.inside': `Inside`, 'sell.photo.extraTitle': `Add more photos (optional)`, 'sell.photo.extraSub': `JPG, PNG up to 10MB each · Up to 7 extra photos`,
      'sell.back': `← Back`, 'sell.continue': `Continue →`, 'sell.submit': `Submit Request →`,
      // About
      'about.eyebrow': `Club`,
      'about.lead': `Welcome to a private world of timeless luxury, where exceptional taste, authenticity, and effortless sophistication come together.`,
      'about.lead2': `Discover authentic designer handbags, from coveted vintage treasures to the latest must-have styles. Whether you're searching for a rare statement piece, a classic investment bag, or a like-new designer find, our carefully curated collection offers something extraordinary for every discerning collector.`,
      'about.card1.title': `Authenticity, Guaranteed`,
      'about.card1.body': `Every piece is examined by our in-house specialists against rigorous criteria — hardware, stitching, leather, date stamps. If we cannot authenticate, we will not list.`,
      'about.card2.title': `Thoughtful Pace`,
      'about.card2.body': `We respond to consignment submissions within 48 hours from a real person — not a queue. The same care goes into every piece we ship.`,
      'about.card3.title': `Sustainable by Nature`,
      'about.card3.body': `Resale is the most beautiful kind of sustainability. Every piece we re-home keeps craftsmanship in circulation and waste out of the bin.`,
      // Checkout
      'checkout.title': `Checkout`, 'checkout.contact': `Contact`, 'checkout.shipping': `Shipping Address`, 'checkout.method': `Shipping Method`, 'checkout.payment': `Payment`,
      'checkout.firstName': `First Name`, 'checkout.lastName': `Last Name`, 'checkout.street': `Street Address`, 'checkout.city': `City`, 'checkout.state': `State / Region`, 'checkout.postal': `Postal Code`, 'checkout.country': `Country`,
      'checkout.standard': `Insured Standard`, 'checkout.standardSub': `3–5 business days · fully insured`, 'checkout.express': `Insured Express`, 'checkout.expressSub': `1–2 business days · signature required`, 'checkout.whiteGlove': `White Glove`, 'checkout.whiteGloveSub': `Hand-delivered in So Cal · by appointment`,
      'checkout.placeOrder': `Place Order`, 'checkout.subtotal': `Subtotal`, 'checkout.shipping2': `Shipping`, 'checkout.tax': `Estimated Tax`, 'checkout.total': `Total`, 'checkout.summary': `Order Summary`,
      // Cart
      'cart.title': `Your Bag`, 'cart.empty': `Your bag is empty.`, 'cart.authIncluded': `Authentication Included`,
      // Footer
      'footer.allHandbags': `All Handbags`, 'footer.newArrivals': `New Arrivals`, 'nav.newIn': `New In`,
      'footer.startRequest': `Start a Request`, 'footer.howItWorks': `How It Works`, 'footer.terms': `Consignment Terms`, 'footer.whatAccept': `What We Accept`, 'footer.payouts': `Payouts`,
      'footer.contact': `Contact Us`, 'footer.shipReturn': `Shipping`, 'footer.auth': `Authentication`, 'footer.faq': `FAQ`, 'footer.care': `Care Guide`,
      'footer.tos': `Terms of Service`, 'footer.privacy': `Privacy Policy`, 'footer.cookies': `Cookie Preferences`, 'footer.access': `Accessibility`, 'footer.authGuarantee': `Authenticity Guarantee`,
      'footer.newsletterLead': `New arrivals, private previews, and styling notes — straight to your inbox.`, 'footer.emailPlaceholder': `Your email address`,
      // Showcase
      'showcase.stat1Big': `360°`, 'showcase.stat1Sub': `Walk-around`,
      'showcase.stat2Big': `HD`, 'showcase.stat2Sub': `Close-ups`,
      'showcase.stat3Big': `48hr`, 'showcase.stat3Sub': `From listing`,
      // Editorial
      'editorial.stat1Big': `12,400+`,
      'editorial.stat2Big': `100%`,
      'editorial.stat3Big': `48hr`,
      // Tiers footer note
      'tiers.note': `Payouts are based on the item's final selling price. Items priced under $100 are accepted at our discretion. See the Consignment Agreement for full terms.`,
      // Tier card payout label (already had key tiers.payoutLabel)
      // Misc small
      'view.product': `View Product`,
      'qv.condition': `Condition`, 'qv.hardware': `Hardware`, 'qv.year': `Year`, 'qv.includes': `Includes`,
      'qv.includesValue': `Full set`,
    },
    es: {
      'hero.headlineHTML': `<span class="script">piezas</span>atemporales,<br><em>revendidas</em> con responsabilidad.`,
      'sell.titleHTML': `Convierte los tesoros del clóset<br>en <em>tu próximo capítulo.</em>`,
      'editorial.titleHTML': `Autenticado por personas, <em>no algoritmos.</em>`,
      'showcase.titleHTML': `Mírala desde <em>todos los ángulos.</em>`,
      'about.titleHTML': `Bienvenido a <em>Casa Consignment.</em>`,
      'arrivals.viewAllArrow': `Ver Todo →`,
      'common.signinLink': `Iniciar Sesión`,
      'common.continueShopping': `Seguir Comprando`,
      'common.checkout': `Pagar →`,
      'common.addToBag': `Añadir al Bolso`,
      'common.saveWishlist': `♡ Guardar en Favoritos`,
      'common.viewCertificate': `Ver Certificado`,
      'common.viewProduct': `Ver Producto`,
      'arrivals.eyebrow': `Recién Llegado`,'arrivals.title': `Nuevas Llegadas`,
      'showcase.eyebrow': `En Movimiento`,'editorial.eyebrow': `Nuestro Estándar`,'social.eyebrow': `Síguenos`,
      'designer.eyebrow': `Compra por Maison`,'designer.title': `Las Casas que Amamos`,
      'tiers.eyebrow': `Pagos Transparentes`,'tiers.title': `Niveles de Comisión`,
      'consignorCta.eyebrow': `Consigna con Casa`,
      'shop.titleFull': `Comprar la Colección`,'shop.leadFull': `Piezas curadas, desde bolsos de patrimonio hasta joyería fina.`,
      'shop.crumbAll': `Toda la Tienda`,'shop.crumbHome': `Inicio`,
      'cat.handbags': `Bolsos`,'cat.jewelry': `Joyería`,'cat.accessories': `Accesorios`,'cat.apparel': `Ropa`,
      'cond.pristine': `Impecable`,'cond.excellent': `Excelente`,'cond.veryGood': `Muy Bueno`,'cond.good': `Bueno`,'cond.new': `Nuevo`, 'cond.fair': `Aceptable`,
      'sell.formTitle': `Iniciar Solicitud de Consignación`,'sell.formSub': `Cuéntanos sobre tu pieza. Cuanto más detalle, más rápido respondemos.`,
      'sell.step.item': `Artículo`,'sell.step.photos': `Fotos`,'sell.step.price': `Precio y Tú`,'sell.step.done': `Listo`,
      'sell.field.brand': `Diseñador / Marca`,'sell.field.category': `Categoría`,'sell.field.model': `Modelo / Estilo`,'sell.field.year': `Año de Compra`,'sell.field.condition': `Condición`,'sell.field.color': `Color Original`,'sell.field.notes': `Notas y Procedencia`,
      'sell.photo.instructions': `Sube una foto clara de cada ángulo — las mismas cinco vistas que Casa fotografía para cada pieza publicada.`,'sell.photo.front': `Frente`,'sell.photo.rear': `Parte trasera`,'sell.photo.side': `Lateral`,'sell.photo.bottom': `Parte inferior`,'sell.photo.inside': `Interior`,'sell.photo.extraTitle': `Agregar más fotos (opcional)`,'sell.photo.extraSub': `JPG, PNG hasta 10MB cada una · Hasta 7 fotos adicionales`,
      'sell.back': `← Atrás`,'sell.continue': `Continuar →`,'sell.submit': `Enviar Solicitud →`,
      'about.eyebrow': `Club`,
      'about.lead': `Bienvenido a un mundo privado de lujo atemporal, donde el gusto excepcional, la autenticidad y una sofisticación sin esfuerzo se encuentran.`,
      'about.lead2': `Descubra bolsos de diseñador auténticos, desde codiciados tesoros vintage hasta los últimos estilos imprescindibles. Ya sea que busque una pieza excepcional, un bolso clásico de inversión o un hallazgo de diseñador como nuevo, nuestra colección cuidadosamente seleccionada ofrece algo extraordinario para cada coleccionista exigente.`,
      'about.card1.title': `Autenticidad Garantizada`,
      'about.card1.body': `Cada pieza es examinada por nuestros especialistas internos contra criterios rigurosos — herrajes, costuras, cuero, sellos de fecha. Si no podemos autenticar, no la publicamos.`,
      'about.card2.title': `Ritmo Considerado`,
      'about.card2.body': `Respondemos a las solicitudes de consignación en 48 horas, por una persona real — no una cola. El mismo cuidado va en cada pieza que enviamos.`,
      'about.card3.title': `Sostenible por Naturaleza`,
      'about.card3.body': `La reventa es el tipo más hermoso de sostenibilidad. Cada pieza que recolocamos mantiene la artesanía en circulación y los residuos fuera del cubo.`,
      'checkout.title': `Pago`,'checkout.contact': `Contacto`,'checkout.shipping': `Dirección de Envío`,'checkout.method': `Método de Envío`,'checkout.payment': `Pago`,
      'checkout.firstName': `Nombre`,'checkout.lastName': `Apellido`,'checkout.street': `Dirección`,'checkout.city': `Ciudad`,'checkout.state': `Estado`,'checkout.postal': `Código Postal`,'checkout.country': `País`,
      'checkout.standard': `Estándar Asegurado`,'checkout.standardSub': `3–5 días hábiles · totalmente asegurado`,'checkout.express': `Exprés Asegurado`,'checkout.expressSub': `1–2 días hábiles · se requiere firma`,'checkout.whiteGlove': `Guante Blanco`,'checkout.whiteGloveSub': `Entrega en mano en So Cal · cita previa`,
      'checkout.placeOrder': `Realizar Pedido`,'checkout.subtotal': `Subtotal`,'checkout.shipping2': `Envío`,'checkout.tax': `Impuesto Estimado`,'checkout.total': `Total`,'checkout.summary': `Resumen del Pedido`,
      'cart.title': `Tu Bolso`,'cart.empty': `Tu bolso está vacío.`,'cart.authIncluded': `Autenticación Incluida`,
      'footer.allHandbags': `Todos los Bolsos`,'footer.newArrivals': `Nuevas Llegadas`, 'nav.newIn': `New In`,
      'footer.startRequest': `Iniciar Solicitud`,'footer.howItWorks': `Cómo Funciona`,'footer.terms': `Términos de Consignación`,'footer.whatAccept': `Qué Aceptamos`,'footer.payouts': `Pagos`,
      'footer.contact': `Contáctanos`,'footer.shipReturn': `Envíos`,'footer.auth': `Autenticación`,'footer.faq': `Preguntas Frecuentes`,'footer.care': `Guía de Cuidado`,
      'footer.tos': `Términos de Servicio`,'footer.privacy': `Política de Privacidad`,'footer.cookies': `Preferencias de Cookies`,'footer.access': `Accesibilidad`,'footer.authGuarantee': `Garantía de Autenticidad`,
      'footer.newsletterLead': `Nuevas llegadas, vistas previas privadas y notas de estilismo — directo a tu bandeja.`,'footer.emailPlaceholder': `Tu correo electrónico`,
      'showcase.stat1Big': `360°`,'showcase.stat1Sub': `Vista 360°`,
      'showcase.stat2Big': `HD`,'showcase.stat2Sub': `Primeros Planos`,
      'showcase.stat3Big': `48hr`,'showcase.stat3Sub': `Desde el listado`,
      'editorial.stat1Big': `12,400+`,'editorial.stat2Big': `100%`,'editorial.stat3Big': `48hr`,
      'tiers.note': `Los pagos se basan en el precio de venta final del artículo. Los artículos con precio inferior a $100 se aceptan a nuestra discreción. Consulta el Acuerdo de Consignación para términos completos.`,
      'view.product': `Ver Producto`,
      'qv.condition': `Condición`,'qv.hardware': `Herrajes`,'qv.year': `Año`,'qv.includes': `Incluye`,'qv.includesValue': `Conjunto completo`,
    },
    fr: {
      'hero.headlineHTML': `<span class="script">pièces</span>intemporelles,<br><em>revendues</em> avec conscience.`,
      'sell.titleHTML': `Transformez vos trésors<br>en <em>votre prochain chapitre.</em>`,
      'editorial.titleHTML': `Authentifié par des humains, <em>pas des algorithmes.</em>`,
      'showcase.titleHTML': `Voyez-la sous <em>tous les angles.</em>`,
      'about.titleHTML': `Bienvenue chez <em>Casa Consignment.</em>`,
      'arrivals.viewAllArrow': `Voir Tout →`,
      'common.signinLink': `Se Connecter`,
      'common.continueShopping': `Continuer les Achats`,
      'common.checkout': `Paiement →`,
      'common.addToBag': `Ajouter au Sac`,
      'common.saveWishlist': `♡ Sauvegarder`,
      'common.viewCertificate': `Voir le Certificat`,
      'common.viewProduct': `Voir le Produit`,
      'arrivals.eyebrow': `Tout Juste Arrivé`,'arrivals.title': `Nouveautés`,
      'showcase.eyebrow': `En Mouvement`,'editorial.eyebrow': `Notre Standard`,'social.eyebrow': `Suivez-nous`,
      'designer.eyebrow': `Acheter par Maison`,'designer.title': `Les Maisons que Nous Aimons`,
      'tiers.eyebrow': `Paiements Transparents`,'tiers.title': `Niveaux de Commission`,
      'consignorCta.eyebrow': `Confiez à Casa`,
      'shop.titleFull': `Découvrir la Collection`,'shop.leadFull': `Pièces sélectionnées, du sac patrimonial à la joaillerie fine.`,
      'shop.crumbAll': `Toute la Boutique`,'shop.crumbHome': `Accueil`,
      'cat.handbags': `Sacs`,'cat.jewelry': `Joaillerie`,'cat.accessories': `Accessoires`,'cat.apparel': `Vêtements`,
      'cond.pristine': `Impeccable`,'cond.excellent': `Excellent`,'cond.veryGood': `Très Bon`,'cond.good': `Bon`,'cond.new': `Neuf`, 'cond.fair': `Correct`,
      'sell.formTitle': `Lancer une Demande de Consignation`,'sell.formSub': `Parlez-nous de votre pièce. Plus de détails, plus rapide la réponse.`,
      'sell.step.item': `Article`,'sell.step.photos': `Photos`,'sell.step.price': `Prix & Vous`,'sell.step.done': `Terminé`,
      'sell.field.brand': `Créateur / Marque`,'sell.field.category': `Catégorie`,'sell.field.model': `Modèle / Style`,'sell.field.year': `Année d'Achat`,'sell.field.condition': `État`,'sell.field.color': `Couleur Originale`,'sell.field.notes': `Notes & Provenance`,
      'sell.photo.instructions': `Téléchargez une photo nette de chaque angle — les cinq mêmes vues que Casa photographie pour chaque pièce publiée.`,'sell.photo.front': `Avant`,'sell.photo.rear': `Arrière`,'sell.photo.side': `Côté`,'sell.photo.bottom': `Dessous`,'sell.photo.inside': `Intérieur`,'sell.photo.extraTitle': `Ajouter plus de photos (facultatif)`,'sell.photo.extraSub': `JPG, PNG jusqu'à 10 Mo chacune · Jusqu'à 7 photos supplémentaires`,
      'sell.back': `← Retour`,'sell.continue': `Continuer →`,'sell.submit': `Soumettre →`,
      'about.eyebrow': `Club`,
      'about.lead': `Bienvenue dans un univers privé de luxe intemporel, où le goût d'exception, l'authenticité et une élégance naturelle se rejoignent.`,
      'about.lead2': `Découvrez des sacs de créateurs authentiques, des trésors vintage les plus convoités aux modèles incontournables du moment. Que vous cherchiez une pièce rare, un sac classique d'investissement ou une trouvaille comme neuve, notre collection soigneusement sélectionnée offre quelque chose d'extraordinaire à chaque collectionneur averti.`,
      'about.card1.title': `Authenticité Garantie`,
      'about.card1.body': `Chaque pièce est examinée par nos spécialistes internes selon des critères rigoureux — fermoirs, coutures, cuir, étampes de date. Si nous ne pouvons pas authentifier, nous ne listons pas.`,
      'about.card2.title': `Rythme Réfléchi`,
      'about.card2.body': `Nous répondons aux soumissions de consignation dans les 48 heures par une vraie personne — pas une file d'attente. Le même soin va dans chaque pièce expédiée.`,
      'about.card3.title': `Durable par Nature`,
      'about.card3.body': `La revente est la plus belle forme de durabilité. Chaque pièce que nous relogeons garde l'artisanat en circulation et les déchets hors poubelle.`,
      'checkout.title': `Paiement`,'checkout.contact': `Contact`,'checkout.shipping': `Adresse de Livraison`,'checkout.method': `Méthode d'Expédition`,'checkout.payment': `Paiement`,
      'checkout.firstName': `Prénom`,'checkout.lastName': `Nom`,'checkout.street': `Adresse`,'checkout.city': `Ville`,'checkout.state': `État / Région`,'checkout.postal': `Code Postal`,'checkout.country': `Pays`,
      'checkout.standard': `Standard Assuré`,'checkout.standardSub': `3–5 jours ouvrables · entièrement assuré`,'checkout.express': `Express Assuré`,'checkout.expressSub': `1–2 jours ouvrables · signature requise`,'checkout.whiteGlove': `Gants Blancs`,'checkout.whiteGloveSub': `Livraison en main propre · sur rendez-vous`,
      'checkout.placeOrder': `Passer la Commande`,'checkout.subtotal': `Sous-total`,'checkout.shipping2': `Livraison`,'checkout.tax': `Taxe Estimée`,'checkout.total': `Total`,'checkout.summary': `Résumé de la Commande`,
      'cart.title': `Votre Sac`,'cart.empty': `Votre sac est vide.`,'cart.authIncluded': `Authentification Incluse`,
      'footer.allHandbags': `Tous les Sacs`,'footer.newArrivals': `Nouveautés`, 'nav.newIn': `New In`,
      'footer.startRequest': `Démarrer une Demande`,'footer.howItWorks': `Comment ça Marche`,'footer.terms': `Conditions de Consignation`,'footer.whatAccept': `Ce Que Nous Acceptons`,'footer.payouts': `Paiements`,
      'footer.contact': `Contactez-nous`,'footer.shipReturn': `Livraison`,'footer.auth': `Authentification`,'footer.faq': `FAQ`,'footer.care': `Guide d'Entretien`,
      'footer.tos': `Conditions de Service`,'footer.privacy': `Politique de Confidentialité`,'footer.cookies': `Préférences Cookies`,'footer.access': `Accessibilité`,'footer.authGuarantee': `Garantie d'Authenticité`,
      'footer.newsletterLead': `Nouveautés, aperçus privés et notes de style — directement dans votre boîte.`,'footer.emailPlaceholder': `Votre adresse e-mail`,
      'showcase.stat1Big': `360°`,'showcase.stat1Sub': `Tour Complet`,
      'showcase.stat2Big': `HD`,'showcase.stat2Sub': `Gros Plans`,
      'showcase.stat3Big': `48hr`,'showcase.stat3Sub': `Depuis le listing`,
      'editorial.stat1Big': `12,400+`,'editorial.stat2Big': `100%`,'editorial.stat3Big': `48hr`,
      'tiers.note': `Les paiements sont basés sur le prix de vente final. Les articles inférieurs à 100 $ sont acceptés à notre discrétion. Consultez l'Accord de Consignation pour les conditions complètes.`,
      'view.product': `Voir le Produit`,
      'qv.condition': `État`,'qv.hardware': `Fermoirs`,'qv.year': `Année`,'qv.includes': `Comprend`,'qv.includesValue': `Ensemble complet`,
    },
    de: {
      'hero.headlineHTML': `<span class="script">zeitlose</span>Stücke,<br><em>verantwortungsvoll</em> weiterverkauft.`,
      'sell.titleHTML': `Verwandeln Sie Schrankschätze<br>in <em>Ihr nächstes Kapitel.</em>`,
      'editorial.titleHTML': `Authentifiziert durch Menschen, <em>nicht Algorithmen.</em>`,
      'showcase.titleHTML': `Sehen Sie es aus <em>jedem Blickwinkel.</em>`,
      'about.titleHTML': `Willkommen bei <em>Casa Consignment.</em>`,
      'arrivals.viewAllArrow': `Alle Ansehen →`,
      'common.signinLink': `Anmelden`,
      'common.continueShopping': `Weiter Einkaufen`,
      'common.checkout': `Zur Kasse →`,
      'common.addToBag': `In den Beutel`,
      'common.saveWishlist': `♡ Auf Wunschliste`,
      'common.viewCertificate': `Zertifikat ansehen`,
      'common.viewProduct': `Produkt ansehen`,
      'arrivals.eyebrow': `Gerade Eingetroffen`,'arrivals.title': `Neuheiten`,
      'showcase.eyebrow': `In Bewegung`,'editorial.eyebrow': `Unser Standard`,'social.eyebrow': `Folgen Sie Uns`,
      'designer.eyebrow': `Nach Haus Einkaufen`,'designer.title': `Die Häuser, Die Wir Lieben`,
      'tiers.eyebrow': `Transparente Auszahlungen`,'tiers.title': `Provisionsstufen`,
      'consignorCta.eyebrow': `Mit Casa verkaufen`,
      'shop.titleFull': `Kollektion Kaufen`,'shop.leadFull': `Kuratierte Stücke, von Erbe-Handtaschen bis Feinschmuck.`,
      'shop.crumbAll': `Alle Shop`,'shop.crumbHome': `Startseite`,
      'cat.handbags': `Handtaschen`,'cat.jewelry': `Schmuck`,'cat.accessories': `Accessoires`,'cat.apparel': `Kleidung`,
      'cond.pristine': `Makellos`,'cond.excellent': `Ausgezeichnet`,'cond.veryGood': `Sehr Gut`,'cond.good': `Gut`,'cond.new': `Neu`, 'cond.fair': `Akzeptabel`,
      'sell.formTitle': `Kommissionsanfrage Starten`,'sell.formSub': `Erzählen Sie uns von Ihrem Stück. Je mehr Details, desto schneller die Antwort.`,
      'sell.step.item': `Artikel`,'sell.step.photos': `Fotos`,'sell.step.price': `Preis & Sie`,'sell.step.done': `Fertig`,
      'sell.field.brand': `Designer / Marke`,'sell.field.category': `Kategorie`,'sell.field.model': `Modell / Stil`,'sell.field.year': `Kaufjahr`,'sell.field.condition': `Zustand`,'sell.field.color': `Originalfarbe`,'sell.field.notes': `Notizen & Herkunft`,
      'sell.photo.instructions': `Lade ein klares Foto aus jedem Blickwinkel hoch — dieselben fünf Ansichten, die Casa für jedes veröffentlichte Stück fotografiert.`,'sell.photo.front': `Vorderseite`,'sell.photo.rear': `Rückseite`,'sell.photo.side': `Seite`,'sell.photo.bottom': `Unterseite`,'sell.photo.inside': `Innenseite`,'sell.photo.extraTitle': `Weitere Fotos hinzufügen (optional)`,'sell.photo.extraSub': `JPG, PNG bis zu 10 MB je Foto · Bis zu 7 zusätzliche Fotos`,
      'sell.back': `← Zurück`,'sell.continue': `Weiter →`,'sell.submit': `Anfrage Senden →`,
      'about.eyebrow': `Club`,
      'about.lead': `Willkommen in einer privaten Welt zeitlosen Luxus, in der außergewöhnlicher Geschmack, Authentizität und mühelose Eleganz zusammenkommen.`,
      'about.lead2': `Entdecken Sie authentische Designer-Handtaschen, von begehrten Vintage-Schätzen bis zu den neuesten Must-haves. Ob Sie ein seltenes Statement-Stück, eine klassische Investmenttasche oder einen neuwertigen Designerfund suchen — unsere sorgfältig kuratierte Kollektion bietet für jeden anspruchsvollen Sammler etwas Außergewöhnliches.`,
      'about.card1.title': `Garantierte Echtheit`,
      'about.card1.body': `Jedes Stück wird von unseren internen Spezialisten gegen strenge Kriterien geprüft — Hardware, Nähte, Leder, Datumsstempel. Wenn wir nicht authentifizieren können, listen wir nicht.`,
      'about.card2.title': `Bedachtes Tempo`,
      'about.card2.body': `Wir antworten auf Kommissionseinreichungen innerhalb von 48 Stunden von einer echten Person — keine Warteschlange. Dieselbe Sorgfalt gilt für jedes versendete Stück.`,
      'about.card3.title': `Natürlich Nachhaltig`,
      'about.card3.body': `Wiederverkauf ist die schönste Form der Nachhaltigkeit. Jedes Stück, das wir vermitteln, hält Handwerk im Umlauf und Müll aus der Tonne.`,
      'checkout.title': `Kasse`,'checkout.contact': `Kontakt`,'checkout.shipping': `Lieferadresse`,'checkout.method': `Versandart`,'checkout.payment': `Zahlung`,
      'checkout.firstName': `Vorname`,'checkout.lastName': `Nachname`,'checkout.street': `Straße`,'checkout.city': `Stadt`,'checkout.state': `Bundesland`,'checkout.postal': `PLZ`,'checkout.country': `Land`,
      'checkout.standard': `Versichert Standard`,'checkout.standardSub': `3–5 Werktage · voll versichert`,'checkout.express': `Versichert Express`,'checkout.expressSub': `1–2 Werktage · Unterschrift erforderlich`,'checkout.whiteGlove': `Weiße Handschuhe`,'checkout.whiteGloveSub': `Persönlich geliefert · nach Vereinbarung`,
      'checkout.placeOrder': `Bestellung Aufgeben`,'checkout.subtotal': `Zwischensumme`,'checkout.shipping2': `Versand`,'checkout.tax': `Geschätzte Steuer`,'checkout.total': `Gesamt`,'checkout.summary': `Bestellübersicht`,
      'cart.title': `Ihr Beutel`,'cart.empty': `Ihr Beutel ist leer.`,'cart.authIncluded': `Authentifizierung Inklusive`,
      'footer.allHandbags': `Alle Handtaschen`,'footer.newArrivals': `Neuheiten`, 'nav.newIn': `New In`,
      'footer.startRequest': `Anfrage Starten`,'footer.howItWorks': `Wie es Funktioniert`,'footer.terms': `Kommissionsbedingungen`,'footer.whatAccept': `Was Wir Akzeptieren`,'footer.payouts': `Auszahlungen`,
      'footer.contact': `Kontakt`,'footer.shipReturn': `Versand`,'footer.auth': `Authentifizierung`,'footer.faq': `FAQ`,'footer.care': `Pflegeanleitung`,
      'footer.tos': `Nutzungsbedingungen`,'footer.privacy': `Datenschutz`,'footer.cookies': `Cookie-Einstellungen`,'footer.access': `Zugänglichkeit`,'footer.authGuarantee': `Echtheitsgarantie`,
      'footer.newsletterLead': `Neuheiten, private Vorschauen und Styling-Notizen — direkt in Ihr Postfach.`,'footer.emailPlaceholder': `Ihre E-Mail-Adresse`,
      'showcase.stat1Big': `360°`,'showcase.stat1Sub': `Rundum-Ansicht`,
      'showcase.stat2Big': `HD`,'showcase.stat2Sub': `Nahaufnahmen`,
      'showcase.stat3Big': `48hr`,'showcase.stat3Sub': `Ab Listing`,
      'editorial.stat1Big': `12,400+`,'editorial.stat2Big': `100%`,'editorial.stat3Big': `48hr`,
      'tiers.note': `Auszahlungen basieren auf dem endgültigen Verkaufspreis. Artikel unter 100 $ werden nach unserem Ermessen angenommen. Die vollständigen Bedingungen finden Sie im Kommissionsvertrag.`,
      'view.product': `Produkt ansehen`,
      'qv.condition': `Zustand`,'qv.hardware': `Hardware`,'qv.year': `Jahr`,'qv.includes': `Enthält`,'qv.includesValue': `Komplettes Set`,
    },
    ja: {
      'hero.headlineHTML': `<span class="script">時代を超えた</span>品々を、<br><em>責任を持って</em>再販。`,
      'sell.titleHTML': `クローゼットの宝物を<br><em>次の章へ。</em>`,
      'editorial.titleHTML': `人間による認証、<em>アルゴリズムではなく。</em>`,
      'showcase.titleHTML': `あらゆる<em>角度から見る。</em>`,
      'about.titleHTML': `<em>Casa Consignment</em> へようこそ。`,
      'arrivals.viewAllArrow': `すべて見る →`,
      'common.signinLink': `サインイン`,
      'common.continueShopping': `お買い物を続ける`,
      'common.checkout': `お支払い →`,
      'common.addToBag': `バッグに追加`,
      'common.saveWishlist': `♡ ウィッシュリストに保存`,
      'common.viewCertificate': `証明書を表示`,
      'common.viewProduct': `商品を見る`,
      'arrivals.eyebrow': `入荷したばかり`,'arrivals.title': `新着品`,
      'showcase.eyebrow': `動きの中で`,'editorial.eyebrow': `私たちの基準`,'social.eyebrow': `フォローする`,
      'designer.eyebrow': `メゾンで選ぶ`,'designer.title': `私たちが愛するメゾン`,
      'tiers.eyebrow': `透明な支払い`,'tiers.title': `手数料階層`,
      'consignorCta.eyebrow': `Casaに委託する`,
      'shop.titleFull': `コレクションを購入`,'shop.leadFull': `厳選作品：伝統的なハンドバッグからファインジュエリーまで。`,
      'shop.crumbAll': `すべてのショップ`,'shop.crumbHome': `ホーム`,
      'cat.handbags': `ハンドバッグ`,'cat.jewelry': `ジュエリー`,'cat.accessories': `アクセサリー`,'cat.apparel': `アパレル`,
      'cond.pristine': `新品同様`,'cond.excellent': `優良`,'cond.veryGood': `良好`,'cond.good': `普通`,'cond.new': `新品`, 'cond.fair': `可`,
      'sell.formTitle': `委託依頼を開始`,'sell.formSub': `お品物について教えてください。詳細が多いほど、迅速に対応できます。`,
      'sell.step.item': `商品`,'sell.step.photos': `写真`,'sell.step.price': `価格とお客様`,'sell.step.done': `完了`,
      'sell.field.brand': `デザイナー / ブランド`,'sell.field.category': `カテゴリー`,'sell.field.model': `モデル / スタイル`,'sell.field.year': `購入年`,'sell.field.condition': `状態`,'sell.field.color': `元の色`,'sell.field.notes': `ノート＆来歴`,
      'sell.photo.instructions': `各アングルの鮮明な写真を1枚ずつアップロードしてください — Casaが実際の掲載商品を撮影する際と同じ5つのアングルです。`,'sell.photo.front': `正面`,'sell.photo.rear': `背面`,'sell.photo.side': `側面`,'sell.photo.bottom': `底面`,'sell.photo.inside': `内側`,'sell.photo.extraTitle': `追加の写真を送る（任意）`,'sell.photo.extraSub': `JPG、PNG、1枚あたり10MBまで · 追加で最大7枚まで`,
      'sell.back': `← 戻る`,'sell.continue': `続ける →`,'sell.submit': `リクエスト送信 →`,
      'about.eyebrow': `クラブ`,
      'about.lead': `卓越した美意識、確かな真正性、そして自然体の洗練が響き合う、時を超えたラグジュアリーのプライベートな世界へようこそ。`,
      'about.lead2': `希少なヴィンテージの名品から最新の注目モデルまで、本物のデザイナーハンドバッグをご覧ください。特別な一点、長く愛せる定番、あるいは新品同様の掘り出し物をお探しの方へ——厳選されたコレクションが、目の肥えたすべての方に特別な出会いをお届けします。`,
      'about.card1.title': `本物保証`,
      'about.card1.body': `すべての品は当社の専門家により厳格な基準で検査されます — 金具、縫製、革、日付スタンプ。認証できなければ掲載しません。`,
      'about.card2.title': `丁寧なペース`,
      'about.card2.body': `委託提出には48時間以内に実在の人物から返信します — 待ち行列ではありません。同じ配慮を発送するすべての品に注ぎます。`,
      'about.card3.title': `本質的にサステナブル`,
      'about.card3.body': `リセールは最も美しい形のサステナビリティです。私たちが再び家を見つけるすべての品が、職人技を循環させ、廃棄物をゴミ箱から遠ざけます。`,
      'checkout.title': `お支払い`,'checkout.contact': `連絡先`,'checkout.shipping': `配送先住所`,'checkout.method': `配送方法`,'checkout.payment': `お支払い`,
      'checkout.firstName': `名`,'checkout.lastName': `姓`,'checkout.street': `住所`,'checkout.city': `市区町村`,'checkout.state': `都道府県`,'checkout.postal': `郵便番号`,'checkout.country': `国`,
      'checkout.standard': `保険付き標準`,'checkout.standardSub': `3～5営業日 · 完全保険`,'checkout.express': `保険付き速達`,'checkout.expressSub': `1～2営業日 · 署名必須`,'checkout.whiteGlove': `ホワイトグローブ`,'checkout.whiteGloveSub': `手渡し配送 · 予約制`,
      'checkout.placeOrder': `注文する`,'checkout.subtotal': `小計`,'checkout.shipping2': `配送`,'checkout.tax': `推定税`,'checkout.total': `合計`,'checkout.summary': `注文概要`,
      'cart.title': `あなたのバッグ`,'cart.empty': `バッグは空です。`,'cart.authIncluded': `認証含む`,
      'footer.allHandbags': `すべてのハンドバッグ`,'footer.newArrivals': `新着品`, 'nav.newIn': `New In`,
      'footer.startRequest': `リクエスト開始`,'footer.howItWorks': `仕組み`,'footer.terms': `委託条件`,'footer.whatAccept': `受付品`,'footer.payouts': `支払い`,
      'footer.contact': `お問い合わせ`,'footer.shipReturn': `配送`,'footer.auth': `認証`,'footer.faq': `FAQ`,'footer.care': `ケアガイド`,
      'footer.tos': `利用規約`,'footer.privacy': `プライバシーポリシー`,'footer.cookies': `クッキー設定`,'footer.access': `アクセシビリティ`,'footer.authGuarantee': `真正性保証`,
      'footer.newsletterLead': `新着情報、プライベートプレビュー、スタイリングノートを受信箱へ。`,'footer.emailPlaceholder': `メールアドレス`,
      'showcase.stat1Big': `360°`,'showcase.stat1Sub': `全角度ビュー`,
      'showcase.stat2Big': `HD`,'showcase.stat2Sub': `クローズアップ`,
      'showcase.stat3Big': `48時間`,'showcase.stat3Sub': `出品から`,
      'editorial.stat1Big': `12,400+`,'editorial.stat2Big': `100%`,'editorial.stat3Big': `48時間`,
      'tiers.note': `支払いは商品の最終販売価格に基づきます。$100未満の商品は当社の裁量で受け付けます。完全な条件は委託契約をご覧ください。`,
      'view.product': `商品を見る`,
      'qv.condition': `状態`,'qv.hardware': `金具`,'qv.year': `年`,'qv.includes': `同梱`,'qv.includesValue': `フルセット`,
    },
    zh: {
      'hero.headlineHTML': `<span class="script">永恒</span>之作，<br><em>负责任地</em>转售。`,
      'sell.titleHTML': `将衣柜中的珍藏<br>变成<em>下一篇章。</em>`,
      'editorial.titleHTML': `由人鉴定，<em>非算法。</em>`,
      'showcase.titleHTML': `从<em>每个角度欣赏。</em>`,
      'about.titleHTML': `欢迎来到 <em>Casa Consignment。</em>`,
      'arrivals.viewAllArrow': `查看全部 →`,
      'common.signinLink': `登录`,
      'common.continueShopping': `继续购物`,
      'common.checkout': `结账 →`,
      'common.addToBag': `加入购物袋`,
      'common.saveWishlist': `♡ 加入愿望清单`,
      'common.viewCertificate': `查看证书`,
      'common.viewProduct': `查看商品`,
      'arrivals.eyebrow': `刚到货`,'arrivals.title': `新品`,
      'showcase.eyebrow': `动态展示`,'editorial.eyebrow': `我们的标准`,'social.eyebrow': `关注我们`,
      'designer.eyebrow': `按品牌选购`,'designer.title': `我们钟爱的品牌`,
      'tiers.eyebrow': `透明支付`,'tiers.title': `佣金等级`,
      'consignorCta.eyebrow': `委托 Casa 寄售`,
      'shop.titleFull': `选购系列`,'shop.leadFull': `精选作品：从传统手袋到精品珠宝。`,
      'shop.crumbAll': `全部商品`,'shop.crumbHome': `首页`,
      'cat.handbags': `手袋`,'cat.jewelry': `珠宝`,'cat.accessories': `配饰`,'cat.apparel': `服装`,
      'cond.pristine': `完美`,'cond.excellent': `极佳`,'cond.veryGood': `良好`,'cond.good': `尚可`,'cond.new': `全新`, 'cond.fair': `一般`,
      'sell.formTitle': `开始寄售请求`,'sell.formSub': `告诉我们您的物品。细节越多，回复越快。`,
      'sell.step.item': `物品`,'sell.step.photos': `照片`,'sell.step.price': `价格与您`,'sell.step.done': `完成`,
      'sell.field.brand': `设计师 / 品牌`,'sell.field.category': `类别`,'sell.field.model': `型号 / 款式`,'sell.field.year': `购买年份`,'sell.field.condition': `状况`,'sell.field.color': `原始颜色`,'sell.field.notes': `备注与来源`,
      'sell.photo.instructions': `请上传每个角度的清晰照片——与Casa为每件正式上架商品拍摄的五个角度相同。`,'sell.photo.front': `正面`,'sell.photo.rear': `背面`,'sell.photo.side': `侧面`,'sell.photo.bottom': `底部`,'sell.photo.inside': `内部`,'sell.photo.extraTitle': `添加更多照片（可选）`,'sell.photo.extraSub': `JPG、PNG，每张最高10MB · 最多可额外添加7张`,
      'sell.back': `← 返回`,'sell.continue': `继续 →`,'sell.submit': `提交请求 →`,
      'about.eyebrow': `俱乐部`,
      'about.lead': `欢迎进入一个私享的永恒奢华世界，在这里，卓越品味、真品保证与浑然天成的优雅交融共生。`,
      'about.lead2': `探索正品设计师手袋，从备受追捧的复古珍藏到最新的必备款式。无论您寻找的是稀有的个性之作、经典的保值之选，还是近乎全新的设计师珍品，我们精心甄选的系列都能为每一位品味独到的收藏家带来非凡之选。`,
      'about.card1.title': `真品保证`,
      'about.card1.body': `每件作品都由我们的内部专家根据严格标准检查 — 五金、缝线、皮革、日期印记。如果无法鉴定，我们不会上架。`,
      'about.card2.title': `审慎节奏`,
      'about.card2.body': `我们在48小时内由真人回复寄售提交 — 不是排队。同样的关怀延伸到我们发出的每一件作品。`,
      'about.card3.title': `天然可持续`,
      'about.card3.body': `转售是最美丽的可持续形式。我们重新安置的每件作品都让工艺保持流通，让浪费远离垃圾桶。`,
      'checkout.title': `结账`,'checkout.contact': `联系方式`,'checkout.shipping': `收货地址`,'checkout.method': `配送方式`,'checkout.payment': `付款`,
      'checkout.firstName': `名`,'checkout.lastName': `姓`,'checkout.street': `街道地址`,'checkout.city': `城市`,'checkout.state': `省/州`,'checkout.postal': `邮编`,'checkout.country': `国家`,
      'checkout.standard': `保险标准`,'checkout.standardSub': `3–5个工作日 · 全额保险`,'checkout.express': `保险快递`,'checkout.expressSub': `1–2个工作日 · 需要签名`,'checkout.whiteGlove': `白手套服务`,'checkout.whiteGloveSub': `亲手送达 · 预约制`,
      'checkout.placeOrder': `下单`,'checkout.subtotal': `小计`,'checkout.shipping2': `运费`,'checkout.tax': `估算税额`,'checkout.total': `总计`,'checkout.summary': `订单概要`,
      'cart.title': `您的购物袋`,'cart.empty': `您的购物袋为空。`,'cart.authIncluded': `包含认证`,
      'footer.allHandbags': `所有手袋`,'footer.newArrivals': `新品`, 'nav.newIn': `New In`,
      'footer.startRequest': `开始请求`,'footer.howItWorks': `如何运作`,'footer.terms': `寄售条款`,'footer.whatAccept': `我们接受什么`,'footer.payouts': `付款`,
      'footer.contact': `联系我们`,'footer.shipReturn': `配送`,'footer.auth': `认证`,'footer.faq': `常见问题`,'footer.care': `护理指南`,
      'footer.tos': `服务条款`,'footer.privacy': `隐私政策`,'footer.cookies': `Cookie 偏好`,'footer.access': `无障碍`,'footer.authGuarantee': `真品保证`,
      'footer.newsletterLead': `新品、私享预览和搭配笔记 — 直送您的邮箱。`,'footer.emailPlaceholder': `您的邮箱地址`,
      'showcase.stat1Big': `360°`,'showcase.stat1Sub': `360°视图`,
      'showcase.stat2Big': `HD`,'showcase.stat2Sub': `特写`,
      'showcase.stat3Big': `48小时`,'showcase.stat3Sub': `上架起`,
      'editorial.stat1Big': `12,400+`,'editorial.stat2Big': `100%`,'editorial.stat3Big': `48小时`,
      'tiers.note': `付款基于物品的最终售价。低于100美元的物品由我们自行决定接受。完整条款请参阅寄售协议。`,
      'view.product': `查看商品`,
      'qv.condition': `状况`,'qv.hardware': `五金`,'qv.year': `年份`,'qv.includes': `包含`,'qv.includesValue': `完整套装`,
    }
  };
  Object.keys(EXTRA_I18N).forEach(lang => Object.assign(I18N[lang], EXTRA_I18N[lang]));


  // =============================================================
  // EXPLICIT DOM TAGGING — set data-i18n on every translatable node
  // =============================================================
  function tagEverything() {
    function setI18n(el, key) { if (el && !el.hasAttribute('data-i18n')) el.setAttribute('data-i18n', key); }
    function setI18nHTML(el, key) { if (el) { el.setAttribute('data-i18n-html', key); el.setAttribute('data-i18n-original', el.innerHTML); } }
    function wrapText(parent, key) {
      if (!parent) return;
      const node = Array.from(parent.childNodes).find(n => n.nodeType === 3 && n.textContent.trim().length > 1);
      if (node) {
        const span = document.createElement('span');
        span.setAttribute('data-i18n', key);
        span.textContent = node.textContent.trim();
        node.replaceWith(span);
      }
    }

    // -------- HERO --------
    setI18n(document.querySelector('.hero-eyebrow'), 'hero.eyebrow');
    setI18n(document.querySelector('.hero-lead'), 'hero.lead');
    setI18nHTML(document.querySelector('.hero h1'), 'hero.headlineHTML');
    // Hero CTA buttons (text before SVG)
    const heroBtns = document.querySelectorAll('.hero .cta-row .btn');
    if (heroBtns[0]) wrapText(heroBtns[0], 'hero.cta.shop');
    if (heroBtns[1]) setI18n(heroBtns[1], 'hero.cta.sell');
    // Hero tags
    const ht = document.querySelectorAll('.hero-tag');
    if (ht[0]) setI18n(ht[0], 'tag.authenticated');
    if (ht[1]) setI18n(ht[1], 'tag.consignor');
    if (ht[2]) setI18n(ht[2], 'tag.insured');

    // -------- TRUST STRIP --------
    const trustItems = document.querySelectorAll('.trust-item');
    const trustKeys = [['trust.auth','trust.auth.sub'],['trust.secure','trust.secure.sub'],['trust.insured','trust.insured.sub'],['trust.final','trust.final.sub']];
    trustItems.forEach((item, i) => {
      const span = item.querySelector('span');
      const small = item.querySelector('small');
      if (span && trustKeys[i]) setI18n(span, trustKeys[i][0]);
      if (small && trustKeys[i]) setI18n(small, trustKeys[i][1]);
    });

    // -------- DESIGNER section --------
    const designerSection = document.querySelector('.section .container .section-head');
    if (designerSection) {
      setI18n(designerSection.querySelector('.eyebrow'), 'designer.eyebrow');
      setI18n(designerSection.querySelector('h2'), 'designer.title');
      setI18n(designerSection.querySelector('p'), 'designer.lead');
    }

    // -------- VIDEO SHOWCASE --------
    const showcase = document.querySelector('.video-showcase');
    if (showcase) {
      const ey = showcase.querySelector('.showcase-info .eyebrow');
      if (ey) setI18n(ey, 'showcase.eyebrow');
      setI18nHTML(showcase.querySelector('.showcase-info h2'), 'showcase.titleHTML');
      setI18n(showcase.querySelector('.showcase-info .lead'), 'showcase.lead');
      const stats = showcase.querySelectorAll('.showcase-stats div');
      stats.forEach((s, i) => {
        const strong = s.querySelector('strong');
        if (strong) setI18n(strong, `showcase.stat${i+1}Big`);
        // The remaining text after <strong> is the label
        const labelNode = Array.from(s.childNodes).find(n => n.nodeType === 3 && n.textContent.trim());
        if (labelNode) {
          const span = document.createElement('span');
          span.setAttribute('data-i18n', `showcase.stat${i+1}Sub`);
          span.textContent = labelNode.textContent.trim();
          labelNode.replaceWith(span);
        }
      });
      const featuredLabel = showcase.querySelector('div[style*="margin-bottom: 12px"]');
      if (featuredLabel) setI18n(featuredLabel, 'showcase.featured');
      const buttons = showcase.querySelectorAll('.showcase-info button');
      if (buttons[0]) wrapText(buttons[0], 'showcase.cta');
      if (buttons[1]) setI18n(buttons[1], 'showcase.guide');
    }

    // -------- ARRIVALS --------
    const arrHead = document.querySelector('.arrivals-head');
    if (arrHead) {
      const ey = arrHead.querySelector('.eyebrow');
      if (ey) setI18n(ey, 'arrivals.eyebrow');
      const h2 = arrHead.querySelector('h2');
      if (h2) setI18n(h2, 'arrivals.title');
      const allBtn = arrHead.querySelector('button');
      if (allBtn) setI18n(allBtn, 'arrivals.viewAllArrow');
    }

    // -------- EDITORIAL --------
    const editorial = document.querySelector('.editorial');
    if (editorial) {
      const ey = editorial.querySelector('.editorial-text .eyebrow');
      if (ey) setI18n(ey, 'editorial.eyebrow');
      setI18nHTML(editorial.querySelector('.editorial-text h2'), 'editorial.titleHTML');
      const p = editorial.querySelector('.editorial-text p');
      if (p) setI18n(p, 'editorial.body');
      const stats = editorial.querySelectorAll('.editorial-stats > div');
      const eKeys = [['editorial.stat1Big','editorial.stat1'],['editorial.stat2Big','editorial.stat2'],['editorial.stat3Big','editorial.stat3']];
      stats.forEach((s, i) => {
        const num = s.querySelector('.stat-num');
        const lbl = s.querySelector('.stat-label');
        if (num && eKeys[i]) setI18n(num, eKeys[i][0]);
        if (lbl && eKeys[i]) setI18n(lbl, eKeys[i][1]);
      });
      const cta = editorial.querySelector('button');
      if (cta) setI18n(cta, 'editorial.cta');
    }

    // -------- SOCIAL --------
    const social = document.querySelector('.social-strip');
    if (social) {
      const ey = social.querySelector('.eyebrow');
      if (ey) setI18n(ey, 'social.eyebrow');
      const lead = social.querySelector('.section-head p');
      if (lead) setI18n(lead, 'social.lead');
    }

    // -------- SHOP --------
    const shopHeader = document.querySelector('#view-shop .shop-header');
    if (shopHeader) {
      setI18n(shopHeader.querySelector('h1'), 'shop.titleFull');
      setI18n(shopHeader.querySelector('p'), 'shop.leadFull');
      // Breadcrumb: Home / Shop All  → break into spans
      const breadcrumb = shopHeader.querySelector('.breadcrumb');
      if (breadcrumb && !breadcrumb.hasAttribute('data-i18n-html')) {
        breadcrumb.innerHTML = `<a data-view="home" data-i18n="shop.crumbHome">Home</a> / <span data-i18n="shop.crumbAll">Shop All</span>`;
        breadcrumb.querySelector('[data-view]').addEventListener('click', (e) => { e.preventDefault(); switchView('home'); });
      }
    }

    // Filter group titles
    const filterGroups = document.querySelectorAll('#view-shop .filter-group .filter-title');
    // Positional: one key per .filter-title in markup order. There is no Color group, so
    // listing 'filter.color' here relabelled the Price group "Color".
    const fgKeys = ['filter.designer','filter.category','filter.condition','filter.price'];
    filterGroups.forEach((ft, i) => {
      if (fgKeys[i]) wrapText(ft, fgKeys[i]);
    });
    // Filter options — categories
    const catOptions = document.querySelectorAll('#view-shop .filter-group:nth-of-type(2) .filter-option');
    const catKeys = ['cat.handbags','cat.jewelry','cat.accessories','cat.apparel'];
    catOptions.forEach((opt, i) => {
      if (catKeys[i]) wrapText(opt, catKeys[i]);
    });
    // Condition options
    const condOptions = document.querySelectorAll('#view-shop .filter-group:nth-of-type(3) .filter-option');
    // Positional, must match the checkbox order in markup and wireConditionFilter().
    // "As Is" has no translation key yet, so it keeps its English label.
    const condKeys = ['cond.new','cond.pristine','cond.excellent','cond.veryGood','cond.good','cond.fair'];
    condOptions.forEach((opt, i) => {
      if (condKeys[i]) wrapText(opt, condKeys[i]);
    });
    // Shop sort dropdown
    const sortSelect = document.querySelector('.sort-select');
    if (sortSelect) {
      const opts = sortSelect.querySelectorAll('option');
      const sortKeys = ['shop.sort.newest','shop.sort.priceLow','shop.sort.priceHigh','shop.sort.alpha'];
      opts.forEach((o, i) => { if (sortKeys[i]) o.setAttribute('data-i18n', sortKeys[i]); });
    }
    // Clear filters button
    const clearBtn = document.querySelector('#view-shop .filters .btn-ghost');
    if (clearBtn) setI18n(clearBtn, 'filter.clear');
    // Size guide chip
    const sgChip = document.querySelector('.size-guide-chip');
    if (sgChip) {
      const label = sgChip.querySelector('.label');
      const small = sgChip.querySelector('small');
      if (label) setI18n(label, 'sizeGuide.label');
      if (small) setI18n(small, 'sizeGuide.sub');
    }

    // -------- SELL HERO --------
    const sellHero = document.querySelector('.sell-hero');
    if (sellHero) {
      const ey = sellHero.querySelector('.eyebrow');
      if (ey) setI18n(ey, 'sell.eyebrow');
      setI18nHTML(sellHero.querySelector('h1'), 'sell.titleHTML');
      const p = sellHero.querySelector('p');
      if (p) setI18n(p, 'sell.lead');
      // Sell steps
      const steps = sellHero.querySelectorAll('.sell-step');
      const stepKeys = [['sell.step1.title','sell.step1.sub'],['sell.step2.title','sell.step2.sub'],['sell.step3.title','sell.step3.sub'],['sell.step4.title','sell.step4.sub']];
      steps.forEach((step, i) => {
        const h4 = step.querySelector('h4');
        const p = step.querySelector('p');
        if (h4 && stepKeys[i]) setI18n(h4, stepKeys[i][0]);
        if (p && stepKeys[i]) setI18n(p, stepKeys[i][1]);
      });
    }

    // -------- COMMISSION TIERS --------
    const tiersWrap = document.querySelector('.tiers-wrap');
    if (tiersWrap) {
      const head = tiersWrap.querySelector('.section-head');
      if (head) {
        setI18n(head.querySelector('.eyebrow'), 'tiers.eyebrow');
        setI18n(head.querySelector('h2'), 'tiers.title');
        setI18n(head.querySelector('p'), 'tiers.lead');
      }
      // Each tier card: "Consignor Payout" label + "Casa commission · XX%" stc text + "Top Tier" ribbon
      tiersWrap.querySelectorAll('.tier-card .payout-label').forEach(el => setI18n(el, 'tiers.payoutLabel'));
      tiersWrap.querySelectorAll('.tier-card .stc').forEach(el => {
        const m = el.textContent.match(/^Casa commission(.*)$/);
        if (m) el.innerHTML = `<span data-i18n="tiers.commission">Casa commission</span>${m[1]}`;
      });
      tiersWrap.querySelectorAll('.tier-card .ribbon').forEach(el => setI18n(el, 'tiers.topTier'));
      // Footer note
      const note = tiersWrap.querySelector('.tier-note');
      if (note) {
        // Replace entire content with a translated version; keep link
        if (!note.hasAttribute('data-i18n-html')) {
          note.setAttribute('data-i18n-html', 'tiers.note');
          note.setAttribute('data-i18n-original', note.innerHTML);
        }
      }
    }

    // -------- CONSIGNOR CTA --------
    const sellerCta = document.querySelector('.seller-cta .seller-cta-inner');
    if (sellerCta) {
      const ey = sellerCta.querySelector('.eyebrow');
      if (ey) setI18n(ey, 'consignorCta.eyebrow');
      const h3 = sellerCta.querySelector('h3');
      if (h3) setI18n(h3, 'consignorCta.title');
      const p = sellerCta.querySelector('p');
      if (p) setI18n(p, 'consignorCta.lead');
      const btns = sellerCta.querySelectorAll('button');
      if (btns[0]) wrapText(btns[0], 'consignorCta.cta');
      if (btns[1]) setI18n(btns[1], 'consignorCta.alt');
    }

    // -------- SELL FORM --------
    const sellForm = document.querySelector('.sell-form-wrap');
    if (sellForm) {
      const h2 = sellForm.querySelector('h2');
      if (h2) setI18n(h2, 'sell.formTitle');
      // Stepper labels
      const stepperLabels = sellForm.querySelectorAll('.stepper-dot .label');
      const sKeys = ['sell.step.item','sell.step.photos','sell.step.price','sell.step.done'];
      stepperLabels.forEach((l, i) => { if (sKeys[i]) setI18n(l, sKeys[i]); });
      // Form field labels (only for step 1 mainly)
      const labels = sellForm.querySelectorAll('.form-step[data-step="1"] .form-field label');
      const fldKeys = ['sell.field.brand','sell.field.category','sell.field.model','sell.field.year','sell.field.condition','sell.field.color','sell.field.notes'];
      labels.forEach((l, i) => { if (fldKeys[i]) setI18n(l, fldKeys[i]); });
      // Step nav buttons - tag by text
      sellForm.querySelectorAll('.form-nav .btn-ghost').forEach(b => {
        if (b.textContent.trim() === '← Back') setI18n(b, 'sell.back');
      });
      sellForm.querySelectorAll('.form-nav .btn-primary').forEach(b => {
        const t = b.textContent.trim();
        if (t === 'Continue →') setI18n(b, 'sell.continue');
        else if (t.includes('Submit')) setI18n(b, 'sell.submit');
      });
    }

    // -------- ABOUT VIEW --------
    const aboutHero = document.querySelector('.about-hero');
    if (aboutHero) {
      const ey = aboutHero.querySelector('.eyebrow');
      if (ey) setI18n(ey, 'about.eyebrow');
      setI18nHTML(aboutHero.querySelector('h1'), 'about.titleHTML');
      const ps = aboutHero.querySelectorAll('p');
      if (ps[0]) setI18n(ps[0], 'about.lead');
      // The Club hero runs to two paragraphs. Without this the second one stays
      // English in ES/FR/DE/JA/ZH while the first translates — worse than either.
      if (ps[1]) setI18n(ps[1], 'about.lead2');
    }
    const aboutCards = document.querySelectorAll('.about-grid .about-card');
    const aboutKeys = [['about.card1.title','about.card1.body'],['about.card2.title','about.card2.body'],['about.card3.title','about.card3.body']];
    aboutCards.forEach((card, i) => {
      if (!aboutKeys[i]) return;
      const h3 = card.querySelector('h3');
      const p = card.querySelector('p');
      if (h3) setI18n(h3, aboutKeys[i][0]);
      if (p) setI18n(p, aboutKeys[i][1]);
    });

    // -------- CHECKOUT VIEW --------
    const checkoutSections = document.querySelectorAll('#view-checkout .checkout-section h3');
    const cKeys = ['checkout.contact','checkout.shipping','checkout.method','checkout.payment'];
    checkoutSections.forEach((h3, i) => {
      if (cKeys[i]) {
        const stepNum = h3.querySelector('.step-num');
        const node = Array.from(h3.childNodes).find(n => n.nodeType === 3 && n.textContent.trim());
        if (node) {
          const span = document.createElement('span');
          span.setAttribute('data-i18n', cKeys[i]);
          span.textContent = node.textContent.trim();
          node.replaceWith(span);
        }
      }
    });
    // Checkout form labels
    const checkoutLabels = document.querySelectorAll('#view-checkout .form-field label');
    const chKeys = ['modal.email','checkout.firstName','checkout.lastName','checkout.street','checkout.city','checkout.state','checkout.postal','checkout.country'];
    checkoutLabels.forEach((l, i) => { if (chKeys[i]) setI18n(l, chKeys[i]); });
    // Order summary header
    const orderSummary = document.querySelector('.order-summary h3');
    if (orderSummary) setI18n(orderSummary, 'checkout.summary');
    // Order totals
    const orderRows = document.querySelectorAll('.order-totals .row');
    if (orderRows.length >= 4) {
      const labels = ['checkout.subtotal','checkout.shipping2','checkout.tax','checkout.total'];
      orderRows.forEach((row, i) => {
        const first = row.querySelector('span:first-child');
        if (first && labels[i]) setI18n(first, labels[i]);
      });
    }
    // Place Order button — has dynamic price, only wrap leading text
    const placeBtn = document.querySelector('#view-checkout button.btn-block');
    if (placeBtn) {
      const tnode = Array.from(placeBtn.childNodes).find(n => n.nodeType === 3 && n.textContent.includes('Place Order'));
      if (tnode) {
        const span = document.createElement('span');
        span.setAttribute('data-i18n', 'checkout.placeOrder');
        span.textContent = 'Place Order';
        tnode.replaceWith(span);
        placeBtn.insertBefore(document.createTextNode(' — $14,940.00'), span.nextSibling);
      }
    }

    // -------- CART DRAWER --------
    const cartHead = document.querySelector('#cart-drawer .drawer-head h3');
    if (cartHead) {
      const node = Array.from(cartHead.childNodes).find(n => n.nodeType === 3 && n.textContent.trim());
      if (node) {
        const span = document.createElement('span');
        span.setAttribute('data-i18n', 'cart.title');
        span.textContent = 'Your Bag';
        node.replaceWith(span);
        cartHead.insertBefore(document.createTextNode(' (2)'), span.nextSibling);
      }
    }
    const cartAuthIncl = document.querySelector('#cart-drawer strong');
    if (cartAuthIncl && cartAuthIncl.textContent.trim() === 'Authentication Included') setI18n(cartAuthIncl, 'cart.authIncluded');
    const cartCheckoutBtn = document.querySelector('#cart-drawer .drawer-foot .btn-primary');
    if (cartCheckoutBtn) setI18n(cartCheckoutBtn, 'common.checkout');
    const cartContBtn = document.querySelector('#cart-drawer .drawer-foot .btn-ghost');
    if (cartContBtn) setI18n(cartContBtn, 'common.continueShopping');

    // -------- ANNOUNCEMENT BAR --------
    const announce = document.querySelector('.announcement');
    if (announce) {
      const spans = announce.querySelectorAll('span');
      if (spans[0]) setI18n(spans[0], 'announce.auth');
      if (spans[1]) setI18n(spans[1], 'announce.ship');
      if (spans[2]) setI18n(spans[2], 'announce.consign');
    }

    // -------- FOOTER --------
    const footerBrandP = document.querySelector('.footer-brand p');
    if (footerBrandP) setI18n(footerBrandP, 'footer.brand');
    // Footer column links — we have a structure of 5 columns (brand + 4 link cols)
    const footerCols = document.querySelectorAll('.footer-col');
    if (footerCols.length >= 4) {
      // Shop column (col 0)
      const shopLinks = footerCols[0].querySelectorAll('li a');
      const shopFooterKeys = ['footer.allHandbags','filter.designer','filter.designer','filter.designer','cat.jewelry','footer.newArrivals'];
      shopLinks.forEach((a, i) => { /* keep brand names; tag generic ones */
        const txt = a.textContent.trim();
        const m = { 'All Handbags':'footer.allHandbags','Jewelry':`cat.jewelry`,'New Arrivals':'footer.newArrivals' };
        if (m[txt]) setI18n(a, m[txt]);
      });
      // Sell column (col 1)
      const sellLinks = footerCols[1].querySelectorAll('li a');
      sellLinks.forEach(a => {
        const m = { 'Start a Request':'footer.startRequest', 'How It Works':'footer.howItWorks', 'Consignment Terms':'footer.terms', 'What We Accept':'footer.whatAccept', 'Payouts':`footer.payouts` };
        const t = a.textContent.trim();
        if (m[t]) setI18n(a, m[t]);
      });
      // Support column (col 2)
      const supLinks = footerCols[2].querySelectorAll('li a');
      supLinks.forEach(a => {
        const m = { 'Contact Us':'footer.contact', 'Shipping':'footer.shipReturn', 'Authentication':`footer.auth`, 'FAQ':`footer.faq`, 'Care Guide':'footer.care' };
        const t = a.textContent.trim();
        if (m[t]) setI18n(a, m[t]);
      });
      // Newsletter column (col 3)
      const newsletterCol = footerCols[3];
      if (newsletterCol) {
        const p = newsletterCol.querySelector('p');
        if (p) setI18n(p, 'footer.newsletterLead');
        const input = newsletterCol.querySelector('input');
        if (input) input.setAttribute('data-i18n-placeholder', 'footer.emailPlaceholder');
      }
    }
    // Footer bottom
    const footerCopy = document.querySelector('.footer-bottom > div:first-child');
    if (footerCopy) {
      // Format: "© 2026 Casa Consignment. All rights reserved."
      const m = footerCopy.textContent.match(/^(© \d{4} Casa Consignment\.) (.+)$/);
      if (m) {
        footerCopy.innerHTML = `${m[1]} <span data-i18n="footer.rights">${m[2]}</span>`;
      }
    }
    const legalLinks = document.querySelectorAll('.legal-links a');
    const llKeys = ['footer.tos']; // Privacy/Cookies/Accessibility/Authenticity-Guarantee links removed
    legalLinks.forEach((a, i) => { if (llKeys[i]) setI18n(a, llKeys[i]); });

    // -------- ACCOUNT MODAL --------
    const accountTitle = document.getElementById('account-title');
    if (accountTitle) setI18n(accountTitle, 'modal.welcome');
    const accountSub = document.getElementById('account-sub');
    if (accountSub) setI18n(accountSub, 'modal.welcomeSub');
    // Tab buttons
    document.querySelectorAll('.tab-row button').forEach(btn => {
      const t = btn.textContent.trim();
      if (t === 'Sign In') setI18n(btn, 'modal.tab.signin');
      else if (t === 'Shop With Us') setI18n(btn, 'modal.tab.shop');
      else if (t.startsWith('Become a Consignor')) {
        // Has NEW pill — wrap text
        wrapText(btn, 'modal.tab.consignor');
      }
    });
    // Auth form placeholders + buttons
    document.querySelectorAll('.auth-form input').forEach(inp => {
      const p = inp.placeholder;
      const m = { 'Email':`modal.email`, 'Password':`modal.password`, 'First name':'modal.firstName', 'Last name':'modal.lastName', 'Choose a password':'modal.createPw' };
      if (m[p]) inp.setAttribute('data-i18n-placeholder', m[p]);
    });
    // "or continue with"
    document.querySelectorAll('.auth-divider').forEach(d => {
      if (d.textContent.trim() === 'or continue with') setI18n(d, 'modal.orContinue');
    });
    // Quick view labels
    const qvDetailGrid = document.querySelectorAll('.detail-grid > div');
    const qvKeys = ['qv.condition','qv.hardware','qv.year','qv.includes'];
    qvDetailGrid.forEach((cell, i) => {
      const span = cell.querySelector('span');
      if (span && qvKeys[i]) setI18n(span, qvKeys[i]);
    });
    const qvAddBtn = document.querySelector('.quickview-info .btn-primary');
    if (qvAddBtn) setI18n(qvAddBtn, 'common.addToBag');
    const qvSaveBtn = document.querySelector('.quickview-info .btn-ghost');
    if (qvSaveBtn) setI18n(qvSaveBtn, 'common.saveWishlist');

    // Product card "View Product" hover label
    document.querySelectorAll('.product-card .quick-add').forEach(qa => {
      const node = Array.from(qa.childNodes).find(n => n.nodeType === 3 && n.textContent.trim() === 'View Product');
      if (node) {
        const span = document.createElement('span');
        span.setAttribute('data-i18n', 'view.product');
        span.textContent = 'View Product';
        node.replaceWith(span);
      }
    });
  }
  tagEverything();

  // =============================================================
  // HTML-aware applyI18n (supports data-i18n-html)
  // =============================================================
  const _origApplyI18n = applyI18n;
  applyI18n = function() {
    _origApplyI18n();
    document.querySelectorAll('[data-i18n-html]').forEach(el => {
      const key = el.getAttribute('data-i18n-html');
      const tr = I18N[currentLang][key];
      if (tr) el.innerHTML = tr;
      else if (I18N.en[key]) el.innerHTML = I18N.en[key];
    });
    // Placeholders
    document.querySelectorAll('[data-i18n-placeholder]').forEach(el => {
      const key = el.getAttribute('data-i18n-placeholder');
      const tr = I18N[currentLang][key];
      if (tr) el.placeholder = tr;
    });
    // Re-render product cards (e.g. View Product label inside quick-add)
    document.querySelectorAll('.product-card .quick-add').forEach(qa => {
      const tr = I18N[currentLang]['view.product'] || 'View Product';
      const span = qa.querySelector('[data-i18n="view.product"]');
      if (span) span.textContent = tr;
    });
  };
  // Apply now with current language
  applyI18n();


  // =============================================================
  // SUPPORT FOOTER UPDATE + CONTACT TICKET + 6HR SLA ALERT
  // =============================================================

  // --- Update Support footer column: "Shipping & Returns" → "Shipping"; FAQ → All Sales Final
  (function updateSupportFooter() {
    document.querySelectorAll('.footer-col ul li a').forEach(a => {
      const t = a.textContent.trim();
      if (t === 'Shipping & Returns') {
        a.textContent = 'Shipping';
        a.setAttribute('data-i18n', 'footer.shipping');
      } else if (t === 'Contact Us') {
        a.setAttribute('data-i18n', 'footer.contact');
        a.style.cursor = 'pointer';
        a.addEventListener('click', (e) => { e.preventDefault(); openContactTicket(); });
      } else if (t === 'FAQ') {
        a.style.cursor = 'pointer';
        a.addEventListener('click', (e) => { e.preventDefault(); openFAQ(); });
      }
    });
  })();

  // --- Translations for new strings
  const CONTACT_I18N = {
    en: { 'footer.shipping': 'Shipping', 'contact.title': 'How can we help?', 'contact.sub': 'A specialist will reach out as soon as possible.', 'contact.category': 'Category', 'contact.subject': 'Subject', 'contact.message': 'Message', 'contact.orderId': 'Order ID (optional)', 'contact.submit': 'Submit Ticket', 'contact.attach': 'Attach a file (optional)', 'faq.title': 'Frequently Asked Questions', 'faq.allSalesFinal': 'Are returns accepted?', 'faq.allSalesFinalBody': 'Pieces are designated Final Sale in the listing and are not eligible for return or exchange. You may cancel an order by emailing info@casaconsignment.com within one hour of placing it. Our authenticity guarantee is separate and always applies: if you believe a piece is not authentic, tell us within 5 days of delivery and we refund the full purchase price and original shipping on its return. Detailed condition notes and HD photography accompany every listing so you can buy with confidence.', 'sla.alertTitle': 'SLA breach', 'sla.alertBody': 'tickets older than 6 hours without a response', 'sla.banner': 'Ticket awaiting response · over 6 hours', 'cat.order': 'Order issue', 'cat.shipping': 'Shipping question', 'cat.auth': 'Authentication question', 'cat.consign': 'Consignment inquiry', 'cat.other': 'Other' },
    es: { 'footer.shipping': 'Envío', 'contact.title': '¿Cómo podemos ayudar?', 'contact.sub': 'Un especialista se pondrá en contacto lo antes posible.', 'contact.category': 'Categoría', 'contact.subject': 'Asunto', 'contact.message': 'Mensaje', 'contact.orderId': 'ID de Pedido (opcional)', 'contact.submit': 'Enviar Ticket', 'contact.attach': 'Adjuntar archivo (opcional)', 'faq.title': 'Preguntas Frecuentes', 'faq.allSalesFinal': '¿Se aceptan devoluciones?', 'faq.allSalesFinalBody': 'Las piezas se designan Venta Final en el anuncio y no son elegibles para devolución o cambio. Puedes cancelar un pedido escribiendo a info@casaconsignment.com dentro de la primera hora. Nuestra garantía de autenticidad es independiente y siempre aplica: si crees que una pieza no es auténtica, avísanos dentro de 5 días de la entrega y reembolsamos el precio completo y el envío original al devolverla. Cada anuncio incluye notas detalladas de condición y fotografía en alta definición.', 'sla.alertTitle': 'Violación de SLA', 'sla.alertBody': 'tickets mayores de 6 horas sin respuesta', 'sla.banner': 'Ticket esperando respuesta · más de 6 horas', 'cat.order': 'Problema con pedido', 'cat.shipping': 'Pregunta de envío', 'cat.auth': 'Pregunta de autenticación', 'cat.consign': 'Consulta de consignación', 'cat.other': 'Otro' },
    fr: { 'footer.shipping': 'Livraison', 'contact.title': 'Comment pouvons-nous aider ?', 'contact.sub': 'Un spécialiste vous contactera dès que possible.', 'contact.category': 'Catégorie', 'contact.subject': 'Sujet', 'contact.message': 'Message', 'contact.orderId': 'ID de Commande (facultatif)', 'contact.submit': 'Envoyer le Ticket', 'contact.attach': 'Joindre un fichier (facultatif)', 'faq.title': 'Questions Fréquentes', 'faq.allSalesFinal': 'Les retours sont-ils acceptés ?', 'faq.allSalesFinalBody': 'Les pièces sont désignées Vente Finale dans l\'annonce et ne peuvent être retournées ni échangées. Vous pouvez annuler une commande en écrivant à info@casaconsignment.com dans l\'heure suivant la commande. Notre garantie d\'authenticité est distincte et s\'applique toujours : si vous pensez qu\'une pièce n\'est pas authentique, prévenez-nous dans les 5 jours suivant la livraison et nous remboursons le prix total et les frais de port initiaux au retour de l\'article. Chaque annonce comporte des notes d\'état détaillées et des photographies haute définition.', 'sla.alertTitle': 'Violation SLA', 'sla.alertBody': 'tickets dépassant 6 heures sans réponse', 'sla.banner': 'Ticket en attente de réponse · plus de 6 heures', 'cat.order': 'Problème de commande', 'cat.shipping': 'Question de livraison', 'cat.auth': "Question d'authentification", 'cat.consign': 'Demande de consignation', 'cat.other': 'Autre' },
    de: { 'footer.shipping': 'Versand', 'contact.title': 'Wie können wir helfen?', 'contact.sub': 'Ein Spezialist meldet sich so schnell wie möglich bei Ihnen.', 'contact.category': 'Kategorie', 'contact.subject': 'Betreff', 'contact.message': 'Nachricht', 'contact.orderId': 'Bestell-ID (optional)', 'contact.submit': 'Ticket Senden', 'contact.attach': 'Datei anhängen (optional)', 'faq.title': 'Häufig Gestellte Fragen', 'faq.allSalesFinal': 'Sind Rückgaben möglich?', 'faq.allSalesFinalBody': 'Stücke werden im Angebot als Final Sale gekennzeichnet und können nicht zurückgegeben oder umgetauscht werden. Sie können eine Bestellung innerhalb einer Stunde per E-Mail an info@casaconsignment.com stornieren. Unsere Echtheitsgarantie gilt davon unabhängig immer: Wenn Sie glauben, dass ein Stück nicht authentisch ist, teilen Sie uns das innerhalb von 5 Tagen nach Lieferung mit, und wir erstatten den vollen Kaufpreis samt ursprünglichem Versand bei Rücksendung. Jedes Angebot enthält detaillierte Zustandsangaben und HD-Fotografie.', 'sla.alertTitle': 'SLA-Verstoß', 'sla.alertBody': 'Tickets älter als 6 Stunden ohne Antwort', 'sla.banner': 'Ticket wartet auf Antwort · über 6 Stunden', 'cat.order': 'Bestellproblem', 'cat.shipping': 'Versandfrage', 'cat.auth': 'Authentifizierungsfrage', 'cat.consign': 'Kommissionsanfrage', 'cat.other': 'Sonstiges' },
    ja: { 'footer.shipping': '配送', 'contact.title': 'どのようにお手伝いできますか？', 'contact.sub': '専門スタッフができるだけ早くご連絡いたします。', 'contact.category': 'カテゴリー', 'contact.subject': '件名', 'contact.message': 'メッセージ', 'contact.orderId': '注文ID（任意）', 'contact.submit': 'チケット送信', 'contact.attach': 'ファイル添付（任意）', 'faq.title': 'よくある質問', 'faq.allSalesFinal': '返品は可能ですか？', 'faq.allSalesFinalBody': '各商品は出品時に「ファイナルセール」として指定され、返品・交換はお受けできません。ご注文から1時間以内であれば info@casaconsignment.com までメールでキャンセルいただけます。真贋保証は別途、常に適用されます。真正でないとお考えの場合は配送後5日以内にご連絡いただければ、ご返送をもって商品代金と当初の送料を全額返金いたします。すべての出品に詳細な状態説明とHD写真を掲載しています。', 'sla.alertTitle': 'SLA違反', 'sla.alertBody': '6時間以上未回答のチケット', 'sla.banner': 'チケット未回答 · 6時間以上経過', 'cat.order': '注文の問題', 'cat.shipping': '配送について', 'cat.auth': '認証について', 'cat.consign': '委託について', 'cat.other': 'その他' },
    zh: { 'footer.shipping': '配送', 'contact.title': '我们如何帮助您？', 'contact.sub': '专家会尽快与您联系。', 'contact.category': '类别', 'contact.subject': '主题', 'contact.message': '消息', 'contact.orderId': '订单ID（可选）', 'contact.submit': '提交工单', 'contact.attach': '附加文件（可选）', 'faq.title': '常见问题', 'faq.allSalesFinal': '可以退货吗？', 'faq.allSalesFinalBody': '所有商品在商品页标注为「最终销售」，不接受退货或换货。下单后一小时内可发送邮件至 info@casaconsignment.com 取消订单。我们的正品保证独立适用：如您认为商品非正品，请在收货后5天内告知我们，退回商品后我们将全额退还购买价款及原始运费。每件商品均附有详细成色说明与高清照片。', 'sla.alertTitle': 'SLA违规', 'sla.alertBody': '超过6小时未回复的工单', 'sla.banner': '工单等待回复 · 超过6小时', 'cat.order': '订单问题', 'cat.shipping': '配送问题', 'cat.auth': '认证问题', 'cat.consign': '寄售咨询', 'cat.other': '其他' }
  };
  Object.keys(CONTACT_I18N).forEach(lang => Object.assign(I18N[lang], CONTACT_I18N[lang]));

  // --- CSS for contact modal + FAQ + SLA banner
  const contactStyle = document.createElement('style');
  contactStyle.textContent = `
    .contact-modal { max-width: 540px; padding: 0; overflow: hidden; }
    .contact-head { padding: 32px 36px 20px; background: linear-gradient(135deg, var(--navy) 0%, var(--navy-deep) 100%); color: #fff; text-align: center; }
    .contact-head h2 { color: #fff; font-size: 26px; font-weight: 500; margin-bottom: 6px; }
    .contact-head p { font-size: 13px; color: rgba(255,255,255,0.75); margin: 0; }
    .contact-body { padding: 28px 36px 32px; }
    .contact-field { margin-bottom: 14px; }
    .contact-field label { display: block; font-size: 11px; letter-spacing: 0.18em; text-transform: uppercase; color: var(--navy); margin-bottom: 6px; }
    .contact-field input, .contact-field select, .contact-field textarea {
      width: 100%;
      padding: 12px 14px;
      border: 1px solid var(--line-control);
      border-radius: 2px;
      background: var(--bg-cream);
      font-family: var(--sans); font-size: 14px;
      color: var(--navy);
    }
    .contact-field textarea { min-height: 110px; resize: vertical; }
    .contact-field input:focus, .contact-field select:focus, .contact-field textarea:focus { outline: none; border-color: var(--navy); }
    .contact-success { text-align: center; padding: 30px 20px; }
    .contact-success svg { width: 56px; height: 56px; color: #2D6A4F; margin-bottom: 14px; }
    .contact-success h3 { font-size: 22px; margin-bottom: 10px; }
    .contact-success .ticket-id { font-family: 'Courier New', monospace; font-size: 14px; color: var(--navy); background: var(--bg); padding: 8px 14px; border-radius: 100px; display: inline-block; margin: 14px 0; letter-spacing: 0.1em; }
    .contact-sla-note { font-size: 12px; color: var(--muted); line-height: 1.5; margin-top: 12px; }
    .contact-sla-note strong { color: var(--navy); }

    /* FAQ modal */
    .faq-modal { max-width: 640px; padding: 0; overflow: hidden; }
    .faq-head { padding: 28px 36px 22px; border-bottom: 1px solid var(--line); }
    .faq-head h2 { font-size: 28px; font-weight: 500; margin-bottom: 4px; }
    .faq-head p { color: var(--muted); font-size: 13px; margin: 0; }
    .faq-body { padding: 24px 36px 32px; max-height: 70vh; overflow-y: auto; }
    .faq-item { padding: 18px 0; border-bottom: 1px solid var(--line); }
    .faq-item:last-child { border-bottom: none; }
    .faq-q { font-family: var(--serif); font-size: 19px; color: var(--navy); margin-bottom: 8px; font-weight: 500; }
    .faq-a { font-size: 14px; color: var(--navy-soft); line-height: 1.7; }
    .faq-final { background: linear-gradient(135deg, #FFF4E0 0%, #FFE9C2 100%); border-left: 4px solid var(--gold); padding: 18px 20px; border-radius: 2px; margin: 0 0 22px; }
    .faq-final .faq-q { color: #6B5418; margin-bottom: 6px; }
    .faq-final .faq-a { color: #6B5418; }

    /* SLA alert banner */
    .sla-banner {
      background: linear-gradient(90deg, #B33A3A 0%, #8B2222 100%);
      color: #fff;
      padding: 12px 20px;
      display: flex; align-items: center; gap: 14px;
      border-radius: 2px;
      margin-bottom: 22px;
      box-shadow: 0 4px 14px rgba(179,58,58,0.25);
    }
    .sla-banner svg { width: 22px; height: 22px; flex-shrink: 0; animation: slaPulse 2s ease-in-out infinite; }
    @keyframes slaPulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.5; } }
    .sla-banner .sla-text { flex: 1; font-size: 13px; line-height: 1.5; }
    .sla-banner .sla-text strong { display: block; font-size: 10px; letter-spacing: 0.22em; text-transform: uppercase; margin-bottom: 2px; }
    .sla-banner button { background: rgba(255,255,255,0.2); border: 1px solid rgba(255,255,255,0.4); color: #fff; padding: 7px 14px; border-radius: 2px; font-size: 11px; letter-spacing: 0.18em; text-transform: uppercase; cursor: pointer; transition: background 0.2s; }
    .sla-banner button:hover { background: rgba(255,255,255,0.32); }

    /* Account icon SLA notification dot */
    .nav-right .icon-btn.has-alert::after {
      content: '';
      position: absolute;
      top: 4px; right: 4px;
      width: 8px; height: 8px;
      background: #B33A3A;
      border-radius: 50%;
      border: 2px solid var(--bg-cream);
      animation: slaPulse 2s ease-in-out infinite;
    }
  `;
  document.head.appendChild(contactStyle);

  // --- Contact ticket modal HTML
  const contactModal = document.createElement('div');
  contactModal.id = 'modal-contact';
  contactModal.className = 'modal-backdrop';
  contactModal.addEventListener('click', (e) => { if (e.target === contactModal) closeModal('contact'); });
  contactModal.innerHTML = `
    <div class="modal contact-modal">
      <button class="modal-close" aria-label="Close" onclick="closeModal('contact')" style="z-index:5; color:#fff;"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 6l12 12M18 6L6 18"/></svg></button>
      <div class="contact-head">
        <h2 data-i18n="contact.title">How can we help?</h2>
        <p data-i18n="contact.sub">A specialist will reach out as soon as possible.</p>
      </div>
      <div class="contact-body" id="contact-body">
        <form id="contact-form" onsubmit="return submitContactTicket(event)">
          <div class="contact-field">
            <label data-i18n="contact.category">Category</label>
            <select id="contact-cat" required>
              <option value="Order" data-i18n="cat.order">Order issue</option>
              <option value="Shipping" data-i18n="cat.shipping">Shipping question</option>
              <option value="Authentication" data-i18n="cat.auth">Authentication question</option>
              <option value="Consignment" data-i18n="cat.consign">Consignment inquiry</option>
              <option value="Membership" data-i18n="cat.membership">Concierge Club / membership</option>
              <option value="Feedback" data-i18n="cat.feedback">Compliment or feedback</option>
              <option value="Other" data-i18n="cat.other">Other</option>
            </select>
          </div>
          <!-- Name + email. Added 6 Aug 2026: this form had NEITHER, and the
               handler sent window.casaUser.email — which is empty for a guest.
               Every ticket from a signed-out visitor therefore reached Casa as
               "From: (guest)" with no reply-to and no acknowledgement to the
               customer. api/tickets.js already branches correctly on a truthy
               email; the form simply never supplied one.
               Prefilled and left editable when signed in. -->
          <div class="contact-field">
            <label data-i18n="contact.name">Your name</label>
            <input type="text" id="contact-name" autocomplete="name">
          </div>
          <div class="contact-field">
            <label data-i18n="contact.email">Your email</label>
            <input type="email" id="contact-email" autocomplete="email" placeholder="you@example.com">
            <span id="contact-email-note" style="display:block; font-size:11px; color:var(--muted); margin-top:5px; line-height:1.5;" data-i18n="contact.emailNote">So we can reply. We only use it to answer this message.</span>
          </div>
          <div class="contact-field">
            <label data-i18n="contact.orderId">Order ID (optional)</label>
            <input type="text" id="contact-order" placeholder="#4521">
          </div>
          <div class="contact-field">
            <label data-i18n="contact.subject">Subject</label>
            <input type="text" id="contact-subject" required>
          </div>
          <div class="contact-field">
            <label data-i18n="contact.message">Message</label>
            <textarea id="contact-message" required placeholder=""></textarea>
          </div>
          <div class="contact-field">
            <label data-i18n="contact.attach">Attach a file (optional)</label>
            <div class="upload-thumbs" id="ticket-photo-thumbs"></div>
            <input type="file" id="ticket-photo-input" accept="image/*" multiple style="display:none">
            <button type="button" class="btn btn-ghost btn-sm" onclick="document.getElementById('ticket-photo-input').click()">+ Add photo</button>
            <span style="display:block; font-size:11px; color:var(--muted); margin-top:5px; line-height:1.5;">JPG or PNG, up to 5 photos — a screenshot, receipt, or picture of the item helps a specialist answer faster.</span>
          </div>
          <button type="submit" class="btn btn-primary btn-block" style="margin-top: 14px;" data-i18n="contact.submit">Submit Ticket</button>
          <div class="contact-sla-note">
            A specialist will reach out as soon as possible.
          </div>
        </form>
        <div class="contact-success" id="contact-success" style="display:none;">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m5 13 4 4L19 7"/></svg>
          <h3>Ticket received</h3>
          <p style="color: var(--muted); font-size: 14px; max-width: 360px; margin: 0 auto;">A specialist will reach out as soon as possible. Track replies in your inbox or your account.</p>
          <div class="ticket-id" id="contact-ticket-id">#0000</div>
        </div>
      </div>
    </div>
  `;
  document.body.appendChild(contactModal);

  // --- FAQ modal
  const faqModal = document.createElement('div');
  faqModal.id = 'modal-faq';
  faqModal.className = 'modal-backdrop';
  faqModal.addEventListener('click', (e) => { if (e.target === faqModal) closeModal('faq'); });
  faqModal.innerHTML = `
    <div class="modal faq-modal">
      <button class="modal-close" aria-label="Close" onclick="closeModal('faq')"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 6l12 12M18 6L6 18"/></svg></button>
      <div class="faq-head">
        <h2 data-i18n="faq.title">Frequently Asked Questions</h2>
        <p>Everything you need to know before shopping or consigning.</p>
      </div>
      <div class="faq-body">
        <div class="faq-final">
          <div class="faq-q" data-i18n="faq.allSalesFinal">Are returns accepted?</div>
          <div class="faq-a" data-i18n="faq.allSalesFinalBody">Pieces are designated Final Sale in the listing and are not eligible for return or exchange. You may cancel an order by emailing info@casaconsignment.com within one hour of placing it. Our authenticity guarantee is separate and always applies: if you believe a piece is not authentic, tell us within 5 days of delivery and we refund the full purchase price and original shipping on its return. Detailed condition notes and HD photography accompany every listing so you can buy with confidence.</div>
        </div>
        <div class="faq-item"><div class="faq-q">How long does shipping take?</div><div class="faq-a">Insured standard shipping is 3–5 business days, fully insured up to the item's value.</div></div>
        <div class="faq-item"><div class="faq-q">How are items authenticated?</div><div class="faq-a">Every item is authenticated by our in-house specialists, who inspect the piece and review the certificate and tag that accompany it before it is listed.</div></div>
        <!-- 16 Sep 2026, Erich: removed "The case ID and full certificate appear on each product
             page and stay with the bag for its lifetime." Certificates have been hidden from
             the storefront since 4 Aug 2026, so the sentence promised something no page shows.
             The matching "Your certificate" item in the Authentication modal went too. -->

        <div class="faq-item"><div class="faq-q">What if my package is damaged in transit?</div><div class="faq-a">Open a Shipping ticket as soon as you notice, with photos of the outer box and contents — the sooner we have them, the stronger the carrier claim. We file the insurance claim with FedEx on your behalf.</div></div>
        <!-- Conformed to Consignor Terms §6. §6.1 sets the commission by the item's
             Offer Summary rather than a published grid; §6.2 sets payout within 30 days
             of a sale being Finalized (itself ~25 days after the sale) and limits methods
             to ACH or check. The previous copy promised 7–14 business days and store
             credit, which contradicted §6.2 and the "No Stored Value" clause in the
             Membership Terms §2.3. -->
        <div class="faq-item"><div class="faq-q">How does consignment payout work?</div><div class="faq-a">Your commission rate is stated in the Offer Summary you accept for each piece, and is applied to the Net Sale Price (the amount we receive, excluding sales tax and shipping collected from the buyer, less any discounts). Indicative rates run 75% to you on pieces under $5,000 and 80% on pieces $5,000 and over — your Offer Summary controls. A sale is Finalized once we have the proceeds in full and the buyer's return window has closed without a return or chargeback, typically about 25 days after the piece sells. We pay you within 30 days of that, by ACH to your U.S. bank account or by check. See the <a class="lnk-consignor-terms" style="color:var(--navy);text-decoration:underline;cursor:pointer;">Consignor Terms of Service</a> for full terms.</div></div>
        <div class="faq-item"><div class="faq-q">Can I cancel an order?</div><div class="faq-a">Orders may be cancelled within 1 hour of placement if they have not yet been packed. After that, the order is final.</div></div>
        <div class="faq-item"><div class="faq-q">Do you ship internationally?</div><div class="faq-a">Not yet. We currently ship within the United States only, fully insured to the item’s value. We are finalising insured international service and expect to open it shortly — email <a href="mailto:info@casaconsignment.com">info@casaconsignment.com</a> if you would like to be notified, or if you are outside the U.S. and interested in a specific piece.</div></div>
      </div>
    </div>
  `;
  document.body.appendChild(faqModal);

  // --- Ticket creation
  let nextTicketId = 7842;
  function generateTicketId() { return '#' + (nextTicketId++); }

  // Is there unsent work sitting in the contact modal? Any typed field, any
  // attached photo, or any upload still running counts. Three fields are left out
  // on purpose, because a value in them is not evidence the visitor started
  // writing: #contact-cat has no blank option so it always holds one, and
  // #contact-name / #contact-email are prefilled from the session by the observer
  // near the end of this file — counting those would make every reopen read as a
  // draft for anyone signed in.
  function casaTicketDraftInProgress() {
    var ids = ['contact-order', 'contact-subject', 'contact-message'];
    for (var i = 0; i < ids.length; i++) {
      var el = document.getElementById(ids[i]);
      if (el && String(el.value || '').trim()) return true;
    }
    return (window.casaTicketPhotos && window.casaTicketPhotos.length > 0) ||
           (window.casaTicketPhotosPending || 0) > 0;
  }

  window.openContactTicket = function() {
    var form = document.getElementById('contact-form');
    var succ = document.getElementById('contact-success');
    // A sent ticket leaves #contact-success showing and the form hidden (see
    // submitContactTicket). Read that BEFORE clearing it below: it is the only
    // signal separating "reopening after sending", which must start a clean
    // ticket, from "reopening mid-compose", which must not.
    var afterSend = !!(succ && succ.style.display === 'block');
    if (form) form.style.display = '';
    if (succ) succ.style.display = 'none';
    // #contact-body is restored too. It should never be hidden any more (see the
    // submit handler), but a stale 'none' here left the modal completely empty
    // and there is no cost to being certain.
    var _b = document.getElementById('contact-body'); if (_b) _b.style.display = '';
    // Five links re-enter this modal (footer, top menu, and the Shipping /
    // Authentication modals' "contact a specialist"), and reopening used to clear
    // the form unconditionally. That threw away whatever had been typed, and —
    // worse — casaResetTicketPhotos() minted a fresh submission ref while earlier
    // uploads were still in flight, so a single ticket's attachments arrived under
    // two different refs. Ticket #19 (3 Sep 2026) is the worked example. Only clear
    // when there is nothing to lose.
    if (afterSend || !casaTicketDraftInProgress()) {
      if (form) form.reset();
      if (typeof window.casaResetTicketPhotos === 'function') window.casaResetTicketPhotos();
    }
    openModal('contact');
  };
  window.openFAQ = function() { openModal('faq'); };

  applyI18n();


  // =============================================================
  // NEW INVENTORY — Kelly 25 Gris Mouette + Tiffany T Bracelet
  //                + new brands (Tiffany & Co., Van Cleef & Arpels)
  //                + real Chanel size guide + LEGIT APP tag visual
  // =============================================================

  // Image paths (URL-encoded for spaces)
  const KELLY_GRIS_DIR = 'Bags%20images/Hermes%20Kelly%2025%20Gris%20Mouette/';
  const KELLY_GRIS_FRONT = KELLY_GRIS_DIR + 'Hermes%20kelly%2025%20Gris%20Mouette%20front.JPG';
  const KELLY_GRIS_BACK = KELLY_GRIS_DIR + 'Hermes%20kelly%2025%20Gris%20Mouette%20back.JPG';
  const KELLY_GRIS_SIDE = KELLY_GRIS_DIR + 'Hermes%20kelly%2025%20Gris%20Mouette%20side.JPG';
  const KELLY_GRIS_BOTTOM = KELLY_GRIS_DIR + 'Hermes%20kelly%2025%20Gris%20Mouette%20bottom%20.JPG';
  const KELLY_GRIS_UPCLOSE = KELLY_GRIS_DIR + 'Hermes%20kelly%2025%20Gris%20Mouette%20up%20close.JPG';
  const KELLY_GRIS_ZIPPER = KELLY_GRIS_DIR + 'Hermes%20kelly%2025%20Gris%20Mouette%20zipper.JPG';
  const KELLY_GRIS_BOX = KELLY_GRIS_DIR + 'Hermes%20kelly%2025%20Gris%20Mouette%20box.JPG';

  const TIFFANY_DIR = 'Bags%20images/Tiffany%20%26%20Co.%20T%20Bracelet%20so%20tea%20consignment/';
  const TIFFANY_FRONT = TIFFANY_DIR + 'Tiffany%20%26%20Co%20T%20Bracelet%20front.JPG';
  const TIFFANY_BACK = TIFFANY_DIR + 'Tiffany%20%26%20Co%20T%20Bracelet%20back.JPG';
  const TIFFANY_BOX = TIFFANY_DIR + 'Tiffany%20%26%20Co%20T%20Bracelet%20box.JPG';

  const AUTH_TAG_IMG = '';   // So TEA asset folder not in this repo — see below
  const AUTH_CERT_IMG = '';  // So TEA asset folder not in this repo — see below
  const CHANEL_SIZING_IMG = window.CASA_ASSET('Chanel_sizing_infopage_casaconsignment.jpg');

  // Extend brandCode for new brands
  brandCode['Tiffany & Co.'] = 'TIF';
  brandCode['Van Cleef & Arpels'] = 'VCA';
  brandCode['Bottega Veneta'] = 'BV';
  brandCode['Saint Laurent'] = 'YSL';

  // --- ADD NEW BRANDS to BRANDS array (before Bottega/Saint Laurent if present)
  // Find index of Bottega
  const bottegaIdx = BRANDS.findIndex(b => b.key === 'bottega');
  const tiffanyBrand = {
    key:'tiffany', name:'Tiffany & Co.',
    svg:'<circle cx="50" cy="58" r="20" fill="#dcdcdc" stroke="none"/><circle cx="50" cy="58" r="20"/><rect x="42" y="28" width="16" height="14" fill="#dcdcdc" stroke="none"/><rect x="42" y="28" width="16" height="14" rx="2"/><text x="50" y="63" text-anchor="middle" font-family="serif" font-size="16" font-weight="700" fill="#141414">T&amp;Co</text>'
  };
  const vcaBrand = {
    key:'vca', name:'Van Cleef & Arpels',
    svg:'<path d="M50 28 Q60 38, 70 38 Q60 50, 60 60 Q50 50, 40 60 Q40 50, 30 38 Q40 38, 50 28 Z" fill="#dcdcdc" stroke="none"/><path d="M50 28 Q60 38, 70 38 Q60 50, 60 60 Q50 50, 40 60 Q40 50, 30 38 Q40 38, 50 28 Z"/><circle cx="50" cy="44" r="3" fill="#141414"/>'
  };
  if (bottegaIdx >= 0) {
    BRANDS.splice(bottegaIdx, 0, tiffanyBrand, vcaBrand);
  } else {
    BRANDS.push(tiffanyBrand, vcaBrand);
  }

  arrivals.forEach(a => { a.sku = buildSku(a.brand, a.year, a.seq); });

  // --- Re-render brand grids, product grids, filters
  renderDesignerCards();
  renderBrandFilters();
  if (document.getElementById('home-arrivals')) document.getElementById('home-arrivals').innerHTML = arrivals.slice(0,4).map(productCard).join('');
  document.getElementById('shop-grid').innerHTML = arrivals.map(productCard).join('');

  // --- Update Shop header count to reflect actual inventory size
  (function updateShopCount() {
    const headerP = document.querySelector('#view-shop .shop-header p');
    if (headerP) {
      const count = arrivals.length;
      headerP.textContent = `${count} curated pieces — from heritage handbags to fine jewelry.`;
      headerP.setAttribute('data-i18n-original', headerP.textContent);
    }
    const results = document.querySelector('.result-count');
    if (results) {
      results.innerHTML = `Showing <strong>1–${arrivals.length}</strong> of ${arrivals.length}`;
    }
  })();

  // --- Showcase thumbnails: real Casa stock only
  //
  // This block used to point slots 1 and 2 at an Hermès Kelly 25 and a Tiffany T
  // bracelet carried over from So TEA. Casa has neither the photography (the
  // "Bags images/" folder is not in this repo, so both 404'd in production) nor
  // the inventory — the catalogue has no Hermès and no jewellery. The homepage
  // showcase is captioned "This week's selects", so it has to show pieces a
  // visitor can actually click through and buy.
  const SHOWCASE_ALT_1 = 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0026-front.jpg?v=1785902986';
  const SHOWCASE_ALT_2 = 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0004-front.jpg?v=1785902728';
  (function updateShowcaseThumbs() {
    showcaseItems[1] = {
      type:'image', src: SHOWCASE_ALT_1,
      brand:'Louis Vuitton', name:'Capucines MM · Beige/Yellow',
      size:'Medium', color:'Beige/Yellow · Gold hardware', swatch:'#D8C9A3'
    };
    showcaseItems[2] = {
      type:'image', src: SHOWCASE_ALT_2,
      brand:'Chanel', name:'Coco Handle · Caviar',
      size:'Small', color:'Black · Caviar', swatch:'#1A1A1A'
    };
    const thumbs = document.querySelectorAll('.showcase-thumbs .showcase-thumb');
    if (thumbs[1]) { const i = thumbs[1].querySelector('img'); if (i) i.src = SHOWCASE_ALT_1; }
    if (thumbs[2]) { const i = thumbs[2].querySelector('img'); if (i) i.src = SHOWCASE_ALT_2; }
  })();

  // --- Update Chanel Size Guide tab to use real chart image
  (function updateChanelSizeGuide() {
    const chanelPanel = document.getElementById('sg-chanel');
    if (chanelPanel) {
      chanelPanel.innerHTML = `
        <h3 style="font-family: var(--sans); font-size: 13px; letter-spacing: 0.18em; text-transform: uppercase; color: var(--navy); margin-bottom: 18px; font-weight: 500;">Chanel Classic Flap</h3>
        <img src="${CHANEL_SIZING_IMG}" alt="Chanel Classic Flap size guide — Square Mini through Maxi with measurements and strap lengths" style="width:100%; height:auto; border-radius:2px;">
        <div class="tip">
          <strong style="display: block; font-size: 10px; letter-spacing: 0.22em; text-transform: uppercase; color: var(--navy); margin-bottom: 6px;">Stylist's Note</strong>
          The <strong>Medium</strong> Classic Flap is the most timeless everyday choice — fits phone, cardholder, and lipstick. The <strong>Jumbo</strong> adds room for a small wallet and sunglasses. Caviar wears beautifully over years; lambskin is softer but shows wear faster.
        </div>
      `;
    }
  })();

  // =============================================================
  // SHOP FILTERS + SORT + GALLERY + CONSIGNMENT REQUEST ROUTING
  // =============================================================

  // -----------------------------------------------------------------------
  // 1) PHOTO GALLERIES — add full galleries for existing BAG 1/2/3
  // -----------------------------------------------------------------------
  function buildBagGallery(prefix, count) {
    const out = [];
    for (let i = 1; i <= count; i++) out.push(`Bags%20images/${prefix}%20-%20${i}.jpg`);
    return out;
  }
  arrivals.forEach(a => {
    if (a.gallery && a.gallery.length) return;
    if (a.img && a.img.includes('BAG%201')) a.gallery = buildBagGallery('BAG%201', 6);
    else if (a.img && a.img.includes('BAG%202')) a.gallery = buildBagGallery('BAG%202', 6);
    else if (a.img && a.img.includes('BAG%203')) a.gallery = buildBagGallery('BAG%203', 5);
    else if (a.img) a.gallery = [a.img];
    else a.gallery = [];
  });

  // -----------------------------------------------------------------------
  // 2) QUICK VIEW PHOTO GALLERY
  // -----------------------------------------------------------------------
  const galleryStyle = document.createElement('style');
  galleryStyle.textContent = `
    .quickview { grid-template-columns: 1.05fr 1fr; }
    @media (max-width: 860px) {
      .quickview { grid-template-columns: 1fr; }
      /* Mobile photo sizing, 2 Sep 2026 per Erich. Was min-height:300px with
         no definite height anywhere below it, so .qv-carousel (flex:1) settled
         at ~200px once the thumb strip took its cut and the photo rendered at
         roughly 25% of the screen. Give the carousel an explicit
         viewport-relative height instead so the photo is the hero. The dvh
         line tracks the collapsing mobile URL bar; the vh line above it is the
         fallback for browsers that don't know dvh. */
      /* .quickview is a grid and .quickview-img-wrap a nested flex column. A
         fixed carousel height inside that squeezed the thumb strip from 73px
         down to 20px, so the wrap goes display:block here and the grid keeps
         its rows content-sized (align-content:start) instead of distributing
         them into the sheet's height.
         The photo is square (sources are 1512x1512), so its height can never
         exceed the screen's width -- aspect-ratio:1 sizes the stage to exactly
         that and wastes no space, with max-height as a guard for short
         landscape screens. Edge-to-edge, no slide padding: on a 393-430px
         phone that lands the photo near 46% of screen height (the physical
         ceiling for an uncropped square) with the thumb strip taking the
         photo block to roughly 54%. */
      /* .quickview is a single-column grid here, and a grid row will not size
         itself to a child whose height comes from aspect-ratio -- the row
         collapsed to 46px and the photo painted straight over the details.
         Plain block flow stacks the same way and sizes correctly. */
      #modal-quickview .quickview { display: block; }
      #modal-quickview .quickview-img-wrap { display: block; height: auto; min-height: 0; }
      #modal-quickview .qv-carousel { flex: none; height: auto; aspect-ratio: 1 / 1; max-height: 62vh; }
      #modal-quickview .qv-slide { padding: 0; }
      /* Override the desktop min(460px, 100%) ceiling: the carousel now has a
         definite height so the 100% term resolves, and a flat 460px would cap
         the photo short of the 58vh box on taller phones. */
      #modal-quickview .qv-slide img,
      #modal-quickview .qv-slide video { max-height: 100%; max-width: 100%; }

      /* Swipe between photos natively. Split-tap navigation moved off mobile
         because the tap now opens the zoom viewer (see qvOpenZoom). */
      #modal-quickview .qv-carousel {
        overflow-x: auto; overflow-y: hidden;
        scroll-snap-type: x mandatory;
        overscroll-behavior-x: contain;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: none;
      }
      #modal-quickview .qv-carousel::-webkit-scrollbar { display: none; }
      #modal-quickview .qv-slide { scroll-snap-align: center; }

      /* Arrows are hover-revealed on desktop and there is no hover on touch,
         so pin them visible at a full 44x44 target. */
      #modal-quickview .qv-arrow { opacity: 1; pointer-events: auto; width: 44px; height: 44px; }
      #modal-quickview .qv-arrow-left { left: 8px; }
      #modal-quickview .qv-arrow-right { right: 8px; }
      #modal-quickview .qv-hint { bottom: 10px; font-size: 8.5px; padding: 5px 12px; white-space: nowrap; }
      #modal-quickview .qv-hint-desktop { display: none; }
      #modal-quickview .qv-hint-mobile { display: inline; }

      /* Thumb strip trimmed so it takes as little of the 58vh budget as it can */
      #modal-quickview .quickview-thumbs { flex: 0 0 auto; padding: 10px 14px; gap: 6px; }
      #modal-quickview .quickview-thumb { flex: 0 0 52px; width: 52px; height: 52px; }

      /* Supporting copy scales down so more of it clears the fold under the
         bigger photo. Nothing here drops below the 12px body-text floor. */
      #modal-quickview .quickview-info h2 { font-size: 22px; line-height: 1.25; margin-bottom: 12px; }
      #modal-quickview .quickview-info .brand-tag { font-size: 9px; margin-bottom: 8px; }
      #modal-quickview .quickview-info .price { font-size: 19px; }
      #modal-quickview .quickview-info .retail { font-size: 12px; margin-bottom: 16px; }
      #modal-quickview .quickview-info .desc { font-size: 12.5px; line-height: 1.6; margin-bottom: 16px; }
      #modal-quickview .quickview-info .qv-spec { margin-bottom: 10px; }
      #modal-quickview .quickview-info .qv-spec li { font-size: 12.5px; padding: 5px 0 5px 14px; }
      #modal-quickview .quickview-info .qv-spec li:before { top: 11px; }
      #modal-quickview .quickview-info .qv-ship { font-size: 10.5px; margin-bottom: 16px; }
      /* Product quick view -> full-height, scrollable sheet on small screens.
         Base .modal.large uses overflow:hidden + inherits max-height:90vh, which
         clipped the stacked image + details on mobile with no way to scroll
         ("can't see the details or pictures"). Scoped to #modal-quickview so the
         account / contact / FAQ modals keep their centered card behavior. */
      #modal-quickview { padding: 0; align-items: stretch; }
      #modal-quickview .modal.large {
        max-width: 100%; width: 100%;
        max-height: 100%; height: 100%;
        border-radius: 0;
        overflow: hidden;              /* modal frame stays put... */
      }
      #modal-quickview .quickview {
        height: 100%;
        overflow-y: auto;              /* ...inner content scrolls (image + all details) */
        -webkit-overflow-scrolling: touch;
      }
      #modal-quickview .quickview-info { padding: 22px 20px 40px; }
      /* Keep the close (X) pinned + visible over content so there's always a
         way to exit — it used to scroll off-screen on mobile. */
      #modal-quickview .modal-close {
        position: absolute; top: 12px; right: 12px; z-index: 20;
        width: 40px; height: 40px;
        background: rgba(255,255,255,0.94);
        box-shadow: 0 2px 10px rgba(0,0,0,0.18);
      }
    }
    @media (min-width: 861px) {
      /* Desktop: give the quick view a definite height so the image column
         (with its thumbnail strip) is fully visible, and the details column
         scrolls internally instead of the modal clipping the bottom.
         Was 88vh (near-fullscreen) — cut to roughly half per Erich/Alexa,
         27 Aug 2026: same width, just short enough to still see the page
         (and the product grid) around it rather than covering everything. */
      #modal-quickview .modal.large { height: 50vh; max-height: 50vh; }
      #modal-quickview .quickview { height: 100%; }
      #modal-quickview .quickview-img-wrap { height: 100%; min-height: 0; }
      #modal-quickview .quickview-info { height: 100%; min-height: 0; overflow-y: auto; }
    }
    .quickview-img-wrap { display: flex; flex-direction: column; background: var(--bg); min-height: 240px; }
    .qv-carousel { flex: 1; position: relative; overflow: hidden; cursor: pointer; background: var(--bg-cream); scroll-behavior: smooth; }
    .qv-track { display: flex; height: 100%; }
    .qv-slide { flex: 0 0 100%; height: 100%; display: flex; align-items: center; justify-content: center; padding: 24px; box-sizing: border-box; }
    /* max-height was a flat 460px, taller than the carousel's real available
       height on most screens once the desktop modal went from 88vh to 50vh
       (27 Aug 2026) — .qv-carousel's overflow:hidden then clipped the bottom
       of every product photo. min(460px, 100%) caps to whichever is smaller:
       the old 460px ceiling, or the slide's actual rendered height (100%,
       resolved since every ancestor up to .modal.large now has a definite
       height on desktop). On mobile the sheet scrolls and heights are
       auto/indefinite, so the 100% term doesn't resolve and this is
       equivalent to the old plain 460px — unchanged there. */
    .qv-slide img, .qv-slide video { max-width: 100%; max-height: min(460px, 100%); width: auto; height: auto; object-fit: contain; }
    .qv-arrow { position: absolute; top: 50%; transform: translateY(-50%); width: 44px; height: 44px; display: flex; align-items: center; justify-content: center; background: rgba(255,255,255,0.9); border-radius: 50%; box-shadow: 0 4px 14px rgba(0,0,0,0.14); color: var(--text); font-size: 22px; line-height: 1; opacity: 0; transition: opacity .25s; pointer-events: none; z-index: 4; }
    .qv-arrow-left { left: 16px; } .qv-arrow-right { right: 16px; }
    .qv-carousel:hover .qv-arrow { opacity: 1; }
    .qv-hint { position: absolute; bottom: 14px; left: 50%; transform: translateX(-50%); background: rgba(20,20,20,0.72); color: #fff; padding: 6px 16px; border-radius: 100px; font-size: 9px; letter-spacing: 0.22em; text-transform: uppercase; pointer-events: none; display: flex; gap: 14px; align-items: center; transition: opacity .3s; }
    .qv-hint-mobile { display: none; }
    .quickview-thumbs { display: flex; gap: 8px; padding: 14px 18px; background: #fff; border-top: 1px solid var(--line); overflow-x: auto; }
    .quickview-thumb { flex: 0 0 64px; width: 64px; height: 64px; background: var(--bg); border: 2px solid transparent; border-radius: 2px; cursor: pointer; overflow: hidden; transition: border-color .2s, transform .2s; }
    .quickview-thumb:hover { transform: translateY(-2px); }
    .quickview-thumb.active { border-color: var(--text); }
    .quickview-thumb img, .quickview-thumb video { width: 100%; height: 100%; object-fit: cover; pointer-events: none; }

    /* Full-screen photo zoom. Opened by tapping the photo on mobile (2 Sep
       2026 per Erich) so shoppers can inspect leather grain, stamps and wear
       up close. Pinch, drag to pan, double-tap to toggle. */
    .qv-zoom { position: fixed; inset: 0; z-index: 2147483000; background: rgba(12,12,12,0.97); display: none; align-items: center; justify-content: center; overflow: hidden; touch-action: none; }
    .qv-zoom.open { display: flex; }
    .qv-zoom-stage { width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; overflow: hidden; touch-action: none; }
    .qv-zoom-stage img { max-width: 100%; max-height: 100%; width: auto; height: auto; object-fit: contain; transform-origin: center center; will-change: transform; pointer-events: none; -webkit-user-select: none; user-select: none; }
    .qv-zoom-close { position: absolute; top: 12px; top: max(12px, env(safe-area-inset-top)); right: 12px; width: 44px; height: 44px; display: flex; align-items: center; justify-content: center; padding: 0; border: none; border-radius: 50%; background: rgba(255,255,255,0.94); color: #141414; font-size: 18px; line-height: 1; cursor: pointer; z-index: 2; box-shadow: 0 2px 10px rgba(0,0,0,0.3); }
    .qv-zoom-hint { position: absolute; bottom: 20px; bottom: max(20px, env(safe-area-inset-bottom)); left: 50%; transform: translateX(-50%); background: rgba(255,255,255,0.16); color: #fff; padding: 6px 16px; border-radius: 100px; font-size: 9px; letter-spacing: 0.2em; text-transform: uppercase; pointer-events: none; transition: opacity .3s; }
    .qv-zoom-hint.hidden { opacity: 0; }
  `;
  document.head.appendChild(galleryStyle);

  // Rebuild the quick-view media area as a click-to-advance carousel (snaps to each picture)
  (function restructureQuickView() {
    const qvBody = document.querySelector('.quickview');
    if (!qvBody) return;
    const oldImg = qvBody.querySelector('.quickview-img');
    const wrap = document.createElement('div');
    wrap.className = 'quickview-img-wrap';
    wrap.innerHTML = `
      <div class="qv-carousel" id="qv-carousel">
        <div class="qv-track" id="qv-track"></div>
        <div id="qv-img" style="display:none"></div>
        <div class="qv-arrow qv-arrow-left">&#8249;</div>
        <div class="qv-arrow qv-arrow-right">&#8250;</div>
        <div class="qv-hint" id="qv-hint"><span class="qv-hint-desktop">&#9664; click left</span><span class="qv-hint-desktop">click right &#9654;</span><span class="qv-hint-mobile">tap to zoom &middot; swipe for more</span></div>
      </div>
      <div class="quickview-thumbs" id="qv-thumbs"></div>
    `;
    if (oldImg) qvBody.replaceChild(wrap, oldImg);
  })();

  let qvMedia = [];
  let qvIndex = 0;

  function qvSlideHTML(m) {
    return m.type === 'video'
      ? `<div class="qv-slide"><video src="${m.src}" autoplay muted loop playsinline></video></div>`
      : `<div class="qv-slide"><img src="${m.src}" alt="Product image" draggable="false"></div>`;
  }
  function qvScrollTo(i, smooth) {
    const c = document.getElementById('qv-carousel');
    if (!c) return;
    c.scrollTo({ left: i * c.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
  }
  function qvUpdateThumbs() {
    document.querySelectorAll('#qv-thumbs .quickview-thumb').forEach((t, i) => t.classList.toggle('active', i === qvIndex));
  }
  function qvGo(dir) {
    if (qvMedia.length < 2) return;
    qvIndex = (qvIndex + dir + qvMedia.length) % qvMedia.length;
    qvScrollTo(qvIndex, true);
    qvUpdateThumbs();
  }
  function qvBuild() {
    const track = document.getElementById('qv-track');
    const carousel = document.getElementById('qv-carousel');
    const thumbs = document.getElementById('qv-thumbs');
    const hint = document.getElementById('qv-hint');
    if (!track || !carousel) return;
    track.innerHTML = qvMedia.map(qvSlideHTML).join('');
    qvIndex = 0;
    qvScrollTo(0, false);
    if (thumbs) {
      thumbs.style.display = qvMedia.length > 1 ? '' : 'none';
      thumbs.innerHTML = qvMedia.map((m, idx) => `
        <div class="quickview-thumb ${idx === 0 ? 'active' : ''}" onclick="qvJump(${idx})">
          ${m.type === 'video' ? `<video src="${m.src}" muted></video>` : `<img src="${m.src}" alt="Thumbnail ${idx+1}">`}
        </div>`).join('');
    }
    if (hint) hint.style.opacity = qvMedia.length > 1 ? '1' : '0';
    qvUpdateThumbs();
  }
  window.qvJump = function(idx) { qvIndex = idx; qvScrollTo(idx, true); qvUpdateThumbs(); };

  // Desktop: click the left or right half of the picture to step to the
  // previous / next picture. Mobile (<= 860px): the tap opens the zoom viewer
  // instead, and stepping moves to swipe or the two pinned arrow buttons --
  // a tap can only mean one thing, and on a phone zoom is what shoppers reach
  // for first. (2 Sep 2026, Erich.)
  const qvIsMobile = () => window.matchMedia('(max-width: 860px)').matches;
  document.addEventListener('click', (e) => {
    const c = document.getElementById('qv-carousel');
    if (!c || !e.target.closest('#qv-carousel')) return;
    const arrow = e.target.closest('.qv-arrow');
    if (arrow) { qvGo(arrow.classList.contains('qv-arrow-left') ? -1 : 1); return; }
    if (qvIsMobile()) {
      if (qvTouchMoved) { qvTouchMoved = false; return; }  // that was a swipe, not a tap
      qvOpenZoom();
      return;
    }
    const r = c.getBoundingClientRect();
    qvGo((e.clientX - r.left) < r.width / 2 ? -1 : 1);
  });
  // Keyboard arrows step too
  document.addEventListener('keydown', (e) => {
    const open = document.getElementById('modal-quickview') && document.getElementById('modal-quickview').classList.contains('open');
    if (!open) return;
    if (qvZoomIsOpen()) return;   // arrows belong to the zoom viewer while it's up
    if (e.key === 'ArrowLeft') qvGo(-1);
    if (e.key === 'ArrowRight') qvGo(1);
  });
  // Keep snap aligned if the window resizes while open
  window.addEventListener('resize', () => qvScrollTo(qvIndex, false));

  // Override openQuickView to populate the carousel (video first if present, then photos)
  const _prevOpenQuickView = openQuickView;
  openQuickView = function(i) {
    _prevOpenQuickView(i);
    const p = arrivals[i];
    window.qvCurrentIdx = i;
    const media = [];
    if (p.video) media.push({ type: 'video', src: p.video });
    const imgs = (p.gallery && p.gallery.length) ? p.gallery.slice() : (p.img ? [p.img] : []);
    imgs.forEach(src => media.push({ type: 'image', src }));
    qvMedia = media;
    qvBuild();
  };
  window.qvSelectThumb = function(i) { if (window.qvJump) window.qvJump(i); };

  // -----------------------------------------------------------------------
  // 2a) MOBILE PHOTO INTERACTION — swipe / arrows to navigate, tap to zoom.
  //     Added 2 Sep 2026 per Erich: on phones the photo now owns ~58vh, and a
  //     tap opens a pinch-and-pan viewer, so split-tap navigation moved to
  //     swipe plus the two pinned arrows (see the <= 860px CSS above).
  // -----------------------------------------------------------------------

  // A horizontal drag on a scroll-snap carousel can still end in a click, so
  // track finger travel and let a swipe fall through without opening the zoom.
  let qvTouchX = 0, qvTouchY = 0, qvTouchMoved = false;
  document.addEventListener('touchstart', (e) => {
    if (!e.target.closest || !e.target.closest('#qv-carousel')) return;
    qvTouchX = e.touches[0].clientX;
    qvTouchY = e.touches[0].clientY;
    qvTouchMoved = false;
  }, { passive: true });
  document.addEventListener('touchmove', (e) => {
    if (qvTouchMoved || !e.target.closest || !e.target.closest('#qv-carousel')) return;
    const t = e.touches[0];
    if (Math.abs(t.clientX - qvTouchX) > 10 || Math.abs(t.clientY - qvTouchY) > 10) qvTouchMoved = true;
  }, { passive: true });

  // Native swipe scrolls the carousel directly, so mirror the slide it lands on
  // back into qvIndex and the thumb strip. scroll doesn't bubble -> capture.
  document.addEventListener('scroll', (e) => {
    const c = e.target;
    if (!c || c.id !== 'qv-carousel' || !c.clientWidth) return;
    clearTimeout(c._qvSyncTimer);
    c._qvSyncTimer = setTimeout(() => {
      const i = Math.round(c.scrollLeft / c.clientWidth);
      if (i !== qvIndex && i >= 0 && i < qvMedia.length) { qvIndex = i; qvUpdateThumbs(); }
    }, 90);
  }, true);

  // --- Full-screen zoom viewer -------------------------------------------
  const QV_ZOOM_MAX = 4;          // 4x is enough to read a date stamp
  const QV_ZOOM_DBL = 2.5;        // double-tap lands here
  let qvZoomEl = null, qvZoomImg = null;
  let qvZoomScale = 1, qvZoomX = 0, qvZoomY = 0;
  let qvPinchDist = 0, qvPinchBase = 1;
  let qvPanFromX = 0, qvPanFromY = 0, qvPanning = false, qvLastTap = 0;

  function qvZoomIsOpen() { return !!(qvZoomEl && qvZoomEl.classList.contains('open')); }

  function qvTouchSpread(t) {
    const dx = t[0].clientX - t[1].clientX, dy = t[0].clientY - t[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }
  function qvZoomApply(animate) {
    if (!qvZoomImg) return;
    qvZoomImg.style.transition = animate ? 'transform .22s ease' : 'none';
    qvZoomImg.style.transform = 'translate(' + qvZoomX + 'px,' + qvZoomY + 'px) scale(' + qvZoomScale + ')';
  }
  // Keep the photo from being dragged off-screen: the scaled image overhangs
  // its layout box by (w*scale - w)/2 on each side, and that's the pan budget.
  function qvZoomClamp() {
    if (qvZoomScale <= 1) { qvZoomScale = 1; qvZoomX = 0; qvZoomY = 0; return; }
    if (qvZoomScale > QV_ZOOM_MAX) qvZoomScale = QV_ZOOM_MAX;
    const w = qvZoomImg.offsetWidth, h = qvZoomImg.offsetHeight;
    const maxX = Math.max(0, (w * qvZoomScale - w) / 2);
    const maxY = Math.max(0, (h * qvZoomScale - h) / 2);
    qvZoomX = Math.min(maxX, Math.max(-maxX, qvZoomX));
    qvZoomY = Math.min(maxY, Math.max(-maxY, qvZoomY));
  }
  function qvZoomHideHint() {
    const hint = qvZoomEl && qvZoomEl.querySelector('.qv-zoom-hint');
    if (hint) hint.classList.add('hidden');
  }

  function qvZoomEnsure() {
    if (qvZoomEl) return qvZoomEl;
    qvZoomEl = document.createElement('div');
    qvZoomEl.className = 'qv-zoom';
    qvZoomEl.id = 'qv-zoom';
    qvZoomEl.innerHTML =
      '<button class="qv-zoom-close" type="button" aria-label="Close photo">' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
      '</button>' +
      '<div class="qv-zoom-stage"><img alt="Product photo, zoomable"></div>' +
      '<div class="qv-zoom-hint">Pinch or double-tap to zoom</div>';
    document.body.appendChild(qvZoomEl);
    qvZoomImg = qvZoomEl.querySelector('img');

    qvZoomEl.querySelector('.qv-zoom-close').addEventListener('click', (e) => {
      e.stopPropagation(); qvCloseZoom();
    });
    // Tapping the dark margin around the photo closes, but only at 1x — while
    // zoomed in, a tap on the photo is a pan or a double-tap, not an exit.
    qvZoomEl.addEventListener('click', (e) => {
      if (qvZoomScale > 1.01 || e.target.closest('.qv-zoom-close')) return;
      const r = qvZoomImg.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) qvCloseZoom();
    });

    const stage = qvZoomEl.querySelector('.qv-zoom-stage');
    stage.addEventListener('touchstart', (e) => {
      qvZoomHideHint();
      if (e.touches.length === 2) {
        qvPinchDist = qvTouchSpread(e.touches);
        qvPinchBase = qvZoomScale;
        qvPanning = false;
        return;
      }
      if (e.touches.length !== 1) return;
      const now = Date.now();
      if (now - qvLastTap < 300) {          // double-tap toggles 1x <-> 2.5x
        e.preventDefault();                 // also suppresses the synthetic click
        qvZoomScale = qvZoomScale > 1.01 ? 1 : QV_ZOOM_DBL;
        qvZoomX = 0; qvZoomY = 0;
        qvZoomClamp(); qvZoomApply(true);
        qvLastTap = 0;
        return;
      }
      qvLastTap = now;
      qvPanning = qvZoomScale > 1.01;
      qvPanFromX = e.touches[0].clientX - qvZoomX;
      qvPanFromY = e.touches[0].clientY - qvZoomY;
    }, { passive: false });

    stage.addEventListener('touchmove', (e) => {
      e.preventDefault();                   // never let the page behind scroll
      if (e.touches.length === 2 && qvPinchDist) {
        qvZoomScale = qvPinchBase * (qvTouchSpread(e.touches) / qvPinchDist);
        qvZoomClamp(); qvZoomApply(false);
      } else if (e.touches.length === 1 && qvPanning) {
        qvZoomX = e.touches[0].clientX - qvPanFromX;
        qvZoomY = e.touches[0].clientY - qvPanFromY;
        qvZoomClamp(); qvZoomApply(false);
      }
    }, { passive: false });

    stage.addEventListener('touchend', () => {
      if (qvZoomScale <= 1.01) { qvZoomScale = 1; qvZoomX = 0; qvZoomY = 0; qvZoomApply(true); }
      qvPinchDist = 0; qvPanning = false;
    }, { passive: true });

    // Trackpad / wheel zoom for anyone who lands here on a laptop
    stage.addEventListener('wheel', (e) => {
      e.preventDefault();
      qvZoomHideHint();
      qvZoomScale *= e.deltaY < 0 ? 1.12 : 1 / 1.12;
      qvZoomClamp(); qvZoomApply(false);
    }, { passive: false });

    return qvZoomEl;
  }

  function qvOpenZoom() {
    const m = qvMedia[qvIndex];
    if (!m || m.type !== 'image') return;   // nothing to zoom on a video slide
    qvZoomEnsure();
    qvZoomImg.src = m.src;
    qvZoomScale = 1; qvZoomX = 0; qvZoomY = 0;
    qvZoomApply(false);
    const hint = qvZoomEl.querySelector('.qv-zoom-hint');
    if (hint) hint.classList.remove('hidden');
    qvZoomEl.classList.add('open');
  }
  function qvCloseZoom() {
    if (!qvZoomEl) return;
    qvZoomEl.classList.remove('open');
    qvZoomScale = 1; qvZoomX = 0; qvZoomY = 0;
    qvZoomApply(false);
  }
  // Capture phase so Escape closes the zoom viewer before the quick view sees it
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape' || !qvZoomIsOpen()) return;
    e.stopPropagation();
    qvCloseZoom();
  }, true);
  // Closing the quick view must not leave the zoom viewer stranded on screen
  (function () {
    const _prevCloseModal = closeModal;
    closeModal = function (name) {
      if (name === 'quickview') qvCloseZoom();
      return _prevCloseModal.apply(this, arguments);
    };
    window.closeModal = closeModal;
  })();

  window.qvOpenZoom = qvOpenZoom;
  window.qvCloseZoom = qvCloseZoom;


  // -----------------------------------------------------------------------
  // 2b) PRODUCT DESCRIPTIONS — spec-list layout (per Casa 7/27 example).
  //     Replaces the static Birkin placeholder description + facts grid with
  //     real, per-item info rendered as a clean "luxury" spec list.
  // -----------------------------------------------------------------------
  // Emptied 25 Sep 2026 (Erich): these bullets were written from general knowledge of
  // each model, not from Alexa's inventory file, and were not shown. Only her data stays.
  var CASA_FEATURES = {
  };
  // Materials held blank until Alexa confirms them. A material line reads as a
  // claim about the goods, so an unconfirmed one is dropped rather than guessed
  // (4 Sep 2026 — Erich, on CASA-0028 rendering 'Beige Leather': the Bride-a-Brac
  // is a canvas case, and 'Beige Coated Canvas' is still inferred from its name
  // rather than inspected). Delete a SKU from here the moment it is confirmed;
  // this is a hold, not a permanent rule.
  // CASA-0042 was held here for a few hours on 11 Sep 2026 and is now released:
  // Alexa confirmed the material in writing ("this pink Louis Vuitton monogram
  // leather"), so its colour carries 'Leather' and the branch below reads it.
  // CASA-0043 — Alexa's Colour cell reads "Black Monogram" and her Model/Name is
  // "Black Tote Monogram", so casaMaterial()'s monogram branch answers "Monogram Coated
  // Canvas". The photographs show tonal embossed grain, i.e. Monogram Empreinte LEATHER.
  // This is the CASA-0042 defect exactly (live as "Pink Monogram Coated Canvas" on a
  // $2,500 leather bag, 11 Sep 2026). The colour cannot fix it here: the word "monogram"
  // is in her NAME, so every colour that does not itself say "leather" still returns
  // canvas. Held until she puts the material in writing — an omitted line costs nothing,
  // a wrong one is a misdescription of goods for sale.
  var CASA_MATERIAL_HOLD = { 'CASA-0028': 1, 'CASA-0043': 1 };
  function casaMaterial(p){
    if(CASA_MATERIAL_HOLD[p.sku]) return '';
    // ONE RULE: this line may only state what the piece's OWN record says — its
    // name or its colour. Nothing here is inferred from the model.
    //
    // What this replaces was a catch-all, `return c + ' Leather'`, that fired for
    // anything no branch above had claimed. So every piece whose name happens not
    // to mention a material was described as leather on the strength of nothing at
    // all: a canvas Hermes case became "Beige Leather", the CC Waist Belts became
    // "Pearl Leather" and "Gold Leather", and a null colour rendered the literal
    // "— Leather". 4 Sep 2026, Erich: "a lot of items still have the same issue
    // I mentioned that would say Leather".
    //
    // Model knowledge is deliberately gone too, even where it was RIGHT — a
    // Capucines really is Taurillon, a Dionysus really is coated canvas. It is the
    // same class of claim as the catch-all, and for goods offered for sale every
    // stated fact should trace to a field Alexa controls. Nothing is lost that she
    // cannot restore without a deploy: put the material in the piece's colour or
    // name in Shopify and it appears here. "Black Taurillon Leather" as the colour
    // renders as exactly that.
    //
    // No catch-all. If the record does not name a material, the line is omitted.
    var n=((p.name||'')+' '+(p.color||'')).toLowerCase();
    var c=(p.color||'').split('·')[0].replace(/monogram/i,'').trim();
    var hasC=c && !/^(black|white)$/i.test(c);
    var drop=function(word){ return c.replace(new RegExp('\s*'+word,'i'),'').trim(); };
    if(/caviar/.test(n)) return (c?c+' ':'')+'Caviar Calfskin';
    if(/tweed/.test(n)) return (c?c+' ':'')+'Tweed';
    if(/suede/.test(n)){ var cs=drop('suede'); return (cs?cs+' ':'')+'Suede'; }
    if(/nylon/.test(n)) return (c?c+' ':'')+'Nylon';
    if(/epi/.test(n)) return (c?c+' ':'')+'Epi Leather';
    if(/gg supreme/.test(n)) return 'GG Supreme Canvas';
    // Monogram is a PATTERN, not a substrate. Louis Vuitton prints it onto coated
    // canvas AND embosses it into Monogram Empreinte leather, so the word on its
    // own cannot establish what the piece is made of. This branch used to answer
    // 'Coated Canvas' either way, which was right only by luck — every monogram
    // piece in the catalogue until now happened to be canvas. CASA-0042 is not,
    // and it rendered live as "Pink Monogram Coated Canvas", a false claim about
    // the goods, until the colour was shortened to drop the word. Canvas is now
    // claimed only when the record does not itself say leather; the leather
    // reading is Alexa's, in writing, 11 Sep 2026: "this pink Louis Vuitton
    // monogram leather". Verified a no-op for the other 37 SKUs — none of them
    // name both monogram and leather.
    if(/monogram/.test(n)){
      var isLeather=/leather/.test(n);
      var cm=(isLeather?drop('leather'):c).replace(/\s{2,}/g,' ').trim();
      var hasM=cm && !/^(black|white)$/i.test(cm);
      return (hasM?cm+' ':'')+'Monogram '+(isLeather?'Leather':'Coated Canvas');
    }
    // The Twilly's colour field already names the fibre ('Corail Silk'), so return
    // it as-is rather than doubling it to 'Corail Silk Silk'.
    if(/silk|twilly|scarf/.test(n)) return c ? (/silk/i.test(c) ? c : c+' Silk') : 'Silk';
    if(/canvas/.test(n)) return (c?c+' ':'')+'Coated Canvas';
    if(/patent/.test(n)){ var cp=drop('patent'); return (cp?cp+' ':'')+'Patent Leather'; }
    // The record itself says leather here — "Embossed Leather Neo Classic Mini",
    // "Le Bambino Leather Top Handle". Reading it is not guessing it.
    if(/leather/.test(n)){ var cl=drop('leather'); return (cl?cl+' ':'')+'Leather'; }
    return '';
  }
  function casaHardware(hw){
    if(!hw||hw==='—') return '';
    if(/gold/i.test(hw)) return 'Gold-Tone Hardware';
    if(/silver/i.test(hw)) return 'Silver-Tone Hardware';
    if(/palladium/i.test(hw)) return 'Palladium Hardware';
    if(/ruthenium/i.test(hw)) return 'Ruthenium Hardware';
    if(/leather/i.test(hw)) return '';
    if(/black/i.test(hw)) return 'Matte Black Hardware';
    return hw+' Hardware';
  }
  var _specStyle=document.createElement('style');
  _specStyle.textContent='.qv-spec{list-style:none;margin:0 0 14px;padding:0;}'+
    '.qv-spec li{position:relative;padding:7px 0 7px 16px;font-size:14px;color:var(--navy-soft);line-height:1.5;border-bottom:1px solid var(--line);}'+
    '.qv-spec li:before{content:"";position:absolute;left:0;top:14px;width:5px;height:5px;border-radius:50%;background:var(--navy);opacity:.45;}'+
    '.qv-spec li:last-child{border-bottom:none;}'+
    '.qv-ship{font-size:11px;letter-spacing:.02em;color:var(--muted);line-height:1.6;margin:0 0 22px;font-style:italic;}';
  document.head.appendChild(_specStyle);
  window.renderQuickViewInfo = function(p){
    if(!p) return;
    var infoEl=document.querySelector('.quickview-info'); if(!infoEl) return;
    // Alexa's format (23 Sep 2026; Size added 25 Sep from her 24 Sep email): Collection
    // year, Color, Hardware, Size, Condition, Includes, under the name and price.
    // Only her sheet's fields, the same lines on every piece. The inferred
    // material line and the CASA_FEATURES bullets are no longer shown: neither is in her
    // format, and the bullets existed for some pieces only, which is the "some have a full
    // description, others don't" she reported.
    var qe=function(s){ return String(s).replace(/[&<>"']/g,function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); };
    var lines=[];
    // Labelled, with her values as written, so each line can be checked against her
    // sheet (Erich, 23 Sep 2026): no "-Tone" or "Pre-owned" wording added by us.
    var has=function(v){ return v!=null && String(v).trim()!=='' && v!=='—'; };
    var yr=(typeof p.year==='number')?p.year:(/^\d{4}(-\d{4})?$/.test(String(p.year))?p.year:null);
    if(yr) lines.push('Collection year: '+qe(yr));
    if(has(p.color)) lines.push('Color: '+qe(p.color));
    if(has(p.hardware)) lines.push('Hardware: '+qe(p.hardware));
    // Size added 25 Sep 2026, in her 24 Sep order: Hardware, Size, Condition.
    if(has(p.size)) lines.push('Size: '+qe(p.size));
    if(has(p.cond)) lines.push('Condition: '+qe(p.cond));
    if(has(p.includes)) lines.push('Includes: '+qe(String(p.includes).trim()));
    var descEl=infoEl.querySelector('.desc');
    if(descEl){
      descEl.innerHTML=(lines.length?'<ul class="qv-spec">'+lines.map(function(l){return '<li>'+l+'</li>';}).join('')+'</ul>':'')+
        '<p class="qv-ship">Every piece is authenticated and sold as-is. Due to import restrictions, this item may not be eligible for shipping in all regions.</p>';
    }
    var grid=infoEl.querySelector('.detail-grid'); if(grid) grid.style.display='none';
  };
  (function(){
    var _pqvInfo = openQuickView;
    openQuickView = function(i){ _pqvInfo(i); try{ renderQuickViewInfo(arrivals[i]); }catch(e){ console.warn('qv info', e); } };
  })();

  // -----------------------------------------------------------------------
  // 3) SHOP FILTERS + SORT
  // -----------------------------------------------------------------------
  const shopState = {
    brands: new Set(),
    categories: new Set(),
    conditions: new Set(),
    colors: new Set(),
    priceMax: 40000,
    sort: 'newest'
  };

  function parsePrice(p) {
    return parseInt(String(p.price).replace(/[^0-9]/g, '')) || 0;
  }

  // NOTE: this declaration and window.categoryOf (~line 6669, "CARTIER →
  // JEWELRY CATEGORY FIX") are the SAME global binding — the later one wins
  // and is what actually runs. Kept in sync (both check explicit item.cat/
  // .category before guessing) so it doesn't matter which one a reader
  // assumes is live, but if you're changing category logic, the one at
  // ~6669 is the one to edit.
  function categoryOf(item) {
    // If the row already carries an explicit category (real inventory data,
    // e.g. 'Accessories' for wallets/belts/keychains), trust it over guessing.
    // Two field names are in use across this file's data sources — the FINAL
    // INVENTORY module's rendered items carry `.category`, everything else
    // tends to carry `.cat` — so check both rather than silently missing one.
    const explicit = item.cat || item.category;
    if (explicit && explicit !== 'Handbags') return explicit;
    const jewelryBrands = ['Tiffany & Co.', 'Van Cleef & Arpels', 'Cartier'];
    if (jewelryBrands.includes(item.brand)) return 'Jewelry';
    const name = ((item.name || '') + ' ' + (item.color || '')).toLowerCase();
    if (/bracelet|necklace|ring|earring|brooch|pendant|cufflink/.test(name)) return 'Jewelry';
    if (/twilly|scarf|foulard|bandeau|\bbelt\b|wallet|card ?holder|key ?chain|key ?ring|key ?holder|\bcharm\b|sunglasses|gloves/.test(name)) return 'Accessories';
    return explicit || 'Handbags';
  }

  function getFilteredShopItems() {
    let items = arrivals.slice();
    if (shopState.brands.size) items = items.filter(a => shopState.brands.has(a.brand));
    if (shopState.categories.size) items = items.filter(a => shopState.categories.has(categoryOf(a)));
    // Case-insensitive: the grades are shown as Alexa typed them ("AS IS", "As IS").
    if (shopState.conditions.size) { const want = new Set([...shopState.conditions].map((c) => c.toLowerCase())); items = items.filter(a => want.has(String(a.cond || '').trim().toLowerCase())); }
    items = items.filter(a => parsePrice(a) <= shopState.priceMax);

    switch (shopState.sort) {
      case 'priceLow':  items.sort((a,b) => parsePrice(a) - parsePrice(b)); break;
      case 'priceHigh': items.sort((a,b) => parsePrice(b) - parsePrice(a)); break;
      case 'alpha':     items.sort((a,b) => a.brand.localeCompare(b.brand) || a.name.localeCompare(b.name)); break;
      case 'coveted':   items.sort((a,b) => (b.gold ? 1 : 0) - (a.gold ? 1 : 0) || parsePrice(b) - parsePrice(a)); break;
      case 'newest':
      default:          items.sort((a,b) => (b.date || '').localeCompare(a.date || '')); break;
    }
    return items;
  }

  function renderShopGrid() {
    const items = getFilteredShopItems();
    const grid = document.getElementById('shop-grid');
    if (grid) {
      grid.innerHTML = items.length ? items.map((p) => {
        const idx = arrivals.indexOf(p);
        return productCard(p, idx);
      }).join('') : '<div class="empty-state" style="grid-column:1/-1;">No pieces match these filters. Try clearing some.</div>';
    }
    // Update result count. `total` must be the FILTERED count, not
    // arrivals.length (the whole catalog) — that made every filtered view
    // read e.g. "Showing 1-5 of 35" even with only 5 pieces to show. Found
    // 27 Aug 2026 while checking the Accessories category page.
    const total = items.length;
    const showing = items.length;
    const rc = document.querySelector('.result-count');
    if (rc) {
      // "1–0 of 0" read as a glitch when a filter matches nothing.
      rc.innerHTML = showing ? `Showing <strong>1–${showing}</strong> of ${total}` : `Showing <strong>0</strong> of 0`;
    }
    // Swap in the Accessories hero treatment when that's the only category
    // filter active; revert to the plain header otherwise.
    const header = document.querySelector('#view-shop .shop-header');
    if (header) {
      const onlyAccessories = shopState.categories.size === 1 && shopState.categories.has('Accessories');
      const h1 = header.querySelector('h1');
      const p = header.querySelector('p');
      const crumb = header.querySelector('.breadcrumb');
      header.classList.toggle('shop-header--accessories', onlyAccessories);
      if (onlyAccessories) {
        if (h1 && h1.textContent !== 'Accessories') { header.dataset.origH1 = h1.textContent; h1.textContent = 'Accessories'; }
        if (p && !header.dataset.origP) { header.dataset.origP = p.textContent; p.textContent = 'Wallets, belts, keychains, and small leather goods — the finishing pieces.'; }
        if (crumb) crumb.innerHTML = '<a data-view="home">Home</a> / Accessories';
      } else if (header.dataset.origH1) {
        if (h1) h1.textContent = header.dataset.origH1;
        if (p) p.textContent = header.dataset.origP;
        if (crumb) crumb.innerHTML = '<a data-view="home">Home</a> / Shop All';
        delete header.dataset.origH1; delete header.dataset.origP;
      }
    }
  }

  // Brand filter listeners — need to be re-attached after renderBrandFilters
  const _prevRenderBrandFilters = renderBrandFilters;
  renderBrandFilters = function() {
    _prevRenderBrandFilters();
    // Re-attach change listeners on the now-rendered brand filter checkboxes
    setTimeout(() => {
      document.querySelectorAll('#brand-filter-options input[type="checkbox"]:not([disabled])').forEach(cb => {
        const label = cb.closest('.filter-option');
        if (!label) return;
        // Brand name is the leading text in the label
        const brandName = label.textContent.replace(/\s*\d+\s*$/, '').trim();
        cb.onchange = () => {
          if (cb.checked) shopState.brands.add(brandName);
          else shopState.brands.delete(brandName);
          renderShopGrid();
        };
        // Sync initial state: if checkbox is preselected, reflect in state
        if (cb.checked) shopState.brands.add(brandName);
      });
    }, 30);
  };
  renderBrandFilters();

  // Category filter
  function wireCategoryFilter() {
    document.querySelectorAll('#view-shop .filter-group:nth-of-type(2) .filter-option input[type="checkbox"]').forEach((cb, i) => {
      const cats = ['Handbags','Jewelry','Accessories','Apparel'];
      const cat = cats[i];
      if (!cat) return;
      cb.onchange = () => {
        if (cb.checked) shopState.categories.add(cat);
        else shopState.categories.delete(cat);
        renderShopGrid();
      };
      // Sync initial checked
      if (cb.checked) shopState.categories.add(cat);
    });
  }
  // Condition filter
  function wireConditionFilter() {
    document.querySelectorAll('#view-shop .filter-group:nth-of-type(3) .filter-option input[type="checkbox"]').forEach((cb, i) => {
      // Every grade the inventory uses. "As Is" was missing, so its checkbox did nothing.
      const conds = ['New','Pristine','Excellent','Very Good','Good','Fair','As Is'];
      const cond = conds[i];
      if (!cond) return;
      cb.onchange = () => {
        if (cb.checked) shopState.conditions.add(cond);
        else shopState.conditions.delete(cond);
        renderShopGrid();
      };
      if (cb.checked) shopState.conditions.add(cond);
    });
  }
  // Price slider
  function wirePriceSlider() {
    const slider = document.querySelector('#view-shop .price-slider');
    if (!slider) return;
    const display = document.querySelector('#view-shop .price-display');
    slider.oninput = (e) => {
      shopState.priceMax = parseInt(e.target.value);
      if (display) {
        const right = display.querySelectorAll('span')[1];
        if (right) right.textContent = '$' + shopState.priceMax.toLocaleString() + (shopState.priceMax >= 40000 ? '+' : '');
      }
      renderShopGrid();
    };
  }
  // Sort dropdown
  function wireSort() {
    const sel = document.querySelector('#view-shop .sort-select');
    if (!sel) return;
    // Add value attributes if missing
    const opts = sel.querySelectorAll('option');
    // Positional, one per <option>. "Most Coveted" removed 23 Sep 2026 (Erich).
    const sortKeys = ['newest','priceLow','priceHigh','alpha'];
    opts.forEach((o, i) => { if (sortKeys[i]) o.value = sortKeys[i]; });
    sel.onchange = () => {
      shopState.sort = sel.value;
      renderShopGrid();
    };
  }
  // Clear filters button
  function wireClearFilters() {
    const clear = document.querySelector('#view-shop .filters > button');
    if (!clear) return;
    clear.onclick = () => {
      shopState.brands.clear();
      shopState.categories.clear();
      shopState.conditions.clear();
      shopState.colors.clear();
      shopState.priceMax = 40000;
      shopState.sort = 'newest';
      document.querySelectorAll('#view-shop input[type="checkbox"]').forEach(cb => cb.checked = false);
      const slider = document.querySelector('#view-shop .price-slider');
      if (slider) slider.value = 40000;
      const display = document.querySelector('#view-shop .price-display');
      if (display) {
        const right = display.querySelectorAll('span')[1];
        if (right) right.textContent = '$40,000+';
      }
      const sel = document.querySelector('#view-shop .sort-select');
      if (sel) sel.value = 'newest';
      renderShopGrid();
      showToast('Filters cleared');
    };
  }

  // Run wirers (with small delay to ensure DOM is settled)
  setTimeout(() => {
    wireCategoryFilter();
    wireConditionFilter();
    wirePriceSlider();
    wireSort();
    wireClearFilters();
    renderShopGrid();
  }, 200);

  // =============================================================
  // SECURITY HARDENING + QA FIXES
  // =============================================================

  // -----------------------------------------------------------------------
  // 1) SECURITY HEADERS via meta tags
  //    (CSP, X-Content-Type-Options, Referrer-Policy)
  // -----------------------------------------------------------------------
  (function injectSecurityMeta() { return; /* Shopify theme: Shopify sends its own headers */
    const metas = [
      { httpEquiv: 'Content-Security-Policy',
        content: "default-src 'self'; img-src 'self' data: blob: https://cdn.shopify.com; media-src 'self' blob:; style-src 'self' 'unsafe-inline' https://fonts.googleapis.com; font-src 'self' https://fonts.gstatic.com; script-src 'self' 'unsafe-inline' https://cdn.sheetjs.com; connect-src 'self' https://cdn.sheetjs.com https://casa-consignment.myshopify.com https://*.myshopify.com; frame-ancestors 'none'; base-uri 'self'; form-action 'self' https://casa-consignment.myshopify.com https://casaconsignment.com" },
      { httpEquiv: 'X-Content-Type-Options', content: 'nosniff' },
      { httpEquiv: 'Referrer-Policy', content: 'strict-origin-when-cross-origin' },
      { httpEquiv: 'Permissions-Policy', content: 'geolocation=(), microphone=(), camera=(), payment=(self)' }
    ];
    metas.forEach(m => {
      // Only add if not already present
      const existing = document.querySelector(`meta[http-equiv="${m.httpEquiv}"]`);
      if (existing) return;
      const meta = document.createElement('meta');
      meta.setAttribute('http-equiv', m.httpEquiv);
      meta.setAttribute('content', m.content);
      document.head.appendChild(meta);
    });
  })();

  // -----------------------------------------------------------------------
  // 2) XSS PROTECTION — escapeHtml utility + patched render functions
  // -----------------------------------------------------------------------
  function escapeHtml(str) {
    if (str === null || str === undefined) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#x27;');
  }
  window.escapeHtml = escapeHtml;

  // -- Patch renderTicketsPanel: escape user-controlled fields
  if (typeof renderTicketsPanel === 'function') {
    const _origRTP = renderTicketsPanel;
    renderTicketsPanel = function() {
      // Sanitize a transient copy of TICKETS
      const _saved = TICKETS.map(t => ({...t}));
      TICKETS.forEach(t => {
        t.subject = escapeHtml(t.subject);
        t.user = escapeHtml(t.user);
        t._message = t._message ? escapeHtml(t._message) : t._message;
      });
      let html;
      try { html = _origRTP(); }
      finally {
        // Restore originals (we only want escaped for render, not for storage)
        TICKETS.forEach((t, i) => { Object.assign(t, _saved[i]); });
      }
      return html;
    };
  }

  // -- Patch openTicketDrawer: escape message bodies + subject + user
  if (typeof openTicketDrawer === 'function') {
    const _origOTD = openTicketDrawer;
    window.openTicketDrawer = function(id) {
      _origOTD(id);
      // Re-render drawer with escaped content
      const drawer = document.getElementById('ticket-drawer');
      if (!drawer) return;
      const ticket = TICKETS.find(t => t.id === id);
      if (!ticket) return;
      const thread = TICKET_THREADS[id] || [];
      // Walk all bodies/froms and escape
      drawer.querySelectorAll('.drawer-body > div').forEach(card => {
        const bodyEl = card.querySelector('div[style*="font-size:13px; line-height:1.6"]');
        const fromEl = card.querySelector('strong');
        if (bodyEl && bodyEl.dataset.escaped !== '1') {
          bodyEl.textContent = bodyEl.textContent; // textContent is auto-escaped
          bodyEl.dataset.escaped = '1';
        }
      });
    };
  }

  // -- Patch renderConsignmentRequestsPanel: escape every user field
  if (typeof renderConsignmentRequestsPanel === 'function') {
    renderConsignmentRequestsPanel = function() {
      const newCount = consignmentRequests.filter(r => r.status === 'New').length;
      const inReview = consignmentRequests.filter(r => r.status === 'In Review').length;
      const approved = consignmentRequests.filter(r => r.status === 'Approved').length;
      const declined = consignmentRequests.filter(r => r.status === 'Declined').length;
      const safeEmail = escapeHtml(CASA_ADMIN_EMAIL);
      return `
        <div class="dash-header">
          <div><h1>Consignment Requests</h1><p>Incoming Sell-form submissions — routed to <strong>${safeEmail}</strong>.</p></div>
          ${dateFilterRow()}
        </div>
        <div class="restricted-banner" style="background:#FFF4E0; border-color:var(--gold); color:#6B5418;">
          <strong>Email Routing</strong>
          Every submission is captured here and emailed via Resend to <strong>${safeEmail}</strong> for Alexa to review, with a copy to the backup inbox. Reply-to is the consignor, so replying from the inbox answers them directly.
        </div>
        <div class="dash-kpis">
          <div class="kpi-card"><div class="label">New</div><div class="value">${newCount}</div><div class="delta">Awaiting first look</div></div>
          <div class="kpi-card"><div class="label">In Review</div><div class="value">${inReview}</div></div>
          <div class="kpi-card"><div class="label">Approved · 7d</div><div class="value">${approved + 4}</div></div>
          <div class="kpi-card"><div class="label">Declined · 7d</div><div class="value">${declined + 1}</div></div>
        </div>
        <div class="dash-panel">
          <h3>Submission Queue <span class="pill">${consignmentRequests.length} total</span></h3>
          <table class="dash-table">
            <thead><tr>
              <th>Ref</th><th>Submitted</th><th>Brand</th><th>Model</th>
              <th>Asking</th><th>Condition</th><th>Seller</th><th>Status</th><th></th>
            </tr></thead>
            <tbody>
              ${consignmentRequests.map(r => {
                const submittedDate = new Date(r.submittedAt);
                const idSafe = escapeHtml(r.id);
                return `<tr>
                  <td><strong>${idSafe}</strong></td>
                  <td>${submittedDate.toLocaleDateString('en-US', { month:'short', day:'numeric', hour:'numeric', minute:'2-digit' })}</td>
                  <td>${escapeHtml(r.brand)}</td>
                  <td>${escapeHtml(r.model) || '—'} ${r.year ? `<span style="font-size:10px; color:var(--muted);">· ${escapeHtml(r.year)}</span>` : ''}</td>
                  <td><strong>${r.asking ? '$' + parseInt(r.asking).toLocaleString() : '—'}</strong></td>
                  <td><span class="tier-pill">${escapeHtml(r.condition)}</span></td>
                  <td>${escapeHtml(r.sellerName || r.email)}</td>
                  <td><span class="status-chip status-${r.status==='New'?'Open':r.status==='In Review'?'Review':'Resolved'}">${escapeHtml(r.status)}</span></td>
                  <td>
                    <button class="btn btn-ghost btn-sm" style="padding:6px 10px;" onclick="openConsignmentRequest('${idSafe}')">View →</button>
                  </td>
                </tr>`;
              }).join('')}
            </tbody>
          </table>
        </div>
      `;
    };
  }

  // -- Patch openConsignmentRequest drawer: escape EVERY user field
  if (typeof openConsignmentRequest === 'function') {
    window.openConsignmentRequest = function(id) {
      const r = consignmentRequests.find(x => x.id === id);
      if (!r) return;
      const submittedDate = new Date(r.submittedAt);
      const photoCount = parseInt(r.photosCount) || 0;
      let drawer = document.getElementById('cr-drawer');
      let backdrop = document.getElementById('cr-backdrop');
      if (!drawer) {
        backdrop = document.createElement('div');
        backdrop.id = 'cr-backdrop';
        backdrop.className = 'drawer-backdrop';
        backdrop.addEventListener('click', () => closeConsignmentRequest());
        document.body.appendChild(backdrop);
        drawer = document.createElement('aside');
        drawer.id = 'cr-drawer';
        drawer.className = 'cart-drawer';
        drawer.style.width = '540px';
        document.body.appendChild(drawer);
      }
      const s = escapeHtml; // shortcut
      const safeEmail = s(r.email || '');
      drawer.innerHTML = `
        <div class="drawer-head" style="flex-direction:column; align-items:stretch; gap:10px;">
          <div style="display:flex; justify-content:space-between; align-items:center;">
            <div>
              <div style="font-size:11px; letter-spacing:0.22em; text-transform:uppercase; color:var(--muted); margin-bottom:4px;">${s(r.id)} · ${submittedDate.toLocaleDateString('en-US', { month:'short', day:'numeric', year:'numeric' })}</div>
              <h3 style="font-family:var(--serif); font-size:22px; letter-spacing:0; text-transform:none; font-weight:500;">${s(r.brand)} ${s(r.model || '')}</h3>
            </div>
            <button class="icon-btn" onclick="closeConsignmentRequest()"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 6l12 12M18 6L6 18"/></svg></button>
          </div>
          <div style="display:flex; gap:12px; align-items:center; font-size:12px;">
            <span class="status-chip status-${r.status==='New'?'Open':r.status==='In Review'?'Review':'Resolved'}">${s(r.status)}</span>
            <span style="color:var(--muted);">Assigned to <strong style="color:var(--navy);">${s(r.assignedTo || '—')}</strong></span>
          </div>
        </div>
        <div class="drawer-body">
          <h4 style="font-size:10px; letter-spacing:0.22em; text-transform:uppercase; color:var(--muted); margin-bottom:10px;">Item Details</h4>
          <div style="display:grid; grid-template-columns: 1fr 1fr; gap:10px 18px; font-size:13px; margin-bottom:20px;">
            <div><span style="display:block; font-size:10px; letter-spacing:0.18em; text-transform:uppercase; color:var(--muted);">Year</span>${s(r.year) || '—'}</div>
            <div><span style="display:block; font-size:10px; letter-spacing:0.18em; text-transform:uppercase; color:var(--muted);">Condition</span>${s(r.condition)}</div>
            <div><span style="display:block; font-size:10px; letter-spacing:0.18em; text-transform:uppercase; color:var(--muted);">Color</span>${s(r.color) || '—'}</div>
            <div><span style="display:block; font-size:10px; letter-spacing:0.18em; text-transform:uppercase; color:var(--muted);">Photos</span>${photoCount} uploaded</div>
            <div><span style="display:block; font-size:10px; letter-spacing:0.18em; text-transform:uppercase; color:var(--muted);">Asking Price</span><strong>$${r.asking ? parseInt(r.asking).toLocaleString() : '—'}</strong></div>
            <div><span style="display:block; font-size:10px; letter-spacing:0.18em; text-transform:uppercase; color:var(--muted);">Retail</span>${r.retail ? '$' + parseInt(r.retail).toLocaleString() : '—'}</div>
            ${r.legitCaseId ? `<div style="grid-column:1/-1;"><span style="display:block; font-size:10px; letter-spacing:0.18em; text-transform:uppercase; color:var(--muted);">Certificate Case</span><span style="font-family:'Courier New',monospace;">${s(r.legitCaseId)}</span></div>` : ''}
          </div>
          <h4 style="font-size:10px; letter-spacing:0.22em; text-transform:uppercase; color:var(--muted); margin-bottom:10px;">Notes from Consignor</h4>
          <div style="font-size:13px; line-height:1.6; color:var(--navy-soft); padding:14px 16px; background:var(--bg); border-radius:2px; margin-bottom:20px;">${r.notes ? s(r.notes) : '<em style="color:var(--muted);">No notes provided.</em>'}</div>
          <h4 style="font-size:10px; letter-spacing:0.22em; text-transform:uppercase; color:var(--muted); margin-bottom:10px;">Consignor Contact</h4>
          <div style="font-size:13px; line-height:1.7; padding:14px 16px; background:var(--bg-cream); border:1px solid var(--line); border-radius:2px; margin-bottom:20px;">
            <strong style="display:block; color:var(--navy); margin-bottom:4px;">${s(r.sellerName) || '—'}</strong>
            <a style="color:var(--navy); text-decoration:underline;" href="mailto:${safeEmail}" rel="noopener">${safeEmail}</a><br>
            <span style="color:var(--muted);">${s(r.phone || '')}</span>
          </div>
          <div style="border-top:1px dashed var(--line); padding-top:16px; margin-top:6px;">
            <div style="font-size:10px; letter-spacing:0.22em; text-transform:uppercase; color:var(--muted); margin-bottom:8px;">Counter-offer (optional)</div>
            <input type="number" placeholder="$" min="0" max="100000" style="width:100%; padding:12px 14px; border:1px solid var(--line); border-radius:2px; font-family:var(--sans); font-size:14px; background:var(--bg-cream); margin-bottom:12px;">
            <div style="display:grid; grid-template-columns:1fr 1fr; gap:8px;">
              <button class="btn btn-danger btn-sm" onclick="decideConsignmentRequest('${s(r.id)}','Declined')">Decline</button>
              <button class="btn btn-success btn-sm" onclick="decideConsignmentRequest('${s(r.id)}','Approved')">Approve & List</button>
            </div>
            <button class="btn btn-ghost btn-block btn-sm" style="margin-top:8px;" onclick="decideConsignmentRequest('${s(r.id)}','In Review')">Send Counter-Offer</button>
          </div>
        </div>
        <div class="drawer-foot" style="font-size:11px; color:var(--muted); letter-spacing:0.14em;">
          <span style="text-transform:uppercase;">Routed to:</span> <strong style="color:var(--navy);">${escapeHtml(CASA_ADMIN_EMAIL)}</strong>
        </div>
      `;
      backdrop.classList.add('open');
      drawer.classList.add('open');
    };
  }

  // -- Patch renderBulkPreview to escape user-uploaded sheet data
  if (typeof renderBulkPreview === 'function') {
    renderBulkPreview = function() {
      const wrap = document.getElementById('bulk-preview');
      if (!wrap) return;
      if (bulkParsedRows.length === 0) {
        wrap.innerHTML = '<div class="empty-state">No inventory file loaded yet.</div>';
        return;
      }
      const photoNames = Object.keys(bulkPhotoMap);
      let matched = 0, missing = 0;
      const s = escapeHtml;
      const tableRows = bulkParsedRows.map((r, i) => {
        let photoKey = (r.PhotoFilename || '').trim();
        let photoMatch = photoNames.find(n => n.toLowerCase() === photoKey.toLowerCase());
        const dataUrl = photoMatch ? bulkPhotoMap[photoMatch] : null;
        if (dataUrl) matched++; else missing++;
        const price = parseFloat(r.Price);
        const priceFmt = isNaN(price) ? s(r.Price) : '$' + price.toLocaleString();
        const knownBrand = BRANDS.find(b => b.name === r.Brand);
        const brandWarn = !knownBrand && r.Brand ? ' (new brand)' : '';
        return `<tr>
          <td>${i+1}</td>
          <td>${dataUrl ? `<img src="${dataUrl}" style="width:44px;height:44px;object-fit:cover;border-radius:2px;border:1px solid var(--line);">` : `<div style="width:44px;height:44px;background:#FCE4E4;border-radius:2px;display:flex;align-items:center;justify-content:center;color:#8B2222;font-size:10px;">?</div>`}</td>
          <td><strong>${s(r.Brand) || '—'}</strong>${brandWarn ? `<span style="color:var(--gold); font-size:10px; letter-spacing:0.12em; text-transform:uppercase; margin-left:4px;">${brandWarn}</span>` : ''}</td>
          <td>${s(r.Name) || '—'}</td>
          <td>${priceFmt}</td>
          <td>${s(r.Size) || '—'}</td>
          <td>${s(r.Color) || '—'}</td>
          <td>${s(r.Condition) || '—'}</td>
          <td>${s(r.Year) || '—'}</td>
          <td><span class="status-chip status-${dataUrl ? 'Resolved' : 'Open'}">${dataUrl ? 'Photo Matched' : 'No Photo'}</span></td>
        </tr>`;
      }).join('');
      wrap.innerHTML = `
        <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:14px;">
          <div style="font-size:13px; color:var(--muted);">
            <strong style="color:var(--navy);">${bulkParsedRows.length}</strong> items parsed ·
            <strong style="color:#2D6A4F;">${matched}</strong> with photos ·
            ${missing > 0 ? `<strong style="color:#B33A3A;">${missing}</strong> missing photos` : `<span style="color:#2D6A4F;">all photos matched</span>`}
          </div>
          <div style="display:flex; gap:8px;">
            <button class="btn btn-ghost btn-sm" onclick="bulkParsedRows=[]; bulkPhotoMap={}; renderBulkPreview(); document.getElementById('bulk-file').value=''; document.getElementById('bulk-photos').value=''; showToast('Bulk upload cleared')">Clear</button>
            <button class="btn btn-primary btn-sm" onclick="publishBulkInventory()" ${matched === 0 ? 'disabled style="opacity:0.5; cursor:not-allowed;"' : ''}>Publish ${matched} Items →</button>
          </div>
        </div>
        <div style="max-height:480px; overflow:auto; border:1px solid var(--line); border-radius:2px;">
          <table class="dash-table">
            <thead><tr><th>#</th><th>Photo</th><th>Brand</th><th>Name</th><th>Price</th><th>Size</th><th>Color</th><th>Condition</th><th>Year</th><th>Match</th></tr></thead>
            <tbody>${tableRows}</tbody>
          </table>
        </div>
      `;
    };
  }

  // -- Patch contact form submit: validate + sanitize before storage
  //
  // ⚠️ DEAD CODE as of 29 Aug 2026 — kept only because deleting a 40-line block from
  // a 735 KB single-file app is a bigger diff than the value it returns. This wraps
  // submitContactTicket, but a LATER full replacement (search "Support tickets → real
  // ticket") reassigns window.submitContactTicket outright with no chaining to any
  // captured original, so nothing below this line ever runs. The replacement carries
  // its own copies of these same validation caps. If you are changing contact-form
  // validation, change it THERE, not here.
  if (typeof submitContactTicket === 'function') {
    const _origSubmit = window.submitContactTicket;
    window.submitContactTicket = function(ev) {
      ev.preventDefault();
      const cat = document.getElementById('contact-cat').value;
      const order = document.getElementById('contact-order').value.trim();
      const subj = document.getElementById('contact-subject').value.trim();
      const msg = document.getElementById('contact-message').value.trim();
      // Validation
      if (!subj || subj.length < 3) { showToast('Subject too short (min 3 chars)'); return false; }
      if (!msg || msg.length < 5) { showToast('Message too short (min 5 chars)'); return false; }
      if (subj.length > 200) { showToast('Subject too long (max 200 chars)'); return false; }
      if (msg.length > 4000) { showToast('Message too long (max 4000 chars)'); return false; }
      // Store but escape on insert
      const id = '#' + (window._nextTicketId = (window._nextTicketId || 7842) + 1);
      const ticket = {
        id, type: 'Customer',
        subject: subj || (cat + ' question'),
        user: 'erich@nouvos.one',
        priority: cat === 'Shipping' ? 'High' : (cat === 'Authentication' ? 'Medium' : 'Low'),
        status: 'Open', age: 'just now',
        ageMinutes: 0,
        _category: cat, _order: order, _message: msg
      };
      TICKETS.unshift(ticket);
      TICKET_THREADS[id] = [{from: 'erich@nouvos.one', role: 'Customer', time: 'just now', body: msg}];
      document.getElementById('contact-form').style.display = 'none';
      document.getElementById('contact-success').style.display = 'block';
      document.getElementById('contact-ticket-id').textContent = id;
      // Null-guarded 29 Aug 2026. #view-dashboard was deleted from this file, so the
      // bare getElementById(...).classList threw a TypeError here. It never fired in
      // production only because this whole patch is dead (see the banner above), which
      // is precisely why it survived unnoticed — do not rely on that a second time.
      var dashEl = document.getElementById('view-dashboard');
      if (dashEl && dashEl.classList.contains('active') &&
          (sectionFilter === 'tickets' || sectionFilter === 'kpis')) {
        renderDashboard();
      }
      setTimeout(checkSLA, 100);
      return false;
    };
  }

  // -----------------------------------------------------------------------
  // 3) FILE UPLOAD SIZE LIMITS (defensive — UI side, real check is server)
  // -----------------------------------------------------------------------
  function clampFileSize(file, maxMB, label) {
    const max = maxMB * 1024 * 1024;
    if (file.size > max) {
      showToast(`${label} too large (max ${maxMB} MB) · "${file.name}" skipped`);
      return false;
    }
    return true;
  }

  // Patch bulk file input change to validate size
  const _bulkFile = document.getElementById('bulk-file');
  if (_bulkFile) {
    const _existing = _bulkFile.onchange;
    _bulkFile.addEventListener('change', (e) => {
      const f = e.target.files[0];
      if (f && !clampFileSize(f, 5, 'Inventory file')) {
        e.target.value = '';
        return;
      }
    }, true);
  }
  const _bulkPhotos = document.getElementById('bulk-photos');
  if (_bulkPhotos) {
    _bulkPhotos.addEventListener('change', (e) => {
      const files = Array.from(e.target.files);
      // Each photo max 10 MB
      const tooLarge = files.filter(f => !clampFileSize(f, 10, 'Photo'));
      if (tooLarge.length > 0) {
        e.target.value = '';
        return;
      }
    }, true);
  }

  // -----------------------------------------------------------------------
  // 4) SAVED ITEMS GRID — smaller cards, 4 columns, capped aspect ratio
  // -----------------------------------------------------------------------
  if (typeof renderSavedPanel === 'function') {
    renderSavedPanel = function() {
      const saved = arrivals.slice(0, 8);
      return `
        <div class="dash-header"><div><h1>Saved Items</h1><p>Pieces you're keeping an eye on.</p></div></div>
        <div class="saved-grid">
          ${saved.map((p,i) => {
            const safeName = escapeHtml(p.name || '');
            const safeBrand = escapeHtml(p.brand || '');
            const safeSku = escapeHtml(p.sku || '');
            const safePrice = escapeHtml(p.price || '');
            const safeImg = p.img ? escapeHtml(p.img) : '';
            return `<div class="saved-card" onclick="openQuickView(${arrivals.indexOf(p)})">
              <span class="saved-badge">♡</span>
              <div class="saved-img">${safeImg ? `<img src="${safeImg}" alt="${safeName}">` : pickArt(i)}</div>
              <div class="saved-info">
                <div class="saved-brand">${safeBrand}</div>
                <div class="saved-name">${safeName}</div>
                <div class="saved-price">${safePrice}</div>
                <div class="saved-sku">${safeSku}</div>
              </div>
            </div>`;
          }).join('')}
        </div>
      `;
    };
  }

  // CSS for compact saved grid
  const savedStyle = document.createElement('style');
  savedStyle.textContent = `
    .saved-grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 16px;
    }
    .saved-card {
      background: #fff;
      border: 1px solid var(--line);
      border-radius: 2px;
      overflow: hidden;
      cursor: pointer;
      transition: transform 0.2s var(--ease), box-shadow 0.2s var(--ease), border-color 0.2s;
      position: relative;
    }
    .saved-card:hover {
      transform: translateY(-3px);
      box-shadow: var(--shadow-md);
      border-color: var(--navy);
    }
    .saved-badge {
      position: absolute;
      top: 10px; right: 10px;
      width: 26px; height: 26px;
      background: rgba(255,255,255,0.92);
      backdrop-filter: blur(6px);
      border-radius: 50%;
      display: flex; align-items: center; justify-content: center;
      color: #D4452D;
      font-size: 13px;
      z-index: 2;
      box-shadow: 0 2px 6px rgba(0,0,0,0.08);
    }
    .saved-img {
      aspect-ratio: 1 / 1;
      max-height: 200px;
      background: var(--bg);
      display: flex; align-items: center; justify-content: center;
      overflow: hidden;
    }
    .saved-img img, .saved-img svg {
      width: 100%; height: 100%;
      object-fit: cover;
    }
    .saved-info { padding: 12px 14px 14px; }
    .saved-brand {
      font-size: 9px; letter-spacing: 0.18em; text-transform: uppercase;
      color: var(--muted);
      margin-bottom: 4px;
    }
    .saved-name {
      font-family: var(--serif);
      font-size: 14px;
      color: var(--navy);
      line-height: 1.3;
      margin-bottom: 8px;
      min-height: 36px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .saved-price {
      font-size: 13px;
      font-weight: 600;
      color: var(--navy);
    }
    .saved-sku {
      margin-top: 8px;
      padding-top: 8px;
      border-top: 1px dashed var(--line);
      font-size: 9px;
      letter-spacing: 0.16em;
      color: var(--muted);
      font-family: 'Courier New', monospace;
    }
    @media (max-width: 1024px) {
      .saved-grid { grid-template-columns: repeat(3, 1fr); }
    }
    @media (max-width: 640px) {
      .saved-grid { grid-template-columns: repeat(2, 1fr); }
      .saved-img { max-height: 160px; }
    }
  `;
  document.head.appendChild(savedStyle);

  // -----------------------------------------------------------------------
  // 5) QA FIXES — defensive guards + minor bugs
  // -----------------------------------------------------------------------

  // 5a) Newsletter input — ensure email validation
  document.querySelectorAll('.footer-newsletter input').forEach(inp => {
    if (inp.type !== 'email') inp.type = 'email';
    if (!inp.maxLength || inp.maxLength <= 0) inp.maxLength = 254;
  });
  document.querySelectorAll('.footer-newsletter button').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const inp = btn.parentElement.querySelector('input');
      if (!inp || !inp.value || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inp.value)) {
        showToast('Please enter a valid email address');
        return;
      }
      const email = inp.value;
      btn.disabled = true;
      try {
        const r = await fetch('/api/subscribe', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email, source: 'footer' })
        });
        const data = await r.json().catch(() => ({}));
        if (r.ok && data.ok) { showToast(`Thanks — added ${escapeHtml(email)} to the list`); inp.value = ''; }
        else { showToast((data && data.error) || 'Something went wrong — try again'); }
      } catch (err) { showToast('Something went wrong — try again'); }
      finally { btn.disabled = false; }
    });
  });

  // 5b) Contact form length attrs (browser validation)
  const _contactSubj = document.getElementById('contact-subject');
  if (_contactSubj) { _contactSubj.maxLength = 200; _contactSubj.minLength = 3; }
  const _contactMsg = document.getElementById('contact-message');
  if (_contactMsg) { _contactMsg.maxLength = 4000; _contactMsg.minLength = 5; }
  const _contactOrder = document.getElementById('contact-order');
  if (_contactOrder) { _contactOrder.maxLength = 20; _contactOrder.pattern = '[#A-Za-z0-9\\-]*'; }

  // 5c) External links — ensure target=_blank ones have rel=noopener noreferrer
  document.querySelectorAll('a[target="_blank"]').forEach(a => {
    if (!a.rel || !a.rel.includes('noopener')) {
      a.rel = (a.rel || '') + ' noopener noreferrer';
    }
  });

  // 5d) Logo & hero images — add lazy loading where missing
  document.querySelectorAll('img:not([loading])').forEach(img => {
    // Eager-load above-the-fold; lazy for others
    const rect = img.getBoundingClientRect();
    if (rect.top > window.innerHeight) img.loading = 'lazy';
    if (!img.alt && img.alt !== '') img.alt = '';  // decorative if not set
  });

  // 5e) Make sidebar icon-buttons in nav-right have aria-label
  document.querySelectorAll('.nav-right .icon-btn').forEach((btn, i) => {
    if (!btn.getAttribute('aria-label')) {
      const labels = ['Language', 'Search', 'Account', 'Shopping bag'];
      btn.setAttribute('aria-label', labels[i] || 'Action');
    }
  });

  // 5f) Replace remaining alert() placeholders with showToast
  document.querySelectorAll('[onclick^="alert("]').forEach(el => {
    const oc = el.getAttribute('onclick') || '';
    const m = oc.match(/alert\(['"](.*?)['"]\)/);
    if (m) {
      const msg = m[1];
      el.setAttribute('onclick', `showToast('${msg.replace(/'/g, "\\'")}')`);
    }
  });

  // 5g) Filter Group: make filter-title actually collapse on click
  document.querySelectorAll('#view-shop .filter-title').forEach(title => {
    title.addEventListener('click', (e) => {
      const sign = title.querySelector('span');
      const group = title.parentElement;
      const options = group.querySelector('.filter-options, .swatches, .price-slider, .price-display');
      if (!options) return;
      const isOpen = sign && sign.textContent === '−';
      group.querySelectorAll('.filter-options, .swatches, .price-slider, .price-display').forEach(el => {
        el.style.display = isOpen ? 'none' : '';
      });
      if (sign) sign.textContent = isOpen ? '+' : '−';
    });
    title.style.cursor = 'pointer';
    title.style.userSelect = 'none';
  });

  // 5h) SLA banner — null guard for renderTicketsPanel + renderKPIsPanel
  // already done with try/catch wrappers above

  // 5i) Pulled certificate input — restrict to alphanumeric to prevent injection
  const _legitInput = document.getElementById('legit-case-input');
  if (_legitInput) {
    _legitInput.maxLength = 32;
    _legitInput.pattern = '[A-Za-z0-9#]*';
    _legitInput.addEventListener('input', (e) => {
      e.target.value = e.target.value.replace(/[^A-Za-z0-9#]/g, '');
    });
  }

  // 5j) Re-render dashboard once to apply new renderSavedPanel + escaping
  setTimeout(() => {
    if (typeof renderDashboard === 'function') renderDashboard();
    applyI18n();
  }, 100);

  // 5k) QA report summary in console (for dev visibility)
  console.log('%cCASA CONSIGNMENT — Security & QA Pass', 'background:#141414; color:#fff; padding:4px 10px; font-weight:bold;');
  console.log('  ✓ CSP, X-Content-Type-Options, Referrer-Policy, Permissions-Policy meta tags');
  console.log('  ✓ XSS protection: escapeHtml() applied to tickets, consignment requests, bulk upload, contact form');
  console.log('  ✓ File upload size limits (5MB sheets, 10MB photos)');
  console.log('  ✓ Newsletter & contact form input validation');
  console.log('  ✓ External links: rel="noopener noreferrer" enforced');
  console.log('  ✓ Lazy image loading for below-the-fold images');
  console.log('  ✓ ARIA labels on nav icon buttons');
  console.log('  ✓ Saved Items grid resized (4 cols, ~200px max, capped aspect ratio)');
  console.log('  ✓ Filter groups: click-to-collapse');
  console.log('  ✓ Certificate reference input: alphanumeric-only sanitization');
  console.log('  ✓ alert() placeholders converted to non-blocking toasts');


  // =============================================================
  // PERFORMANCE FIX + AUTH BADGE ON SAVED ITEMS
  // =============================================================

  // -----------------------------------------------------------------------
  // 1) BREAK THE RENDER LOOP
  //    Old behavior: renderDashboard → applyI18n → renderDashboard → ...
  //    (chained through 5 override layers per call, causing 1-3s lag).
  //    New behavior: single canonical render() with re-entry guard +
  //    requestAnimationFrame debounce. applyI18n does NOT trigger
  //    dashboard re-render anymore.
  // -----------------------------------------------------------------------
  (function fixDashboardPerf() {
    // Canonical i18n applier — translates DOM but does NOT touch dashboard
    function _applyI18nCore() {
      const dict = I18N[currentLang] || I18N.en;
      // Text-content keys
      document.querySelectorAll('[data-i18n]').forEach(el => {
        const key = el.getAttribute('data-i18n');
        const tr = dict[key] || I18N.en[key];
        if (tr === undefined) return;
        if (el.children.length === 0) {
          if (el.textContent !== tr) el.textContent = tr;
        } else {
          // Replace only the first non-empty text node
          let replaced = false;
          el.childNodes.forEach(n => {
            if (n.nodeType === 3 && !replaced && n.textContent.trim()) {
              if (n.textContent.trim() !== tr) n.textContent = tr;
              replaced = true;
            }
          });
        }
      });
      // HTML-aware keys
      document.querySelectorAll('[data-i18n-html]').forEach(el => {
        const key = el.getAttribute('data-i18n-html');
        const tr = dict[key] || I18N.en[key];
        if (tr !== undefined && el.innerHTML !== tr) el.innerHTML = tr;
      });
      // Placeholder keys
      document.querySelectorAll('[data-i18n-placeholder]').forEach(el => {
        const key = el.getAttribute('data-i18n-placeholder');
        const tr = dict[key];
        if (tr !== undefined && el.placeholder !== tr) el.placeholder = tr;
      });
    }

    // Replace global applyI18n — the dashboard render loop this used to
    // guard against (renderDashboard → applyI18n → renderDashboard → ...)
    // no longer exists; the internal staff dashboard was removed 27 Aug 2026
    // along with renderDashboard/ROLES/buildSidebar/PANEL_RENDERERS.
    applyI18n = function() {
      _applyI18nCore();
    };
    window.applyI18n = applyI18n;
  })();

  // -----------------------------------------------------------------------
  // 2) AUTH BADGE ON SAVED ITEMS
  //    Adds the LEGIT APP shield corner badge + "Authenticated" pill on
  //    saved-card so users see verified status at a glance.
  // -----------------------------------------------------------------------
  const savedAuthStyle = document.createElement('style');
  savedAuthStyle.textContent = `
    .saved-card .saved-auth-corner {
      position: absolute;
      top: 10px; left: 10px;
      background: rgba(11,15,28,0.85);
      backdrop-filter: blur(8px);
      width: 24px; height: 24px;
      border-radius: 50%;
      display: flex; align-items: center; justify-content: center;
      z-index: 2;
      transition: transform 0.25s var(--ease);
    }
    .saved-card .saved-auth-corner.pending { background: rgba(184,153,104,0.92); }
    .saved-card .saved-auth-corner svg { width: 12px; height: 12px; color:#141414; }
    .saved-card .saved-auth-corner.pending svg { color: #fff; }
    .saved-card:hover .saved-auth-corner { transform: scale(1.1); }
    .saved-card .saved-auth-pill {
      display: inline-flex; align-items: center; gap: 5px;
      margin-top: 8px;
      padding: 3px 8px;
      background: linear-gradient(90deg, rgba(135,197,224,0.18) 0%, rgba(184,223,239,0.18) 100%);
      border: 1px solid rgba(27,58,92,0.15);
      border-radius: 100px;
      font-size: 9px; letter-spacing: 0.18em; text-transform: uppercase;
      color: var(--navy);
      font-weight: 500;
    }
    .saved-card .saved-auth-pill.pending {
      background: rgba(184,153,104,0.12);
      border-color: rgba(184,153,104,0.3);
      color: #8B6914;
    }
    .saved-card .saved-auth-pill svg { width: 10px; height: 10px; }
    .saved-card .saved-cert-link {
      display: inline-block;
      margin-top: 8px;
      font-size: 9px; letter-spacing: 0.16em; text-transform: uppercase;
      color: var(--navy);
      text-decoration: underline;
      cursor: pointer;
      margin-left: 8px;
    }
    .saved-card .saved-cert-link:hover { color: var(--navy-deep); }
  `;
  document.head.appendChild(savedAuthStyle);

  applyI18n();


  // =============================================================
  // INVENTORY COMMIT — 7 new/replacement items + SKU migration
  // to MS-{seq}-{BRAND}-SO TCONSIGNMENT L-{COLOR} format
  // =============================================================

  // -----------------------------------------------------------------------
  // 1) Helper for building MS- SKUs (using the customer-preferred format
  //    with the literal space in "SO TCONSIGNMENT")
  // -----------------------------------------------------------------------
  function buildMSku(seq, brandCode3, colorCode3) {
    const seqStr = String(seq).padStart(4, '0');
    return `MS-${seqStr}-${brandCode3}-SO TCONSIGNMENT L-${colorCode3}`;
  }

  // -----------------------------------------------------------------------
  // 2) Asset path helpers (URL-encoded)
  // -----------------------------------------------------------------------
  const enc = (s) => encodeURI(s);

// (Removed unused So TEA sample image-path constants — catalog uses Casa Bags via CB())

  // -----------------------------------------------------------------------
  // 3) ADD Cartier as a brand + flip Van Cleef from Coming Soon to active
  // -----------------------------------------------------------------------
  brandCode['Cartier'] = 'CAR';
  // VCA brand code already exists as 'VCA' from earlier round

  // Insert Cartier into BRANDS before Bottega/Saint Laurent
  if (!BRANDS.find(b => b.key === 'cartier')) {
    const insertIdx = BRANDS.findIndex(b => b.key === 'bottega');
    const cartierBrand = {
      key:'cartier', name:'Cartier',
      svg:'<rect x="22" y="36" width="56" height="52" rx="3" fill="#dcdcdc" stroke="none"/><rect x="22" y="36" width="56" height="52" rx="3"/><path d="M30 36 C30 18 70 18 70 36"/><text x="50" y="64" text-anchor="middle" font-family="serif" font-size="14" font-weight="700" fill="#141414">C</text>'
    };
    if (insertIdx >= 0) BRANDS.splice(insertIdx, 0, cartierBrand);
    else BRANDS.push(cartierBrand);
  }

  // -----------------------------------------------------------------------
  // 4) REMOVE the two demo items that user is REPLACING with real ones:
  //    - "Birkin 30 Togo · Gold" (demo with single hermes_togo photo)
  //    - "Kelly 25 Sellier · Mauve Sylvestre" (demo, no photos)
  // -----------------------------------------------------------------------
  for (let i = arrivals.length - 1; i >= 0; i--) {
    const a = arrivals[i];
    if (a.name === 'Birkin 30 Togo · Gold' ||
        a.name === 'Kelly 25 Sellier · Mauve Sylvestre') {
      arrivals.splice(i, 1);
    }
  }

  // -----------------------------------------------------------------------
  // 5) Image-path helpers — still used by the FINAL INVENTORY module below
  //    (its per-item G(folder, n) fallback when a SKU has no CASA_GALLERIES
  //    entry). The old CASA-0001-0004 placeholder batch that used to live
  //    here (CASA-0002 was a phantom then; since the 28 Aug 2026 renumber it
  //    is the real Classic Flap Caviar, formerly CASA-0027) and a 6-item
  //    accessories draft were removed 27 Aug 2026 —
  //    both were dead weight: FINAL INVENTORY's `arrivals.length = 0` wipes
  //    anything unshifted here before the page ever paints, whether or not
  //    hydrateCatalog() reaches a real DB. Real inventory — including the
  //    accessories batch, now correctly numbered — lives in FINAL INVENTORY.
  // -----------------------------------------------------------------------
  const CB = (n) => enc('Casa Bags/' + n);
  const G = (folder, n) => Array.from({length:n}, (_, i) => CB(folder + "/" + (i+1) + ".jpg"));

  // -----------------------------------------------------------------------
  // 6) MIGRATE ALL OTHER existing SKUs to MS- format
  // -----------------------------------------------------------------------
  // Color → 3-letter color code
  function colorCode3(color) {
    const c = (color || '').toLowerCase();
    if (c.includes('gold') || c.includes('yellow')) return 'GOL';
    if (c.includes('silver') || c.includes('white gold') || c.includes('palladium')) return 'SIL';
    if (c.includes('black') || c.includes('noir')) return 'BLK';
    if (c.includes('brown') || c.includes('monogram') || c.includes('togo') || c.includes('etoupe')) return 'BRO';
    if (c.includes('pink') || c.includes('rose') || c.includes('mauve')) return 'PIN';
    if (c.includes('red') || c.includes('rouge') || c.includes('cherry') || c.includes('vif')) return 'RED';
    if (c.includes('blue') || c.includes('bleu') || c.includes('mouette') || c.includes('gris')) return 'BLU';
    if (c.includes('beige') || c.includes('ebony') || c.includes('tan')) return 'BEI';
    if (c.includes('green') || c.includes('vert')) return 'GRN';
    return 'BRO';
  }

  // Migrate every arrival that doesn't already have an MS- SKU
  let nextAutoSeq = 100;
  const usedSeqs = new Set(arrivals.filter(a => a.sku && a.sku.startsWith('MS-')).map(a => parseInt(a.sku.match(/MS-(\d{4})/)?.[1] || '0', 10)));
  arrivals.forEach(a => {
    // Real production SKUs are CASA-XXXX (Shopify/Neon convention) — never
    // rewrite those into the legacy MS- format. Was silently mangling every
    // CASA-00xx item's sku on the pre-hydration array, which broke New In's
    // arrivals.findIndex(p => p.sku === sku) lookup for any curated SKU here.
    if (a.sku && (a.sku.startsWith('MS-') || a.sku.startsWith('CASA-'))) return; // already migrated / real SKU
    while (usedSeqs.has(nextAutoSeq)) nextAutoSeq++;
    const brand3 = (brandCode[a.brand] || a.brand.slice(0,3).toUpperCase()).slice(0,3);
    const color3 = colorCode3(a.color);
    a.sku = buildMSku(nextAutoSeq, brand3, color3);
    usedSeqs.add(nextAutoSeq);
    nextAutoSeq++;
  });

  // -----------------------------------------------------------------------
  // 7) Re-render brand cards, filters, and product grids
  // -----------------------------------------------------------------------
  try { renderDesignerCards(); } catch(e) {}
  try { renderBrandFilters(); } catch(e) {}
  if (document.getElementById('home-arrivals')) {
    document.getElementById('home-arrivals').innerHTML = arrivals.slice(0,4).map(productCard).join('');
  }
  if (document.getElementById('shop-grid')) {
    document.getElementById('shop-grid').innerHTML = arrivals.map(productCard).join('');
  }

  // Update shop header count
  const shopHeaderP = document.querySelector('#view-shop .shop-header p');
  if (shopHeaderP) {
    shopHeaderP.textContent = `${arrivals.length} curated pieces — from heritage handbags to fine jewelry.`;
  }
  const resultCount = document.querySelector('.result-count');
  if (resultCount) {
    resultCount.innerHTML = `Showing <strong>1–${arrivals.length}</strong> of ${arrivals.length}`;
  }

  // Re-render dashboard if visible
  try { if (typeof renderDashboard === 'function') renderDashboard(); } catch(e) {}

  console.log('%cCASA · Inventory committed', 'background:#2D6A4F; color:#fff; padding:4px 10px; font-weight:bold;');
  console.log('  ✓ Cartier added as new brand');
  console.log('  ✓ Van Cleef & Arpels flipped from Coming Soon → active');
  console.log('  ✓ All SKUs migrated to MS-{seq}-{BRAND}-SO TCONSIGNMENT L-{COLOR} format');
  console.log(`  ✓ Total catalog: ${arrivals.length} pieces`);


  // =============================================================
  // WIRE ALL FOOTER LINKS + DESIGNER CARDS WITH FILTERS
  // =============================================================

  // -----------------------------------------------------------------------
  // 1) NAVIGATION HELPERS — Shop with pre-selected filters
  // -----------------------------------------------------------------------

  function _shopReset() {
    // Clear all current shop state + uncheck UI
    if (typeof shopState === 'undefined') return;
    shopState.brands.clear();
    shopState.categories.clear();
    shopState.conditions.clear();
    // colors was missing here. Every other filter was cleared, so "Shop All" after
    // browsing a colour left that colour applied and the grid did not visibly
    // change — the button read as dead, which is the same complaint the category
    // filter caused (4 Sep 2026). Any Set added to shopState must be cleared here;
    // scripts/verify-shop-filters.cjs fails the build if one is not.
    shopState.colors.clear();
    shopState.priceMax = 40000;
    shopState.sort = 'newest';
    document.querySelectorAll('#view-shop input[type="checkbox"]').forEach(cb => cb.checked = false);
    const slider = document.querySelector('#view-shop .price-slider');
    if (slider) slider.value = 40000;
    const sel = document.querySelector('.sort-select');
    if (sel) sel.value = 'newest';
  }

  function _scrollToShopHeader() {
    const el = document.querySelector('#view-shop .shop-header');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  window.navigateShopByBrand = function(brandName) {
    switchView('shop');
    setTimeout(() => {
      _shopReset();
      shopState.brands.add(brandName);
      document.querySelectorAll('#brand-filter-options input[type="checkbox"]:not([disabled])').forEach(cb => {
        const label = cb.closest('.filter-option');
        if (!label) return;
        const name = label.textContent.replace(/\s*\d+\s*$/, '').replace(/\s*Coming Soon\s*$/i, '').trim();
        cb.checked = (name === brandName);
      });
      if (typeof renderShopGrid === 'function') renderShopGrid();
      _scrollToShopHeader();
      showToast(`Filtered to ${brandName}`);
    }, 120);
  };

  window.navigateShopByCategory = function(catName) {
    switchView('shop');
    setTimeout(() => {
      _shopReset();
      shopState.categories.add(catName);
      const cats = ['Handbags','Jewelry','Accessories','Apparel'];
      const idx = cats.indexOf(catName);
      if (idx >= 0) {
        const cbs = document.querySelectorAll('#view-shop .filter-group:nth-of-type(2) .filter-option input[type="checkbox"]');
        if (cbs[idx]) cbs[idx].checked = true;
      }
      if (typeof renderShopGrid === 'function') renderShopGrid();
      _scrollToShopHeader();
      showToast(`Showing ${catName} only`);
    }, 120);
  };

  // "Shop All" (drawer) and the portal "Shop" button mean the whole catalogue.
  //
  // Both were plain data-view="shop" controls, so a click only reached
  // switchView() — which toggles the active view, portal mode, the nav highlight
  // and the scroll position, and touches NOTHING else. shopState lives at module
  // scope and survives every view change, and nothing re-renders #shop-grid on a
  // view switch. So after browsing Handbags or Accessories from the Shop menu,
  // "Shop All" showed the same filtered grid with the same ticked checkbox, and
  // the only way back to the full catalogue was to untick it by hand.
  // Reported 28 Aug 2026.
  //
  // renderShopGrid() also restores the Accessories hero header (it owns the
  // dataset.origH1 revert), so clearing the filter through here puts the title,
  // lead and breadcrumb back too — doing it by hand would not.
  window.navigateShopAll = function() {
    switchView('shop');
    setTimeout(() => {
      _shopReset();
      if (typeof renderShopGrid === 'function') renderShopGrid();
    }, 120);
  };

  window.navigateShopNewest = function() {
    switchView('shop');
    setTimeout(() => {
      _shopReset();
      shopState.sort = 'newest';
      const sel = document.querySelector('.sort-select');
      if (sel) sel.value = 'newest';
      if (typeof renderShopGrid === 'function') renderShopGrid();
      _scrollToShopHeader();
      showToast('Sorted by newest arrivals');
    }, 120);
  };

  // -----------------------------------------------------------------------
  // 2) NAVIGATION HELPERS — Sell with scroll to specific section
  // -----------------------------------------------------------------------

  function _scrollTo(selector, offset = -100) {
    const el = document.querySelector(selector);
    if (!el) return;
    const top = el.getBoundingClientRect().top + window.scrollY + offset;
    window.scrollTo({ top, behavior: 'smooth' });
  }

  window.navigateSellTo = function(target) {
    switchView('sell');
    setTimeout(() => {
      switch (target) {
        case 'top':       window.scrollTo({top: 0, behavior: 'smooth'}); break;
        case 'how':       _scrollTo('.sell-hero .sell-steps', -120); break;
        case 'tiers':     _scrollTo('.tiers-wrap', -100); break;
        case 'consignor': _scrollTo('.seller-cta', -100); break;
        case 'form':      _scrollTo('.sell-form-wrap', -100); break;
        case 'legit':     _scrollTo('.legit-pull-card', -100); break;
      }
    }, 200);
  };

  // -----------------------------------------------------------------------
  // 3) CARE GUIDE MODAL — new
  // -----------------------------------------------------------------------
  const careStyle = document.createElement('style');
  careStyle.textContent = `
    .modal.careguide { max-width: 680px; padding: 0; overflow: hidden; }
    .care-head { padding: 28px 36px 22px; border-bottom: 1px solid var(--line); }
    .care-head h2 { font-size: 28px; font-weight: 500; margin-bottom: 4px; }
    .care-head p { color: var(--muted); font-size: 13px; margin: 0; }
    .care-tabs {
      display: flex; gap: 0;
      padding: 0 36px;
      border-bottom: 1px solid var(--line);
      background: var(--bg-cream);
    }
    .care-tabs button {
      padding: 14px 18px;
      font-size: 11px; letter-spacing: 0.22em; text-transform: uppercase;
      color: var(--muted);
      border-bottom: 2px solid transparent;
      transition: all 0.2s;
    }
    .care-tabs button.active { color: var(--navy); border-bottom-color: var(--navy); }
    .care-body { padding: 28px 36px 32px; max-height: 70vh; overflow-y: auto; }
    .care-section { margin-bottom: 26px; }
    .care-section:last-child { margin-bottom: 0; }
    .care-section h3 { font-family: var(--serif); font-size: 19px; color: var(--navy); margin-bottom: 12px; font-weight: 500; }
    .care-tip {
      display: flex; align-items: flex-start; gap: 12px;
      padding: 10px 0;
      font-size: 14px; color: var(--navy-soft); line-height: 1.6;
    }
    .care-tip svg { width: 18px; height: 18px; color: var(--navy); flex-shrink: 0; margin-top: 2px; }
    .care-warning {
      padding: 14px 18px;
      background: #FFF4E0;
      border-left: 4px solid var(--gold);
      color: #6B5418;
      font-size: 13px; line-height: 1.6;
      border-radius: 2px;
      margin: 14px 0;
    }
    .care-warning strong { display: block; font-size: 10px; letter-spacing: 0.22em; text-transform: uppercase; margin-bottom: 4px; }
  `;
  document.head.appendChild(careStyle);

  const careModal = document.createElement('div');
  careModal.id = 'modal-careguide';
  careModal.className = 'modal-backdrop';
  careModal.addEventListener('click', (e) => { if (e.target === careModal) closeModal('careguide'); });
  careModal.innerHTML = `
    <div class="modal careguide">
      <button class="modal-close" aria-label="Close" onclick="closeModal('careguide')"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 6l12 12M18 6L6 18"/></svg></button>
      <div class="care-head">
        <h2>Care Guide</h2>
        <p>Keep your Casa pieces in the condition they arrived.</p>
      </div>
      <div class="care-tabs">
        <button class="active" onclick="switchCareTab(this,'bags')">Handbags & Leather</button>
        <button onclick="switchCareTab(this,'jewelry')">Jewelry</button>
        <button onclick="switchCareTab(this,'storage')">Storage & Travel</button>
      </div>
      <div class="care-body">
        <div class="care-panel" data-care="bags">
          <div class="care-section">
            <h3>Daily Use</h3>
            <div class="care-tip"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="m5 13 4 4L19 7"/></svg><div><strong>Avoid direct sunlight</strong> — UV fades colored leathers (especially pinks, blues, and pastels) within months.</div></div>
            <div class="care-tip"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="m5 13 4 4L19 7"/></svg><div><strong>Don't overload.</strong> Stretching distorts the silhouette permanently. Use the original stuffing or acid-free tissue when stored.</div></div>
            <div class="care-tip"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="m5 13 4 4L19 7"/></svg><div><strong>Wipe daily with a soft dry cloth</strong> — never use baby wipes or anything containing alcohol on leather.</div></div>
            <div class="care-tip"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="m5 13 4 4L19 7"/></svg><div><strong>Hardware</strong> — buff palladium and gold with a microfiber cloth. Tarnish on plated hardware is normal with age.</div></div>
          </div>
          <div class="care-section">
            <h3>By Leather Type</h3>
            <div class="care-tip"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="3"/></svg><div><strong>Togo & Clemence</strong> — soft and grained. Naturally resistant to scratches; light scuffs buff out.</div></div>
            <div class="care-tip"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="3"/></svg><div><strong>Epsom</strong> — embossed, structured. Holds its shape well; doesn't show wear.</div></div>
            <div class="care-tip"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="3"/></svg><div><strong>Caviar</strong> (Chanel) — durable, low-maintenance. Wipe with a damp cloth, dry immediately.</div></div>
            <div class="care-tip"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="3"/></svg><div><strong>Lambskin</strong> — soft and delicate. Scratches easily. Best for occasion wear, not everyday.</div></div>
          </div>
          <div class="care-warning">
            <strong>Avoid these</strong>
            Direct sunlight · rain · perfume / lotion / sunscreen contact · stuffing in plastic · cleaning with household products
          </div>
        </div>
        <div class="care-panel" data-care="jewelry" style="display:none;">
          <div class="care-section">
            <h3>Gold & Diamonds</h3>
            <div class="care-tip"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="m5 13 4 4L19 7"/></svg><div><strong>Polish with a microfiber jewelry cloth</strong> after each wear. Use the cloth that came in the box.</div></div>
            <div class="care-tip"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="m5 13 4 4L19 7"/></svg><div><strong>Remove before showering, swimming, or working out.</strong> Chlorine and salt water dull diamonds and corrode plated metals.</div></div>
            <div class="care-tip"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="m5 13 4 4L19 7"/></svg><div><strong>Apply perfume and lotion first</strong>, jewelry second. Most damage to bracelets comes from skincare chemistry.</div></div>
          </div>
          <div class="care-section">
            <h3>Specific Pieces</h3>
            <div class="care-tip"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="3"/></svg><div><strong>Van Cleef & Arpels Alhambra</strong> — mother of pearl is porous. Avoid water entirely; clean only with a dry cloth.</div></div>
            <div class="care-tip"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="3"/></svg><div><strong>Cartier Juste un Clou</strong> — diamonds are scratch-resistant but the gold can show micro-marks. Polish quarterly.</div></div>
            <div class="care-tip"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="3"/></svg><div><strong>Tiffany Lock & T Bracelet</strong> — store flat to prevent bending the hinge mechanism.</div></div>
          </div>
          <div class="care-warning">
            <strong>Professional Cleaning</strong>
            Many maisons (Cartier, VCA, Tiffany) offer complimentary cleaning at their boutiques with proof of authenticity. We provide the certificate — bring it with you.
          </div>
        </div>
        <div class="care-panel" data-care="storage" style="display:none;">
          <div class="care-section">
            <h3>At Home</h3>
            <div class="care-tip"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="m5 13 4 4L19 7"/></svg><div><strong>Always in the dustbag.</strong> The original dustbag is breathable and protects against dust and light.</div></div>
            <div class="care-tip"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="m5 13 4 4L19 7"/></svg><div><strong>Stuff lightly with acid-free tissue</strong> to maintain shape. Avoid newspaper — ink transfers.</div></div>
            <div class="care-tip"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="m5 13 4 4L19 7"/></svg><div><strong>Cool, dry, dark closet.</strong> Avoid attics, basements, and any spot near a window or radiator.</div></div>
            <div class="care-tip"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="m5 13 4 4L19 7"/></svg><div><strong>Rotate hardware-heavy bags upright</strong> so the hardware doesn't imprint on softer panels.</div></div>
          </div>
          <div class="care-section">
            <h3>Travel</h3>
            <div class="care-tip"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="3"/></svg><div><strong>Pack inside the dustbag</strong>, never loose in a suitcase.</div></div>
            <div class="care-tip"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="3"/></svg><div><strong>Keep the lock & keys separate</strong> from the bag during travel to prevent scuffs.</div></div>
            <div class="care-tip"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="3"/></svg><div><strong>Carry-on only.</strong> Never check a luxury bag — climate control in checked baggage damages leather.</div></div>
          </div>
        </div>
      </div>
    </div>
  `;
  document.body.appendChild(careModal);

  window.openCareGuide = function() { openModal('careguide'); };
  window.switchCareTab = function(btn, name) {
    btn.parentElement.querySelectorAll('button').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    document.querySelectorAll('.care-panel').forEach(p => p.style.display = 'none');
    const panel = document.querySelector(`.care-panel[data-care="${name}"]`);
    if (panel) panel.style.display = 'block';
  };

  // -----------------------------------------------------------------------
  // 4) WIRE ALL FOOTER LINKS
  // -----------------------------------------------------------------------
  function wireAllFooterLinks() {
    const footerCols = document.querySelectorAll('.footer-col');
    if (footerCols.length < 4) return;

    // First link column = Shop
    if (footerCols[0]) {
      footerCols[0].querySelectorAll('li a').forEach(a => {
        a.removeAttribute('data-view');
        a.style.cursor = 'pointer';
        const t = a.textContent.trim();
        if (t === 'All Handbags' || t === 'Todos los Bolsos' || t === 'Tous les Sacs' || t === 'Alle Handtaschen' || t === 'すべてのハンドバッグ' || t === '所有手袋') {
          a.onclick = (e) => { e.preventDefault(); navigateShopByCategory('Handbags'); };
        } else if (t === 'Jewelry' || t === 'Joyería' || t === 'Joaillerie' || t === 'Schmuck' || t === 'ジュエリー' || t === '珠宝') {
          a.onclick = (e) => { e.preventDefault(); navigateShopByCategory('Jewelry'); };
        } else if (t === 'New Arrivals' || t === 'Nuevas Llegadas' || t === 'Nouveautés' || t === 'Neuheiten' || t === '新着品' || t === '新品') {
          a.onclick = (e) => { e.preventDefault(); navigateShopNewest(); };
        } else {
          // Brand name — applies brand filter
          a.onclick = (e) => { e.preventDefault(); navigateShopByBrand(t); };
        }
      });
    }

    // Second link column = Sell
    if (footerCols[1]) {
      footerCols[1].querySelectorAll('li a').forEach(a => {
        a.removeAttribute('data-view');
        a.style.cursor = 'pointer';
        const t = a.textContent.trim();
        if (t === 'Start a Request' || t === 'Iniciar Solicitud' || t === 'Démarrer une Demande' || t === 'Anfrage Starten' || t === 'リクエスト開始' || t === '开始请求') {
          a.onclick = (e) => { e.preventDefault(); navigateSellTo('form'); };
        } else if (t === 'How It Works' || t === 'Cómo Funciona' || t === 'Comment ça Marche' || t === 'Wie es Funktioniert' || t === '仕組み' || t === '如何运作') {
          a.onclick = (e) => { e.preventDefault(); navigateSellTo('how'); };
        } else if (t === 'Consignment Terms' || t === 'Términos de Consignación' || t === 'Conditions de Consignation' || t === 'Kommissionsbedingungen' || t === '委託条件' || t === '寄售条款') {
          a.onclick = (e) => { e.preventDefault(); navigateSellTo('tiers'); };
        } else if (t === 'What We Accept' || t === 'Qué Aceptamos' || t === 'Ce Que Nous Acceptons' || t === 'Was Wir Akzeptieren' || t === '受付品' || t === '我们接受什么') {
          a.onclick = (e) => { e.preventDefault(); navigateSellTo('top'); };
        } else if (t === 'Payouts' || t === 'Pagos' || t === 'Paiements' || t === 'Auszahlungen' || t === '支払い' || t === '付款') {
          a.onclick = (e) => { e.preventDefault(); navigateSellTo('tiers'); };
        }
      });
    }

    // Third link column = Support
    if (footerCols[2]) {
      footerCols[2].querySelectorAll('li a').forEach(a => {
        a.style.cursor = 'pointer';
        const t = a.textContent.trim();
        if (t === 'Contact Us' || t === 'Contáctanos' || t === 'Contactez-nous' || t === 'Kontakt' || t === 'お問い合わせ' || t === '联系我们') {
          a.onclick = (e) => { e.preventDefault(); openContactTicket(); };
        } else if (t === 'Shipping' || t === 'Envío' || t === 'Livraison' || t === 'Versand' || t === '配送') {
          a.onclick = (e) => { e.preventDefault(); openShipping(); };
        } else if (t === 'Authentication' || t === 'Autenticación' || t === 'Authentification' || t === 'Authentifizierung' || t === '認証' || t === '认证') {
          a.onclick = (e) => { e.preventDefault(); openAuthentication(); };
        } else if (t === 'FAQ' || t === 'Preguntas Frecuentes' || t === 'よくある質問' || t === '常见问题') {
          a.onclick = (e) => { e.preventDefault(); openFAQ(); };
        } else if (t === 'Care Guide' || t === 'Guía de Cuidado' || t === 'Guide d\'Entretien' || t === 'Pflegeanleitung' || t === 'ケアガイド' || t === '护理指南') {
          a.onclick = (e) => { e.preventDefault(); openCareGuide(); };
        }
      });
    }
  }
  wireAllFooterLinks();

  // -----------------------------------------------------------------------
  // 5) DESIGNER CARDS ON HOME → filter Shop by that brand
  // -----------------------------------------------------------------------
  function wireDesignerCards() {
    document.querySelectorAll('.designer-card:not(.coming-soon)').forEach(card => {
      card.removeAttribute('data-view');
      const h3 = card.querySelector('h3');
      if (!h3) return;
      const brand = h3.textContent.trim();
      card.style.cursor = 'pointer';
      card.onclick = (e) => { e.preventDefault(); e.stopPropagation(); navigateShopByBrand(brand); };
    });
  }
  wireDesignerCards();

  // Re-wire after any re-render of designer cards
  const _origRenderDesigner = renderDesignerCards;
  renderDesignerCards = function() {
    _origRenderDesigner();
    setTimeout(wireDesignerCards, 50);
  };

  // -----------------------------------------------------------------------
  // 6) HERO "Sell With Us" already has data-view="sell" — works
  // -----------------------------------------------------------------------
  // "Learn More" button on editorial — route to About
  document.querySelectorAll('.editorial button.btn-primary').forEach(b => {
    if (b.textContent.trim() === 'Learn More' && !b.hasAttribute('data-view')) {
      b.setAttribute('data-view', 'about');
      b.addEventListener('click', (e) => { e.preventDefault(); switchView('about'); });
    }
  });

  // -----------------------------------------------------------------------
  // 7) Translations for Care Guide tabs/sections (light coverage)
  // -----------------------------------------------------------------------
  const CARE_I18N = {
    en: { 'care.title':`Care Guide`, 'care.sub':`Keep your Casa pieces in the condition they arrived.`, 'care.tab.bags':`Handbags & Leather`, 'care.tab.jewelry':`Jewelry`, 'care.tab.storage':`Storage & Travel` },
    es: { 'care.title':`Guía de Cuidado`, 'care.sub':`Mantén tus piezas de Casa en la condición en la que llegaron.`, 'care.tab.bags':`Bolsos y Cuero`, 'care.tab.jewelry':`Joyería`, 'care.tab.storage':`Almacenamiento y Viaje` },
    fr: { 'care.title':`Guide d'Entretien`, 'care.sub':`Gardez vos pièces Casa dans l'état où elles sont arrivées.`, 'care.tab.bags':`Sacs & Cuir`, 'care.tab.jewelry':`Joaillerie`, 'care.tab.storage':`Rangement & Voyage` },
    de: { 'care.title':`Pflegeanleitung`, 'care.sub':`Behalten Sie Ihre Casa-Stücke in dem Zustand bei, in dem sie angekommen sind.`, 'care.tab.bags':`Taschen & Leder`, 'care.tab.jewelry':`Schmuck`, 'care.tab.storage':`Aufbewahrung & Reise` },
    ja: { 'care.title':`ケアガイド`, 'care.sub':`Casaの品を届いた時の状態に保ちましょう。`, 'care.tab.bags':`バッグ＆レザー`, 'care.tab.jewelry':`ジュエリー`, 'care.tab.storage':`保管と旅行` },
    zh: { 'care.title':`护理指南`, 'care.sub':`让您的 Casa 作品保持收到时的状态。`, 'care.tab.bags':`手袋与皮革`, 'care.tab.jewelry':`珠宝`, 'care.tab.storage':`存储与旅行` }
  };
  Object.keys(CARE_I18N).forEach(lang => Object.assign(I18N[lang], CARE_I18N[lang]));

  // Apply translations
  try { applyI18n(); } catch(e) {}

  console.log('%cCASA · All footer links wired', 'background:#141414; color:#141414; padding:4px 10px; font-weight:bold;');
  console.log('  ✓ Footer Shop column → Shop view with brand/category/sort filter pre-applied');
  console.log('  ✓ Footer Sell column → Sell view, scrolls to relevant section');
  console.log('  ✓ Footer Support: Contact → ticket modal, Shipping → Shipping modal, Authentication → Authentication modal, FAQ → FAQ modal, Care Guide → Care Guide modal');
  console.log('  ✓ Home Designer cards → Shop with that brand filter');
  console.log('  ✓ Editorial "Learn More" → About view');


  // =============================================================
  // CARTIER → JEWELRY CATEGORY FIX
  // =============================================================
  //
  // Override the existing function to include Cartier (and future-proof for
  // any other jewelry-only maison). This way the Jewelry filter on Shop
  // correctly includes the Cartier Juste un Clou.
  // This is the version of categoryOf() that actually wins — both `categoryOf`
  // (declared earlier, ~line 5286) and `window.categoryOf` are the same global
  // binding, so this later reassignment overwrites the earlier one entirely.
  // 27 Aug 2026: was dropping real inventory rows that carry an explicit
  // `cat`/`category` the regex below doesn't recognize (e.g. CASA-0029
  // "Pochette Toiletries", cat:'Accessories' — falls through to 'Handbags'
  // since "pochette"/"toiletries" match none of the keywords). Explicit data
  // now wins over guessing, same fix as the earlier definition.
  window.categoryOf = function(item) {
    const explicit = item.cat || item.category;
    if (explicit && explicit !== 'Handbags') return explicit;
    const jewelryBrands = ['Tiffany & Co.', 'Van Cleef & Arpels', 'Cartier'];
    if (jewelryBrands.includes(item.brand)) return 'Jewelry';
    // Specific item types (in case a Maison sells both bags and jewelry)
    const name = (item.name || '').toLowerCase();
    if (/bracelet|necklace|ring|earring|brooch|pendant|cufflink/.test(name)) return 'Jewelry';
    // Non-bag accessories (scarves, twillies, belts, small leather goods, etc.)
    if (/twilly|scarf|foulard|bandeau|\bbelt\b|wallet|card ?holder|key ?chain|key ?ring|key ?holder|\bcharm\b|sunglasses|gloves/.test(name)) return 'Accessories';
    return explicit || 'Handbags';
  };

  // Re-render shop so the fix shows immediately if user is on Shop
  if (typeof renderShopGrid === 'function') renderShopGrid();

  // Instagram feed widget scaffolding (INSTAGRAM_WIDGET_URL, injectInstagramFeed,
  // the "setup pending" banner, and its CSP relaxation) removed 27 Aug 2026 — no
  // feed widget will be built. The real @CasaConsignment photo grid above
  // (#ig-grid, populated from Casa Social/ in the main render pass) and the
  // working Instagram/TikTok/Linktree profile links stay as-is.

  console.log('%cCASA · Cartier categorization', 'background:#141414; color:#141414; padding:4px 10px; font-weight:bold;');
  console.log('  ✓ Cartier now categorized as Jewelry (also Tiffany, VCA, and any future jewelry-only brand)');

  // =============================================================
  // CASA · ENGLISH COPY OVERRIDE (single source of truth)
  // Runs last so it wins over every earlier i18n pass. To edit the
  // English copy, change the values here.
  // =============================================================
  (function casaEnglishCopy(){
    const EN = {
      // Nav
      'nav.shop': `Shop`, 'nav.discover': `Newsletter`, 'nav.sell': `Sell`, 'nav.about': `Club`,
      // Trust strip
      'trust.auth': `Expertly Verified`, 'trust.auth.sub': `Inspected by specialists, never software`,
      'trust.secure': `Protected Checkout`, 'trust.secure.sub': `Encrypted, bank-grade payments`,
      'trust.insured': `Insured U.S. Shipping`, 'trust.insured.sub': `Tracked and covered, door to door`,
      'trust.final': `Bought With Confidence`, 'trust.final.sub': `What you see is exactly what arrives`,
      // Maisons
      'designer.eyebrow': `The Maisons`, 'designer.title': `Names That Endure`,
      'designer.lead': `Drawn from private wardrobes and discerning collectors — chosen for their craft, their history, and the quiet way they refuse to go out of style.`,
      // Showcase
      'showcase.eyebrow': `Up Close`, 'showcase.titleHTML': `Studied, <em>down to the stitch.</em>`,
      'showcase.lead': `Every arrival is photographed in full detail — grain, hardware, lining, and stamps — so the screen tells you everything the boutique would. Nothing flattered, nothing hidden.`,
      'showcase.stat1': `In the round`, 'showcase.stat2': `Hardware detail`, 'showcase.stat3': `Listed in`,
      'showcase.stat1Sub': `In the round`, 'showcase.stat2Sub': `Hardware detail`, 'showcase.stat3Sub': `Listed in`,
      'showcase.stat3Big': `48h`,
      'showcase.featured': `This week's selects`, 'showcase.cta': `See What's New`, 'showcase.guide': `Sizing Guide`,
      // Arrivals
      'arrivals.eyebrow': `Fresh to the Floor`, 'arrivals.title': `Newly Arrived`,
      'arrivals.viewAll': `Browse All`, 'arrivals.viewAllArrow': `Browse All →`,
      // Editorial
      'editorial.eyebrow': `The Standard`, 'editorial.titleHTML': `Authenticity Guaranteed Through <em>Expert Verification.</em>`,
      'editorial.body': `Luxury is in the details, and our authentication specialists know them all. With years of hands-on experience examining rare and highly coveted pieces from Chanel, Louis Vuitton, and other prestigious brands, they expertly assess every element — from leather and hardware to stitching, stamps, date codes and craftsmanship. They read authenticity the way others read a signature. Every item is meticulously inspected and authenticated, ensuring that every piece we offer is genuine, trusted and worthy of its next chapter.`,
      'editorial.stat1': `Pieces Verified`, 'editorial.cta': `Learn More`,
      // Social
      'social.eyebrow': `In the Wild`,
      'social.lead': `Arrivals, fittings, and the stories behind the pieces. Tag #CasaStyled to be featured.`,
      // Shop
      'shop.titleFull': `The Collection`, 'shop.leadFull': `A rotating wardrobe of verified rarities — from heritage handbags to signed jewelry.`,
      // Sell
      'sell.eyebrow': `Where Luxury Finds Its Next Home`,
      'sell.titleHTML': `Your treasured pieces<br>deserve <em>a new story.</em>`,
      'sell.lead': `Submit your photos for review and receive a personalized offer from a Casa specialist within 1–2 business days.`,
      'sell.step1.title': `Tell Us About Your Piece`,
      'sell.step2.title': `Authentication & Valuation`,
      'sell.step3.title': `Send Your Piece with Confidence`,
      'sell.step4.title': `Receive Your Payment`,
      'tiers.eyebrow': `Clear, Fair Payouts`, 'tiers.title': `What You Keep`,
      'tiers.lead': `The more your piece sells for, the more you earn. We provide complete transparency on your payout before you consign, so you'll always know exactly what to expect.`,
      // This override is what actually renders the tier-note: the element carries
      // data-i18n-html (see the i18n wiring above), so i18n replaces its innerHTML and
      // any handler attached by wireLegalLinks() is lost on every language switch.
      // The onclick therefore lives in the string itself.
      'tiers.note': `<strong>No upfront fees.</strong> Authentication, condition assessment, photography, and listing preparation are on us — our commission is our only compensation, and the exact percentage is stated in your Offer Summary before you accept it. Your payout is issued within 30 days after the sale is finalized, by ACH or check. Withdraw an unsold piece early and a return fee applies ($50 shipping + $150 processing). See the <a href="#" role="button" onclick="event.preventDefault();window.openLegal&amp;&amp;window.openLegal('agreement')" style="color: var(--navy); text-decoration: underline;">Consignor Terms of Service</a> for full terms.`,
      // Casa positioning line — Alexa asks that this appear across the site
      'casa.positioning': `Casa Consignment is a curated luxury intake platform where every piece is authenticated, strategically positioned, and placed in front of serious buyers only.`,
      // About / Our Story
      'about.eyebrow': `Club`,
      'about.titleHTML': `Welcome to <em>Casa Consignment.</em>`,
      'about.lead': `Welcome to a private world of timeless luxury, where exceptional taste, authenticity, and effortless sophistication come together.`,
      'about.lead2': `Discover authentic designer handbags, from coveted vintage treasures to the latest must-have styles. Whether you're searching for a rare statement piece, a classic investment bag, or a like-new designer find, our carefully curated collection offers something extraordinary for every discerning collector.`,
      'about.card1.title': `Authentic, Always`,
      'about.card1.body': `Every handbag is authenticated by specialists — from coveted vintage treasures to the latest must-have styles. If it cannot be verified, it never reaches the floor.`,
      'about.card2.title': `A Trusted Experience`,
      'about.card2.body': `We are committed to providing a trusted shopping experience, helping you find the perfect piece that complements your unique taste.`,
      'about.card3.title': `Luxury Within Reach`,
      'about.card3.body': `Explore our collection and uncover the handbag you've been searching for — because luxury should always feel within reach.`,
      // Footer
      'footer.stayInKnow': `Join the List`,
      'footer.newsletterLead': `Early access to arrivals, private previews, and the occasional styling note. No noise.`,
      // Size guide (now covers Chanel + Hermès)
      'sizeGuide.sub': `Chanel & Hermès`,
      'showcase.guide': `Size Guide`,
    };
    try {
      if (typeof I18N !== 'undefined' && I18N.en) Object.assign(I18N.en, EN);
      // Fix the nav tagging for the current nav order: Shop · Discover · Sell · Our Story
      const navLinks = document.querySelectorAll('.nav-left .nav-link');
      const keys = ['nav.shop','nav.discover','nav.sell','nav.about'];
      navLinks.forEach((a, i) => { if (keys[i]) a.setAttribute('data-i18n', keys[i]); });
      if (typeof applyI18n === 'function') applyI18n();
    } catch (e) { console.warn('Casa copy override failed', e); }
  })();

  // =============================================================
  // CONTACT / FEEDBACK — customer can submit issues or suggestions (logs a ticket)
  // =============================================================
  // submitContact()/resetContact() removed — the old static contact modal they drove was
  // consolidated into the live ticket modal (submitContactTicket / openContactTicket).

  // =============================================================
  // LEFT DRAWER MENU — toggle + auto-close on navigate / outside click
  // =============================================================
  (function casaDrawer(){
    const drawer = document.getElementById('side-drawer');
    const menuBtn = document.getElementById('menu-btn');
    const closeBtn = document.getElementById('drawer-close');
    if (!drawer) return;
    const open = () => { drawer.classList.remove('dismissed'); drawer.classList.add('open'); };
    // 'dismissed' is what actually makes closing stick while the pointer is
    // still over the drawer — see the .side-drawer.dismissed rule.
    const close = () => { drawer.classList.remove('open'); drawer.classList.add('dismissed'); };
    // Moving the pointer off the drawer re-arms the hover-to-reveal affordance.
    drawer.addEventListener('mouseleave', () => drawer.classList.remove('dismissed'));
    if (menuBtn) menuBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      if (drawer.classList.contains('open')) close(); else open();
    });
    if (closeBtn) closeBtn.addEventListener('click', close);
    // Close after picking a destination (the [data-view] handler does the navigation)
    drawer.querySelectorAll('[data-view], .drawer-account').forEach(el =>
      el.addEventListener('click', () => setTimeout(close, 10)));
    // Click outside closes (when opened via hamburger)
    document.addEventListener('click', (e) => {
      if (drawer.classList.contains('open') && !drawer.contains(e.target) && e.target !== menuBtn && !(menuBtn && menuBtn.contains(e.target))) close();
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  })();

  // =============================================================
  // NEW IN — clean gallery (mirrors Shop All), newest-first
  // =============================================================
  (function casaNewIn(){
    // New In is a CURATED list, not "everything sorted by date". Sorting by date
    // never did anything: every product carries the same 2026-07-01 stamp, so
    // New In was just Shop All in arbitrary order.
    //
    // Order here IS the display order — last three Louis Vuitton, then last
    // three Chanel. To change what appears on New In, edit this array and
    // nothing else.
    //
    // ⚠️ There is no new_in column in the database, so this cannot be edited
    // from Shopify or Neon. Two other places used to each carry their own copy
    // of "refresh home-arrivals + New In" (the final-inventory module, and
    // rerenderCatalog() after hydrateCatalog() fetches the DB ~400ms after
    // load) — consolidated 28 Aug 2026 into window.casaRefreshHomeAndNewIn()
    // below, which both now call. This is the ONLY function anywhere that
    // writes #newin-grid; there is no other path left to silently regress it.
    window.CASA_NEW_IN = [
      'CASA-0045',  // Hermès · Silk Twilly Scarf Orange    (added 25 Sep 2026, $175)
      'CASA-0044',  // Fendi · Zucca Mama Baguette         (added 14 Sep 2026, $1,650)
      'CASA-0043',  // Louis Vuitton · Black Tote Monogram (added 14 Sep 2026, $1,850)
      'CASA-0041',  // Hermès · Birkin 30 Togo Orange      (added 14 Sep 2026, $12,000; title corrected from "Brikin" 23 Sep on Erich's instruction)
      'CASA-0040',  // Chanel · LA PAUSA Black and White  (added 14 Sep 2026, $5,500)
      'CASA-0039',  // Chanel · Hobo 25 Mini Caviar Black (added 14 Sep 2026, $7,400)
      'CASA-0038',  // Chanel · Chain Bucket Bag Denim    (added 14 Sep 2026, $3,000)
      'CASA-0042',  // Louis Vuitton · Pink Backup Backpack   (added 11 Sep 2026, $2,500)
      'CASA-0032',  // Chanel · CC Waist Belt Pearl      (added 28 Aug 2026, $2,300)
      'CASA-0033',  // Chanel · CC Waist Belt Gold       (added 28 Aug 2026, $1,700)
      'CASA-0034',  // Chanel · Wallet Pink              (added 28 Aug 2026, $1,000)
      'CASA-0035',  // Chanel · Card Holder Deep Pink    (added 28 Aug 2026, $500)
      'CASA-0036',  // Givenchy · Antigona Bag Burgundy  (added 28 Aug 2026, $750)
      'CASA-0037',  // Louis Vuitton · Key Chain Pink    (added 28 Aug 2026, $100 — cut from $200 13 Sep 2026)
      'CASA-0027',  // Chanel · Mini Bucket Bag          (added 11 Aug 2026)
      'CASA-0028',  // Hermès · Bride-à-Brac Canvas Case (added 11 Aug 2026)
      'CASA-0029',  // Louis Vuitton · Pochette Toiletries (added 11 Aug 2026)
      'CASA-0030',  // Chanel · Black Patent Boy WOC     (added 11 Aug 2026)
      'CASA-0031',  // Hermès · Savana Dance Twilly      (added 11 Aug 2026)
      'CASA-0026',  // Louis Vuitton · Capucines MM
      'CASA-0025',  // Louis Vuitton · Capucines MM
      'CASA-0024',  // Louis Vuitton · Capucines MM
      'CASA-0002',  // Chanel · Classic Flap Caviar   (was CASA-0027 until 28 Aug 2026)
      'CASA-0023',  // Chanel · Vanity with Chain
      'CASA-0021'   // Chanel · Hobo 25   (replaced CASA-0022, 5 Aug 2026)
    ];
    function renderNewIn(){
      try {
        const g = document.getElementById('newin-grid');
        if (!g || typeof productCard !== 'function' || !Array.isArray(arrivals)) return;
        // Keep the ORIGINAL index so openQuickView(i) still opens the right bag.
        const picked = (window.CASA_NEW_IN || [])
          .map(sku => arrivals.findIndex(p => p && p.sku === sku))
          .filter(i => i >= 0);
        // If none of the curated SKUs are loaded, fall back to the full
        // catalogue. An empty New In page is worse than an uncurated one.
        if (!picked.length) {
          console.warn('New In: none of the curated SKUs found, showing all');
          g.innerHTML = arrivals.map((p, i) => productCard(p, i)).join('');
          return;
        }
        g.innerHTML = picked.map(i => productCard(arrivals[i], i)).join('');
      } catch (e) { console.warn('New In render failed', e); }
    }
    window.casaRenderNewIn = renderNewIn;
    // Shared by every caller that needs to refresh home-arrivals + New In
    // together after `arrivals` changes — the final-inventory module and
    // rerenderCatalog() both call this instead of keeping their own copy.
    window.casaRefreshHomeAndNewIn = function(){
      try {
        const h = document.getElementById('home-arrivals');
        if (h && typeof productCard === 'function') h.innerHTML = arrivals.slice(0,4).map(p => productCard(p)).join('');
      } catch (e) {}
      try { if (typeof window.casaRenderNewIn === 'function') window.casaRenderNewIn(); } catch (e) {}
    };
    renderNewIn();
    // Re-render whenever the New In tab is opened (in case data/lang changed)
    const _sv = window.switchView;
    if (typeof _sv === 'function') {
      window.switchView = function(view){ _sv(view); if (view === 'newin') renderNewIn(); };
    }
  })();

  // ===== FINAL INVENTORY — 20 items from "Casa Consignment - Inventory 2026.xlsx" =====
  (function casaFinalInventory(){
    try {
      const G = (folder,n) => Array.from({length:n}, (_, i) => enc('Casa Bags/'+folder+'/'+(i+1)+'.jpg'));
      const money = v => v ? ('$'+Number(v).toLocaleString('en-US')) : 'Price on request';
    const CASA_GALLERIES = {
      'CASA-0001': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0001-front.jpg?v=1785902704', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0001-rear.jpg?v=1785902706', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0001-side.jpg?v=1785902708', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0001-bottom.jpg?v=1785902710'],
      'CASA-0003': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0003-front.jpg?v=1785902715', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0003-rear.jpg?v=1785902717', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0003-side.jpg?v=1785902719', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0003-bottom.jpg?v=1785902720', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0003-interior.jpg?v=1785902722'],
      'CASA-0004': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0004-front.jpg?v=1785902728', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0004-rear.jpg?v=1785902730', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0004-side.jpg?v=1785902731', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0004-bottom.jpg?v=1785902733', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0004-interior.jpg?v=1785902735'],
      'CASA-0005': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0005-front.jpg?v=1785902740', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0005-rear.jpg?v=1785902742', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0005-side.jpg?v=1785902743', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0005-bottom.jpg?v=1785902745', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0005-interior.jpg?v=1785902746'],
      'CASA-0006': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0006-front.jpg?v=1785902753', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0006-rear.jpg?v=1785902755', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0006-side.jpg?v=1785902756', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0006-bottom.jpg?v=1785902758'],
      'CASA-0007': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0007-front.png?v=1785902767', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0007-bottom.png?v=1785902774', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0007-rear.png?v=1785902770', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0007-side.png?v=1785902772'],
      'CASA-0008': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0008-front.jpg?v=1785902780', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0008-rear.jpg?v=1785902782', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0008-side.jpg?v=1785902784', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0008-bottom.jpg?v=1785902785', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0008-interior.jpg?v=1785902787'],
      // 2.png is the front (leather tab, D-ring, LV heat stamp); 1.png is the blank
      // rear panel. Front leads the gallery. The uploaded filenames are the wrong way
      // round — casa-0009-rear.png holds the front photo — so the DB gallery is ordered
      // rear,front,side,bottom to produce this. See the Gallery Audit (2026-08-05).
      'CASA-0009': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0009-front.png?v=1785902792', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0009-rear.png?v=1785902794', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0009-side.png?v=1785902796', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0009-bottom.png?v=1785902798', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0009-5.png?v=1789428894'],
      'CASA-0010': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0010-front.jpg?v=1785902805', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0010-rear.jpg?v=1785902806', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0010-side.jpg?v=1785902808', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0010-bottom.jpg?v=1785902810'],
      'CASA-0011': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0011-front.jpg?v=1785902814', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0011-rear.jpg?v=1785902815', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0011-side.jpg?v=1785902817', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0011-bottom.jpg?v=1785902819', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0011-interior.jpg?v=1785902821'],
      'CASA-0012': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0012-front.png?v=1785902826', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0012-rear.png?v=1785902828', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0012-side.png?v=1785902830', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0012-bottom.png?v=1785902835'],
      // 5.png = the "Prada Black Purse Front.png" pulled from the accessories
      // drive-download folder. Despite the filename, it's actually an interior
      // tag/authentication shot, not the bag's exterior front — so it's added
      // as a supporting photo, not swapped to position 1 as first planned.
      // Flagged to Erich to confirm; easy to reorder if he wants it first anyway.
      'CASA-0013': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0013-hero.png?v=1788018802', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0013-rear.png?v=1785902843', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0013-side.png?v=1785902845', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0013-bottom.png?v=1785902847', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0013-interior.png?v=1788018805'],
      'CASA-0014': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0014-front.png?v=1785902853', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0014-rear.png?v=1785902855', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0014-side.png?v=1785902857', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0014-bottom.png?v=1785902860'],
      'CASA-0015': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0015-front.png?v=1785902865', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0015-rear.png?v=1785902867', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0015-side.png?v=1785902869', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0015-bottom.png?v=1785902872', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0015-5.png?v=1789428896'],
      'CASA-0016': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0016-front.png?v=1785902877', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0016-rear.png?v=1785902879', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0016-side.png?v=1785902880', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0016-bottom.png?v=1785902883', 'Casa Bags/CASA-0016/Inside.png'],
      'CASA-0017': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0017-front.png?v=1785902888', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0017-rear.png?v=1785902891', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0017-side.png?v=1785902893', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0017-bottom.png?v=1785902895'],
      'CASA-0018': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0018-front.png?v=1785902900', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0018-rear.png?v=1785902902', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0018-side.png?v=1785902904', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0018-bottom.png?v=1785902906'],
      'CASA-0019': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0019-front.png?v=1785902912', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0019-rear.png?v=1785902914', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0019-side.png?v=1785902916', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0019-bottom.png?v=1785902918', 'Casa Bags/CASA-0019/Inside.png'],
      'CASA-0020': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0020-front.png?v=1785902924', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0020-rear.png?v=1785902926', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0020-side.png?v=1785902928', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0020-bottom.png?v=1785902929'],
      'CASA-0021': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0021-front.webp?v=1785902934', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0021-rear.webp?v=1785902935', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0021-side.webp?v=1785902936', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0021-bottom.webp?v=1785902938', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0021-interior.webp?v=1785902939'],
      'CASA-0022': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0022-front.webp?v=1785902944', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0022-rear.webp?v=1785902945', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0022-side.webp?v=1785902947', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0022-bottom.webp?v=1785902948', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0022-interior.webp?v=1785902950'],
      'CASA-0023': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0023-front.webp?v=1785902955', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0023-rear.webp?v=1785902956', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0023-side.webp?v=1785902958', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0023-bottom.webp?v=1785902959', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0023-interior.webp?v=1785902960'],
      // CASA-0002's own image folder doesn't exist on disk (verify_galleries.py
      // flagged all 5 positions missing). Erich staged fresh studio photos of the
      // same bag under "Casa Bags/CASA-0002/" — matches on brand/model/hardware,
      // and the new inventory sheet's CASA-0002 row is an exact price ($8,000)
      // and retail ($10,400) match. Per this repo's own documented history,
      // CASA-0002 and CASA-0002 are the same physical bag and Alexa's sheet still
      // calls it CASA-0002 — so these are folded in here rather than creating a
      // second, duplicate listing. If that's wrong, flag it and this reverts easily.
      // Trimmed to 5 on 28 Aug 2026. Positions 1-5 match the live gallery exactly
      // (perceptual distance 0 on every one); 6.jpg has never been published, so
      // listing it here made the pre-hydration flash show a photo the real
      // catalogue does not have — and blocked the gallery manifest from recording
      // this SKU at all. Per this repo's own rule: an extra local file is an
      // unpublished one, not a missing production image. To publish 6.jpg, upload
      // it to Shopify first and add it back here after.
      'CASA-0002': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0027-front.jpg?v=1785902997', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0027-rear.jpg?v=1785902998', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0027-side.jpg?v=1785903000', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0027-bottom.jpg?v=1785903001', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0027-interior.jpg?v=1785903003'],
      // Updated 27 Aug 2026 to add the "Inside" photos Erich marked, and to
      // match what's actually on disk now (4.jpg/5.jpg were renamed away
      // when these got staged). CASA-0025/0026's old position-5 "interior"
      // was verified by eye to actually be a duplicate BOTTOM shot — the
      // real interior is inside.jpg, added here for the first time; this
      // is the exact ~13-SKU "bottom mislabeled interior" issue this repo's
      // own notes already flag. Still needs pushing to Shopify to go live.
      'CASA-0024': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0024-front.jpg?v=1785902965', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0024-rear.jpg?v=1785902967', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0024-side.jpg?v=1785902968', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0024-bottom.jpg?v=1785902970', 'Casa Bags/CASA-0024/inside.jpg'],
      'CASA-0025': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0025-front.jpg?v=1785902975', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0025-rear.jpg?v=1785902976', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0025-side.jpg?v=1785902978', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0025-inside.jpg?v=1787967071', 'Casa Bags/CASA-0025/inside.jpg'],
      'CASA-0026': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0026-front.jpg?v=1785902986', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0026-rear.jpg?v=1785902987', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0026-side.jpg?v=1785902989', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0026-inside.jpg?v=1787967073', 'Casa Bags/CASA-0026/inside.jpg'],
      // Added 27 Aug 2026 — was missing here, which is why New In was
      // silently dropping these 5 whenever hydrateCatalog() couldn't reach
      // the real DB (this local preview, or any hydration failure).
      'CASA-0027': ['Casa Bags/CASA-0027/1 front.png', 'Casa Bags/CASA-0027/2 rear.png', 'Casa Bags/CASA-0027/3 side.png', 'Casa Bags/CASA-0027/4 interior.png'],
      'CASA-0028': ['Casa Bags/CASA-0028/1 front.png', 'Casa Bags/CASA-0028/2 rear.png', 'Casa Bags/CASA-0028/3 side.png', 'Casa Bags/CASA-0028/4 bottom.png', 'Casa Bags/CASA-0028/5 interior.png'],
      'CASA-0029': ['Casa Bags/CASA-0029/1 front.png', 'Casa Bags/CASA-0029/2 rear.png', 'Casa Bags/CASA-0029/3 bottom.png'],
      'CASA-0030': ['Casa Bags/CASA-0030/1 front.png', 'Casa Bags/CASA-0030/2 rear.png', 'Casa Bags/CASA-0030/3 side.png', 'Casa Bags/CASA-0030/4 interior.png', 'Casa Bags/CASA-0030/5 bottom.png'],
      'CASA-0031': ['Casa Bags/CASA-0031/1 front.png', 'Casa Bags/CASA-0031/2 front-detail.png', 'Casa Bags/CASA-0031/3 front-draped.png'],
      // Accessories/purse batch, added 27 Aug 2026 from Alexa's emailed photos —
      // priced and numbered per "Casa Consignment - Inventory 2026 (1).xlsx".
      // RENUMBERED 28 Aug 2026 to match Alexa's sheet exactly. The old off-by-one
      // was not a slip in her sheet — it was ours: CASA-0027 was a re-list of
      // CASA-0002 (same physical bag, three MD5-identical photos), which pushed
      // every SKU from 0028 up one above the sheet. Folding 0027 back onto 0002
      // frees that slot, so 0028..0032 each drop by one and this new batch lands
      // on 0032..0037. Sheet and site now agree row-for-row.
      //
      // Safe to do because there are ZERO real bag orders (all 9 Shopify orders
      // are refunded smoke tests plus one membership) — verified 28 Aug 2026.
      // The 3 real saved-wishlist rows that sat on the old numbers are remapped
      // in the same change; see scripts/renumber-2026-08-28.mjs.
      'CASA-0032': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0032-1_3794e563-3e30-4311-b843-9cab7c35e681.png?v=1787964509', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0032-2_5504e62c-bd2b-462b-98c9-d1631090afcb.png?v=1787964509', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0032-3_1daab509-9379-4ae6-a897-7210993f9692.png?v=1787964509'],
      // 4.png is the whole belt laid out (CC drop visible); 1.png is a tight crop of
      // the clasp and extender, which does not read as a belt at all. 4.png leads, per
      // Erich 4 Sep 2026. Matches the Shopify media order, which is the source of
      // truth — reordered there first (scripts/reorder-casa-0033-media.mjs), never here
      // first. Files keep their upload numbers; renaming would rewrite every CDN URL.
      'CASA-0033': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0033-3.png?v=1787964515', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0033-4.png?v=1787964515', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0033-1.png?v=1787964515', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0033-2.png?v=1787964515'],
      'CASA-0034': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0034-1.png?v=1787964525', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0034-2.png?v=1787964525', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0034-3.png?v=1787964525', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0034-4.png?v=1787964525', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0034-5.png?v=1787964525'],
      'CASA-0035': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0039-1.png?v=1787946751', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0039-2.png?v=1787946754', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0039-3.png?v=1787946757', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0039-4.png?v=1787946759'],
      'CASA-0036': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0036-1.png?v=1787964537', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0036-2.png?v=1787964537', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0036-3.png?v=1787964537', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0036-4.png?v=1787964537', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0036-5.png?v=1787964537', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0036-6.png?v=1787964537'],
      'CASA-0037': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0038-1.png?v=1787946762', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/casa-0038-2.png?v=1787946764'],
      // front, rear, side, interior — same order as the Shopify media, which is what
      // products.gallery mirrors. Alexa's edited PNGs, 10 Sep 2026.
      'CASA-0038': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0038-1_7e92ccb8-e060-4d6e-bb85-35894d46bff8.png?v=1789428800', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0038-2_24f25cd3-eb1b-4d31-8e34-c3364766da1b.png?v=1789428802', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0038-3.png?v=1789428805', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0038-4.png?v=1789428808', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0038-5.png?v=1789428810'],
      'CASA-0039': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0039-1_675b31dd-3637-486c-b310-94ec4c1c96f9.png?v=1789428816', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0039-2_b0292b37-b057-4178-9826-9477fe221ee0.png?v=1789428818', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0039-3_28c5d0ed-33cf-4084-9078-5a60e8fd3205.png?v=1789428820', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0039-4_a9cd5379-b0f1-4af1-a6b5-23f2d3e4803b.png?v=1789428822', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0039-5.png?v=1789428825', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0039-6.png?v=1789428827'],
      'CASA-0040': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0040-1.png?v=1789428833', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0040-2.png?v=1789428835', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0040-3.png?v=1789428837', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0040-4.png?v=1789428839', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0040-5.jpg?v=1789428841'],
      'CASA-0041': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0041-1.png?v=1789428847', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0041-2.png?v=1789428849', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0041-3.png?v=1789428851', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0041-4.png?v=1789428853', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0041-5.png?v=1789428856', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0041-6.png?v=1789428858'],
      'CASA-0042': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0042-1.png?v=1789134713', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0042-2.png?v=1789134716', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0042-3.png?v=1789134718', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0042-4.png?v=1789134722'],
      'CASA-0043': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0043-1.png?v=1789428865', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0043-2.png?v=1789428867', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0043-3.png?v=1789428869', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0043-4.png?v=1789428871', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0043-5.png?v=1789428873'],
      'CASA-0044': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0044-1.png?v=1789428880', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0044-2.png?v=1789428882', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0044-3.png?v=1789428884', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0044-4.png?v=1789428886', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0044-5.png?v=1789428888'],
      'CASA-0045': ['https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0045-1.png?v=1790347767', 'https://cdn.shopify.com/s/files/1/0770/0414/4830/files/CASA-0045-2.png?v=1790347769'],
    };
      const items = [
        {sku:'CASA-0001', brand:'Chanel', name:'Classic Flap - Caviar', cat:'Handbags', color:'Grey', cond:'AS IS', size:'Meduim', year:2025, hw:'Gold', price:5500, retail:'', inc:'Authenticity dust bag and box', folder:'Chanel Classic Flap Ivory', n:4, badge:'New'},
        {sku:'CASA-0003', brand:'Chanel', name:'Classic mini - Tweed', cat:'Handbags', color:'Baby blue', cond:'Pristine', size:'Mini', year:2026, hw:'Silver', price:6000, retail:'', inc:'Authenticity dust bag and box', folder:'', n:0, badge:'Rare'},
        {sku:'CASA-0004', brand:'Chanel', name:'Coco Handle Bag - Caviar', cat:'Handbags', color:'Black', cond:'Very Good', size:'Meduim', year:2026, hw:'Silver', price:4000, retail:'', inc:'Authenticity dust bag and box', folder:'', n:0, badge:'Rare'},
        {sku:'CASA-0005', brand:'Louis Vuitton', name:'Backup Backpack', cat:'Handbags', color:'Black -Monogram', cond:'Very Good', size:'Small', year:2024, hw:'Gold Hardwear', price:2800, retail:'', inc:'Authenticity dust bag and box', folder:'LV Montsouris Backpack Black', n:4, badge:'New'},
        {sku:'CASA-0006', brand:'Louis Vuitton', name:'Alma BB Â·', cat:'Handbags', color:'Monogram', cond:'Very Good', size:'Small', year:2023, hw:'Gold Hardwear', price:1300, retail:'', inc:'Authenticity dust bag and box', folder:'LV Alma BB Monogram', n:4, badge:'New'},
        {sku:'CASA-0007', brand:'Louis Vuitton', name:'Canvas Vanity PM', cat:'Handbags', color:'Black - Brown Monogram', cond:'AS IS', size:'Small', year:'', hw:'Gold Hardwear', price:2000, retail:'', inc:'Authenticity dust bag and box', folder:'', n:0, badge:''},
        {sku:'CASA-0008', brand:'Louis Vuitton', name:'Kimono Tote Black', cat:'Handbags', color:'Black -Monogram', cond:'Very Good', size:'Meduim', year:'', hw:'Gold Hardwear', price:2190, retail:'', inc:'Authenticity dust bag and box', folder:'', n:0, badge:''},
        {sku:'CASA-0009', brand:'Louis Vuitton', name:'Epi Leather Shoulder Bag', cat:'Handbags', color:'Pink', cond:'Very Good', size:'Small', year:'', hw:'Silver Hardwear', price:600, retail:'', inc:'Authenticity dust bag and box', folder:'', n:0, badge:''},
        {sku:'CASA-0010', brand:'Louis Vuitton', name:'Computer Bag', cat:'Travel', color:'Monogram', cond:'Excellent', size:'Large', year:'', hw:'Gold Hardwear', price:1850, retail:'', inc:'Authenticity dust bag and box', folder:'', n:0, badge:''},
        {sku:'CASA-0011', brand:'Louis Vuitton', name:'Canvas Neonoe MM', cat:'Handbags', color:'Monogram', cond:'Very Good', size:'Meduim', year:2017, hw:'Gold Hardwear', price:1700, retail:'', inc:'Authenticity dust bag and box', folder:'', n:0, badge:''},
        {sku:'CASA-0012', brand:'Louis Vuitton', name:'Nano Bucket Bag', cat:'Handbags', color:'White - Monogram', cond:'Excellent', size:'Small', year:'', hw:'Gold Hardwear', price:1480, retail:'', inc:'Authenticity dust bag and box', folder:'', n:0, badge:'New'},
        {sku:'CASA-0013', brand:'Prada', name:'Re-Edition 2005 Shoulder Bag', cat:'Handbags', color:'Black', cond:'Very Good', size:'Small', year:2005, hw:'Silver Hardwear', price:1200, retail:'', inc:'Authenticity dust bag and box', folder:'', n:0, badge:''},
        {sku:'CASA-0014', brand:'Prada', name:'Re-Edition 2005 Shoulder Bag', cat:'Handbags', color:'Beige', cond:'Fair', size:'Small', year:2005, hw:'Silver Hardwear', price:1000, retail:'', inc:'Authenticity dust bag and box', folder:'', n:0, badge:''},
        {sku:'CASA-0015', brand:'Gucci', name:'G Shoulder Bag', cat:'Handbags', color:'Red', cond:'AS IS', size:'Small', year:'', hw:'Gold Hardwear', price:500, retail:'', inc:'Authenticity dust bag and box', folder:'', n:0, badge:''},
        {sku:'CASA-0016', brand:'Fendi', name:'Peekaboo', cat:'Handbags', color:'Dark Grey', cond:'Good', size:'Meduim', year:'', hw:'Gold Hardwear', price:3000, retail:'', inc:'Authenticity raincoat', folder:'', n:0, badge:'Rare'},
        {sku:'CASA-0017', brand:'Gucci', name:'GG Supreme Dionysus', cat:'Handbags', color:'Brown', cond:'As IS', size:'Super Mini', year:'', hw:'Silver Hardwear', price:700, retail:'', inc:'Authenticity dust bag and box', folder:'', n:0, badge:''},
        {sku:'CASA-0018', brand:'Christian Dior', name:'Saddle Bag', cat:'Handbags', color:'Black', cond:'Good', size:'Meduim', year:'', hw:'Gold Hardwear', price:2500, retail:'', inc:'Authenticity dust bag and box', folder:'', n:0, badge:'Rare'},
        {sku:'CASA-0019', brand:'Balenciaga', name:'Embossed Leather Neo Classic Mini', cat:'Handbags', color:'Black', cond:'Good', size:'Mini', year:'', hw:'Black Hardwear', price:1150, retail:'', inc:'Authenticity dust bag and box', folder:'', n:0, badge:''},
        {sku:'CASA-0020', brand:'Jacquemus', name:'Le Bambino Leather Top Handle', cat:'Handbags', color:'Black', cond:'Good', size:'Mini', year:'', hw:'Gold Hardwear', price:400, retail:'', inc:'Authenticity dust bag  and box', folder:'', n:0, badge:'New'},
        {sku:'CASA-0021', brand:'Chanel', name:'Hobo 25', cat:'Handbags', color:'Blue Suede', cond:'Excellent', size:'Small', year:2025, hw:'Gold Hardwear', price:8500, retail:'', inc:'Authenticity dust bag and box', folder:'', n:0, badge:'New', date:'2026-07-09'},
        {sku:'CASA-0022', brand:'Chanel', name:'Virginie Viard Gold', cat:'Handbags', color:'Gold & Metallic', cond:'Excellent', size:'Small', year:2025, hw:'Gold Hardwear', price:4300, retail:'', inc:'Authenticiy dust bag and box', folder:'', n:0, badge:'New', date:'2026-07-09'},
        {sku:'CASA-0023', brand:'Chanel', name:'vanity with chain', cat:'Handbags', color:'Black', cond:'Excellent', size:'Mini', year:'2020-2021', hw:'Gold Hardwear', price:3000, retail:'', inc:'Authenticiy, box, and dust bag', folder:'', n:0, badge:'New', date:'2026-07-09'},
        {sku:'CASA-0002', brand:'Chanel', name:'Classic Flap Â· Caviar', cat:'Handbags', color:'Beige', cond:'Excellent', size:'Med', year:2025, hw:'Gold', price:8000, retail:'', inc:'Authenticity dust bag and box', folder:'', n:0, badge:'New', date:'2026-06-08'},
        {sku:'CASA-0024', brand:'Louis Vuitton', name:'Capucines Mm', cat:'Handbags', color:'Black', cond:'Pristine', size:'Large', year:2023, hw:'Gold Hardwear', price:4500, retail:'', inc:'Authenticity', folder:'', n:0, badge:'New', date:'2026-07-24'},
        {sku:'CASA-0025', brand:'Louis Vuitton', name:'Capucines Mm', cat:'Handbags', color:'Black', cond:'Pristine', size:'Large', year:2023, hw:'Gold Hardwear', price:4500, retail:'', inc:'Authenticity', folder:'', n:0, badge:'New', date:'2026-07-24'},
        {sku:'CASA-0026', brand:'Louis Vuitton', name:'Capucines Mm', cat:'Handbags', color:'Beige/Yellow', cond:'Pristine', size:'Large', year:2023, hw:'Gold Hardwear', price:4500, retail:'', inc:'Authenticity', folder:'', n:0, badge:'New', date:'2026-07-24'},
        {sku:'CASA-0027', brand:'Chanel', name:'Mini Bucket Bag', cat:'Handbags', color:'Black', cond:'Pristine', size:'Mini', year:2022, hw:'Gold Hardwear', price:4999, retail:'', inc:'Authenticity dust bag  and box', folder:'', n:0, badge:'New', date:'2026-08-11'},
        {sku:'CASA-0028', brand:'HermÃ¨s', name:'Bride-a-Brac Canvas Case', cat:'Case', color:'Beige', cond:'As IS', size:'Small', year:'', hw:'', price:900, retail:'', inc:'Authenticity dust bag  and box', folder:'', n:0, badge:'New', date:'2026-08-11'},
        {sku:'CASA-0029', brand:'Louis Vuitton', name:'Pochette Toiletries', cat:'Accessories', color:'Monogram', cond:'Very Good', size:'Meduim', year:'', hw:'Gold Hardwear', price:750, retail:'', inc:'Authenticity dust bag  and box', folder:'', n:0, badge:'New', date:'2026-08-11'},
        {sku:'CASA-0030', brand:'Chanel', name:'Black Patent Boy', cat:'Handbags', color:'Patent', cond:'Good', size:'Small', year:'', hw:'Silver Hardwear', price:1799, retail:'', inc:'Authenticity dust bag  and box', folder:'', n:0, badge:'New', date:'2026-08-11'},
        {sku:'CASA-0031', brand:'HermÃ¨s', name:"The Savana Dance ' Twilly", cat:'Accessories', color:'Corail silk', cond:'Excellent', size:'', year:'', hw:'', price:199, retail:'', inc:'Authenticity box', folder:'', n:0, badge:'New', date:'2026-08-11'},
        // Accessories/purse batch — 27 Aug 2026, from Alexa's emailed photos,
        // priced per "Casa Consignment - Inventory 2026 (1).xlsx" (see SKU
        // renumbering note in CASA_GALLERIES above).
        {sku:'CASA-0032', brand:'Chanel', name:'CC Waist Belt', cat:'Accessories', color:'Pearl', cond:'Excellent', size:'Meduim', year:2026, hw:'Silver', price:2300, retail:'', inc:'Authenticity case and box', folder:'', n:0, badge:'New', date:'2026-08-27'},
        {sku:'CASA-0033', brand:'Chanel', name:'CC Waist Belt', cat:'Accessories', color:'Gold', cond:'Excellent', size:'Small', year:2025, hw:'Gold', price:1700, retail:'', inc:'Authenticity case and box', folder:'', n:0, badge:'New', date:'2026-08-27'},
        {sku:'CASA-0034', brand:'Chanel', name:'Wallet - Caviar', cat:'Accessories', color:'Pink', cond:'Pristine', size:'', year:2026, hw:'Silver', price:1000, retail:'', inc:'Authenticity dust bag  and box', folder:'', n:0, badge:'New', date:'2026-08-27'},
        {sku:'CASA-0035', brand:'Chanel', name:'Card Holder - Caviar', cat:'Accessories', color:'Deep Pink', cond:'Fair', size:'', year:'', hw:'', price:500, retail:'', inc:'Authenticity dust bag', folder:'', n:0, badge:'New', date:'2026-08-28'},
        {sku:'CASA-0036', brand:'Givenchy', name:'Antigona Bag', cat:'Handbags', color:'Burgundy', cond:'AS IS', size:'Meduim', year:'', hw:'', price:750, retail:'', inc:'Authenticity', folder:'', n:0, badge:'New', date:'2026-08-27'},
        {sku:'CASA-0037', brand:'Louis Vuitton', name:'Key Chain', cat:'Accessories', color:'Pink', cond:'Fair', size:'', year:'', hw:'', price:100, retail:'', inc:'Authenticity', folder:'', n:0, badge:'New', date:'2026-08-28'},
        {sku:'CASA-0038', brand:'Chanel', name:'Chain Bucket BagÂ - Denim', cat:'Handbags', color:'Denim', cond:'New', size:'Small', year:2021, hw:'Silver', price:3000, retail:'', inc:'Authenticity dust bag  and box', folder:'', n:0, badge:'New', date:'2026-09-14'},
        {sku:'CASA-0039', brand:'Chanel', name:'Hobo 25 Mini - Caviar', cat:'Handbags', color:'Black', cond:'Pristine', size:'Mini', year:2025, hw:'Gold', price:7400, retail:'', inc:'Authenticity dust bag  and box', folder:'', n:0, badge:'New', date:'2026-09-14'},
        {sku:'CASA-0040', brand:'Chanel', name:'LA PAUSA - Lambskin Leather', cat:'Handbags', color:'Blcak and White', cond:'Pristine', size:'Small', year:2019, hw:'tweed & sliver', price:5500, retail:'', inc:'Authenticity dust bag and box', folder:'', n:0, badge:'New', date:'2026-09-14'},
        {sku:'CASA-0041', brand:'HermÃ¨s', name:'Birkin 30 - Togo', cat:'Handbags', color:'Orange', cond:'Very Good', size:'Large', year:2017, hw:'Silver', price:12000, retail:'', inc:'Authenticity dust bag box raincoat lock and key', folder:'', n:0, badge:'New', date:'2026-09-14'},
        {sku:'CASA-0042', brand:'Louis Vuitton', name:'Pink Backup Backpack', cat:'Handbags', color:'Pink Monogram', cond:'Very Good', size:'Small', year:'', hw:'Gold', price:2500, retail:'', inc:'Authenticity dust bag  and box', folder:'', n:0, badge:'New', date:'2026-09-11'},
        {sku:'CASA-0043', brand:'Louis Vuitton', name:'Black Tote Monogram', cat:'Handbags', color:'Black Monogram', cond:'Very Good', size:'Large', year:2023, hw:'Gold', price:1850, retail:'', inc:'Authenticity dust bag  and box', folder:'', n:0, badge:'New', date:'2026-09-14'},
        {sku:'CASA-0044', brand:'Fendi', name:'Zucca Mama Baguette', cat:'Handbags', color:'Black and Brown', cond:'Excellent', size:'Small', year:2000, hw:'Silver', price:1650, retail:'', inc:'Authenticity', folder:'', n:0, badge:'New', date:'2026-09-14'},
        {sku:'CASA-0045', brand:'Hermès', name:'Silk Twilly Scarf', cat:'Accessories', color:'Orange', cond:'Pristine', size:'', year:'', hw:'', price:175, retail:'', inc:'Authenticity box', folder:'', n:0, badge:'New', date:'2026-09-25'},
      ];
      // The DB has no `category` column (checked 28 Aug 2026: products holds
      // sku/brand/name/color/condition/size/year/hardware/price/retail/gallery/
      // status/... and nothing else), so hydrateCatalog()'s toArrival() has
      // nothing to read and used to hard-code every row to 'Handbags'. That
      // quietly undid the 27 Aug "explicit category wins" fix for real visitors:
      // it held before hydration and was overwritten ~400ms later, which is why
      // CASA-0029 Pochette Toiletries still filed under Handbags on the live
      // site even though the sheet, this array and the shop filter all say
      // Accessories. Publish the curated categories so toArrival() can keep them.
      //
      // Only the four real filter buckets are exported. The sheet also uses
      // 'Travel' (CASA-0010) and 'Case' (CASA-0028), which match no filter — a
      // row carrying one would disappear from every category page, so those
      // deliberately keep falling back to Handbags.
      const SHOP_BUCKETS = ['Handbags', 'Jewelry', 'Accessories', 'Apparel'];
      window.CASA_CATEGORY = Object.fromEntries(
        items.filter(i => SHOP_BUCKETS.includes(i.cat)).map(i => [i.sku, i.cat])
      );
      const mapped = items.map((it, idx) => {
        const gal = (CASA_GALLERIES[it.sku] || (it.folder ? G(it.folder, it.n).map(x=>x) : [])).map(p => typeof p==='string' ? enc(p) : p);
        return {
          brand: it.brand, name: it.name, price: money(it.price),
          retail: it.retail ? money(it.retail) : '', cond: it.cond, badge: it.badge || '',
          img: gal[0] || '', gallery: gal, size: it.size||'—', color: it.color||'—',
          hardware: it.hw||'—', year: it.year||'—', includes: '', sku: it.sku,
          category: it.cat, authStatus: 'pending', seq: idx+1, date: it.date || '2026-06-08'
        };
      });
      arrivals.length = 0;
      // Only display products that have photos. The 9 SKUs without the new
      // studio shots are kept in Shopify/data but hidden from the storefront.
      arrivals.push(...mapped.filter(p => p.gallery && p.gallery.length > 0));
      const r = () => {
        try { const s=document.getElementById('shop-grid'); if(s) s.innerHTML = arrivals.map(productCard).join(''); } catch(e){}
        // Home-arrivals + New In: shared with rerenderCatalog() via
        // window.casaRefreshHomeAndNewIn() — one function owns both writes.
        if (typeof window.casaRefreshHomeAndNewIn === 'function') window.casaRefreshHomeAndNewIn();
        try { if(typeof renderDesignerCards==='function') renderDesignerCards(); } catch(e){}
        try { if(typeof renderBrandFilters==='function') renderBrandFilters(); } catch(e){}
      };
      r();
      document.querySelectorAll('.result-count').forEach(el=>{ if(/Showing|of /.test(el.textContent)) el.innerHTML = 'Showing <strong>1–'+arrivals.length+'</strong> of '+arrivals.length; });
      console.log('Casa final inventory loaded:', arrivals.length, 'items');
    } catch(e){ console.warn('Final inventory load failed', e); }
  })();

  // =====================================================================
  // CASA · PHASE A PATCH — Sell/Support wiring, dedicated Shipping &
  // Authentication pages, embedded legal documents, checkout returns
  // notice, consignor email hook, and Phase-B integration config seams.
  // =====================================================================
  (function casaPhaseA(){

    // ---- Phase-B integration config (fill in + deploy serverless next) ----
    window.CASA_CONFIG = window.CASA_CONFIG || {
      SHOPIFY_DOMAIN: '',            // e.g. casa-consignment.myshopify.com
      SHOPIFY_STOREFRONT_TOKEN: '',  // Storefront API token (public)
      EMAIL_ENDPOINT: '',            // serverless endpoint that sends mail
      SUPPORT_INBOX: 'info@casaconsignment.com'
    };
    // Phase-B hook: real consignor confirmation email is sent here once
    // EMAIL_ENDPOINT is live. Until then this is a no-op that just logs.
    window.sendConsignorConfirmation = function(email){
      if (!window.CASA_CONFIG.EMAIL_ENDPOINT) {
        console.log('[Casa] (Phase B) would email consignor confirmation to:', email || '(unknown)');
        return Promise.resolve({ simulated: true });
      }
      try {
        return fetch(window.CASA_CONFIG.EMAIL_ENDPOINT, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ type: 'consignor_confirmation', email })
        });
      } catch(e) { return Promise.resolve({ error: true }); }
    };

    // ---- Styles for the info (shipping/auth) + legal modals ----
    const st = document.createElement('style');
    st.textContent = `
      .modal.info-modal, .modal.legal-modal { max-width: 720px; padding: 0; overflow: hidden; }
      .info-head, .legal-head { padding: 28px 36px 22px; border-bottom: 1px solid var(--line); }
      .info-head h2, .legal-head h2 { font-size: 28px; font-weight: 500; margin-bottom: 4px; }
      .info-head p, .legal-head p { color: var(--muted); font-size: 13px; margin: 0; }
      .info-body { padding: 22px 36px 32px; max-height: 70vh; overflow-y: auto; }
      .info-item { padding: 16px 0; border-bottom: 1px solid var(--line); }
      .info-item:last-child { border-bottom: 0; }
      .info-item h4 { font-family: var(--serif); font-size: 18px; color: var(--navy); margin-bottom: 6px; font-weight: 500; }
      .info-item p { font-size: 14px; color: var(--navy-soft); line-height: 1.65; margin: 0; }
      .info-callout { padding: 14px 18px; background: var(--bg); border-left: 4px solid var(--navy); border-radius: 2px; margin: 0 0 18px; font-size: 13px; color: var(--navy-soft); line-height: 1.6; }
      .info-callout strong, .legit-badge strong { display:block; font-size:10px; letter-spacing:0.22em; text-transform:uppercase; color: var(--navy); margin-bottom: 4px; }
      .legit-badge { display:flex; align-items:center; gap:14px; padding:16px 18px; background:#141414; color:#fff; border-radius:3px; margin-bottom:18px; }
      .legit-badge .lb-mark { font-family: var(--serif); font-size:20px; letter-spacing:0.04em; }
      .legit-badge strong { color: rgba(255,255,255,0.7); }
      .legit-badge span { font-size:12.5px; line-height:1.55; color: rgba(255,255,255,0.92); }
      .legal-nav { display:flex; gap:0; padding:0 36px; border-bottom:1px solid var(--line); background: var(--bg-cream); flex-wrap: wrap; }
      .legal-nav button { padding:13px 16px; font-size:10.5px; letter-spacing:0.16em; text-transform:uppercase; color:var(--muted); border-bottom:2px solid transparent; transition:all .2s; }
      .legal-nav button.active { color:var(--navy); border-bottom-color:var(--navy); }
      .legal-body { padding: 24px 36px 34px; max-height: 68vh; overflow-y:auto; }
      .legal-doc { display:none; }
      .legal-doc.active { display:block; }
      .legal-doc h3 { font-family: var(--serif); font-size:22px; color:var(--navy); font-weight:500; margin:0 0 4px; }
      .legal-doc .legal-meta { font-size:11px; letter-spacing:0.14em; text-transform:uppercase; color:var(--muted); margin-bottom:18px; }
      .legal-doc h4 { font-size:12px; letter-spacing:0.06em; color:var(--navy); margin:18px 0 6px; font-weight:600; }
      .legal-doc p { font-size:13px; color:var(--navy-soft); line-height:1.65; margin:0 0 10px; }
      .legal-doc table.tier-table { width:100%; border-collapse:collapse; margin:6px 0 12px; font-size:13px; }
      .legal-doc table.tier-table th, .legal-doc table.tier-table td { text-align:left; padding:8px 10px; border-bottom:1px solid var(--line); }
      .legal-doc table.tier-table th { font-size:10px; letter-spacing:0.16em; text-transform:uppercase; color:var(--muted); font-weight:600; }
      .legal-doc .sig { margin-top:18px; padding-top:14px; border-top:1px solid var(--line); font-size:12px; color:var(--muted); line-height:1.7; }
    `;
    document.head.appendChild(st);

    const closeBtn = (name) => `<button class="modal-close" aria-label="Close" onclick="closeModal('${name}')"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 6l12 12M18 6L6 18"/></svg></button>`;
    function mkModal(id, inner){
      const el = document.createElement('div');
      el.id = 'modal-' + id;
      el.className = 'modal-backdrop';
      el.addEventListener('click', (e)=>{ if (e.target === el) closeModal(id); });
      el.innerHTML = inner;
      document.body.appendChild(el);
      return el;
    }

    // ---------------- A3 · SHIPPING ----------------
    mkModal('shipping', `
      <div class="modal info-modal">
        ${closeBtn('shipping')}
        <div class="info-head"><h2 data-i18n="ship.title">Shipping</h2><p data-i18n="ship.sub">Insured, tracked, and handled with care — in both directions.</p></div>
        <div class="info-body">
          <div class="info-callout"><strong>Always insured</strong>Every shipment, inbound and outbound, is insured to the item's value and tracked door to door.<span style="display:block; margin-top:8px; font-size:12px; color:var(--muted); line-height:1.5;">Gold and Elite Concierge members receive complimentary insured shipping on eligible consignments; standard insured-shipping rates apply otherwise.</span></div>
          <div class="info-item"><h4>Buying — delivery to you</h4><p><strong>Insured Standard — FedEx, 3–5 business days.</strong> Fully insured to the item’s value, signature required. Shipping is calculated at checkout and is a flat charge based on the order value — typically 1–2% of the item price, because Casa carries the risk of loss until the piece reaches you. Expedited service is coming shortly; email us if you need a piece sooner.</p></div>
          <div class="info-item"><h4>Selling — sending your piece in</h4><p>Once your offer is accepted, we email a <strong>prepaid, fully insured shipping label</strong>. Pack the item with all accessories included in your offer, drop it at any FedEx location, and you're covered in transit. Your piece must reach us within 15 days or the offer expires.</p></div>
          <div class="info-item"><h4>Risk of loss</h4><p>On purchases, risk of loss passes to you upon proof of delivery to the address you selected at checkout. On items you send to consign, the risk stays with you in transit and through our inspection, until the item is Accepted under the Consignor Terms — which is why we provide insured labels.</p></div>
          <div class="info-item"><h4>Damaged or lost in transit?</h4><p>Open a <a class="lnk-ship-ticket" style="color:var(--navy); text-decoration:underline; cursor:pointer;">Shipping ticket</a> as soon as you notice, with photos of the outer box and contents — the sooner we have them, the stronger the carrier claim. We file the FedEx insurance claim on your behalf.</p></div>
          <div class="info-item"><h4>International</h4><p>We currently ship within the <strong>United States only</strong>. Insured international service is being finalised and we expect to open it shortly — email <a href="mailto:info@casaconsignment.com">info@casaconsignment.com</a> and we will notify you, or discuss a specific piece with you directly.</p></div>
        </div>
      </div>`);

    // ---------------- A3 · AUTHENTICATION ----------------
    mkModal('authentication', `
      <div class="modal info-modal">
        ${closeBtn('authentication')}
        <div class="info-head"><h2 data-i18n="authpg.title">Authentication</h2><p data-i18n="authpg.sub">Every piece is certified before it ever reaches the floor.</p></div>
        <div class="info-body">
          
          <div class="info-item"><h4>How it works</h4><p>Each item is examined by specialists with years of experience in luxury maisons, and certified before listing. We assess leather, hardware, stitching, stamps, date codes, and craftsmanship before anything is listed.</p></div>
          <div class="info-item"><h4>Only authentic goods</h4><p>We accept only fully authentic products. If we determine in good faith that an item is not authentic, we notify you in writing and document the basis for that determination. To the extent permitted by law we may then decline to return the item, surrender it to the rights holder or the authorities, or — after not less than thirty (30) days' written notice to you — dispose of it. See Consignor Terms §4.3.</p></div>
          <div class="info-item"><h4>Questions about a certificate?</h4><p>Open an <a class="lnk-auth-ticket" style="color:var(--navy); text-decoration:underline; cursor:pointer;">Authentication ticket</a> and a specialist will respond as soon as possible.</p></div>
        </div>
      </div>`);

    window.openShipping = function(){ openModal('shipping'); };
    window.openAuthentication = function(){ openModal('authentication'); };

    // ---------------- A4 · LEGAL DOCUMENTS ----------------
    // Source: Legal Documents/ (TOS, Commission Tiers, Consignment Agreement).
    // Cleaned of source-template artifacts (Rebag/Rebis/Clair Trade) and
    // governing law set to Florida to match the executed Consignment Agreement.
    const TOS_HTML = `
      <h3>Terms of Service</h3>
      <div class="legal-meta">Casa Consignment LLC · The executed documents govern</div>
      <p>Using this site, and any purchase, consignment or membership through it, is governed
      by the documents Casa's attorney prepared and that you accept at the point they apply:</p>
      <ul>
        <li><strong>Website Terms of Use</strong> — using this site</li>
        <li><strong>Buyer Terms of Purchase</strong> — buying a piece</li>
        <li><strong>Consignor Terms of Service</strong> — consigning to, or selling to, Casa</li>
        <li><strong>Concierge Membership Terms</strong> — the Concierge Club</li>
        <li><strong>Privacy Policy</strong> — how your information is handled</li>
      </ul>
      <p>Open any of them from Legal in the footer. Each is served with a version, and the
      version you accepted is recorded against your signature.</p>
      <!-- REMOVED 28 Aug 2026: a self-drafted "Terms of Service Agreement" (~39 sections)
           rendered here. Same reasoning as the 2026-07-31 removal further down, and the
           same conclusion — two contradicting consignor contracts on one domain is worse
           than none, and ambiguity resolves against the drafter. It was never the primary
           path (openLegal() prefers casaLegalView() and the real /api/legal documents),
           but it was written into the DOM on every page load and was reachable whenever
           casaLegalView was not yet defined.
           Checked clause by clause against the attorney's FINAL 7.30.26 documents:
             · Return Fee was "a $10 fee", and said an unpaid fee left the Product
               "the property of Casa Consignment". Consignor Terms §8.1 sets a $50.00
               shipping + $150.00 processing fee, and states failure to pay a Return Fee
               NEVER transfers title to Casa.
             · "If you neither accept nor reject within the New Offer Period, the new offer
               is deemed accepted." Consignor Terms §4.2 is explicit the other way:
               "Silence is never treated as acceptance of a lower payout."
             · "Title passes to Casa Consignment upon acceptance of the Product."
               Consignor Terms §7 keeps title with the consignor until the item sells, and
               states Casa "acquire[s] no ownership interest".
             · Counterfeits were "retained and destroyed within one month". §4.3 requires
               written notice, a documented basis, and not less than thirty (30) days'
               written notice before disposal.
             · Risk of loss passed to Casa "once it opens the package". §3 keeps it with
               the consignor until Acceptance — expressly including during inspection.
             · Amendments were "effective immediately after posting". §15 requires 15 days'
               notice and is prospective only.
             · It carried its own Limited Liability, Indemnity, and Applicable Law and Venue
               sections with NO arbitration clause, NO class-action waiver and NO $100
               liability cap — giving away the protections Buyer §10, Consignor §16 and
               Terms of Use §6 actually secure.
           Accessibility Policy and the Casa Trade terms below are KEPT: no executed
           document covers either, and neither contradicted one. -->
      <h4>Accessibility Policy</h4><p>The Company seeks to lower technical barriers to accessibility for persons with disabilities and takes commercially reasonable steps to make our website accessible. If you are unable to access any website content, feature, or functionality, please email info@casaconsignment.com and we will make reasonable efforts to address the problem, which may include providing an alternative method to obtain the content or fulfill your request.</p>
      <h4>Trade Terms and Conditions</h4><p>The Casa Trade trade-in service is offered and provided by Casa Consignment only. By using Casa Trade you represent that you are the sole, rightful owner of the item(s) offered, with full authority to sell, and that the item(s) are not counterfeit or stolen. You agree all information you provide is true, accurate, and complete. You are fully responsible for shipping, insuring, and tracking your item(s); Casa Consignment is not responsible for lost, stolen, or damaged item(s) until the item is in Casa Consignment's possession.</p>
      <p>Casa Consignment may revise the trade-in value if inspection differs from the original description. If the revised value is lower, you have five (5) business days to accept or decline. If you do not respond within that period, your silence is not treated as acceptance: the revised offer lapses and Casa Consignment cancels the Casa Trade order — in which case purchased items are refunded and relisted and your traded-in items are returned. The trade-in transaction is final and cannot be cancelled by you unless the quoted value has been revised and declined. Casa Consignment calculates sales tax on Trade orders based on the final shipping location; you agree to pay all related taxes. Casa Consignment may cancel any trade-in offer at any time before payment is issued.</p>
      <!-- REMOVED 2026-07-31: a self-drafted "Consignment Terms and Conditions" block,
           plus "Casa Consignment Credit" and "Wallet Terms", used to live here. Each
           contradicted the attorney-executed documents now served from /api/legal:
             · Return Fee was "$50 + 3% of Minimum Payout (max $300)"; Consignor
               Terms §8.1 sets a flat $50 shipping + $150 processing.
             · Payout was "deposited to the Wallet section of your account"; §6.2 pays
               by ACH or check and states Casa does NOT hold payout balances.
             · Casa Credit / Wallet Seller Funds are stored value, which Membership
               Terms §2.3 expressly disclaims ("No Stored Value") and which would make
               Casa look like a money transmitter with escheatment exposure.
           Two contradicting consignor contracts on one site is worse than none, so the
           superseded copy is gone and every legal link routes to the executed documents.
           Consignment terms: see the Consignor Terms of Service in the Legal hub. -->
    `;

    const TIERS_HTML = `
      <h3>Casa Consignment Commission Tiers</h3>
      <div class="legal-meta">Consignor payouts are determined by an item's final selling price</div>
      <table class="tier-table">
        <thead><tr><th>Final Selling Price</th><th>Consignor Payout</th><th>Casa Commission</th></tr></thead>
        <tbody>
          <tr><td>Under $5,000</td><td>75%</td><td>25%</td></tr>
          <tr><td>$5,000 or more</td><td>80%</td><td>20%</td></tr>
        </tbody>
      </table>
      <p>Casa charges consignors no upfront, authentication, or processing fee — our commission is our only compensation. These rates are indicative; the commission stated in the Offer Summary you accept controls, and it applies to the item's Net Sale Price. Payouts are issued within 30 days after a sale is finalized, by ACH or check. See the Consignor Terms of Service for full terms.</p>
    `;

    const AGREEMENT_HTML = `
      <h3>Consignor Terms of Service</h3>
      <div class="legal-meta">Casa Consignment LLC · A Florida Limited Liability Company</div>
      <p>The Consignor Terms of Service could not be loaded just now. They are the binding
      agreement between you and Casa, and they are the document you sign when you consign a
      piece — so we would rather show you nothing than show you a paraphrase of them.</p>
      <p>Please try again in a moment, or ask us for a copy and we will send it to you:
      <a href="mailto:info@casaconsignment.com" style="color:var(--navy);text-decoration:underline;">info@casaconsignment.com</a>.</p>
      <p>You can also open them directly here once the connection returns:
      <a class="lnk-consignor-terms" style="color:var(--navy);text-decoration:underline;cursor:pointer;">Consignor Terms of Service</a>.</p>
      <div class="sig">Casa Consignment LLC · Turnberry Plaza, Suite 901, 2875 N.E. 191st Street, Aventura, Florida 33180 · info@casaconsignment.com</div>
    `;

    const LEGAL = {
      tos:       { label: 'Terms of Service', html: TOS_HTML },
      tiers:     { label: 'Commission Tiers', html: TIERS_HTML },
      agreement: { label: 'Consignment Agreement', html: AGREEMENT_HTML }
    };

    mkModal('legal', `
      <div class="modal legal-modal">
        ${closeBtn('legal')}
        <div class="legal-head"><h2>Legal</h2><p>Our Terms of Service, commission tiers, and consignment agreement.</p></div>
        <div class="legal-nav">
          <button data-doc="tos" class="active" onclick="switchLegalDoc(this,'tos')">Terms of Service</button>
          <button data-doc="tiers" onclick="switchLegalDoc(this,'tiers')">Commission Tiers</button>
          <button data-doc="agreement" onclick="switchLegalDoc(this,'agreement')">Consignment Agreement</button>
        </div>
        <div class="legal-body">
          <div class="legal-doc active" data-doc="tos">${LEGAL.tos.html}</div>
          <div class="legal-doc" data-doc="tiers">${LEGAL.tiers.html}</div>
          <div class="legal-doc" data-doc="agreement">${LEGAL.agreement.html}</div>
        </div>
      </div>`);

    window.switchLegalDoc = function(btn, doc){
      const modal = document.getElementById('modal-legal');
      modal.querySelectorAll('.legal-nav button').forEach(b=>b.classList.toggle('active', b===btn));
      modal.querySelectorAll('.legal-doc').forEach(d=>d.classList.toggle('active', d.getAttribute('data-doc')===doc));
      modal.querySelector('.legal-body').scrollTop = 0;
    };
    // Every legal link on the site funnels through openLegal(). It now resolves to the
    // attorney-executed documents served from /api/legal, because those are the ones
    // customers electronically sign — showing them different text elsewhere on the same
    // site is exactly the mismatch a click-to-accept record is supposed to prevent.
    // The in-page modal remains only as an offline fallback if that module failed.
    const LEGAL_SLUG = {
      tos:       'terms-of-service',
      privacy:   'privacy-policy',
      buyer:     'buyer-terms-of-purchase',
      agreement: 'consignor-terms',
      tiers:     'consignor-terms',
      membership:'membership-terms'
    };
    window.openLegal = function(doc){
      doc = doc || 'tos';
      if (typeof window.casaLegalView === 'function') {
        window.casaLegalView(LEGAL_SLUG[doc] || 'terms-of-service');
        return;
      }
      const modal = document.getElementById('modal-legal');
      if (!modal) return;
      const key = (doc === 'privacy' || doc === 'buyer' || doc === 'membership') ? 'tos' : doc;
      const btn = modal.querySelector(`.legal-nav button[data-doc="${key}"]`);
      if (btn) window.switchLegalDoc(btn, key);
      openModal('legal');
    };

    // Shipping/Auth in-modal "open a ticket" links
    document.querySelectorAll('.lnk-ship-ticket, .lnk-auth-ticket').forEach(a=>{
      a.addEventListener('click', ()=>{ closeModal(a.classList.contains('lnk-ship-ticket')?'shipping':'authentication'); if (typeof openContactTicket==='function') openContactTicket(); });
    });

    // ---------------- A1 · TOP-MENU SELL + SUPPORT WIRING ----------------
    function wireTopMenu(){
      document.querySelectorAll('.top-menu-panel a').forEach(a=>{
        const t = (a.textContent || '').trim();
        let fn = null;
        // Sell
        if (t === 'Start a Request') fn = ()=>navigateSellTo('form');
        else if (t === 'How It Works') fn = ()=>navigateSellTo('how');
        else if (t === 'Consignment Terms') fn = ()=>openLegal('agreement');
        else if (t === 'What We Accept') fn = ()=>navigateSellTo('top');
        else if (t === 'Payouts') fn = ()=>navigateSellTo('tiers');
        // Support
        else if (t === 'Contact Us') fn = ()=>openContactTicket();
        else if (t === 'Shipping') fn = ()=>openShipping();
        else if (t === 'Authentication') fn = ()=>openAuthentication();
        else if (t === 'FAQ') fn = ()=>openFAQ();
        else if (t === 'Care Guide') fn = ()=>openCareGuide();
        else if (t === 'Chanel Size Guide' || t === 'Size Guide') fn = ()=>openModal('sizeguide');
        // The Newsletter tab is #view-discover — the id kept its original name when
        // "Discover" was rebuilt into the newsletter on 28 Aug. Wired here rather than
        // left on the inline onclick because unmatched labels keep their attribute and
        // then the markup and the real behaviour disagree, which is exactly how the
        // Shipping/Authentication links read as broken when they were fine.
        else if (t === 'Newsletter') fn = ()=>switchView('discover');
        else if (t === 'Club' || t === 'Our Story') fn = ()=>switchView('about');
        if (fn){
          a.removeAttribute('data-view');
          a.removeAttribute('onclick');
          a.style.cursor = 'pointer';
          a.onclick = (e)=>{ e.preventDefault(); fn(); };
        }
      });
    }
    wireTopMenu();

    // ---------------- A4 · WIRE LEGAL LINKS THROUGHOUT THE PAGE ----------------
    function wireLegalLinks(){
      // Footer "Terms of Service"
      const ftos = document.getElementById('footer-tos-link');
      if (ftos) ftos.onclick = (e)=>{ e.preventDefault(); openLegal('tos'); };
      // Tier-note "Consignor Terms of Service" — only wire links that don't already
      // carry their own handler, or this clobbers a more specific target.
      document.querySelectorAll('.tier-note a').forEach(a=>{
        a.style.cursor='pointer';
        if (!a.getAttribute('onclick')) a.onclick=(e)=>{ e.preventDefault(); openLegal('agreement'); };
      });
      // Inline checkbox/agreement links (auth modal + consignment request).
      // Order matters: "privacy" is checked before the generic "terms" catch-all,
      // because "Terms of Service and Privacy Policy" contains both words and used to
      // resolve to Terms — sending anyone looking for the Privacy Policy to the wrong
      // document. There IS a separate Privacy Policy now.
      document.querySelectorAll('.auth-form label a, #view-review label a, .seller-cta a').forEach(a=>{
        const t = (a.textContent||'').trim().toLowerCase();
        let doc = null;
        if (t.includes('privacy')) doc = 'privacy';
        else if (t.includes('commission tier')) doc = 'tiers';
        else if (t.includes('consignor') || t.includes('consignment')) doc = 'agreement';
        else if (t.includes('membership')) doc = 'membership';
        else if (t.includes('purchase') || t.includes('sale')) doc = 'buyer';
        else if (t.includes('terms')) doc = 'tos';
        if (doc){ a.style.cursor='pointer'; a.onclick=(e)=>{ e.preventDefault(); openLegal(doc); }; }
      });
    }
    wireLegalLinks();

    // ---------------- A6 · CHECKOUT "ALL SALES FINAL" NOTICE ----------------
    function injectFinalSaleNotice(){
      if (document.getElementById('casa-final-sale-note')) return;
      const note = document.createElement('div');
      note.id = 'casa-final-sale-note';
      note.style.cssText = 'display:flex; gap:10px; align-items:flex-start; margin:14px 0; padding:12px 14px; background:var(--bg); border-left:3px solid var(--navy); font-size:12px; color:var(--navy-soft); line-height:1.55; border-radius:2px;';
      note.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" style="flex-shrink:0; margin-top:1px; color:var(--navy);"><circle cx="12" cy="12" r="9"/><path d="M12 8v5M12 16h.01"/></svg><div><strong>Final Sale.</strong> Pieces are designated Final Sale in the listing and are not eligible for return or exchange. You may cancel your order by email within one (1) hour of placing it. Our authenticity guarantee still applies: if a piece is not authentic, tell us within 5 days of delivery for a full refund of the purchase price and original shipping.</div>`;
      // Checkout view — place above the order summary / place-order area
      const checkout = document.getElementById('view-checkout');
      if (checkout){
        const anchor = checkout.querySelector('.checkout-summary, .order-summary, form, .container');
        if (anchor) anchor.appendChild(note);
      }
    }
    injectFinalSaleNotice();
    // Cart drawer mini-note
    (function cartNote(){
      // Lives in .drawer-foot, just above Checkout. It used to be appended to
      // .drawer-body, which the bag re-renders on every change, so the note was wiped
      // (or, before a render, sat under the fixed totals panel on phones: Casa's
      // 22 Sep report, row 15). The foot is never re-rendered, only its figures.
      const foot = document.querySelector('#cart-drawer .drawer-foot');
      const checkoutBtn = foot && foot.querySelector('.btn-primary');
      if (foot && checkoutBtn && !document.getElementById('casa-cart-final-note')){
        const n = document.createElement('div');
        n.id = 'casa-cart-final-note';
        n.style.cssText = 'font-size:11px; color:var(--muted); text-align:center; padding:10px 0 0; letter-spacing:0.04em; line-height:1.5;';
        n.textContent = 'Final Sale — no returns or exchanges. Cancel within 1 hour of ordering. Authenticity guaranteed.';
        foot.insertBefore(n, checkoutBtn);
      }
    })();

    // ---------------- A7 · CONSIGNOR SIGNUP EMAIL HOOK ----------------
    (function consignorHook(){
      const panel = document.getElementById('tab-consignor');
      if (!panel) return;
      const form = panel.querySelector('form.auth-form');
      if (!form) return;
      form.addEventListener('submit', ()=>{
        const email = (form.querySelector('input[type="email"]')||{}).value || '';
        try { window.sendConsignorConfirmation(email); } catch(e){}
      });
    })();

    // ---------------- A8 · LABEL SIMULATED INTEGRATIONS AS SANDBOX ----------------
    function labelSandbox(){
      document.querySelectorAll('.integration-card').forEach(card=>{
        if (card.querySelector('.casa-sandbox-tag')) return;
        const tag = document.createElement('div');
        tag.className = 'casa-sandbox-tag';
        tag.style.cssText = 'display:inline-block; margin-top:6px; font-size:9px; letter-spacing:0.18em; text-transform:uppercase; color:#8a6d1a; background:#FFF4E0; border:1px solid #E6D08A; padding:2px 7px; border-radius:10px;';
        tag.textContent = 'Sandbox · not live yet';
        const meta = card.querySelector('.ic-meta') || card;
        meta.appendChild(tag);
      });
    }
    // Run now and after any dashboard render that may build the cards.
    labelSandbox();
    if (typeof window.renderDashboard === 'function'){
      const _rd = window.renderDashboard;
      window.renderDashboard = function(){ const r=_rd.apply(this, arguments); setTimeout(labelSandbox, 30); return r; };
    }

    // ---------------- Light i18n for the new pages ----------------
    try {
      const T = {
        en:{ 'ship.title':'Shipping','ship.sub':"Insured, tracked, and handled with care — in both directions.",'authpg.title':'Authentication','authpg.sub':'Every piece is certified before it ever reaches the floor.' },
        es:{ 'ship.title':'Envío','ship.sub':'Asegurado, rastreado y tratado con cuidado — en ambos sentidos.','authpg.title':'Autenticación','authpg.sub':'Cada pieza se certifica antes de salir a la venta.' },
        fr:{ 'ship.title':'Livraison','ship.sub':'Assurée, suivie et manipulée avec soin — dans les deux sens.','authpg.title':'Authentification','authpg.sub':'Chaque pièce est certifiée avant sa mise en vente.' },
        de:{ 'ship.title':'Versand','ship.sub':'Versichert, verfolgt und sorgfältig behandelt — in beide Richtungen.','authpg.title':'Authentifizierung','authpg.sub':'Jedes Stück wird zertifiziert, bevor es angeboten wird.' },
        ja:{ 'ship.title':'配送','ship.sub':'往復ともに保険付き・追跡付きで丁寧にお届けします。','authpg.title':'認証','authpg.sub':'すべての品は出品前に認証されます。' },
        zh:{ 'ship.title':'配送','ship.sub':'全程保险、可追踪、双向悉心处理。','authpg.title':'认证','authpg.sub':'每件商品上架前都经过认证。' }
      };
      if (typeof I18N !== 'undefined') Object.keys(T).forEach(l=>{ if (I18N[l]) Object.assign(I18N[l], T[l]); });
      if (typeof applyI18n === 'function') applyI18n();
    } catch(e){}

    console.log('%cCASA · Phase A patch loaded', 'background:#141414; color:#fff; padding:4px 10px; font-weight:bold;');
    console.log('  ✓ Top-menu Sell/Support wired (Shipping & Authentication now have dedicated pages)');
    console.log('  ✓ Legal docs embedded: Terms of Service · Commission Tiers · Consignment Agreement');
    console.log('  ✓ Checkout + cart show the Final Sale designation, the 1-hour cancellation window, and the authenticity guarantee');
    console.log('  ✓ Integration config seams + consignor email hook ready for Phase B');
  })();

  // =====================================================================
  // CASA · SHOPIFY COMMERCE (Phase B) — real cart + headless checkout via
  // the Storefront API. Buyers add items to a real bag (persisted), then
  // checkout redirects to Shopify's secure hosted checkout (payments +
  // order-confirmation email handled by Shopify).
  // =====================================================================
  (function casaShopifyCommerce(){
    const SHOP_DOMAIN = 'casa-consignment.myshopify.com';
    const SF_TOKEN    = '735ee8b36c9afb58852dd5088fe05253'; // PUBLIC Storefront API token (safe client-side)
    const SF_API      = `https://${SHOP_DOMAIN}/api/2024-10/graphql.json`;
    // keep the Phase-A config block in sync
    try { window.CASA_CONFIG.SHOPIFY_DOMAIN = SHOP_DOMAIN; window.CASA_CONFIG.SHOPIFY_STOREFRONT_TOKEN = SF_TOKEN; } catch(e){}

    // SKU -> Shopify variant (from the imported catalog). CASA-0001 & CASA-0020
    // are draft (no price) so are intentionally absent / not purchasable.
    const VARIANT_MAP = {
      // Repointed 28 Aug 2026: this entry held the ARCHIVED 0002 shell's variant
      // (…7159998) at a stale $8,400. Since the renumber merged CASA-0027 back
      // onto 0002, the live variant is the one the surviving product carries.
      'CASA-0002':{vid:'gid://shopify/ProductVariant/48234382917822',price:8000},
      'CASA-0003':{vid:'gid://shopify/ProductVariant/47673607192766',price:6000},
      'CASA-0004':{vid:'gid://shopify/ProductVariant/47673607225534',price:4000},
      'CASA-0005':{vid:'gid://shopify/ProductVariant/47673607454910',price:2800},
      'CASA-0006':{vid:'gid://shopify/ProductVariant/47673607487678',price:1300},
      'CASA-0007':{vid:'gid://shopify/ProductVariant/47673607520446',price:2000},
      'CASA-0008':{vid:'gid://shopify/ProductVariant/47673607553214',price:2190},
      'CASA-0009':{vid:'gid://shopify/ProductVariant/47673607585982',price:600},
      'CASA-0010':{vid:'gid://shopify/ProductVariant/47673607618750',price:1850},
      'CASA-0011':{vid:'gid://shopify/ProductVariant/47673607651518',price:1700},
      'CASA-0012':{vid:'gid://shopify/ProductVariant/47673607684286',price:1480},
      'CASA-0013':{vid:'gid://shopify/ProductVariant/47673607717054',price:1200},
      'CASA-0014':{vid:'gid://shopify/ProductVariant/47673607749822',price:1000},
      'CASA-0015':{vid:'gid://shopify/ProductVariant/47673607782590',price:500},
      'CASA-0016':{vid:'gid://shopify/ProductVariant/47673607815358',price:3000},
      'CASA-0017':{vid:'gid://shopify/ProductVariant/47673607848126',price:700},
      'CASA-0018':{vid:'gid://shopify/ProductVariant/47673607880894',price:2500},
      'CASA-0019':{vid:'gid://shopify/ProductVariant/47673607913662',price:1150}
    };
    window.CASA_VARIANT_MAP = VARIANT_MAP;

    // ---- cart state (persisted) ----
    let CART = [];
    try { CART = JSON.parse(localStorage.getItem('casa_cart') || '[]'); if(!Array.isArray(CART)) CART = []; } catch(e){ CART = []; }
    const save = () => { try { localStorage.setItem('casa_cart', JSON.stringify(CART)); } catch(e){} };
    const fmt = n => new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',maximumFractionDigits:0}).format(n||0);
    const toast = m => { try { showToast(m); } catch(e){ try{console.log(m);}catch(_){} } };

    // Resolve a SKU's Shopify variant. Prefers the DB value carried on `arrivals`
    // (set by /api/shopify-sync) and falls back to the legacy hardcoded map, which
    // only covers CASA-0002..0019 and is no longer authoritative.
    function variantIdFor(sku){
      if (typeof window.casaVariantFor === 'function') {
        const v = window.casaVariantFor(sku); if (v) return v;
      }
      try {
        const arr = (typeof arrivals !== 'undefined' && Array.isArray(arrivals)) ? arrivals : [];
        const a = arr.find(x => x && x.sku === sku);
        if (a && a.shopifyVariantId) {
          const v = String(a.shopifyVariantId);
          return v.indexOf('gid://') === 0 ? v : 'gid://shopify/ProductVariant/' + v;
        }
      } catch(e){}
      return (VARIANT_MAP[sku] || {}).vid || null;
    }

    function prod(sku){
      const arr = (typeof arrivals !== 'undefined' && Array.isArray(arrivals)) ? arrivals : [];
      const a = arr.find(x => x && x.sku === sku) || {};
      const vm = VARIANT_MAP[sku] || {};
      const img = (a.gallery && a.gallery[0]) || '';
      // After DB hydration `a.price` is a formatted string ("$7,400"), so read the
      // numeric field first — otherwise cart subtotals silently render as $0.
      let price = 0;
      if (typeof a.priceNum === 'number' && !isNaN(a.priceNum)) price = a.priceNum;
      else if (typeof a.price === 'number') price = a.price;
      else if (typeof a.price === 'string' && /\d/.test(a.price)) price = Number(a.price.replace(/[^0-9.]/g,'')) || 0;
      if (!price && vm.price) price = vm.price;
      return { sku, brand:a.brand||'', name:a.name||sku, cond:a.cond||'', img, price, vid: variantIdFor(sku) };
    }

    window.casaAddToCart = function(sku, noWait){
      if(!sku) return false;
      if(!variantIdFor(sku)){
        // WAIT FOR THE CATALOGUE (23 Sep 2026). Only 19 of the 44 pieces are in the built-in
        // fallback list; the rest get their Shopify variant from /api/products, which can
        // take several seconds after a quiet spell (12 s seen on a preview). A tap in that
        // window used to say "not available" for a piece that is. Now it waits up to 15 s
        // for hydrateCatalog() to finish, then tries once more; only a piece that is still
        // unbuyable after the catalogue has loaded gets the message below.
        if(!noWait && !window.__casaCatalogLoaded){
          if(window.__casaAddWaiting === sku) return false;
          window.__casaAddWaiting = sku;
          toast('One moment, loading this piece…');
          var t0 = Date.now();
          (function poll(){
            if(window.__casaCatalogLoaded || Date.now() - t0 > 15000){
              window.__casaAddWaiting = null;
              if(window.casaAddToCart(sku, true)){ try{ if(typeof openCart==='function') openCart(); }catch(e){} }
              return;
            }
            setTimeout(poll, 250);
          })();
          return false;
        }
        var why = (typeof window.casaPurchaseInfo==='function') ? (window.casaPurchaseInfo(sku)||{}).reason : null;
        toast(why==='price-mismatch'
          ? 'This piece is being repriced — please contact us to purchase.'
          : "This piece isn't available to purchase online yet.");
        return false;
      }
      if(CART.find(c => c.sku === sku)){ toast('Already in your bag.'); renderCart(); return true; }
      CART.push({ sku, qty: 1 }); // consignment pieces are one-of-a-kind
      save(); renderCart(); toast('Added to your bag.');
      const added = prod(sku);
      window.casaTrack('Add to Bag', { sku: sku, brand: added.brand });
      return true;
    };
    window.casaRemoveFromCart = function(sku){
      CART = CART.filter(c => c.sku !== sku); save(); renderCart();
    };
    window.casaCartCount = () => CART.reduce((s,c)=>s+c.qty,0);

    const AUTH_NOTE = `<div style="margin-top:24px;padding:16px;background:var(--bg);border-radius:2px;font-size:12px;color:var(--navy-soft);line-height:1.6;"><strong style="display:block;font-size:11px;letter-spacing:0.2em;text-transform:uppercase;color:var(--navy);margin-bottom:6px;">Authentication Included</strong>Every piece in your bag has been examined and authenticated by our specialists before listing.</div>`;
    const FINAL_NOTE = `<div style="font-size:11px;color:var(--muted);text-align:center;padding:10px 0 0;letter-spacing:0.04em;">Final Sale — no returns or exchanges. Cancel within 1 hour of ordering. Authenticity guaranteed.</div>`;

    function renderCart(){
      const body = document.querySelector('#cart-drawer .drawer-body');
      const head = document.querySelector('#cart-drawer .drawer-head h3');
      const badge = document.getElementById('cart-count');
      const subEl = document.querySelector('#cart-drawer .drawer-foot .drawer-totals span:last-child');
      const items = CART.map(c => ({ ...prod(c.sku), qty:c.qty }));
      const n = items.reduce((s,i)=>s+i.qty,0);
      const sub = items.reduce((s,i)=>s + (i.price||0)*i.qty, 0);
      if(head) head.textContent = `Your Bag (${n})`;
      if(badge){ badge.textContent = n; badge.style.display = n ? '' : 'none'; }
      if(subEl) subEl.innerHTML = `<strong>${fmt(sub)}</strong>`;
      if(!body) return;
      if(!items.length){ body.innerHTML = `<div style="padding:48px 8px;text-align:center;color:var(--muted);font-size:14px;">Your bag is empty.</div>` + AUTH_NOTE; return; }
      body.innerHTML = items.map(i => `
        <div class="order-item">
          <div class="order-thumb">${i.img ? `<img src="${i.img}" alt="" style="width:100%;height:100%;object-fit:cover;border-radius:4px;">` : ''}</div>
          <div>
            <div class="brand">${i.brand}</div>
            <div class="name">${i.name}</div>
            <div style="font-size:11px;color:var(--muted);margin-top:4px;">${i.cond ? i.cond + ' · ' : ''}<a onclick="casaRemoveFromCart('${i.sku}')" style="cursor:pointer;text-decoration:underline;">Remove</a></div>
          </div>
          <div class="price">${fmt(i.price * i.qty)}</div>
        </div>`).join('') + AUTH_NOTE + FINAL_NOTE;
    }
    window.casaRenderCart = renderCart;

    // ---- headless checkout ----
    // The definition that used to sit here was REMOVED on 29 Aug 2026. It was a
    // complete second copy of window.casaShopifyCheckout, overwritten unconditionally
    // by the real one further down (search "window.casaShopifyCheckout = async" — the
    // later assignment is a full replacement, not a wrapper, so it captured nothing
    // from this one and this one never ran). Two live-looking checkout functions in
    // one file is how a fix lands in the dead copy and appears to do nothing.
    //
    // The surviving version is the only one to edit. It is materially different and
    // the difference is the point: it reads the cart from localStorage rather than the
    // in-scope CART array, routes every SKU through purchaseInfo() so a Shopify price
    // that disagrees with the displayed price BLOCKS the sale, tells the buyer which
    // pieces are not purchasable instead of silently dropping them, and guards against
    // Shopify handing back a checkout URL on our own host. The copy that was here did
    // none of that — reviving it would quietly reintroduce every one of those holes.
    //
    // wireButtons() below calls casaShopifyCheckout by name at click time, so it
    // resolves to the live global even though that global is defined later in the file.

    // ---- wiring ----
    // make openCart re-render the live bag
    if(typeof window.openCart === 'function'){ const _oc = window.openCart; window.openCart = function(){ _oc.apply(this, arguments); renderCart(); }; }

    function wireButtons(){
      // cart drawer "Checkout →" → Shopify (was switchView('checkout'))
      const cartCheckout = document.querySelector('#cart-drawer .drawer-foot .btn-primary');
      if(cartCheckout && !cartCheckout._casaWired){ cartCheckout._casaWired = true; cartCheckout.onclick = function(){ casaShopifyCheckout(this); }; }
      // checkout view "Place Order" → Shopify
      document.querySelectorAll('#view-checkout button').forEach(b => {
        if(!b._casaWired && /place order/i.test(b.textContent||'')){ b._casaWired = true; b.onclick = function(e){ e.preventDefault(); casaShopifyCheckout(this); }; }
      });
    }
    wireButtons();

    // Add-to-Bag (quick view) — delegate on text, read the open product's SKU
    document.addEventListener('click', function(e){
      const btn = e.target.closest('button, a'); if(!btn) return;
      if((btn.textContent||'').trim().toLowerCase() === 'add to bag'){
        const skuEl = document.getElementById('qv-sku');
        const sku = skuEl ? (skuEl.textContent||'').trim() : '';
        if(sku) casaAddToCart(sku); // the inline handler also opens the cart
      }
    });

    // initial paint (start empty unless persisted)
    renderCart();
    // keep buttons wired if views re-render
    document.addEventListener('click', () => setTimeout(wireButtons, 0));

    console.log('%cCASA · Shopify commerce live', 'background:#2D6A4F; color:#fff; padding:4px 10px; font-weight:bold;');
    console.log('  ✓ Real cart (persisted) · ' + Object.keys(VARIANT_MAP).length + ' purchasable SKUs mapped to Shopify variants');
    console.log('  ✓ Checkout → Storefront API cartCreate → Shopify hosted checkout');
  })();

  // =====================================================================
  // CASA · "LAST CALL" REVISIONS — white homepage logo + vibrant imagery,
  // $75 authentication surcharge note, membership tiers, About/Shop hero
  // imagery (original color, white lettering). All as overrides/injections.
  // =====================================================================
  (function casaLastCall(){
    const st = document.createElement('style');
    st.textContent = `
      /* (1) Homepage portal — WHITE logo, vibrant (un-faded) background */
      /* INTERNAL TEST (uncommitted, 19 Aug 2026) — darkened a second pass, per Erich:
         the un-darkened overlay read fine in isolation but the ask was more contrast. */
      .portal-overlay { background: linear-gradient(180deg, rgba(0,0,0,0.45) 0%, rgba(0,0,0,0.18) 34%, rgba(0,0,0,0.55) 100%) !important; }
      /* white rounded panel removed, logo.png swapped for logo-maintenance.png (red icon,
         wordmark recolored white) to match the maintenance.html treatment on the same
         landing.jpg backdrop. Dark drop-shadow replaces the panel's own contrast. Box
         sized up 30% (210/23.8vw/357 -> 273/30.9vw/464) per Erich, second pass. */
      .portal-logo-center { filter: drop-shadow(0 2px 10px rgba(0,0,0,0.7)) drop-shadow(0 0 26px rgba(0,0,0,0.55)) !important; background-color: transparent !important; background-image: url('${window.CASA_ASSET('logo-maintenance.png')}') !important; background-repeat: no-repeat !important; background-position: center !important; background-size: contain !important; aspect-ratio: 1 / 1 !important; padding: 0 !important; border-radius: 0 !important; box-shadow: none !important; width: clamp(273px, 30.9vw, 464px) !important; box-sizing: border-box; }
      .portal-center .portal-tagline { color: #fff !important; text-shadow: 0 1px 10px rgba(0,0,0,0.65), 0 0 22px rgba(0,0,0,0.45) !important; }
      .portal-link { color: #fff !important; border-color: rgba(255,255,255,0.88) !important; background: rgba(0,0,0,0.18) !important; backdrop-filter: blur(2px); }
      .portal-link:hover { background: #fff !important; color: #141414 !important; border-color: #fff !important; }

      /* Remove strikethrough ("scratched") retail prices site-wide (per Erich) */
      .quickview-info .retail, .retail { display: none !important; }

      /* (4) About hero — original-color image, light dark overlay, WHITE lettering */
      .about-hero { background: linear-gradient(rgba(0,0,0,0.40), rgba(0,0,0,0.55)), url('${window.CASA_ASSET('our-story.jpg')}') center/cover no-repeat !important; }
      .about-hero .eyebrow { color: rgba(255,255,255,0.92) !important; }
      .about-hero h1, .about-hero h1 em { color: #fff !important; }
      .about-hero p { color: rgba(255,255,255,0.92) !important; }

      /* (5) Sell-with-us imagery as the header background on the other pages */
      .shop-header { background: linear-gradient(rgba(0,0,0,0.52), rgba(0,0,0,0.60)), url('${window.CASA_ASSET('sell-with-us.jpg')}') center/cover no-repeat !important; color: #fff !important; border-bottom: none !important; padding: 76px 0 58px !important; }
      .shop-header h1 { color: #fff !important; }
      .shop-header p, .shop-header .breadcrumb, .shop-header .breadcrumb a { color: rgba(255,255,255,0.85) !important; }

      /* (2) Authentication surcharge note */
      .casa-surcharge-note { display:flex; gap:10px; align-items:flex-start; max-width:680px; margin:16px auto 0; padding:12px 16px; background:var(--bg); border-left:3px solid var(--navy); border-radius:2px; font-size:13px; color:var(--navy-soft); line-height:1.55; }
      .casa-surcharge-note svg { color:var(--navy); }

      /* (3) Membership tiers */
      .casa-membership { padding: 78px 0; background: var(--bg-cream); border-top: 1px solid var(--line); }
      .casa-membership .section-head { text-align: center; margin-bottom: 38px; }
      .membership-grid { display: grid; grid-template-columns: repeat(3, minmax(0,1fr)); gap: 22px; max-width: 1000px; margin: 0 auto; align-items: start; }
      .member-card .tier-best { font-size: 11px; color: var(--muted); letter-spacing: 0.04em; margin: 12px 0 0; }
      .member-card.featured .tier-best { color: rgba(255,255,255,0.62); }
      /* Casa positioning line — used across Sell / About */
      .casa-positioning { max-width: 860px; margin: 0 auto; padding: 26px 28px; text-align: center; font-family: var(--serif); font-size: clamp(17px,2vw,22px); line-height: 1.5; color: var(--navy); background: var(--bg-cream); border-top: 1px solid var(--line); border-bottom: 1px solid var(--line); }
      .casa-positioning.on-dark { background: transparent; border: none; color: rgba(255,255,255,0.95); }
      .member-note { max-width: 720px; margin: 26px auto 0; text-align: center; font-size: 12.5px; line-height: 1.6; color: var(--muted); }
      .member-card { position: relative; background: #fff; border: 1px solid var(--line); border-radius: 4px; padding: 32px 28px; text-align: center; }
      .member-card.featured { background: #141414; color: #fff; border-color: #141414; }
      .member-card .tier-name { font-family: var(--serif); font-size: 22px; margin-bottom: 6px; }
      .member-card .tier-price { font-size: 34px; font-weight: 500; margin-bottom: 4px; }
      .member-card .tier-price span { font-size: 13px; color: var(--muted); font-weight: 400; }
      .member-card.featured .tier-price span { color: rgba(255,255,255,0.6); }
      .member-card .tier-per { font-size: 11px; letter-spacing: 0.18em; text-transform: uppercase; color: var(--muted); margin-bottom: 18px; }
      .member-card.featured .tier-per { color: rgba(255,255,255,0.6); }
      .member-card ul { list-style: none; padding: 0; margin: 0 0 4px; }
      .member-card li { font-size: 14px; padding: 7px 0; color: var(--navy-soft); border-top: 1px solid var(--line); }
      .member-card.featured li { color: rgba(255,255,255,0.9); border-top-color: rgba(255,255,255,0.14); }
      .member-card .ribbon { position: absolute; top: -11px; left: 50%; transform: translateX(-50%); background: var(--gold, #B89968); color: #fff; font-size: 10px; letter-spacing: 0.18em; text-transform: uppercase; padding: 4px 14px; border-radius: 20px; }
      /* Qualifiers that keep advertised benefits matching Schedule A's [A]
         access-based caveats without shouting them. */
      .member-card .tier-sub { color: var(--muted); font-size: 11.5px; }
      @media (max-width: 860px){ .membership-grid { grid-template-columns: 1fr; max-width: 420px; } }
    `;
    document.head.appendChild(st);

    // (2) Brand positioning line — Alexa asks that the positioning statement
    // appear across the site (Sell + About). The old "$75 authentication fee"
    // note is superseded: Casa charges consignors no per-item fee at all (see tier-note).
    try {
      const POS = (window.I18N && I18N.en && I18N.en['casa.positioning'])
        || 'Casa Consignment is a curated luxury intake platform where every piece is authenticated, strategically positioned, and placed in front of serious buyers only.';
      // Remove any prior $75 surcharge note left by an earlier build
      document.querySelectorAll('.casa-surcharge-note').forEach(n => n.remove());
      // Sell page — above the payout tiers
      const tiers = document.querySelector('.tiers-wrap');
      if (tiers && !tiers.parentNode.querySelector('.casa-positioning')) {
        const el = document.createElement('div');
        el.className = 'casa-positioning';
        el.textContent = POS;
        tiers.parentNode.insertBefore(el, tiers);
      }
      // About / Our Story — just below the hero
      const aboutHero = document.querySelector('#view-about .about-hero');
      if (aboutHero && !aboutHero.parentNode.querySelector('.casa-positioning')) {
        const el2 = document.createElement('div');
        el2.className = 'casa-positioning';
        el2.textContent = POS;
        aboutHero.insertAdjacentElement('afterend', el2);
      }
    } catch(e){}

    // (3) Membership section — shown on BOTH the About/Our Story page and the
    // Sell page (consignors look at Sell, so the tiers must be discoverable there).
    try {
      const MEMBERSHIP_HTML = `
          <section class="casa-membership">
            <div class="container">
              <div class="section-head">
                <span class="eyebrow" style="font-size:11px; letter-spacing:0.32em; text-transform:uppercase; color:var(--navy-soft); display:block; margin-bottom:14px;">Concierge Club</span>
                <h2 style="font-size:clamp(30px,4vw,44px); font-weight:400;">The Casa Concierge Club</h2>
                <p style="color:var(--muted); max-width:580px; margin:10px auto 0;">A premium service for collectors and consignors — priority evaluation, complimentary insured shipping kits, and white-glove access. Membership is never required to buy or consign.</p>
              </div>
              <div class="membership-grid">
                <div class="member-card">
                  <div class="tier-name">Silver</div>
                  <div class="tier-price">$149<span> /month</span></div>
                  <div class="tier-per">Priority access</div>
                  <!-- Benefits mirror Schedule A of the Membership Terms & Conditions
                       exactly. Membership Terms §7 states benefits modify the Terms of
                       Sale and Consignor Terms "only to the extent expressly stated in
                       Schedule A", so anything advertised here that is not in Schedule A
                       is a promise Casa is not contractually granting. "Reduced
                       consignment fees" was removed for that reason. -->
                  <ul>
                    <li>Priority evaluation</li>
                    <li>Member dashboard</li>
                    <li>Early access to new listings and launches<span class="tier-sub"> (subject to availability)</span></li>
                  </ul>
                  <p class="tier-best">Best for getting started</p>
                </div>
                <div class="member-card featured">
                  <div class="ribbon">Most Popular</div>
                  <div class="tier-name">Gold</div>
                  <div class="tier-price">$299<span> /month</span></div>
                  <div class="tier-per">The Casa favorite</div>
                  <ul>
                    <li>Everything in Silver</li>
                    <li>Up to <strong>5</strong> complimentary prepaid, insured FedEx shipping kits per membership year<span class="tier-sub"> (eligible consignments)</span></li>
                    <li>Priority listing<span class="tier-sub"> (subject to volume)</span></li>
                  </ul>
                  <p class="tier-best">Best for active consignors</p>
                </div>
                <div class="member-card">
                  <div class="tier-name">Elite</div>
                  <div class="tier-price">$599<span> /month</span></div>
                  <div class="tier-per">White-glove service</div>
                  <ul>
                    <li>Everything in Silver &amp; Gold</li>
                    <li>Complimentary insured FedEx shipping kits increased to <strong>8</strong> per membership year</li>
                    <li>White-glove concierge service and a designated luxury advisor<span class="tier-sub"> (email/phone/text, business hours)</span></li>
                    <li>First access to selected inventory, time-limited, before general release<span class="tier-sub"> (subject to availability)</span></li>
                    <li>Invitations to private Casa events<span class="tier-sub"> (subject to occurrence and capacity)</span></li>
                  </ul>
                  <p class="tier-best">Best for serious collectors</p>
                </div>
              </div>
              <!-- Membership Terms §3.1 requires the automatic-renewal disclosure, and
                   §5 sets out cancellation. The previous copy said "pricing stays locked
                   for existing members", which §6.1 contradicts (prices may change at
                   renewal on 30 days' notice), so that claim was removed. -->
              <p class="member-note">The Casa Concierge Club is a priority-access program, separate from your commission <em>payout</em> — it does not change your commission rate.
                <strong>Memberships are billed monthly and renew automatically each month on the monthly anniversary of enrollment</strong>, at the then-current monthly price for your tier plus applicable taxes, until you cancel. You may cancel at any time, without fee or penalty, from your account settings or by emailing info@casaconsignment.com; cancellation takes effect at the end of your paid month and you keep your benefits until then. Cancel within 3 days of enrolling without using a benefit and we refund in full. We will give you at least 30 days’ notice by email before any price change.
                <!-- Annual clause approved — Alexa confirmed with Grant, 27 Aug 2026. -->
                If you choose annual billing instead, your membership is billed once a year — twelve times your tier’s monthly rate, with no separate annual discount — and renews automatically each year on the anniversary of enrollment, at the then-current annual price for your tier plus applicable taxes, until you cancel. You may cancel at any time, without fee or penalty, from your account settings or by emailing info@casaconsignment.com; cancellation takes effect at the end of your paid year and you keep your benefits until then. Cancel within 3 days of enrolling without using a benefit and we refund in full. We will give you at least 30 days’ notice by email before any price change. Shipping-kit allowances are counted per membership year — a 12-month period from your enrollment date, separate from the billing cycle. Benefits are as stated in Schedule A of the <a class="lnk-membership-terms" style="color:var(--navy);text-decoration:underline;cursor:pointer;">Membership Terms &amp; Conditions</a>.</p>
            </div>
          </section>`;
      // About / Our Story — after the story cards
      const aboutAnchor = document.querySelector('#view-about .about-grid');
      if (aboutAnchor && !aboutAnchor.parentNode.querySelector('.casa-membership')) {
        aboutAnchor.insertAdjacentHTML('afterend', MEMBERSHIP_HTML);
      }
      // Sell page — directly below the payout tiers, where consignors are looking
      const sellAnchor = document.querySelector('#view-sell .tiers-wrap') || document.querySelector('.tiers-wrap');
      if (sellAnchor && !sellAnchor.parentNode.querySelector('.casa-membership')) {
        sellAnchor.insertAdjacentHTML('afterend', MEMBERSHIP_HTML);
      }
    } catch(e){}

    console.log('%cCASA · Revisions applied', 'background:#141414; color:#fff; padding:4px 10px; font-weight:bold;');
    console.log('  ✓ White homepage logo + vibrant background; About/Shop heroes use original-color imagery + white lettering');
    console.log('  ✓ The Casa Concierge Club (Silver $149 / Gold $299 / Elite $599 per MONTH); no consignor processing fee; positioning on Sell + About');
  })();

  // =====================================================================
  // CASA · LAUNCH-FINALIZE PHASE (2026-07) — Consign upgrades
  // (Commission Calculator, Pricing Guide, Benefits) + Sell to Casa
  // (instant-estimate buyout + policy). Submissions route to a Shopify
  // intake seam (casaSubmitIntake) that goes live once the Admin API
  // endpoint is provisioned. Front-end only; safe on the static site.
  // =====================================================================
  (function casaLaunchPhase(){
    window.CASA_CONFIG = window.CASA_CONFIG || {};
    if (typeof window.CASA_CONFIG.INTAKE_ENDPOINT === 'undefined') window.CASA_CONFIG.INTAKE_ENDPOINT = '/api/intake';
    window.casaSubmitIntake = function(type, data){
      try {
        var ep = window.CASA_CONFIG.INTAKE_ENDPOINT;
        if (!ep){ console.log('[Casa] intake seam (ready for Shopify Draft Order/Customer):', type, data); return Promise.resolve({ simulated: true }); }
        return fetch(ep, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ type: type, data: data }) });
      } catch(e){ return Promise.resolve({ error: true }); }
    };

    // Did the submission actually land?
    //
    // WHY THIS EXISTS: casaSubmitIntake returns the raw fetch promise, and
    // fetch RESOLVES on 4xx/5xx — it only rejects on a network failure. Three
    // callers (Sell to Casa, Consign, Membership interest) used to fire it and
    // paint the success screen unconditionally. On 3 Aug 2026, with the Shopify
    // admin token returning 401, every one of those submissions was failing
    // while the customer was told "your offer is on the way". Consignor leads
    // are the top of the funnel; losing them silently is the worst failure this
    // site can have.
    //
    // Returns a Promise<boolean>. `simulated` is the no-endpoint dev seam and
    // counts as success so local work is not blocked.
    window.casaIntakeLanded = function(type, data){
      // Failure report for the health alerts (23 Sep 2026). Observes the result
      // only; every caller still gets exactly the same true/false as before.
      var report = function(ok){
        if (!ok) { try { window.casaSignal && window.casaSignal('form_submit_failed', String(type)); } catch (x) {} }
        return ok;
      };
      var p;
      try { p = window.casaSubmitIntake(type, data); }
      catch(e){ return Promise.resolve(report(false)); }
      if (!p || typeof p.then !== 'function') return Promise.resolve(true);
      return p.then(function(r){
        if (!r) return false;
        if (r.simulated) return true;
        if (r.error) return false;
        if (typeof r.ok === 'undefined') return true;   // not a Response — legacy seam
        return !!r.ok;
      }).catch(function(){ return false; }).then(report);
    };

    // One wording for every failed submission, so the recovery path is always
    // the same and always reaches a human.
    window.CASA_INTAKE_FAIL_MSG =
      'Something went wrong sending that. Please email info@casaconsignment.com and we will pick it up.';

    var money = function(n){ return '$' + (Math.round(n)).toLocaleString('en-US'); };

    var st = document.createElement('style');
    st.textContent = `
      .casa-calc { padding: 60px 0; background: #fff; border-top: 1px solid var(--line); }
      .casa-calc .eyebrow { font-size:11px; letter-spacing:0.32em; text-transform:uppercase; color:var(--navy-soft); display:block; margin-bottom:12px; }
      .calc-card { max-width: 620px; margin: 0 auto; background: var(--bg-cream); border:1px solid var(--line); border-radius:6px; padding: 30px 28px; }
      .calc-row { display:flex; flex-direction:column; gap:6px; margin-bottom:16px; }
      .calc-row label { font-size:11px; letter-spacing:0.14em; text-transform:uppercase; color:var(--muted); }
      .calc-row input, .calc-row select { padding:13px 14px; border:1px solid var(--line-control); border-radius:3px; background:#fff; font-family:var(--sans); font-size:15px; color:var(--navy); }
      .calc-result { text-align:center; padding: 22px 12px; margin: 8px 0 4px; background:#fff; border:1px solid var(--line); border-radius:4px; }
      .calc-result .keep-label { font-size:11px; letter-spacing:0.18em; text-transform:uppercase; color:var(--muted); }
      .calc-result .keep-amt { font-size: clamp(30px, 6vw, 46px); font-weight:500; color:var(--navy); line-height:1.1; margin:6px 0 4px; }
      .calc-result .keep-sub { font-size:12.5px; color:var(--navy-soft); }
      .calc-note { font-size:12px; color:var(--muted); line-height:1.6; margin-top:14px; text-align:center; }
      .calc-note a { color:var(--navy); text-decoration:underline; cursor:pointer; }
      .casa-sellcasa { padding: 70px 0; background: #141414; color:#fff; text-align:center; }
      .casa-sellcasa .eyebrow { font-size:11px; letter-spacing:0.32em; text-transform:uppercase; color:rgba(255,255,255,0.6); display:block; margin-bottom:14px; }
      .casa-sellcasa h2 { font-size:clamp(30px,4vw,44px); font-weight:400; color:#fff; margin-bottom:14px; }
      .casa-sellcasa p { color:rgba(255,255,255,0.82); max-width:560px; margin:0 auto 26px; line-height:1.6; }
      .casa-sellcasa .btn-primary { background:#fff !important; color:#141414 !important; border:none !important; }
      .benefit-table { width:100%; border-collapse:collapse; margin:8px 0 4px; font-size:13px; }
      .benefit-table th, .benefit-table td { border:1px solid var(--line); padding:9px 11px; text-align:left; }
      .benefit-table th { background:var(--bg-cream); font-size:11px; letter-spacing:0.08em; text-transform:uppercase; }
      .sc-estimate { text-align:center; padding:16px; margin:6px 0 14px; background:var(--bg-cream); border:1px solid var(--line); border-radius:4px; font-size:14px; color:var(--navy-soft); }
      .sc-estimate strong { font-size:22px; color:var(--navy); display:inline-block; }
      .sc-policy { margin-top:16px; font-size:12.5px; color:var(--navy-soft); }
      .sc-policy summary { cursor:pointer; font-weight:600; color:var(--navy); }
      .sc-policy p { margin:8px 0; line-height:1.55; }
      #modal-pricingguide .info-body, #modal-sellcasa .info-body { max-height:72vh; overflow-y:auto; }
    `;
    document.head.appendChild(st);

    // ---- Commission Calculator (Consign) ----
    try {
      var tiers = document.querySelector('#view-sell .tiers-wrap');
      if (tiers && !document.querySelector('.casa-calc')) {
        var calc = document.createElement('section');
        calc.className = 'casa-calc';
        calc.innerHTML = `
          <div class="container">
            <div class="section-head" style="text-align:center; margin-bottom:28px;">
              <span class="eyebrow">Estimate Your Payout</span>
              <h2 style="font-size:clamp(28px,4vw,40px); font-weight:400;">Commission Calculator</h2>
              <p style="color:var(--muted); max-width:520px; margin:10px auto 0;">See what you keep before you consign. Enter an estimated sale price.</p>
            </div>
            <div class="calc-card">
              <div class="calc-row"><label>Estimated sale price (USD)</label><input id="calc-price" type="number" min="0" step="50" placeholder="e.g. 3000" inputmode="numeric"></div>
              <div class="calc-result" id="calc-result"><div class="keep-label">You keep</div><div class="keep-amt">&mdash;</div><div class="keep-sub">Enter a sale price above</div></div>
              <p class="calc-note">Estimate only. Final payout is confirmed in the Offer Summary you accept. No upfront or processing fees. <a href="#" role="button" onclick="event.preventDefault();openModal('pricingguide')">See the Pricing Guide</a>.</p>
            </div>
          </div>`;
        tiers.insertAdjacentElement('afterend', calc);
        var priceEl = calc.querySelector('#calc-price');
        var resEl = calc.querySelector('#calc-result');
        var render = function(){
          var p = parseFloat(priceEl.value) || 0;
          var fee, lowPct, highPct, band;
          if (!p){ resEl.innerHTML = '<div class="keep-label">You keep</div><div class="keep-amt">&mdash;</div><div class="keep-sub">Enter a sale price above</div>'; return; }
          // No per-item fee: Consignor Terms §6.1 makes the commission Casa's only
          // compensation, so subtracting a processing fee here understated every payout.
          // Rates per Alexa's "CC Consignment Commission Tiers" PDF, 27 Aug 2026 — flat
          // 25%/20% by price, no membership override. The old 'elite' branch gave
          // Concierge Club members a boosted rate, which directly contradicted the
          // Benefits copy a few lines below ("membership... does not change your
          // commission") — dropped so `tier` no longer affects the payout, only price does.
          // The Membership dropdown that fed `tier` was removed 23 Sep 2026: it changed nothing.
          fee = 0;
          if (p >= 5000){ lowPct = 0.80; highPct = 0.80; band = '80% payout · items $5,000 and over'; }
          else { lowPct = 0.75; highPct = 0.75; band = '75% payout · items under $5,000'; }
          var low = Math.max(0, p*lowPct - fee), high = Math.max(0, p*highPct - fee);
          var amt = (low === high) ? money(high) : (money(low) + '–' + money(high));
          resEl.innerHTML = '<div class="keep-label">You keep</div><div class="keep-amt">' + amt + '</div><div class="keep-sub">' + band + (fee ? ' · after ' + money(fee) + ' processing' : ' · no upfront fees') + '</div>';
        };
        priceEl.addEventListener('input', render);
      }
    } catch(e){ console.warn('Casa calc inject failed', e); }

    // ---- Pricing Guide modal (+ Benefits comparison) ----
    try {
      if (!document.getElementById('modal-pricingguide')) {
        var pg = document.createElement('div');
        pg.className = 'modal-backdrop'; pg.id = 'modal-pricingguide';
        pg.setAttribute('onclick', "if(event.target===this) closeModal('pricingguide')");
        pg.innerHTML = `
          <div class="modal info-modal">
            <button class="modal-close" aria-label="Close" onclick="closeModal('pricingguide')"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 6l12 12M18 6L6 18"/></svg></button>
            <div class="info-head"><h2>Pricing Guide</h2><p>How consignment pricing works at Casa — transparent, and separated into three clear layers.</p></div>
            <div class="info-body">
              <div class="info-callout"><strong>Two layers, never mixed</strong>Optional access, and your outcome. There is no third layer: Casa charges consignors no upfront, authentication, or processing fee.</div>
              <div class="info-item"><h4>1 · Access — The Casa Concierge Club (optional)</h4><p>The Casa Concierge Club adds priority evaluation, a member dashboard, early access, complimentary insured FedEx shipping kits, priority listing, and white-glove service. Silver $149/mo · Gold $299/mo · Elite $599/mo. Membership is never required to consign, and it does not change your commission.</p></div>
              <div class="info-item"><h4>2 · Outcome — Commission</h4><p>Indicatively you keep <strong>75%</strong> on pieces under $5,000 and <strong>80%</strong> on pieces $5,000 and over — the rate in the Offer Summary you accept controls, and it applies to the Net Sale Price. Our commission is our only compensation: authentication, condition assessment, photography, and listing preparation are included at no charge. Casa sets the listing price using market data and item condition; you'll always see your payout before you consign.</p></div>
              <div class="info-item"><h4>If you withdraw a piece early</h4><p>You may request the return of any unsold item at any time. A return fee of <strong>$50 shipping + $150 processing</strong> per item applies, payable in advance or netted against amounts otherwise payable to you. If <em>we</em> ask you to retrieve an item, no return fee applies.</p></div>
              <h4 style="font-size:10px; letter-spacing:0.22em; text-transform:uppercase; color:var(--muted); margin:18px 0 8px;">Concierge Club Benefits</h4>
              <table class="benefit-table">
                <thead><tr><th>Benefit</th><th>Silver</th><th>Gold</th><th>Elite</th></tr></thead>
                <tbody>
                  <!-- Rows mirror Schedule A of the Membership Terms. "Reduced
                       consignment fees" and "Highest payout tier" are removed: Schedule A
                       grants no commission benefit, and §7 limits benefits to what
                       Schedule A expressly states. Shipping-kit counts are stated because
                       the benefit is capped per membership year, not unlimited. -->
                  <tr><td>Monthly price</td><td>$149</td><td>$299</td><td>$599</td></tr>
                  <tr><td>Priority evaluation</td><td>✓</td><td>✓</td><td>✓</td></tr>
                  <tr><td>Member dashboard</td><td>✓</td><td>✓</td><td>✓</td></tr>
                  <tr><td>Early access to new listings</td><td>✓</td><td>✓</td><td>✓</td></tr>
                  <tr><td>Complimentary insured FedEx shipping kits <span style="color:var(--muted);font-size:11px;">(per membership year)</span></td><td>—</td><td>up to 5</td><td>up to 8</td></tr>
                  <!-- Schedule A lists "Authentication included — no authentication fee"
                       as a Gold benefit, but the Consignor Terms establish no
                       authentication fee for anyone (§6.1 makes the commission Casa's
                       only compensation). Advertising it as a paid tier's benefit would
                       imply non-members pay something they do not. Casa still honours the
                       Schedule A promise; it is simply not a differentiator, so it is not
                       listed as one. -->
                  <tr><td>Priority listing</td><td>—</td><td>✓</td><td>✓</td></tr>
                  <tr><td>White-glove concierge &amp; designated advisor</td><td>—</td><td>—</td><td>✓</td></tr>
                  <tr><td>First access to selected inventory</td><td>—</td><td>—</td><td>✓</td></tr>
                  <tr><td>Private-event invitations</td><td>—</td><td>—</td><td>✓</td></tr>
                </tbody>
              </table>
            </div>
          </div>`;
        document.body.appendChild(pg);
      }
    } catch(e){ console.warn('Casa pricing guide failed', e); }

    // ---- Sell to Casa (instant-estimate buyout) ----
    try {
      var sellView = document.getElementById('view-sell');
      if (sellView && !document.querySelector('.casa-sellcasa')) {
        var sc = document.createElement('section');
        sc.className = 'casa-sellcasa';
        sc.innerHTML = `
          <div class="container">
            <span class="eyebrow">Prefer a Quick Sale?</span>
            <h2>Sell Directly to Casa</h2>
            <p>Not in a rush for the perfect buyer? We'll make you an outright offer and purchase your piece directly. Get an instant estimate, send it in, and get paid fast.</p>
            <button class="btn btn-primary" onclick="openModal('sellcasa')">Get an Instant Estimate →</button>
          </div>`;
        var afterEl = sellView.querySelector('.casa-membership') || sellView.querySelector('.seller-cta') || sellView.querySelector('.tiers-wrap');
        if (afterEl) afterEl.insertAdjacentElement('afterend', sc); else sellView.appendChild(sc);
      }
      if (!document.getElementById('modal-sellcasa')) {
        var scm = document.createElement('div');
        scm.className = 'modal-backdrop'; scm.id = 'modal-sellcasa';
        scm.setAttribute('onclick', "if(event.target===this) closeModal('sellcasa')");
        scm.innerHTML = `
          <div class="modal info-modal">
            <button class="modal-close" aria-label="Close" onclick="closeModal('sellcasa')"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 6l12 12M18 6L6 18"/></svg></button>
            <div class="info-head"><h2>Sell to Casa</h2><p>An outright offer — we buy your piece directly.</p></div>
            <div class="info-body">
              <form id="sellcasa-form" onsubmit="return casaSellToCasaSubmit(event)">
                <div class="form-row">
                  <div class="form-field"><label>Designer / Brand</label><select name="brand" required><option value="">Select</option><option>Chanel</option><option>Louis Vuitton</option><option>Hermès</option><option>Gucci</option><option>Dior</option><option>Prada</option><option>Fendi</option><option>Balenciaga</option><option>Jacquemus</option><option>Other</option></select></div>
                  <div class="form-field"><label>Model</label><input type="text" name="model" placeholder="e.g. Classic Flap" required></div>
                </div>
                <div class="form-row">
                  <div class="form-field"><label>Condition</label><select name="condition" required><option value="">Select</option><option>Pristine</option><option>Excellent</option><option>Very Good</option><option>Good</option><option>As Is</option></select></div>
                  <div class="form-field"><label>Expected resale value (USD)</label><input id="sc-resale" type="number" name="resale" min="0" step="50" placeholder="$" inputmode="numeric" required></div>
                </div>
                <div class="sc-estimate" id="sc-estimate">Enter an expected resale value to see your instant estimate.</div>
                <div class="form-field full">
                  <label>Photos — front, rear, side, bottom, inside</label>
                  <div class="upload-thumbs" id="sc-required-photo-slots">
                    <div class="upload-thumb photo-slot" data-slot="front">
                      <input type="file" id="sc-photo-input-front" class="sc-photo-slot-input" data-slot="front" accept="image/*" style="display:none">
                      <label for="sc-photo-input-front" style="cursor:pointer;width:100%;height:100%;display:flex;align-items:center;justify-content:center;">
                        <span class="photo-slot-label">Front</span>
                        <img class="photo-slot-preview" style="display:none;width:100%;height:100%;object-fit:cover;">
                      </label>
                    </div>
                    <div class="upload-thumb photo-slot" data-slot="rear">
                      <input type="file" id="sc-photo-input-rear" class="sc-photo-slot-input" data-slot="rear" accept="image/*" style="display:none">
                      <label for="sc-photo-input-rear" style="cursor:pointer;width:100%;height:100%;display:flex;align-items:center;justify-content:center;">
                        <span class="photo-slot-label">Rear</span>
                        <img class="photo-slot-preview" style="display:none;width:100%;height:100%;object-fit:cover;">
                      </label>
                    </div>
                    <div class="upload-thumb photo-slot" data-slot="side">
                      <input type="file" id="sc-photo-input-side" class="sc-photo-slot-input" data-slot="side" accept="image/*" style="display:none">
                      <label for="sc-photo-input-side" style="cursor:pointer;width:100%;height:100%;display:flex;align-items:center;justify-content:center;">
                        <span class="photo-slot-label">Side</span>
                        <img class="photo-slot-preview" style="display:none;width:100%;height:100%;object-fit:cover;">
                      </label>
                    </div>
                    <div class="upload-thumb photo-slot" data-slot="bottom">
                      <input type="file" id="sc-photo-input-bottom" class="sc-photo-slot-input" data-slot="bottom" accept="image/*" style="display:none">
                      <label for="sc-photo-input-bottom" style="cursor:pointer;width:100%;height:100%;display:flex;align-items:center;justify-content:center;">
                        <span class="photo-slot-label">Bottom</span>
                        <img class="photo-slot-preview" style="display:none;width:100%;height:100%;object-fit:cover;">
                      </label>
                    </div>
                    <div class="upload-thumb photo-slot" data-slot="inside">
                      <input type="file" id="sc-photo-input-inside" class="sc-photo-slot-input" data-slot="inside" accept="image/*" style="display:none">
                      <label for="sc-photo-input-inside" style="cursor:pointer;width:100%;height:100%;display:flex;align-items:center;justify-content:center;">
                        <span class="photo-slot-label">Inside</span>
                        <img class="photo-slot-preview" style="display:none;width:100%;height:100%;object-fit:cover;">
                      </label>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-field"><label>Your Name</label><input type="text" name="name" required></div>
                  <div class="form-field"><label>Email</label><input type="email" name="email" required></div>
                </div>
                <div class="form-field full"><label>Phone</label><input type="tel" name="phone"></div>
                <label style="display:flex; gap:10px; align-items:flex-start; font-size:12px; color:var(--muted); margin:6px 0 14px; line-height:1.5;"><input type="checkbox" required style="margin-top:2px;"> I understand the estimate is not a firm offer, and I have read the <a onclick="var d=document.getElementById('sc-policy-details'); if(d){d.open=true; d.scrollIntoView({block:'nearest'});} event.preventDefault();" style="color:var(--navy); text-decoration:underline; cursor:pointer;">Sell to Casa policy</a>.</label>
                <button class="btn btn-primary btn-block" type="submit" id="sellcasa-submit" disabled>Submit for a Firm Offer →</button>
              </form>
              <div id="sellcasa-success" style="display:none; text-align:center; padding:24px 8px;">
                <div style="width:64px;height:64px;margin:0 auto 16px;border-radius:50%;background:var(--bg-cream);display:flex;align-items:center;justify-content:center;"><svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#141414" stroke-width="2"><path d="m5 13 4 4L19 7"/></svg></div>
                <h3 style="margin-bottom:8px;">Got it — your offer is on the way</h3>
                <p style="color:var(--muted); max-width:420px; margin:0 auto;">A specialist will review your piece and send a firm offer within 24 hours. Thank you for choosing Casa Consignment.</p>
              </div>
              <details class="sc-policy" id="sc-policy-details">
                <summary>Sell to Casa — Policy</summary>
                <p><strong>Outright purchase.</strong> "Sell to Casa" is a direct buyout, not a consignment. Casa purchases the item from you for an agreed price and assumes ownership and resale risk.</p>
                <p><strong>Estimate vs. firm offer.</strong> The instant estimate is indicative only. A firm offer is issued after a specialist reviews your photos and details — typically within 24 hours — and may be revised on physical inspection and authentication.</p>
                <p><strong>Acceptance is final.</strong> Once you accept a firm offer and Casa receives and verifies the item, the sale is final and payment is issued by your chosen method.</p>
                <p><strong>Authentication.</strong> All items are authenticated. Items found inauthentic or materially different from your description will have the offer withdrawn and be returned to you.</p>
                <p><strong>Ownership.</strong> You confirm you are the rightful owner and that the item is authentic and free of any lien or claim.</p>
                <p><strong>Shipping.</strong> Send items insured per our guidance; risk of loss remains with you until Casa receives and opens the package.</p>
              </details>
            </div>
          </div>`;
        document.body.appendChild(scm);
        var resale = scm.querySelector('#sc-resale');
        var est = scm.querySelector('#sc-estimate');
        if (resale && est){
          resale.addEventListener('input', function(){
            var r = parseFloat(resale.value) || 0;
            if (!r){ est.textContent = 'Enter an expected resale value to see your instant estimate.'; return; }
            est.innerHTML = 'Estimated instant offer: <strong>' + money(r*0.50) + '–' + money(r*0.65) + '</strong><br><span style="font-size:12px;color:var(--muted);">A firm offer is confirmed within 24 hours after review.</span>';
          });
        }

        // ---- Sell to Casa photos: same compress → upload-to-Blob pipeline as
        // Consign a Piece (casaCompressPhoto / api/consignment-photo are generic,
        // keyed only by submission ref + slot — no server change needed). Kept in
        // its own state object so the two flows can never cross-contaminate each
        // other's photos. Previously this modal had one generic <input multiple>
        // whose handler only recorded data.photoCount — the files never left the
        // browser, which is why Sell to Casa leads reached staff with no photos.
        window.casaSellPhotos = { front: null, rear: null, side: null, bottom: null, inside: null, extra: [] };
        var casaSellPhotoRef = null;
        function casaSellPhotoSubmissionRef(){
          if (!casaSellPhotoRef) casaSellPhotoRef = 's' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
          return casaSellPhotoRef;
        }
        function casaUploadSellPhoto(slot, blob){
          var ref = casaSellPhotoSubmissionRef();
          return fetch('/api/consignment-photo?ref=' + encodeURIComponent(ref) + '&slot=' + encodeURIComponent(slot), {
            method: 'POST',
            headers: { 'Content-Type': blob.type || 'image/jpeg' },
            body: blob
          }).then(function(r){ return r.json().catch(function(){ return {}; }); })
            .then(function(j){ return (j && j.ok && j.url) ? j.url : null; })
            .catch(function(){ return null; });
        }
        function casaUpdateSellSubmitEnabled(){
          var btn = document.getElementById('sellcasa-submit');
          if (btn) btn.disabled = !CASA_REQUIRED_PHOTO_SLOTS.every(function(s){ return !!window.casaSellPhotos[s]; });
        }
        scm.querySelectorAll('.sc-photo-slot-input').forEach(function(input){
          input.addEventListener('change', function(e){
            var file = e.target.files && e.target.files[0];
            if (!file) return;
            var slot = input.dataset.slot;
            var tile = input.closest('.photo-slot');
            var img = tile ? tile.querySelector('.photo-slot-preview') : null;
            var labelSpan = tile ? tile.querySelector('.photo-slot-label') : null;

            var previewReader = new FileReader();
            previewReader.onload = function(ev){
              if (img) { img.src = ev.target.result; img.style.display = 'block'; }
              if (labelSpan) labelSpan.style.display = 'none';
            };
            previewReader.readAsDataURL(file);

            if (tile) { tile.classList.remove('uploaded', 'upload-failed'); tile.classList.add('uploading'); }
            window.casaSellPhotos[slot] = null;
            casaUpdateSellSubmitEnabled();

            casaCompressPhoto(file).then(function(blob){ return casaUploadSellPhoto(slot, blob); }).then(function(url){
              if (tile) tile.classList.remove('uploading');
              if (url) {
                window.casaSellPhotos[slot] = url;
                if (tile) tile.classList.add('uploaded');
              } else if (tile) {
                tile.classList.add('upload-failed');
                try { window.casaSignal && window.casaSignal('photo_upload_failed', 'sell ' + slot); } catch (e) {}
                if (img) img.style.display = 'none';
                if (labelSpan) { labelSpan.style.display = 'flex'; labelSpan.textContent = labelSpan.textContent.replace(/\s*\(retry\)$/, '') + ' (retry)'; }
              }
              casaUpdateSellSubmitEnabled();
            });
          });
        });
      }
      window.casaSellToCasaSubmit = function(ev){
        ev.preventDefault();
        try {
          var f = ev.target, data = {};
          f.querySelectorAll('input, select').forEach(function(el){
            // Photo slots are handled below via window.casaSellPhotos — those
            // hold real uploaded Blob URLs, not a count. Same reasoning as the
            // Consign flow (see casaConsignPhotos near the top of this script).
            if (el.type === 'file') return;
            if (el.type === 'checkbox') data[el.name || 'agree'] = el.checked;
            else if (el.name) data[el.name] = el.value;
          });
          // Real photo URLs (uploaded to Blob storage as each slot was filled),
          // not a count — see the compress/upload wiring above.
          data.photos = window.casaSellPhotos || {};
          data.submission_ref = (typeof casaSellPhotoSubmissionRef === 'function') ? casaSellPhotoSubmissionRef() : '';

          // Only claim the offer is on its way once the request has actually
          // landed — see casaIntakeLanded.
          var btn = f.querySelector('button[type=submit], .btn-primary');
          var label = btn ? btn.textContent : '';
          if (btn){ btn.disabled = true; btn.textContent = 'Sending…'; }

          var err = f.querySelector('.casa-intake-err');
          if (!err){
            err = document.createElement('p');
            err.className = 'casa-intake-err';
            err.style.cssText = 'color:#b3261e;font-size:13px;line-height:1.5;margin-top:12px;';
            f.appendChild(err);
          }
          err.textContent = '';

          window.casaIntakeLanded('sell_to_casa', data).then(function(ok){
            if (btn){ btn.disabled = false; btn.textContent = label; }
            if (!ok){ err.textContent = window.CASA_INTAKE_FAIL_MSG; return; }
            f.style.display = 'none';
            var s = document.getElementById('sellcasa-success'); if (s) s.style.display = 'block';
          });
        } catch(e){}
        return false;
      };
    } catch(e){ console.warn('Casa sell-to-casa failed', e); }

    // ---- Consign Submit-Item flow → intake seam ----
    try {
      var _setStep = window.setStep;
      if (typeof _setStep === 'function') {
        window.setStep = function(n){
          // Step 1 has no <form> to submit — .sell-form-wrap is a plain div and
          // "Continue" just calls setStep(2) directly — so the `required` on
          // Brand/Model below does nothing on its own; HTML5 constraint
          // validation only fires on a real form submission. Gate it here
          // instead, using reportValidity() so it still gets the native
          // browser tooltip/outline without needing a hand-built error UI.
          // Server-side mirror in api/intake.js (same reasoning as bag_request's
          // own guard: a client check alone is bypassable).
          if (n === 2) {
            try {
              var step1 = document.querySelector('.form-step[data-step="1"]');
              if (step1) {
                var invalid = Array.prototype.find.call(step1.querySelectorAll('[required]'), function(el){ return !el.checkValidity(); });
                if (invalid) { invalid.reportValidity(); if (invalid.focus) invalid.focus(); return; }
              }
            } catch(e){}
          }
          if (n === 4) {
            try {
              var wrap = document.querySelector('.sell-form-wrap'), data = {};
              if (wrap) {
                wrap.querySelectorAll('.form-step[data-step="1"] input, .form-step[data-step="1"] select, .form-step[data-step="1"] textarea, .form-step[data-step="2"] input, .form-step[data-step="2"] select, .form-step[data-step="2"] textarea, .form-step[data-step="3"] input, .form-step[data-step="3"] select, .form-step[data-step="3"] textarea').forEach(function(el){
                  // File inputs are handled below via window.casaConsignPhotos —
                  // those hold real uploaded URLs, not a count, and there are
                  // now six of them (5 required slots + the extras input) on
                  // Step 2, so this loop must not touch them at all.
                  if (el.type === 'file') return;
                  var lab = '', fld = el.closest('.form-field'); if (fld){ var l = fld.querySelector('label'); if (l) lab = l.textContent.trim(); }
                  var key = lab || el.placeholder || el.type;
                  if (el.type === 'checkbox') data[key] = el.checked;
                  else if (el.value) data[key] = el.value;
                });
                // Real photo URLs (uploaded to Blob storage as each slot was
                // filled), not a count — see the compress/upload wiring near
                // the top of this script. `submission_ref` lets the durable
                // consignment_photos audit rows be cross-referenced later.
                data.photos = window.casaConsignPhotos || {};
                data.submission_ref = (typeof casaConsignPhotoSubmissionRef === 'function') ? casaConsignPhotoSubmissionRef() : '';

                // Step 4 IS the confirmation screen, so by the time we know the
                // result the UI has already committed to "received". If the
                // submission did not land, replace that confirmation rather
                // than letting a thank-you sit on top of a dropped lead.
                window.casaIntakeLanded('consignment', data).then(function(ok){
                  var panel = document.querySelector('.form-step[data-step="4"]');
                  if (!panel) return;
                  var prev = panel.querySelector('.casa-consign-failed');
                  if (prev) prev.parentNode.removeChild(prev);
                  if (ok){
                    // Recovered on a retry — restore the confirmation.
                    panel.querySelectorAll('[data-casa-hidden]').forEach(function(el){
                      el.style.display = el.getAttribute('data-casa-hidden') || '';
                      el.removeAttribute('data-casa-hidden');
                    });
                    return;
                  }
                  Array.prototype.forEach.call(panel.children, function(el){
                    if (el.classList.contains('casa-consign-failed')) return;
                    el.setAttribute('data-casa-hidden', el.style.display || '');
                    el.style.display = 'none';
                  });
                  var box = document.createElement('div');
                  box.className = 'casa-consign-failed';
                  box.style.cssText = 'text-align:center;padding:34px 18px;';
                  box.innerHTML =
                    '<div style="width:60px;height:60px;margin:0 auto 16px;border-radius:50%;background:#fdeceb;display:flex;align-items:center;justify-content:center;">' +
                      '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#b3261e" stroke-width="2"><path d="M12 8v5M12 16.5v.5"/><circle cx="12" cy="12" r="9"/></svg>' +
                    '</div>' +
                    '<h3 style="margin-bottom:8px;">We could not submit your piece</h3>' +
                    '<p style="color:var(--muted);max-width:430px;margin:0 auto 18px;line-height:1.6;">' +
                      'Nothing was sent, so please do not consider this submitted. ' +
                      'Email <a href="mailto:info@casaconsignment.com" style="color:var(--navy);text-decoration:underline;">info@casaconsignment.com</a> ' +
                      'with your details and we will take it from there.</p>' +
                    '<button type="button" class="btn btn-primary" style="min-width:170px;">Try again</button>';
                  box.querySelector('button').addEventListener('click', function(){
                    if (typeof window.setStep === 'function') window.setStep(4);
                  });
                  panel.appendChild(box);
                });
              }
            } catch(e){}
          }
          return _setStep(n);
        };
      }
    } catch(e){ console.warn('Casa submit-item wire failed', e); }

    console.log('%cCASA · Launch-finalize build', 'background:#141414;color:#fff;padding:4px 10px;font-weight:bold;');
    console.log('  ✓ Commission Calculator + Pricing Guide + Benefits (Consign)');
    console.log('  ✓ Sell to Casa: instant-estimate buyout + policy');
    console.log('  ✓ Submissions routed to casaSubmitIntake seam (set CASA_CONFIG.INTAKE_ENDPOINT to go live)');
  })();

  // =====================================================================
  // CASA · MEMBERSHIP FLOW (Shopify Subscriptions seam) — LP4
  // Adds join CTAs to the tier cards and routes to a Shopify subscription
  // checkout when configured (CASA_CONFIG.MEMBERSHIP_CHECKOUT), otherwise
  // captures interest. Includes a benefit-gating seam (casaIsMember).
  // LIVE as of 3 Aug 2026 — Shopify Subscriptions app, one selling plan group
  // per tier, monthly recurring. Setting these URLs is what flips the cards
  // from "Request an invitation" to "Join <tier>".
  //
  // Permalink form: /cart/<variantId>:1?selling_plan=<sellingPlanId>
  // The selling_plan param is the whole point — WITHOUT it the same variant
  // checks out as a ONE-OFF charge and never bills again, which is the silent
  // failure mode here: the customer pays $299, Casa sees a paid order, and no
  // subscription contract is ever created. Verified 3 Aug: all three land on
  // Shopify checkout showing "Recurring Subscription every month".
  //
  // Re-read these IDs from the Storefront API (product.variants.sellingPlan-
  // Allocations) if the plans are ever rebuilt — they change.
  // =====================================================================
  (function casaMembershipFlow(){
    window.CASA_CONFIG = window.CASA_CONFIG || {};
    // Variant + selling plan per tier. Read back from the Storefront API
    // (product.variants.sellingPlanAllocations) if the plans are ever rebuilt —
    // both IDs change. Deliberately NOT checkout URLs: see casaStartMembership
    // for why the ?selling_plan= permalink cannot be used.
    // sellingPlanId is now per billing interval: the annual plan reuses the SAME
    // variant (tier identity in api/_lib/membership.js is untouched) but needs
    // its own selling plan id, since that is what tells Shopify to bill once a
    // year at 12x the monthly price instead of monthly. Annual selling plans
    // created in Shopify 16 Aug 2026 (same variant, second plan per group,
    // fixed price, no billing anchor — mirrors the monthly plan exactly).
    // casaStartMembership() still falls back to the waitlist modal for any
    // interval whose id is blank, so a future rebuild that clears one of these
    // fails safe instead of checking out onto a plan that no longer exists.
    window.CASA_CONFIG.MEMBERSHIP_PLANS = window.CASA_CONFIG.MEMBERSHIP_PLANS || {
      silver: { variantId:'48388096262334', sellingPlanId:{ monthly:'15680798910', yearly:'15703048382' } },   // $149/mo · $1,788/yr
      gold:   { variantId:'48389008588990', sellingPlanId:{ monthly:'15680831678', yearly:'15703081150' } },   // $299/mo · $3,588/yr
      elite:  { variantId:'48389012062398', sellingPlanId:{ monthly:'15680864446', yearly:'15703113918' } }    // $599/mo · $7,188/yr
    };
    // Where members cancel. The Membership Terms promise cancellation "from
    // your account settings", so this has to resolve to a real self-serve
    // portal — /account on the shop domain redirects into Shopify's customer
    // account login, which is the stable entry point (the raw
    // shopify.com/<storeId>/account form hardcodes a store id).
    // Straight to the member's Membership page in the Shopify customer account (the
    // "Subscription management URL" in Subscriptions > Settings, 23 Sep 2026). It asks
    // them to sign in first, then lands on pause / cancel / skip / update card.
    if (typeof window.CASA_CONFIG.MEMBER_PORTAL_URL === 'undefined') window.CASA_CONFIG.MEMBER_PORTAL_URL = 'https://shopify.com/77004144830/account/pages/6971b1a1-27f6-4c27-b8b0-3009fd3b921d';

    // Benefit-gating seam — real tier comes from the Shopify customer +
    // active subscription once billing is live; localStorage is a stand-in.
    window.casaMembership = window.casaMembership || { tier: (function(){ try { return localStorage.getItem('casa_member_tier') || null; } catch(e){ return null; } })() };
    // Which billing frequency the Monthly/Yearly toggle currently has selected.
    // Shared globally (not per-card) because the About and Sell pages render two
    // copies of the same membership section — switching the toggle on either
    // should move both, since they represent one choice.
    window.casaMembershipInterval = window.casaMembershipInterval || 'monthly';
    var RANK = { silver:1, gold:2, elite:3 };
    window.casaIsMember = function(min){ var t = window.casaMembership.tier; if (!t) return false; if (!min) return true; return (RANK[t]||0) >= (RANK[min]||0); };

    var st = document.createElement('style');
    st.textContent = `
      .member-cta { margin-top:16px; }
      .member-cta button { width:100%; padding:12px 14px; border-radius:3px; border:1px solid #141414; background:#fff; color:#141414; font-family:var(--sans); font-size:12px; letter-spacing:0.16em; text-transform:uppercase; cursor:pointer; transition:all .2s; }
      .member-cta button:hover { background:#141414; color:#fff; }
      .member-cta .mem-waitlist-note { display:block; margin-top:8px; font-size:11px; line-height:1.5; color:var(--muted); letter-spacing:0.01em; }
      .member-card.featured .member-cta button { background:#fff; color:#141414; border-color:#fff; }
      .member-card.featured .member-cta button:hover { background:var(--bg-cream); }
      .mem-status { max-width:760px; margin:22px auto 0; padding:14px 18px; background:var(--bg-cream); border:1px solid var(--line); border-radius:4px; text-align:center; font-size:13px; color:var(--navy-soft); }
      .mem-status a { color:var(--navy); text-decoration:underline; cursor:pointer; }
      .mem-billing-toggle { display:inline-flex; margin-top:18px; border:1px solid var(--line); border-radius:999px; padding:3px; background:#fff; }
      .mem-billing-toggle .mem-bt-btn { border:none; background:transparent; padding:8px 18px; font-family:var(--sans); font-size:11px; letter-spacing:0.14em; text-transform:uppercase; color:var(--muted); border-radius:999px; cursor:pointer; transition:all .2s; }
      .mem-billing-toggle .mem-bt-btn.is-active { background:#141414; color:#fff; }
    `;
    document.head.appendChild(st);

    var TIER_OF = function(name){ name = (name||'').toLowerCase(); if (name.indexOf('silver')>=0) return 'silver'; if (name.indexOf('gold')>=0) return 'gold'; if (name.indexOf('elite')>=0) return 'elite'; return ''; };

    // Add a join CTA to each membership card (both copies: Sell + About)
    document.querySelectorAll('.casa-membership .member-card').forEach(function(card){
      if (card.querySelector('.member-cta')) return;
      var nm = card.querySelector('.tier-name'); var tier = TIER_OF(nm ? nm.textContent : '');
      if (!tier) return;
      var wrap = document.createElement('div'); wrap.className = 'member-cta';
      // Label the button for what it actually does. Recurring billing is not
      // wired yet, so "Choose Gold" promises an enrolment the site cannot
      // complete — the click opens a waitlist form. Say so, and swap to the
      // enrolment label automatically once MEMBERSHIP_PLANS is configured.
      var _p = ((window.CASA_CONFIG || {}).MEMBERSHIP_PLANS || {})[tier];
      var liveBilling = !!(_p && _p.variantId && _p.sellingPlanId && _p.sellingPlanId.monthly);
      var label = liveBilling
        ? 'Join ' + (nm ? nm.textContent.trim() : 'Plan')
        : 'Request an invitation';
      wrap.innerHTML = '<button type="button" onclick="casaStartMembership(\'' + tier + '\')">' + label + '</button>' +
        (liveBilling ? '' : '<span class="mem-waitlist-note">Enrolment opens shortly — join the list and we will contact you.</span>');
      card.appendChild(wrap);
      // Tag the button with its tier so the enrolment call can put just this
      // one into a pending state — the cards render twice (Sell + About).
      var _b = wrap.querySelector('button'); if (_b) _b.__t = tier;
    });

    // Monthly/Yearly toggle — one payment a year at 12x the monthly rate, no
    // discount. The yearly figure is derived from whatever monthly figure is
    // already in the markup (never a second hardcoded number to drift out of
    // sync), and re-render touches both membership sections (About + Sell) so
    // the choice stays in sync wherever the toggle is clicked.
    document.querySelectorAll('.casa-membership').forEach(function(section){
      if (section.querySelector('.mem-billing-toggle')) return;
      var head = section.querySelector('.section-head');
      if (!head) return;
      section.querySelectorAll('.tier-price').forEach(function(el){
        if (el.dataset.monthly) return;
        var digits = el.textContent.replace(/[^0-9]/g, '');
        el.dataset.monthly = digits || '';
      });
      var tg = document.createElement('div');
      tg.className = 'mem-billing-toggle';
      tg.setAttribute('role', 'group');
      tg.setAttribute('aria-label', 'Billing frequency');
      tg.innerHTML =
        '<button type="button" class="mem-bt-btn" data-interval="monthly" aria-pressed="true">Billed monthly</button>' +
        '<button type="button" class="mem-bt-btn" data-interval="yearly" aria-pressed="false">Billed yearly</button>';
      head.appendChild(tg);
    });

    function casaRenderMembershipBilling(interval){
      interval = interval === 'yearly' ? 'yearly' : 'monthly';
      window.casaMembershipInterval = interval;
      document.querySelectorAll('.casa-membership').forEach(function(section){
        section.querySelectorAll('.mem-bt-btn').forEach(function(b){
          var active = b.getAttribute('data-interval') === interval;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        section.querySelectorAll('.tier-price').forEach(function(el){
          var monthly = Number(el.dataset.monthly || 0);
          if (!monthly) return;
          el.innerHTML = interval === 'yearly'
            ? '$' + (monthly * 12).toLocaleString() + '<span> /year</span>'
            : '$' + monthly.toLocaleString() + '<span> /month</span>';
        });
      });
    }
    document.addEventListener('click', function(e){
      var b = e.target && e.target.closest ? e.target.closest('.mem-bt-btn') : null;
      if (!b) return;
      casaRenderMembershipBilling(b.getAttribute('data-interval'));
    });
    casaRenderMembershipBilling(window.casaMembershipInterval);

    // Membership modal — interest capture until billing is live; links to the
    // Shopify customer portal once MEMBER_PORTAL_URL is set.
    if (!document.getElementById('modal-membership')) {
      var mm = document.createElement('div');
      mm.className = 'modal-backdrop'; mm.id = 'modal-membership';
      mm.setAttribute('onclick', "if(event.target===this) closeModal('membership')");
      mm.innerHTML = `
        <div class="modal info-modal">
          <button class="modal-close" aria-label="Close" onclick="closeModal('membership')"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 6l12 12M18 6L6 18"/></svg></button>
          <div class="info-head"><h2>The Casa Concierge Club</h2><p>Priority evaluation, complimentary insured shipping kits, priority listing, and white-glove access.</p></div>
          <div class="info-body">
            <div class="info-callout" style="text-align:left;"><strong id="mem-tier-name">Membership</strong>Secure monthly membership is launching shortly. Join the list and we'll invite you the moment it opens.</div>
            <form id="mem-form" onsubmit="return casaMembershipInterest(event)" style="margin-top:10px;">
              <input type="hidden" name="tier" id="mem-tier-field" value="">
              <div class="form-field full"><label>Email</label><input type="email" name="email" placeholder="you@example.com" required></div>
              <button class="btn btn-primary btn-block" type="submit" style="margin-top:12px;">Notify Me at Launch →</button>
            </form>
            <div id="mem-success" style="display:none; padding:18px 8px; text-align:center;"><h3 style="margin-bottom:6px;">You're on the list 🤍</h3><p style="color:var(--muted);">We'll email you the moment membership opens.</p></div>
          </div>
        </div>`;
      document.body.appendChild(mm);
    }

    // Enrol via the Storefront cart API, NOT a /cart/<variant>:1?selling_plan=<id>
    // permalink.
    //
    // Verified in-browser 3 Aug 2026: that permalink form silently DROPS the
    // selling plan. The checkout renders, the price is right, and the word
    // "subscription" appears nowhere on the page — the customer pays $299 once
    // and no subscription contract is ever created. It fails as a normal sale,
    // which is the worst way for a billing bug to fail.
    //
    // cartCreate with sellingPlanId is the supported path and is what the bag
    // checkout already uses (casaShopifyCheckout). The returned checkoutUrl
    // carries the plan; the cart line reports it back via sellingPlanAllocation,
    // which is how this is regression-tested.
    window.casaStartMembership = function(tier){
      var interval = window.casaMembershipInterval === 'yearly' ? 'yearly' : 'monthly';
      var plan = (window.CASA_CONFIG.MEMBERSHIP_PLANS || {})[tier];
      var sellingPlanId = plan && plan.sellingPlanId && plan.sellingPlanId[interval];
      // Yearly falls back to the waitlist modal below until its selling plan
      // exists in Shopify — same "not live yet" behaviour monthly had before
      // 3 Aug 2026, so nobody can check out onto a plan that isn't real.
      if (plan && plan.variantId && sellingPlanId){
        var btns = document.querySelectorAll('.casa-membership .member-cta button');
        btns.forEach(function(b){ if (b.__t === tier){ b.disabled = true; b.dataset.prev = b.textContent; b.textContent = 'Opening checkout…'; } });
        var restore = function(){ btns.forEach(function(b){ if (b.__t === tier){ b.disabled = false; if (b.dataset.prev) b.textContent = b.dataset.prev; } }); };
        var SHOP  = (window.CASA_CONFIG && window.CASA_CONFIG.SHOPIFY_DOMAIN) || 'casa-consignment.myshopify.com';
        var TOKEN = (window.CASA_CONFIG && window.CASA_CONFIG.SHOPIFY_STOREFRONT_TOKEN) || '';
        var q = 'mutation{ cartCreate(input:{lines:[{quantity:1,' +
                'merchandiseId:"gid://shopify/ProductVariant/' + plan.variantId + '",' +
                'sellingPlanId:"gid://shopify/SellingPlan/' + sellingPlanId + '"}]}){' +
                ' cart{ checkoutUrl lines(first:1){edges{node{sellingPlanAllocation{sellingPlan{id}}}}} }' +
                ' userErrors{ message } } }';
        fetch('https://' + SHOP + '/api/2024-10/graphql.json', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': TOKEN },
          body: JSON.stringify({ query: q })
        }).then(function(r){ return r.json(); }).then(function(j){
          var cc = j && j.data && j.data.cartCreate;
          var cart = cc && cc.cart;
          var alloc = cart && cart.lines && cart.lines.edges[0] && cart.lines.edges[0].node.sellingPlanAllocation;
          // Refuse to send the customer to a checkout that would bill once.
          // Charging $299 for a membership that never renews is worse than not
          // selling it — it is a chargeback and a support ticket.
          if (!cart || !cart.checkoutUrl || !alloc){
            restore();
            console.warn('[casa] membership cartCreate returned no selling plan', j);
            (typeof window.showToast==='function'?window.showToast('Could not open the membership checkout. Please try again or email info@casaconsignment.com.'):alert('Could not open the membership checkout. Please try again or email info@casaconsignment.com.'));
            return;
          }
          window.location.href = cart.checkoutUrl;
        }).catch(function(e){
          restore();
          console.warn('[casa] membership cartCreate failed', e);
          (typeof window.showToast==='function'?window.showToast('Could not open the membership checkout. Please try again or email info@casaconsignment.com.'):alert('Could not open the membership checkout. Please try again or email info@casaconsignment.com.'));
        });
        return;
      }
      var names = interval === 'yearly'
        ? { silver:'Silver — $1,788/year', gold:'Gold — $3,588/year', elite:'Elite — $7,188/year' }
        : { silver:'Silver — $149/month', gold:'Gold — $299/month', elite:'Elite — $599/month' };
      var f = document.getElementById('mem-tier-field'); if (f) f.value = tier;
      var tn = document.getElementById('mem-tier-name'); if (tn) tn.textContent = names[tier] || 'Membership';
      var frm = document.getElementById('mem-form'); var suc = document.getElementById('mem-success');
      if (frm) frm.style.display = ''; if (suc) suc.style.display = 'none';
      openModal('membership');
    };
    window.casaMembershipInterest = function(ev){
      ev.preventDefault();
      try {
        var f = ev.target, data = {};
        f.querySelectorAll('input').forEach(function(el){ if (el.name) data[el.name] = el.value; });

        // "You're on the list" has to mean the list actually has them on it.
        var btn = f.querySelector('button[type=submit]');
        var label = btn ? btn.textContent : '';
        if (btn){ btn.disabled = true; btn.textContent = 'Sending…'; }

        var err = f.querySelector('.casa-intake-err');
        if (!err){
          err = document.createElement('p');
          err.className = 'casa-intake-err';
          err.style.cssText = 'color:#b3261e;font-size:13px;line-height:1.5;margin-top:10px;';
          f.appendChild(err);
        }
        err.textContent = '';

        window.casaIntakeLanded('membership_interest', data).then(function(ok){
          if (btn){ btn.disabled = false; btn.textContent = label; }
          if (!ok){ err.textContent = window.CASA_INTAKE_FAIL_MSG; return; }
          f.style.display = 'none';
          var s = document.getElementById('mem-success'); if (s) s.style.display = 'block';
        });
      } catch(e){}
      return false;
    };

    // Member-status line (shows when a tier is set — mgmt/demo now, real
    // Shopify membership status once billing is wired).
    if (window.casaMembership.tier){
      document.querySelectorAll('.casa-membership .container').forEach(function(c){
        if (c.querySelector('.mem-status')) return;
        var portal = window.CASA_CONFIG.MEMBER_PORTAL_URL;
        var el = document.createElement('div'); el.className = 'mem-status';
        el.innerHTML = 'You are a <strong>' + window.casaMembership.tier.toUpperCase() + '</strong> member.' + (portal ? ' <a href="' + portal + '">Manage membership →</a>' : '');
        c.appendChild(el);
      });
    }

    console.log('%cCASA · Membership flow (Shopify Subscriptions seam)', 'background:#141414;color:#fff;padding:4px 10px;font-weight:bold;');
    console.log('  ✓ Join CTAs on tier cards → casaStartMembership() → Shopify subscription checkout when configured');
    console.log('  ✓ Membership: live monthly billing via Shopify Subscriptions (Silver/Gold/Elite), Terms gated, portal wired');
    console.log('  ' + (window.CASA_CONFIG.MEMBERSHIP_PLANS.silver.sellingPlanId.yearly ? '✓' : '⏳') + ' Yearly billing toggle: UI live; checkout ' + (window.CASA_CONFIG.MEMBERSHIP_PLANS.silver.sellingPlanId.yearly ? 'wired to Shopify annual selling plans' : 'waitlists until the annual selling plans exist in Shopify (sellingPlanId.yearly is blank)'));
  })();

  // =====================================================================
  // CASA · HIDE "JEWELRY" CATEGORY (temporary, launch) — no jewelry
  // inventory yet. Hides every Jewelry entry point (Shop menu, filters,
  // footer, category chips, Care Guide tab) from the public.
  // TO RE-ENABLE later: set ENABLED = false below (or delete this IIFE)
  // and redeploy.
  // =====================================================================
  (function casaHideJewelry(){
    var ENABLED = true;
    if (!ENABLED) return;
    var TERMS = ['jewelry','jewellery','joyería','joyeria','joaillerie','schmuck','ジュエリー','珠宝'];
    function isJewelry(t){ t = (t || '').replace(/\s+/g,' ').trim().toLowerCase(); return !!t && TERMS.indexOf(t) >= 0; }
    function hide(el){ if (el && !el.hasAttribute('data-casa-jewelry-hidden')){ el.setAttribute('data-casa-jewelry-hidden','1'); el.style.display = 'none'; } }
    function sweep(){
      try {
        // Shop category filter checkboxes
        document.querySelectorAll('.filter-option').forEach(function(l){ if (isJewelry(l.textContent)) hide(l); });
        // Menu / footer / category-chip links & buttons (leaf text = exactly "Jewelry")
        document.querySelectorAll('a, button').forEach(function(el){ if (el.children.length === 0 && isJewelry(el.textContent)) hide(el); });
        // Care Guide "Jewelry" tab + its panel
        document.querySelectorAll('[onclick*="jewelry"], [data-care="jewelry"]').forEach(function(el){ if (el.tagName === 'BUTTON' || (el.className || '').indexOf('care-panel') >= 0) hide(el); });
      } catch(e){}
    }
    sweep();
    // Re-sweep after view changes / language switches (filters re-render)
    var _sv = window.switchView; if (typeof _sv === 'function'){ window.switchView = function(){ var r = _sv.apply(this, arguments); setTimeout(sweep, 60); return r; }; }
    var _ai = window.applyI18n; if (typeof _ai === 'function'){ window.applyI18n = function(){ var r = _ai.apply(this, arguments); setTimeout(sweep, 30); return r; }; }
    // Safety net for any late re-renders (debounced; hides via style only, so no loop)
    try { var mo = new MutationObserver(function(){ if (mo._t) return; mo._t = setTimeout(function(){ mo._t = null; sweep(); }, 150); }); mo.observe(document.body, { childList:true, subtree:true }); } catch(e){}
    console.log('%cCASA · Jewelry category hidden (launch — no inventory yet)', 'background:#141414;color:#fff;padding:4px 10px;font-weight:bold;');
  })();

